webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isNative) {

  /** Used to detect functions containing a `this` reference */
  var reThis = /\bthis\b/;

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
      objectClass = '[object Object]';

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Used for native method references */
  var errorProto = Error.prototype,
      objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * An object used to flag environments features.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  var support = {};

  (function() {
    var ctor = function() { this.x = 1; },
        object = { '0': 1, 'length': 1 },
        props = [];

    ctor.prototype = { 'valueOf': 1, 'y': 1 };
    for (var key in new ctor) { props.push(key); }
    for (key in arguments) { }

    /**
     * Detect if an `arguments` object's [[Class]] is resolvable (all but Firefox < 4, IE < 9).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.argsClass = toString.call(arguments) == argsClass;

    /**
     * Detect if `arguments` objects are `Object` objects (all but Narwhal and Opera < 10.5).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.argsObject = arguments.constructor == Object && !(arguments instanceof Array);

    /**
     * Detect if `name` or `message` properties of `Error.prototype` are
     * enumerable by default. (IE < 9, Safari < 5.1)
     *
     * @memberOf _.support
     * @type boolean
     */
    support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');

    /**
     * Detect if `prototype` properties are enumerable by default.
     *
     * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
     * (if the prototype or a property on the prototype has been set)
     * incorrectly sets a function's `prototype` property [[Enumerable]]
     * value to `true`.
     *
     * @memberOf _.support
     * @type boolean
     */
    support.enumPrototypes = propertyIsEnumerable.call(ctor, 'prototype');

    /**
     * Detect if functions can be decompiled by `Function#toString`
     * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.funcDecomp = !isNative(window.WinRTError) && reThis.test(function() { return this; });

    /**
     * Detect if `Function#name` is supported (all but IE).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.funcNames = typeof Function.name == 'string';

    /**
     * Detect if `arguments` object indexes are non-enumerable
     * (Firefox < 4, IE < 9, PhantomJS, Safari < 5.1).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.nonEnumArgs = key != 0;

    /**
     * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
     *
     * In IE < 9 an objects own properties, shadowing non-enumerable ones, are
     * made non-enumerable as well (a.k.a the JScript [[DontEnum]] bug).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.nonEnumShadows = !/valueOf/.test(props);

    /**
     * Detect if own properties are iterated after inherited properties (all but IE < 9).
     *
     * @memberOf _.support
     * @type boolean
     */
    support.ownLast = props[0] != 'x';

    /**
     * Detect if `Array#shift` and `Array#splice` augment array-like objects correctly.
     *
     * Firefox < 10, IE compatibility mode, and IE < 9 have buggy Array `shift()`
     * and `splice()` functions that fail to remove the last element, `value[0]`,
     * of array-like objects even though the `length` property is set to `0`.
     * The `shift()` method is buggy in IE 8 compatibility mode, while `splice()`
     * is buggy regardless of mode in IE < 9 and buggy in compatibility mode in IE 9.
     *
     * @memberOf _.support
     * @type boolean
     */
    support.spliceObjects = (arrayRef.splice.call(object, 0, 1), !object[0]);

    /**
     * Detect lack of support for accessing string characters by index.
     *
     * IE < 8 can't access characters by index and IE 8 can only access
     * characters by index on string literals.
     *
     * @memberOf _.support
     * @type boolean
     */
    support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';

    /**
     * Detect if a DOM node's [[Class]] is resolvable (all but IE < 9)
     * and that the JS engine errors when attempting to coerce an object to
     * a string without a `toString` function.
     *
     * @memberOf _.support
     * @type boolean
     */
    try {
      support.nodeClass = !(toString.call(document) == objectClass && !({ 'toString': 0 } + ''));
    } catch(e) {
      support.nodeClass = true;
    }
  }(1));

  return support;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * Slices the `collection` from the `start` index up to, but not including,
   * the `end` index.
   *
   * Note: This function is used instead of `Array#slice` to support node lists
   * in IE < 9 and to ensure dense arrays are returned.
   *
   * @private
   * @param {Array|Object|string} collection The collection to slice.
   * @param {number} start The start index.
   * @param {number} end The end index.
   * @returns {Array} Returns the new array.
   */
  function slice(array, start, end) {
    start || (start = 0);
    if (typeof end == 'undefined') {
      end = array ? array.length : 0;
    }
    var index = -1,
        length = end - start || 0,
        result = Array(length < 0 ? 0 : length);

    while (++index < length) {
      result[index] = array[start + index];
    }
    return result;
  }

  return slice;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isNative) {

  /** `Object#toString` result shortcuts */
  var arrayClass = '[object Array]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray;

  /**
   * Checks if `value` is an array.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
   * @example
   *
   * (function() { return _.isArray(arguments); })();
   * // => false
   *
   * _.isArray([1, 2, 3]);
   * // => true
   */
  var isArray = nativeIsArray || function(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == arrayClass || false;
  };

  return isArray;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(3), __webpack_require__(1), __webpack_require__(98), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArguments, isNative, isObject, shimKeys, support) {

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys;

  /**
   * Creates an array composed of the own enumerable property names of an object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   * @example
   *
   * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
   * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
   */
  var keys = !nativeKeys ? shimKeys : function(object) {
    if (!isObject(object)) {
      return [];
    }
    if ((support.enumPrototypes && typeof object == 'function') ||
        (support.nonEnumArgs && object.length && isArguments(object))) {
      return shimKeys(object);
    }
    return nativeKeys(object);
  };

  return keys;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(96), __webpack_require__(31), __webpack_require__(8), __webpack_require__(61), __webpack_require__(97), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreateCallback, indicatorObject, isArguments, isArray, isString, iteratorTemplate, objectTypes) {

  /** Used to fix the JScript [[DontEnum]] bug */
  var shadowedProps = [
    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
    'toLocaleString', 'toString', 'valueOf'
  ];

  /** `Object#toString` result shortcuts */
  var arrayClass = '[object Array]',
      boolClass = '[object Boolean]',
      dateClass = '[object Date]',
      errorClass = '[object Error]',
      funcClass = '[object Function]',
      numberClass = '[object Number]',
      objectClass = '[object Object]',
      regexpClass = '[object RegExp]',
      stringClass = '[object String]';

  /** Used as the data object for `iteratorTemplate` */
  var iteratorData = {
    'args': '',
    'array': null,
    'bottom': '',
    'firstArg': '',
    'init': '',
    'keys': null,
    'loop': '',
    'shadowedProps': null,
    'support': null,
    'top': '',
    'useHas': false
  };

  /** Used for native method references */
  var errorProto = Error.prototype,
      objectProto = Object.prototype,
      stringProto = String.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to avoid iterating non-enumerable properties in IE < 9 */
  var nonEnumProps = {};
  nonEnumProps[arrayClass] = nonEnumProps[dateClass] = nonEnumProps[numberClass] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
  nonEnumProps[boolClass] = nonEnumProps[stringClass] = { 'constructor': true, 'toString': true, 'valueOf': true };
  nonEnumProps[errorClass] = nonEnumProps[funcClass] = nonEnumProps[regexpClass] = { 'constructor': true, 'toString': true };
  nonEnumProps[objectClass] = { 'constructor': true };

  (function() {
    var length = shadowedProps.length;
    while (length--) {
      var key = shadowedProps[length];
      for (var className in nonEnumProps) {
        if (hasOwnProperty.call(nonEnumProps, className) && !hasOwnProperty.call(nonEnumProps[className], key)) {
          nonEnumProps[className][key] = false;
        }
      }
    }
  }());

  /**
   * Creates compiled iteration functions.
   *
   * @private
   * @param {...Object} [options] The compile options object(s).
   * @param {string} [options.array] Code to determine if the iterable is an array or array-like.
   * @param {boolean} [options.useHas] Specify using `hasOwnProperty` checks in the object loop.
   * @param {Function} [options.keys] A reference to `_.keys` for use in own property iteration.
   * @param {string} [options.args] A comma separated string of iteration function arguments.
   * @param {string} [options.top] Code to execute before the iteration branches.
   * @param {string} [options.loop] Code to execute in the object loop.
   * @param {string} [options.bottom] Code to execute after the iteration branches.
   * @returns {Function} Returns the compiled function.
   */
  function createIterator() {
    // data properties
    iteratorData.shadowedProps = shadowedProps;

    // iterator options
    iteratorData.array = iteratorData.bottom = iteratorData.loop = iteratorData.top = '';
    iteratorData.init = 'iterable';
    iteratorData.useHas = true;

    // merge options into a template data object
    for (var object, index = 0; object = arguments[index]; index++) {
      for (var key in object) {
        iteratorData[key] = object[key];
      }
    }
    var args = iteratorData.args;
    iteratorData.firstArg = /^[^,]+/.exec(args)[0];

    // create the function factory
    var factory = Function(
        'baseCreateCallback, errorClass, errorProto, hasOwnProperty, ' +
        'indicatorObject, isArguments, isArray, isString, keys, objectProto, ' +
        'objectTypes, nonEnumProps, stringClass, stringProto, toString',
      'return function(' + args + ') {\n' + iteratorTemplate(iteratorData) + '\n}'
    );

    // return the compiled function
    return factory(
      baseCreateCallback, errorClass, errorProto, hasOwnProperty,
      indicatorObject, isArguments, isArray, isString, iteratorData.keys, objectProto,
      objectTypes, nonEnumProps, stringClass, stringProto, toString
    );
  }

  return createIterator;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator, defaultsIteratorOptions) {

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object. Subsequent sources will overwrite property assignments of previous
   * sources. If a callback is provided it will be executed to produce the
   * assigned values. The callback is bound to `thisArg` and invoked with two
   * arguments; (objectValue, sourceValue).
   *
   * @static
   * @memberOf _
   * @type Function
   * @alias extend
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param {Function} [callback] The function to customize assigning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
   * // => { 'name': 'fred', 'employer': 'slate' }
   *
   * var defaults = _.partialRight(_.assign, function(a, b) {
   *   return typeof a == 'undefined' ? b : a;
   * });
   *
   * var object = { 'name': 'barney' };
   * defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  var assign = createIterator(defaultsIteratorOptions, {
    'top':
      defaultsIteratorOptions.top.replace(';',
        ';\n' +
        "if (argsLength > 3 && typeof args[argsLength - 2] == 'function') {\n" +
        '  var callback = baseCreateCallback(args[--argsLength - 1], args[argsLength--], 2);\n' +
        "} else if (argsLength > 2 && typeof args[argsLength - 1] == 'function') {\n" +
        '  callback = args[--argsLength];\n' +
        '}'
      ),
    'loop': 'result[index] = callback ? callback(result[index], iterable[index]) : iterable[index]'
  });

  return assign;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bean - copyright (c) Jacob Thornton 2011-2012
  * https://github.com/fat/bean
  * MIT license
  */
(function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else context[name] = definition()
})('bean', this, function (name, context) {
  name    = name    || 'bean'
  context = context || this

  var win            = window
    , old            = context[name]
    , namespaceRegex = /[^\.]*(?=\..*)\.|.*/
    , nameRegex      = /\..*/
    , addEvent       = 'addEventListener'
    , removeEvent    = 'removeEventListener'
    , doc            = document || {}
    , root           = doc.documentElement || {}
    , W3C_MODEL      = root[addEvent]
    , eventSupport   = W3C_MODEL ? addEvent : 'attachEvent'
    , ONE            = {} // singleton for quick matching making add() do one()

    , slice          = Array.prototype.slice
    , str2arr        = function (s, d) { return s.split(d || ' ') }
    , isString       = function (o) { return typeof o == 'string' }
    , isFunction     = function (o) { return typeof o == 'function' }

      // events that we consider to be 'native', anything not in this list will
      // be treated as a custom event
    , standardNativeEvents =
        'click dblclick mouseup mousedown contextmenu '                  + // mouse buttons
        'mousewheel mousemultiwheel DOMMouseScroll '                     + // mouse wheel
        'mouseover mouseout mousemove selectstart selectend '            + // mouse movement
        'keydown keypress keyup '                                        + // keyboard
        'orientationchange '                                             + // mobile
        'focus blur change reset select submit '                         + // form elements
        'load unload beforeunload resize move DOMContentLoaded '         + // window
        'readystatechange message '                                      + // window
        'error abort scroll '                                              // misc
      // element.fireEvent('onXYZ'... is not forgiving if we try to fire an event
      // that doesn't actually exist, so make sure we only do these on newer browsers
    , w3cNativeEvents =
        'show '                                                          + // mouse buttons
        'input invalid '                                                 + // form elements
        'touchstart touchmove touchend touchcancel '                     + // touch
        'gesturestart gesturechange gestureend '                         + // gesture
        'textinput '                                                     + // TextEvent
        'readystatechange pageshow pagehide popstate '                   + // window
        'hashchange offline online '                                     + // window
        'afterprint beforeprint '                                        + // printing
        'dragstart dragenter dragover dragleave drag drop dragend '      + // dnd
        'loadstart progress suspend emptied stalled loadmetadata '       + // media
        'loadeddata canplay canplaythrough playing waiting seeking '     + // media
        'seeked ended durationchange timeupdate play pause ratechange '  + // media
        'volumechange cuechange '                                        + // media
        'checking noupdate downloading cached updateready obsolete '       // appcache

      // convert to a hash for quick lookups
    , nativeEvents = (function (hash, events, i) {
        for (i = 0; i < events.length; i++) events[i] && (hash[events[i]] = 1)
        return hash
      }({}, str2arr(standardNativeEvents + (W3C_MODEL ? w3cNativeEvents : ''))))

      // custom events are events that we *fake*, they are not provided natively but
      // we can use native events to generate them
    , customEvents = (function () {
        var isAncestor = 'compareDocumentPosition' in root
              ? function (element, container) {
                  return container.compareDocumentPosition && (container.compareDocumentPosition(element) & 16) === 16
                }
              : 'contains' in root
                ? function (element, container) {
                    container = container.nodeType === 9 || container === window ? root : container
                    return container !== element && container.contains(element)
                  }
                : function (element, container) {
                    while (element = element.parentNode) if (element === container) return 1
                    return 0
                  }
          , check = function (event) {
              var related = event.relatedTarget
              return !related
                ? related == null
                : (related !== this && related.prefix !== 'xul' && !/document/.test(this.toString())
                    && !isAncestor(related, this))
            }

        return {
            mouseenter: { base: 'mouseover', condition: check }
          , mouseleave: { base: 'mouseout', condition: check }
          , mousewheel: { base: /Firefox/.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel' }
        }
      }())

      // we provide a consistent Event object across browsers by taking the actual DOM
      // event object and generating a new one from its properties.
    , Event = (function () {
            // a whitelist of properties (for different event types) tells us what to check for and copy
        var commonProps  = str2arr('altKey attrChange attrName bubbles cancelable ctrlKey currentTarget ' +
              'detail eventPhase getModifierState isTrusted metaKey relatedNode relatedTarget shiftKey '  +
              'srcElement target timeStamp type view which propertyName')
          , mouseProps   = commonProps.concat(str2arr('button buttons clientX clientY dataTransfer '      +
              'fromElement offsetX offsetY pageX pageY screenX screenY toElement'))
          , mouseWheelProps = mouseProps.concat(str2arr('wheelDelta wheelDeltaX wheelDeltaY wheelDeltaZ ' +
              'axis')) // 'axis' is FF specific
          , keyProps     = commonProps.concat(str2arr('char charCode key keyCode keyIdentifier '          +
              'keyLocation location'))
          , textProps    = commonProps.concat(str2arr('data'))
          , touchProps   = commonProps.concat(str2arr('touches targetTouches changedTouches scale rotation'))
          , messageProps = commonProps.concat(str2arr('data origin source'))
          , stateProps   = commonProps.concat(str2arr('state'))
          , overOutRegex = /over|out/
            // some event types need special handling and some need special properties, do that all here
          , typeFixers   = [
                { // key events
                    reg: /key/i
                  , fix: function (event, newEvent) {
                      newEvent.keyCode = event.keyCode || event.which
                      return keyProps
                    }
                }
              , { // mouse events
                    reg: /click|mouse(?!(.*wheel|scroll))|menu|drag|drop/i
                  , fix: function (event, newEvent, type) {
                      newEvent.rightClick = event.which === 3 || event.button === 2
                      newEvent.pos = { x: 0, y: 0 }
                      if (event.pageX || event.pageY) {
                        newEvent.clientX = event.pageX
                        newEvent.clientY = event.pageY
                      } else if (event.clientX || event.clientY) {
                        newEvent.clientX = event.clientX + doc.body.scrollLeft + root.scrollLeft
                        newEvent.clientY = event.clientY + doc.body.scrollTop + root.scrollTop
                      }
                      if (overOutRegex.test(type)) {
                        newEvent.relatedTarget = event.relatedTarget
                          || event[(type == 'mouseover' ? 'from' : 'to') + 'Element']
                      }
                      return mouseProps
                    }
                }
              , { // mouse wheel events
                    reg: /mouse.*(wheel|scroll)/i
                  , fix: function () { return mouseWheelProps }
                }
              , { // TextEvent
                    reg: /^text/i
                  , fix: function () { return textProps }
                }
              , { // touch and gesture events
                    reg: /^touch|^gesture/i
                  , fix: function () { return touchProps }
                }
              , { // message events
                    reg: /^message$/i
                  , fix: function () { return messageProps }
                }
              , { // popstate events
                    reg: /^popstate$/i
                  , fix: function () { return stateProps }
                }
              , { // everything else
                    reg: /.*/
                  , fix: function () { return commonProps }
                }
            ]
          , typeFixerMap = {} // used to map event types to fixer functions (above), a basic cache mechanism

          , Event = function (event, element, isNative) {
              if (!arguments.length) return
              event = event || ((element.ownerDocument || element.document || element).parentWindow || win).event
              this.originalEvent = event
              this.isNative       = isNative
              this.isBean         = true

              if (!event) return

              var type   = event.type
                , target = event.target || event.srcElement
                , i, l, p, props, fixer

              this.target = target && target.nodeType === 3 ? target.parentNode : target

              if (isNative) { // we only need basic augmentation on custom events, the rest expensive & pointless
                fixer = typeFixerMap[type]
                if (!fixer) { // haven't encountered this event type before, map a fixer function for it
                  for (i = 0, l = typeFixers.length; i < l; i++) {
                    if (typeFixers[i].reg.test(type)) { // guaranteed to match at least one, last is .*
                      typeFixerMap[type] = fixer = typeFixers[i].fix
                      break
                    }
                  }
                }

                props = fixer(event, this, type)
                for (i = props.length; i--;) {
                  if (!((p = props[i]) in this) && p in event) this[p] = event[p]
                }
              }
            }

        // preventDefault() and stopPropagation() are a consistent interface to those functions
        // on the DOM, stop() is an alias for both of them together
        Event.prototype.preventDefault = function () {
          if (this.originalEvent.preventDefault) this.originalEvent.preventDefault()
          else this.originalEvent.returnValue = false
        }
        Event.prototype.stopPropagation = function () {
          if (this.originalEvent.stopPropagation) this.originalEvent.stopPropagation()
          else this.originalEvent.cancelBubble = true
        }
        Event.prototype.stop = function () {
          this.preventDefault()
          this.stopPropagation()
          this.stopped = true
        }
        // stopImmediatePropagation() has to be handled internally because we manage the event list for
        // each element
        // note that originalElement may be a Bean#Event object in some situations
        Event.prototype.stopImmediatePropagation = function () {
          if (this.originalEvent.stopImmediatePropagation) this.originalEvent.stopImmediatePropagation()
          this.isImmediatePropagationStopped = function () { return true }
        }
        Event.prototype.isImmediatePropagationStopped = function () {
          return this.originalEvent.isImmediatePropagationStopped && this.originalEvent.isImmediatePropagationStopped()
        }
        Event.prototype.clone = function (currentTarget) {
          //TODO: this is ripe for optimisation, new events are *expensive*
          // improving this will speed up delegated events
          var ne = new Event(this, this.element, this.isNative)
          ne.currentTarget = currentTarget
          return ne
        }

        return Event
      }())

      // if we're in old IE we can't do onpropertychange on doc or win so we use doc.documentElement for both
    , targetElement = function (element, isNative) {
        return !W3C_MODEL && !isNative && (element === doc || element === win) ? root : element
      }

      /**
        * Bean maintains an internal registry for event listeners. We don't touch elements, objects
        * or functions to identify them, instead we store everything in the registry.
        * Each event listener has a RegEntry object, we have one 'registry' for the whole instance.
        */
    , RegEntry = (function () {
        // each handler is wrapped so we can handle delegation and custom events
        var wrappedHandler = function (element, fn, condition, args) {
            var call = function (event, eargs) {
                  return fn.apply(element, args ? slice.call(eargs, event ? 0 : 1).concat(args) : eargs)
                }
              , findTarget = function (event, eventElement) {
                  return fn.__beanDel ? fn.__beanDel.ft(event.target, element) : eventElement
                }
              , handler = condition
                  ? function (event) {
                      var target = findTarget(event, this) // deleated event
                      if (condition.apply(target, arguments)) {
                        if (event) event.currentTarget = target
                        return call(event, arguments)
                      }
                    }
                  : function (event) {
                      if (fn.__beanDel) event = event.clone(findTarget(event)) // delegated event, fix the fix
                      return call(event, arguments)
                    }
            handler.__beanDel = fn.__beanDel
            return handler
          }

        , RegEntry = function (element, type, handler, original, namespaces, args, root) {
            var customType     = customEvents[type]
              , isNative

            if (type == 'unload') {
              // self clean-up
              handler = once(removeListener, element, type, handler, original)
            }

            if (customType) {
              if (customType.condition) {
                handler = wrappedHandler(element, handler, customType.condition, args)
              }
              type = customType.base || type
            }

            this.isNative      = isNative = nativeEvents[type] && !!element[eventSupport]
            this.customType    = !W3C_MODEL && !isNative && type
            this.element       = element
            this.type          = type
            this.original      = original
            this.namespaces    = namespaces
            this.eventType     = W3C_MODEL || isNative ? type : 'propertychange'
            this.target        = targetElement(element, isNative)
            this[eventSupport] = !!this.target[eventSupport]
            this.root          = root
            this.handler       = wrappedHandler(element, handler, null, args)
          }

        // given a list of namespaces, is our entry in any of them?
        RegEntry.prototype.inNamespaces = function (checkNamespaces) {
          var i, j, c = 0
          if (!checkNamespaces) return true
          if (!this.namespaces) return false
          for (i = checkNamespaces.length; i--;) {
            for (j = this.namespaces.length; j--;) {
              if (checkNamespaces[i] == this.namespaces[j]) c++
            }
          }
          return checkNamespaces.length === c
        }

        // match by element, original fn (opt), handler fn (opt)
        RegEntry.prototype.matches = function (checkElement, checkOriginal, checkHandler) {
          return this.element === checkElement &&
            (!checkOriginal || this.original === checkOriginal) &&
            (!checkHandler || this.handler === checkHandler)
        }

        return RegEntry
      }())

    , registry = (function () {
        // our map stores arrays by event type, just because it's better than storing
        // everything in a single array.
        // uses '$' as a prefix for the keys for safety and 'r' as a special prefix for
        // rootListeners so we can look them up fast
        var map = {}

          // generic functional search of our registry for matching listeners,
          // `fn` returns false to break out of the loop
          , forAll = function (element, type, original, handler, root, fn) {
              var pfx = root ? 'r' : '$'
              if (!type || type == '*') {
                // search the whole registry
                for (var t in map) {
                  if (t.charAt(0) == pfx) {
                    forAll(element, t.substr(1), original, handler, root, fn)
                  }
                }
              } else {
                var i = 0, l, list = map[pfx + type], all = element == '*'
                if (!list) return
                for (l = list.length; i < l; i++) {
                  if ((all || list[i].matches(element, original, handler)) && !fn(list[i], list, i, type)) return
                }
              }
            }

          , has = function (element, type, original, root) {
              // we're not using forAll here simply because it's a bit slower and this
              // needs to be fast
              var i, list = map[(root ? 'r' : '$') + type]
              if (list) {
                for (i = list.length; i--;) {
                  if (!list[i].root && list[i].matches(element, original, null)) return true
                }
              }
              return false
            }

          , get = function (element, type, original, root) {
              var entries = []
              forAll(element, type, original, null, root, function (entry) {
                return entries.push(entry)
              })
              return entries
            }

          , put = function (entry) {
              var has = !entry.root && !this.has(entry.element, entry.type, null, false)
                , key = (entry.root ? 'r' : '$') + entry.type
              ;(map[key] || (map[key] = [])).push(entry)
              return has
            }

          , del = function (entry) {
              forAll(entry.element, entry.type, null, entry.handler, entry.root, function (entry, list, i) {
                list.splice(i, 1)
                entry.removed = true
                if (list.length === 0) delete map[(entry.root ? 'r' : '$') + entry.type]
                return false
              })
            }

            // dump all entries, used for onunload
          , entries = function () {
              var t, entries = []
              for (t in map) {
                if (t.charAt(0) == '$') entries = entries.concat(map[t])
              }
              return entries
            }

        return { has: has, get: get, put: put, del: del, entries: entries }
      }())

      // we need a selector engine for delegated events, use querySelectorAll if it exists
      // but for older browsers we need Qwery, Sizzle or similar
    , selectorEngine
    , setSelectorEngine = function (e) {
        if (!arguments.length) {
          selectorEngine = doc.querySelectorAll
            ? function (s, r) {
                return r.querySelectorAll(s)
              }
            : function () {
                throw new Error('Bean: No selector engine installed') // eeek
              }
        } else {
          selectorEngine = e
        }
      }

      // we attach this listener to each DOM event that we need to listen to, only once
      // per event type per DOM element
    , rootListener = function (event, type) {
        if (!W3C_MODEL && type && event && event.propertyName != '_on' + type) return

        var listeners = registry.get(this, type || event.type, null, false)
          , l = listeners.length
          , i = 0

        event = new Event(event, this, true)
        if (type) event.type = type

        // iterate through all handlers registered for this type, calling them unless they have
        // been removed by a previous handler or stopImmediatePropagation() has been called
        for (; i < l && !event.isImmediatePropagationStopped(); i++) {
          if (!listeners[i].removed) listeners[i].handler.call(this, event)
        }
      }

      // add and remove listeners to DOM elements
    , listener = W3C_MODEL
        ? function (element, type, add) {
            // new browsers
            element[add ? addEvent : removeEvent](type, rootListener, false)
          }
        : function (element, type, add, custom) {
            // IE8 and below, use attachEvent/detachEvent and we have to piggy-back propertychange events
            // to simulate event bubbling etc.
            var entry
            if (add) {
              registry.put(entry = new RegEntry(
                  element
                , custom || type
                , function (event) { // handler
                    rootListener.call(element, event, custom)
                  }
                , rootListener
                , null
                , null
                , true // is root
              ))
              if (custom && element['_on' + custom] == null) element['_on' + custom] = 0
              entry.target.attachEvent('on' + entry.eventType, entry.handler)
            } else {
              entry = registry.get(element, custom || type, rootListener, true)[0]
              if (entry) {
                entry.target.detachEvent('on' + entry.eventType, entry.handler)
                registry.del(entry)
              }
            }
          }

    , once = function (rm, element, type, fn, originalFn) {
        // wrap the handler in a handler that does a remove as well
        return function () {
          fn.apply(this, arguments)
          rm(element, type, originalFn)
        }
      }

    , removeListener = function (element, orgType, handler, namespaces) {
        var type     = orgType && orgType.replace(nameRegex, '')
          , handlers = registry.get(element, type, null, false)
          , removed  = {}
          , i, l

        for (i = 0, l = handlers.length; i < l; i++) {
          if ((!handler || handlers[i].original === handler) && handlers[i].inNamespaces(namespaces)) {
            // TODO: this is problematic, we have a registry.get() and registry.del() that
            // both do registry searches so we waste cycles doing this. Needs to be rolled into
            // a single registry.forAll(fn) that removes while finding, but the catch is that
            // we'll be splicing the arrays that we're iterating over. Needs extra tests to
            // make sure we don't screw it up. @rvagg
            registry.del(handlers[i])
            if (!removed[handlers[i].eventType] && handlers[i][eventSupport])
              removed[handlers[i].eventType] = { t: handlers[i].eventType, c: handlers[i].type }
          }
        }
        // check each type/element for removed listeners and remove the rootListener where it's no longer needed
        for (i in removed) {
          if (!registry.has(element, removed[i].t, null, false)) {
            // last listener of this type, remove the rootListener
            listener(element, removed[i].t, false, removed[i].c)
          }
        }
      }

      // set up a delegate helper using the given selector, wrap the handler function
    , delegate = function (selector, fn) {
        //TODO: findTarget (therefore $) is called twice, once for match and once for
        // setting e.currentTarget, fix this so it's only needed once
        var findTarget = function (target, root) {
              var i, array = isString(selector) ? selectorEngine(selector, root) : selector
              for (; target && target !== root; target = target.parentNode) {
                for (i = array.length; i--;) {
                  if (array[i] === target) return target
                }
              }
            }
          , handler = function (e) {
              var match = findTarget(e.target, this)
              if (match) fn.apply(match, arguments)
            }

        // __beanDel isn't pleasant but it's a private function, not exposed outside of Bean
        handler.__beanDel = {
            ft       : findTarget // attach it here for customEvents to use too
          , selector : selector
        }
        return handler
      }

    , fireListener = W3C_MODEL ? function (isNative, type, element) {
        // modern browsers, do a proper dispatchEvent()
        var evt = doc.createEvent(isNative ? 'HTMLEvents' : 'UIEvents')
        evt[isNative ? 'initEvent' : 'initUIEvent'](type, true, true, win, 1)
        element.dispatchEvent(evt)
      } : function (isNative, type, element) {
        // old browser use onpropertychange, just increment a custom property to trigger the event
        element = targetElement(element, isNative)
        isNative ? element.fireEvent('on' + type, doc.createEventObject()) : element['_on' + type]++
      }

      /**
        * Public API: off(), on(), add(), (remove()), one(), fire(), clone()
        */

      /**
        * off(element[, eventType(s)[, handler ]])
        */
    , off = function (element, typeSpec, fn) {
        var isTypeStr = isString(typeSpec)
          , k, type, namespaces, i

        if (isTypeStr && typeSpec.indexOf(' ') > 0) {
          // off(el, 't1 t2 t3', fn) or off(el, 't1 t2 t3')
          typeSpec = str2arr(typeSpec)
          for (i = typeSpec.length; i--;)
            off(element, typeSpec[i], fn)
          return element
        }

        type = isTypeStr && typeSpec.replace(nameRegex, '')
        if (type && customEvents[type]) type = customEvents[type].base

        if (!typeSpec || isTypeStr) {
          // off(el) or off(el, t1.ns) or off(el, .ns) or off(el, .ns1.ns2.ns3)
          if (namespaces = isTypeStr && typeSpec.replace(namespaceRegex, '')) namespaces = str2arr(namespaces, '.')
          removeListener(element, type, fn, namespaces)
        } else if (isFunction(typeSpec)) {
          // off(el, fn)
          removeListener(element, null, typeSpec)
        } else {
          // off(el, { t1: fn1, t2, fn2 })
          for (k in typeSpec) {
            if (typeSpec.hasOwnProperty(k)) off(element, k, typeSpec[k])
          }
        }

        return element
      }

      /**
        * on(element, eventType(s)[, selector], handler[, args ])
        */
    , on = function(element, events, selector, fn) {
        var originalFn, type, types, i, args, entry, first

        //TODO: the undefined check means you can't pass an 'args' argument, fix this perhaps?
        if (selector === undefined && typeof events == 'object') {
          //TODO: this can't handle delegated events
          for (type in events) {
            if (events.hasOwnProperty(type)) {
              on.call(this, element, type, events[type])
            }
          }
          return
        }

        if (!isFunction(selector)) {
          // delegated event
          originalFn = fn
          args       = slice.call(arguments, 4)
          fn         = delegate(selector, originalFn, selectorEngine)
        } else {
          args       = slice.call(arguments, 3)
          fn         = originalFn = selector
        }

        types = str2arr(events)

        // special case for one(), wrap in a self-removing handler
        if (this === ONE) {
          fn = once(off, element, events, fn, originalFn)
        }

        for (i = types.length; i--;) {
          // add new handler to the registry and check if it's the first for this element/type
          first = registry.put(entry = new RegEntry(
              element
            , types[i].replace(nameRegex, '') // event type
            , fn
            , originalFn
            , str2arr(types[i].replace(namespaceRegex, ''), '.') // namespaces
            , args
            , false // not root
          ))
          if (entry[eventSupport] && first) {
            // first event of this type on this element, add root listener
            listener(element, entry.eventType, true, entry.customType)
          }
        }

        return element
      }

      /**
        * add(element[, selector], eventType(s), handler[, args ])
        *
        * Deprecated: kept (for now) for backward-compatibility
        */
    , add = function (element, events, fn, delfn) {
        return on.apply(
            null
          , !isString(fn)
              ? slice.call(arguments)
              : [ element, fn, events, delfn ].concat(arguments.length > 3 ? slice.call(arguments, 5) : [])
        )
      }

      /**
        * one(element, eventType(s)[, selector], handler[, args ])
        */
    , one = function () {
        return on.apply(ONE, arguments)
      }

      /**
        * fire(element, eventType(s)[, args ])
        *
        * The optional 'args' argument must be an array, if no 'args' argument is provided
        * then we can use the browser's DOM event system, otherwise we trigger handlers manually
        */
    , fire = function (element, type, args) {
        var types = str2arr(type)
          , i, j, l, names, handlers

        for (i = types.length; i--;) {
          type = types[i].replace(nameRegex, '')
          if (names = types[i].replace(namespaceRegex, '')) names = str2arr(names, '.')
          if (!names && !args && element[eventSupport]) {
            fireListener(nativeEvents[type], type, element)
          } else {
            // non-native event, either because of a namespace, arguments or a non DOM element
            // iterate over all listeners and manually 'fire'
            handlers = registry.get(element, type, null, false)
            args = [false].concat(args)
            for (j = 0, l = handlers.length; j < l; j++) {
              if (handlers[j].inNamespaces(names)) {
                handlers[j].handler.apply(element, args)
              }
            }
          }
        }
        return element
      }

      /**
        * clone(dstElement, srcElement[, eventType ])
        *
        * TODO: perhaps for consistency we should allow the same flexibility in type specifiers?
        */
    , clone = function (element, from, type) {
        var handlers = registry.get(from, type, null, false)
          , l = handlers.length
          , i = 0
          , args, beanDel

        for (; i < l; i++) {
          if (handlers[i].original) {
            args = [ element, handlers[i].type ]
            if (beanDel = handlers[i].handler.__beanDel) args.push(beanDel.selector)
            args.push(handlers[i].original)
            on.apply(null, args)
          }
        }
        return element
      }

    , bean = {
          'on'                : on
        , 'add'               : add
        , 'one'               : one
        , 'off'               : off
        , 'remove'            : off
        , 'clone'             : clone
        , 'fire'              : fire
        , 'Event'             : Event
        , 'setSelectorEngine' : setSelectorEngine
        , 'noConflict'        : function () {
            context[name] = old
            return this
          }
      }

  // for IE, clean up on unload to avoid leaks
  if (win.attachEvent) {
    var cleanup = function () {
      var i, entries = registry.entries()
      for (i in entries) {
        if (entries[i].type && entries[i].type !== 'unload') off(entries[i].element, entries[i].type)
      }
      win.detachEvent('onunload', cleanup)
      win.CollectGarbage && win.CollectGarbage()
    }
    win.attachEvent('onunload', cleanup)
  }

  // initialize selector engine to internal default (qSA or throw Error)
  setSelectorEngine()

  return bean
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(146), __webpack_require__(89), __webpack_require__(144), __webpack_require__(9), __webpack_require__(88), __webpack_require__(148), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_RESULT__ = function(defaults, escape, escapeStringChar, keys, reInterpolate, templateSettings, values) {

  /** Used as a safe reference for `undefined` in pre ES5 environments */
  var undefined;

  /** Used to match empty string literals in compiled template source */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /**
   * Used to match ES6 template delimiters
   * http://people.mozilla.org/~jorendorff/es6-draft.html#sec-literals-string-literals
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to ensure capturing order of template delimiters */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals */
  var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;

  /**
   * A micro-templating method that handles arbitrary delimiters, preserves
   * whitespace, and correctly escapes quotes within interpolated code.
   *
   * Note: In the development build, `_.template` utilizes sourceURLs for easier
   * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
   *
   * For more information on precompiling templates see:
   * http://lodash.com/custom-builds
   *
   * For more information on Chrome extension sandboxes see:
   * http://developer.chrome.com/stable/extensions/sandboxingEval.html
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} text The template text.
   * @param {Object} data The data object used to populate the text.
   * @param {Object} [options] The options object.
   * @param {RegExp} [options.escape] The "escape" delimiter.
   * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
   * @param {Object} [options.imports] An object to import into the template as local variables.
   * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
   * @param {string} [sourceURL] The sourceURL of the template's compiled source.
   * @param {string} [variable] The data object variable name.
   * @returns {Function|string} Returns a compiled function when no `data` object
   *  is given, else it returns the interpolated text.
   * @example
   *
   * // using the "interpolate" delimiter to create a compiled template
   * var compiled = _.template('hello <%= name %>');
   * compiled({ 'name': 'fred' });
   * // => 'hello fred'
   *
   * // using the "escape" delimiter to escape HTML in data property values
   * _.template('<b><%- value %></b>', { 'value': '<script>' });
   * // => '<b>&lt;script&gt;</b>'
   *
   * // using the "evaluate" delimiter to generate HTML
   * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
   * _.template('hello ${ name }', { 'name': 'pebbles' });
   * // => 'hello pebbles'
   *
   * // using the internal `print` function in "evaluate" delimiters
   * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
   * // => 'hello barney!'
   *
   * // using a custom template delimiters
   * _.templateSettings = {
   *   'interpolate': /{{([\s\S]+?)}}/g
   * };
   *
   * _.template('hello {{ name }}!', { 'name': 'mustache' });
   * // => 'hello mustache!'
   *
   * // using the `imports` option to import jQuery
   * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the `sourceURL` option to specify a custom sourceURL for the template
   * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
   * compiled(data);
   * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
   *
   * // using the `variable` option to ensure a with-statement isn't used in the compiled template
   * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
   * compiled.source;
   * // => function(data) {
   *   var __t, __p = '', __e = _.escape;
   *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
   *   return __p;
   * }
   *
   * // using the `source` property to inline compiled templates for meaningful
   * // line numbers in error messages and a stack trace
   * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
   *   var JST = {\
   *     "main": ' + _.template(mainText).source + '\
   *   };\
   * ');
   */
  function template(text, data, options) {
    // based on John Resig's `tmpl` implementation
    // http://ejohn.org/blog/javascript-micro-templating/
    // and Laura Doktorova's doT.js
    // https://github.com/olado/doT
    var settings = templateSettings.imports._.templateSettings || templateSettings;
    text = String(text || '');

    // avoid missing dependencies when `iteratorTemplate` is not defined
    options = defaults({}, options, settings);

    var imports = defaults({}, options.imports, settings.imports),
        importsKeys = keys(imports),
        importsValues = values(imports);

    var isEvaluating,
        index = 0,
        interpolate = options.interpolate || reNoMatch,
        source = "__p += '";

    // compile the regexp to match each delimiter
    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + '|' +
      interpolate.source + '|' +
      (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
      (options.evaluate || reNoMatch).source + '|$'
    , 'g');

    text.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);

      // escape characters that cannot be included in string literals
      source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);

      // replace delimiters with snippets
      if (escapeValue) {
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;

      // the JS engine embedded in Adobe products requires returning the `match`
      // string in order to produce the correct `offset` value
      return match;
    });

    source += "';\n";

    // if `variable` is not specified, wrap a with-statement around the generated
    // code to add the data object to the top of the scope chain
    var variable = options.variable,
        hasVariable = variable;

    if (!hasVariable) {
      variable = 'obj';
      source = 'with (' + variable + ') {\n' + source + '\n}\n';
    }
    // cleanup code by stripping empty strings
    source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
      .replace(reEmptyStringMiddle, '$1')
      .replace(reEmptyStringTrailing, '$1;');

    // frame code as the function body
    source = 'function(' + variable + ') {\n' +
      (hasVariable ? '' : variable + ' || (' + variable + ' = {});\n') +
      "var __t, __p = '', __e = _.escape" +
      (isEvaluating
        ? ', __j = Array.prototype.join;\n' +
          "function print() { __p += __j.call(arguments, '') }\n"
        : ';\n'
      ) +
      source +
      'return __p\n}';

    try {
      var result = Function(importsKeys, 'return ' + source ).apply(undefined, importsValues);
    } catch(e) {
      e.source = source;
      throw e;
    }
    if (data) {
      return result(data);
    }
    // provide the compiled function's source by its `toString` method, in
    // supported environments, or the `source` property as a convenience for
    // inlining compiled templates during the build process
    result.source = source;
    return result;
  }

  return template;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator, eachIteratorOptions) {

  /**
   * A function compiled to iterate `arguments` objects, arrays, objects, and
   * strings consistenly across environments, executing the callback for each
   * element in the collection. The callback is bound to `thisArg` and invoked
   * with three arguments; (value, index|key, collection). Callbacks may exit
   * iteration early by explicitly returning `false`.
   *
   * @private
   * @type Function
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   */
  var baseEach = createIterator(eachIteratorOptions);

  return baseEach;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys) {

  /** Reusable iterator options shared by `each`, `forIn`, and `forOwn` */
  var eachIteratorOptions = {
    'args': 'collection, callback, thisArg',
    'top': "callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3)",
    'array': "typeof length == 'number'",
    'keys': keys,
    'loop': 'if (callback(iterable[index], index, collection) === false) return result'
  };

  return eachIteratorOptions;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(139), __webpack_require__(1), __webpack_require__(9), __webpack_require__(147)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreateCallback, baseIsEqual, isObject, keys, property) {

  /**
   * Produces a callback bound to an optional `thisArg`. If `func` is a property
   * name the created callback will return the property value for a given element.
   * If `func` is an object the created callback will return `true` for elements
   * that contain the equivalent object properties, otherwise it will return `false`.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // wrap to create custom callback shorthands
   * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
   *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
   *   return !match ? func(callback, thisArg) : function(object) {
   *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
   *   };
   * });
   *
   * _.filter(characters, 'age__gt38');
   * // => [{ 'name': 'fred', 'age': 40 }]
   */
  function createCallback(func, thisArg, argCount) {
    var type = typeof func;
    if (func == null || type == 'function') {
      return baseCreateCallback(func, thisArg, argCount);
    }
    // handle "_.pluck" style callback shorthands
    if (type != 'object') {
      return property(func);
    }
    var props = keys(func),
        key = props[0],
        a = func[key];

    // handle "_.where" style callback shorthands
    if (props.length == 1 && a === a && !isObject(a)) {
      // fast path the common case of providing an object with a single
      // property containing a primitive value
      return function(object) {
        var b = object[key];
        return a === b && (a !== 0 || (1 / a == 1 / b));
      };
    }
    return function(object) {
      var length = props.length,
          result = false;

      while (length--) {
        if (!(result = baseIsEqual(object[props[length]], func[props[length]], null, true))) {
          break;
        }
      }
      return result;
    };
  }

  return createCallback;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(support) {

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var hasOwnProperty = objectProto.hasOwnProperty,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * Checks if `value` is an `arguments` object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
   * @example
   *
   * (function() { return _.isArguments(arguments); })(1, 2, 3);
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == argsClass || false;
  }
  // fallback for browsers that can't detect `arguments` objects by [[Class]]
  if (!support.argsClass) {
    isArguments = function(value) {
      return value && typeof value == 'object' && typeof value.length == 'number' &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee') || false;
    };
  }

  return isArguments;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(92), __webpack_require__(79), __webpack_require__(36), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(bind, identity, setBindData, support) {

  /** Used to detected named functions */
  var reFuncName = /^\s*function[ \n\r\t]+\w/;

  /** Used to detect functions containing a `this` reference */
  var reThis = /\bthis\b/;

  /** Native method shortcuts */
  var fnToString = Function.prototype.toString;

  /**
   * The base implementation of `_.createCallback` without support for creating
   * "_.pluck" or "_.where" style callbacks.
   *
   * @private
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   */
  function baseCreateCallback(func, thisArg, argCount) {
    if (typeof func != 'function') {
      return identity;
    }
    // exit early for no `thisArg` or already bound by `Function#bind`
    if (typeof thisArg == 'undefined' || !('prototype' in func)) {
      return func;
    }
    var bindData = func.__bindData__;
    if (typeof bindData == 'undefined') {
      if (support.funcNames) {
        bindData = !func.name;
      }
      bindData = bindData || !support.funcDecomp;
      if (!bindData) {
        var source = fnToString.call(func);
        if (!support.funcNames) {
          bindData = !reFuncName.test(source);
        }
        if (!bindData) {
          // checks if `func` references the `this` keyword and stores the result
          bindData = reThis.test(source);
          setBindData(func, bindData);
        }
      }
    }
    // exit early if there are no `this` references or `func` is bound
    if (bindData === false || (bindData !== true && bindData[1] & 1)) {
      return func;
    }
    switch (argCount) {
      case 1: return function(value) {
        return func.call(thisArg, value);
      };
      case 2: return function(a, b) {
        return func.call(thisArg, a, b);
      };
      case 3: return function(value, index, collection) {
        return func.call(thisArg, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(thisArg, accumulator, value, index, collection);
      };
    }
    return bind(func, thisArg);
  }

  return baseCreateCallback;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isNative, noop) {

  /** Used as the property descriptor for `__bindData__` */
  var descriptor = {
    'configurable': false,
    'enumerable': false,
    'value': null,
    'writable': false
  };

  /** Used to set meta data on functions */
  var defineProperty = (function() {
    // IE 8 only accepts DOM elements
    try {
      var o = {},
          func = isNative(func = Object.defineProperty) && func,
          result = func(o, o, o) && func;
    } catch(e) { }
    return result;
  }());

  /**
   * Sets `this` binding data on a given function.
   *
   * @private
   * @param {Function} func The function to set data on.
   * @param {Array} value The data array to set.
   */
  var setBindData = !defineProperty ? noop : function(func, value) {
    descriptor.value = value;
    defineProperty(func, '__bindData__', descriptor);
  };

  return setBindData;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(13), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _bonzo, _qwery) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _bonzo2 = _interopRequireDefault(_bonzo);

    var _qwery2 = _interopRequireDefault(_qwery);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    // Warning: side effect. This patches the bonzo module for use everywhere
    _bonzo2.default.aug({
        height: function height() {
            return this.dim().height;
        }
    });

    var $ = function $(selector, context) {
        return (0, _bonzo2.default)((0, _qwery2.default)(selector, context));
    };

    $.create = function (s) {
        return (0, _bonzo2.default)(_bonzo2.default.create(s));
    };

    // #? duplicated in lib/closest.js?
    $.ancestor = function (el, className) {
        if (el === null || el === undefined || el.nodeName.toLowerCase() === 'html') {
            return null;
        }
        if (!el.parentNode || (0, _bonzo2.default)(el.parentNode).hasClass(className)) {
            return el.parentNode;
        }
        return $.ancestor(el.parentNode, className);
    };

    // #? does this offer any value?
    $.forEachElement = function (selector, fn) {
        var els = (0, _qwery2.default)(selector);
        els.forEach(fn);
        return els;
    };

    // #es6 can be named exports once we're es6-only
    // eslint-disable-next-line guardian-frontend/no-default-export
    exports.default = $;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(13),
    __webpack_require__(5),
    __webpack_require__(28),
    __webpack_require__(14),
    __webpack_require__(55)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    bonzo,
    qwery,
    fetchJSON,
    assign,
    clone
) {

    /**
     * TODO (jamesgorrie):
     * * ERROR HANDLING!
     * * Find a way to run the Component constructor manually,
     *   Perhaps in the create method somewhere.
     * @constructor
     */
    var Component = function () {};

    /** @type {boolean} */
    Component.prototype.useBem = false;

    /** @type {string} */
    Component.prototype.templateName = null;

    /** @type {string} */
    Component.prototype.componentClass = null;

    /** @type {string} */
    Component.prototype.endpoint = null;

    /** @type {Object.<string.string>} */
    Component.prototype.classes = null;

    /** @type {Element|null} */
    Component.prototype.elem = null;

    /** @type {Object|string|null} */
    Component.prototype.model = null;

    /** @type {Object|string|null} */
    Component.prototype.template = null;

    /** @type {boolean} */
    Component.prototype.rendered = false;

    /** @type {boolean} */
    Component.prototype.destroyed = false;

    /** @type {Object.<string.Element>} */
    Component.prototype.elems = null;

    /** @type {Object.<string.*>} */
    Component.prototype.options = null;

    /** @type {Object.<string.*>} */
    Component.prototype.defaultOptions = {};

    /** @type {String} */
    Component.prototype.responseDataKey = 'html';

    /** @type {Boolean} */
    Component.prototype.autoupdated = false;

    /** @type {Number} in seconds */
    Component.prototype.updateEvery = 60;

    /** @type {Number} id of autoupdate timer */
    Component.prototype.t = null;

    /** @type {Object.<string.*>} data to send with fetch */
    Component.prototype.fetchData = null;

    /** @type {String} */
    Component.prototype.manipulationType = 'append';

    /**
     * Uses the this.componentClass
     * TODO (jamesgorrie): accept strings etc Also what to do with multiple objects?
     * @param {Element|string=} elem (optional)
     */
    Component.prototype.attachTo = function (elem) {
        this.checkAttached();
        if (!elem) {
            throw new ComponentError('Need element to attach to');
        } else {
            this.elem = elem;
            this._prerender();
            this._ready();
        }
    };

    /**
     * @param {Element=} parent (optional)
     */
    Component.prototype.render = function (parent) {
        this.checkAttached();
        var template = this.template;

        if (!template && this.templateName) {
            var templateEl = document.getElementById('tmpl-' + this.templateName);

            if (templateEl) {
                template = templateEl.innerHTML;
            }
        }

        if (template) {
            this.elem = bonzo.create(template)[0];
            this._prerender();
            bonzo(parent || document.body)[this.manipulationType](this.elem);
        }

        this._ready();
        return this;
    };

    /**
     * Throws an error if this is already attached to the DOM
     */
    Component.prototype.checkAttached = function () {
        if (this.rendered) {
            throw new ComponentError('Already rendered');
        }
    };

    /**
     * @param {Element} parent
     * @param {String} key
     * @return {Promise}
     */
    Component.prototype.fetch = function (parent, key) {
        this.checkAttached();

        this.responseDataKey = key || this.responseDataKey;
        var self = this;

        return this._fetch()
            .then(function render(resp) {
                self.elem = bonzo.create(resp[self.responseDataKey])[0];
                self._prerender();

                if (!self.destroyed) {
                    bonzo(parent)[self.manipulationType](self.elem);
                    self._ready(self.elem);
                }
            })
            .catch(self.error);
    };

    /**
     * @return Promise
     */
    Component.prototype._fetch = function () {
        var endpoint = (typeof this.endpoint === 'function') ? this.endpoint() : this.endpoint,
            self = this,
            opt;

        for (opt in this.options) {
            endpoint = endpoint.replace(':' + opt, this.options[opt]);
        }

        return fetchJSON(endpoint, {
            mode: 'cors',
            body: this.fetchData
        }).then(function (resp) {
            self.fetched(resp);
            return resp;
        });
    };

    /**
     * This is just used to set up the component internally
     */
    Component.prototype._ready = function (elem) {
        if (!this.destroyed) {
            this.rendered = true;
            this._autoupdate();
            this.ready(elem);
        }
    };

    /**
     * Used as we need for pre-prerendering
     */
    Component.prototype._prerender = function () {
        this.elems = {};
        this.prerender();
    };

    /**
     * Check if we should auto update, if so, do so
     */
    Component.prototype._autoupdate = function () {
        var self = this;
        var setAutoUpdate = function() {
            self.t = setTimeout(update, self.updateEvery * 1000);
        };

        function update() {
            self._fetch()
                .then(function (resp) {
                    self.autoupdate(bonzo.create(resp[self.responseDataKey])[0]);

                    if (self.autoupdated) {
                        setAutoUpdate();
                    }
                })
                .catch(function () {
                    setAutoUpdate();
                });
        }

        if (this.autoupdated) {
            setAutoUpdate();
        }
    };

    /**
     * This is user to edit this.elem before it's rendered
     * This will help with the rendering performance that
     * we would lose if rendered then manipulated
     */
    Component.prototype.prerender = function () {};

    /**
     * Once the render / decorate methods have been called
     * This is where you could do your event binding
     * This function is made to be overridden
     */
    Component.prototype.ready = function () {};

    /**
     * Once the render / decorate methods have been called
     * This is where you could do your error event binding
     * This function is made to be overridden
     */
    Component.prototype.error = function () {};

    /**
     * This is called whenever a fetch occurs. This includes
     * explicit fetch calls and autoupdate.
     */
    Component.prototype.fetched = function () {};

    /**
     * @param {Element} elem new element
     */
    Component.prototype.autoupdate = function (elem) {
        var oldElem = this.elem;
        this.elem = elem;

        this._prerender();
        bonzo(oldElem).replaceWith(this.elem);
    };

    /**
     * Once we're done with it, remove event bindings etc
     */
    Component.prototype.dispose = function () {};

    /**
     * @param {string} eventName
     * @param {Element|Function} elem if ommited which is also handler
     * @param {Function} handler
     */
    Component.prototype.on = function (eventName, elem, handler) {
        if (typeof elem === 'function') {
            handler = elem;
            bean.on(this.elem, eventName, handler.bind(this));
        } else {
            elem = !elem.length ? [elem] : elem;
            bean.on(this.elem, eventName, elem, handler.bind(this));
        }
        return this;
    };

    /**
     * @param {string} eventName
     * @param {Object=} args (optional)
     */
    Component.prototype.emit = function (eventName, args) {
        bean.fire(this.elem, eventName, args);
    };

    /**
     * TODO: After working on comments, wondering if this should support NodeLists
     * @param {string} elemName this corresponds to this.classes
     */
    Component.prototype.getElem = function (elemName) {
        if (this.elems[elemName]) { return this.elems[elemName]; }

        var elem = qwery(this.getClass(elemName), this.elem)[0];
        this.elems[elemName] = elem;

        return elem;
    };

    /**
     * @param {string} eventName
     * @param {boolean} sansDot
     * @return {string}
     */
    Component.prototype.getClass = function (elemName, sansDot) {
        var className = this.useBem ? this.componentClass + '__' + elemName : this.classes[elemName];

        return (sansDot ? '' : '.') + className;
    };

    /**
     * @param {string} state
     * @param {string|null} elemName
     */
    Component.prototype.setState = function (state, elemName) {
        var elem = elemName ? this.getElem(elemName) : this.elem;
        bonzo(elem).addClass(this.componentClass + (elemName ? '__' + elemName : '') + '--' + state);
    };

    /**
     * @param {string|null} state
     * @param {string|null} elemName
     * return {Boolean}
     */
    Component.prototype.removeState = function (state, elemName) {
        var elem = elemName ? this.getElem(elemName) : this.elem;
        return bonzo(elem).removeClass(this.componentClass + (elemName ? '__' + elemName : '') + '--' + state);
    };

    /**
     * @param {string} state
     * @param {string|null} elemName
     */
    Component.prototype.toggleState = function (state, elemName) {
        var elem = elemName ? this.getElem(elemName) : this.elem;
        bonzo(elem).toggleClass(this.componentClass + (elemName ? '__' + elemName : '') + '--' + state);
    };

    /**
     * @param {string|null} state
     * @param {string|null} elemName
     * return {Boolean}
     */
    Component.prototype.hasState = function (state, elemName) {
        var elem = elemName ? this.getElem(elemName) : this.elem;
        return bonzo(elem).hasClass(this.componentClass + (elemName ? '__' + elemName : '') + '--' + state);
    };

    /**
     * @param {Object} options
     */
    Component.prototype.setOptions = function (options) {
        this.options = assign(clone(this.defaultOptions), this.options || {}, options);
    };

    /**
     * Removes the event handling, leave the DOM
     */
    Component.prototype.detach = function () {
        bean.off(this.elem);
    };

    /**
     * Removes all event listeners and removes the DOM elem
     */
    Component.prototype.destroy = function () {
        if (this.elem) {
            bonzo(this.elem).remove();
            delete this.elem;
        }

        clearTimeout(this.t);
        this.t = null;
        this.autoupdated = false;

        this.detach();
        this.destroyed = true;
        this.rendered = false;
    };

    /**
     * @param {Function} child
     */
    Component.define = function (child) {
        function Tmp() {}
        Tmp.prototype = Component.prototype;
        child.prototype = new Tmp();
        child.prototype.constructor = child;
    };

    /** @contructor */
    function ComponentError(message) {
        return new Error('Component: ' + message);
    }

    return Component;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * A no-operation function.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.noop(object) === undefined;
   * // => true
   */
  function noop() {
    // no operation performed
  }

  return noop;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(52)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayPool) {

  /**
   * Gets an array from the array pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Array} The array from the pool.
   */
  function getArray() {
    return arrayPool.pop() || [];
  }

  return getArray;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(52), __webpack_require__(78)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayPool, maxPoolSize) {

  /**
   * Releases the given array back to the array pool.
   *
   * @private
   * @param {Array} [array] The array to release.
   */
  function releaseArray(array) {
    array.length = 0;
    if (arrayPool.length < maxPoolSize) {
      arrayPool.push(array);
    }
  }

  return releaseArray;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used to pool arrays and objects used internally */
  var arrayPool = [];

  return arrayPool;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(1), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isNative, isObject, noop) {

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  function baseCreate(prototype, properties) {
    return isObject(prototype) ? nativeCreate(prototype) : {};
  }
  // fallback for browsers without `Object.create`
  if (!nativeCreate) {
    baseCreate = (function() {
      function Object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          Object.prototype = prototype;
          var result = new Object;
          Object.prototype = null;
        }
        return result || window.Object();
      };
    }());
  }

  return baseCreate;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(94), __webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseClone, baseCreateCallback) {

  /**
   * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
   * be cloned, otherwise they will be assigned by reference. If a callback
   * is provided it will be executed to produce the cloned values. If the
   * callback returns `undefined` cloning will be handled by the method instead.
   * The callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep=false] Specify a deep clone.
   * @param {Function} [callback] The function to customize cloning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the cloned value.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * var shallow = _.clone(characters);
   * shallow[0] === characters[0];
   * // => true
   *
   * var deep = _.clone(characters, true);
   * deep[0] === characters[0];
   * // => false
   *
   * _.mixin({
   *   'clone': _.partialRight(_.clone, function(value) {
   *     return _.isElement(value) ? value.cloneNode(false) : undefined;
   *   })
   * });
   *
   * var clone = _.clone(document.body);
   * clone.childNodes.length;
   * // => 0
   */
  function clone(value, isDeep, callback, thisArg) {
    // allows working with "Collections" methods without using their `index`
    // and `collection` arguments for `isDeep` and `callback`
    if (typeof isDeep != 'boolean' && isDeep != null) {
      thisArg = callback;
      callback = isDeep;
      isDeep = false;
    }
    return baseClone(value, isDeep, typeof callback == 'function' && baseCreateCallback(callback, thisArg, 1));
  }

  return clone;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(24), __webpack_require__(65)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator, eachIteratorOptions, forOwnIteratorOptions) {

  /**
   * Iterates over own enumerable properties of an object, executing the callback
   * for each property. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, key, object). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
   *   console.log(key);
   * });
   * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
   */
  var forOwn = createIterator(eachIteratorOptions, forOwnIteratorOptions);

  return forOwn;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** `Object#toString` result shortcuts */
  var stringClass = '[object String]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /**
   * Checks if `value` is a string.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
   * @example
   *
   * _.isString('fred');
   * // => true
   */
  function isString(value) {
    return typeof value == 'string' ||
      value && typeof value == 'object' && toString.call(value) == stringClass || false;
  }

  return isString;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * Checks if `value` is a DOM node in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a DOM node, else `false`.
   */
  function isNode(value) {
    // IE < 9 presents DOM nodes as `Object` objects except they have `toString`
    // methods that are `typeof` "string" and still can coerce nodes to strings
    return typeof value.toString != 'function' && typeof (value + '') == 'string';
  }

  return isNode;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys) {

  /** Reusable iterator options for `assign` and `defaults` */
  var defaultsIteratorOptions = {
    'args': 'object, source, guard',
    'top':
      'var args = arguments,\n' +
      '    argsIndex = 0,\n' +
      "    argsLength = typeof guard == 'number' ? 2 : args.length;\n" +
      'while (++argsIndex < argsLength) {\n' +
      '  iterable = args[argsIndex];\n' +
      '  if (iterable && objectTypes[typeof iterable]) {',
    'keys': keys,
    'loop': "if (typeof result[index] == 'undefined') result[index] = iterable[index]",
    'bottom': '  }\n}'
  };

  return defaultsIteratorOptions;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function(eachIteratorOptions) {

  /** Reusable iterator options for `forIn` and `forOwn` */
  var forOwnIteratorOptions = {
    'top': 'if (!objectTypes[typeof iterable]) return result;\n' + eachIteratorOptions.top,
    'array': false
  };

  return forOwnIteratorOptions;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _fastdom) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _fastdom2 = _interopRequireDefault(_fastdom);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var promisify = function promisify(fdaction) {
        return function (fn, ctx) {
            return new Promise(function (resolve, reject) {
                return fdaction(
                /* this function needs to be bound to ctx - it therefore cannot
                       be an arrow function as this will be bound with the current
                       context and cannot be rebound.
                    */
                function () {
                    try {
                        resolve(fn.call(this));
                    } catch (e) {
                        reject(e);
                    }
                }, ctx);
            });
        };
    };
    exports.default = {
        read: promisify(_fastdom2.default.read.bind(_fastdom2.default)),
        write: promisify(_fastdom2.default.write.bind(_fastdom2.default))
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(19),
    __webpack_require__(5),
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(75)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    qwery,
    $,
    config,
    fastdomPromise
) {
    return function (props) {
        this.id = props.id;
        this.start = props.start;
        this.expiry = props.end;
        this.author = props.author;
        this.audienceOffset = props.audienceOffset;
        this.audience = props.audience;

        this.description = 'Using the wonderful frontend AB testing framework to AB test emails, since the AB ' +
            'function in ExactTarget re-randomises all recipients on each send, and we need users to receive their ' +
            'variant for several weeks. This test will ensure users are added to the corresponding email list ' +
            '(listId) in ExactTarget';
        this.successMeasure = 'We can trial different email formats to fairly compare their CTO rates';
        this.audienceCriteria = 'All users who see an email signup box';
        this.dataLinkNames = '';
        this.idealOutcome = '';

        var SIGNUP_URL = props.signupPage;
        var CANONICAL_LIST_ID = props.canonicalListId;

        this.canRun = function () {
            return (SIGNUP_URL && (config.page.contentId === SIGNUP_URL)) || config.page.pageId === '/email-newsletters';
        };

        this.variants = props.testIds.map(function(variant) {
            return {
                id: variant.variantId,
                test: function () {
                    if (SIGNUP_URL && config.page.contentId === SIGNUP_URL) {
                        enhanceWebView(variant.listId);
                    } else {
                        updateNewslettersPage(variant.listId);
                    }
                }
            };
        });

        function enhanceWebView(emailListId) {
            var emailForm = $('.js-email-sub__iframe')[0];
            emailForm.setAttribute('src', 'https://www.theguardian.com/email/form/plaintone/' + emailListId);
        }

        function updateNewslettersPage(emailListId) {
            return fastdomPromise.write(function () {
                var input = $('input[value="' + CANONICAL_LIST_ID + '"]')[0];
                var button = $('button[value="' + CANONICAL_LIST_ID + '"]')[0];
                input.setAttribute('value', emailListId);
                button.setAttribute('value', emailListId);
            });
        }
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used as the max size of the `arrayPool` and `objectPool` */
  var maxPoolSize = 40;

  return maxPoolSize;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * This method returns the first argument provided to it.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.identity(object) === object;
   * // => true
   */
  function identity(value) {
    return value;
  }

  return identity;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * The base implementation of `_.indexOf` without support for binary searches
   * or `fromIndex` constraints.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  return baseIndexOf;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(229),
    __webpack_require__(129),
    __webpack_require__(322),
    __webpack_require__(187),
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(30),
    __webpack_require__(257),
    __webpack_require__(75),
    __webpack_require__(4),
    __webpack_require__(7),
    __webpack_require__(132),
    __webpack_require__(76),
    __webpack_require__(14),
    __webpack_require__(21),
    __webpack_require__(235),
    __webpack_require__(190)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    uniq,
    commercialFeatures,
    targetingTool,
    viewLog,
    $,
    config,
    cookies,
    ElementInView,
    fastdom,
    mediator,
    storage,
    geolocation,
    url,
    assign,
    template,
    toArray,
    acquisitionsEpicControlTemplate
) {

    var membershipBaseURL = 'https://membership.theguardian.com/supporter';
    var contributionsBaseURL = 'https://contribute.theguardian.com';

    var lastContributionDate = cookies.getCookie('gu.contributions.contrib-timestamp');

    /**
     * How many times the user can see the Epic, e.g. 6 times within 7 days with minimum of 1 day in between views.
     * @type {{days: number, count: number, minDaysBetweenViews: number}}
     */
    var maxViews = {
        days: 30,
        count: 4,
        minDaysBetweenViews: 0
    };

    function daysSince(date) {
        var oneDay = 24 * 60 * 60 * 1000;

        try {
            var ms = Date.parse(date);

            if (isNaN(ms)) return Infinity;
            return (new Date() - ms) / oneDay;
        } catch(e) {
            return Infinity;
        }
    }

    function controlTemplate(variant) {
        return template(acquisitionsEpicControlTemplate, {
            membershipUrl: variant.membershipURL,
            contributionUrl: variant.contributeURL,
            componentName: variant.componentName
        });
    }

    function doTagsMatch(options) {
        return options.useTargetingTool ? targetingTool.isAbTestTargeted(options) : true;
    }

    // Returns an array containing:
    // - the first element matching insertAtSelector, if isMultiple is false or not supplied
    // - all elements matching insertAtSelector, if isMultiple is true
    // - or an empty array if the selector doesn't match anything on the page
    function getTargets(insertAtSelector, isMultiple) {
        var els = document.querySelectorAll(insertAtSelector);

        if (isMultiple) {
            return toArray(els);
        } else if (els.length) {
            return [els[0]];
        }

        return [];
    }

    function defaultCanEpicBeDisplayed(testConfig) {
        var enoughTimeSinceLastContribution = daysSince(lastContributionDate) >= 90;

        var worksWellWithPageTemplate = (typeof testConfig.pageCheck === 'function')
            ? testConfig.pageCheck(config.page)
            : config.page.contentType === 'Article' && !config.page.isMinuteArticle;

        var storedGeolocation = geolocation.getSync();
        var inCompatibleLocation = testConfig.locations ? testConfig.locations.some(function (geo) {
            return geo === storedGeolocation;
        }) : true;
        var locationCheck = (typeof testConfig.locationCheck === 'function') ? testConfig.locationCheck(storedGeolocation) : true;

        var isImmersive = config.page.isImmersive === true;

        var tagsMatch = doTagsMatch(testConfig);

        var canReasonablyAskForMoney = commercialFeatures.canReasonablyAskForMoney;

        return enoughTimeSinceLastContribution &&
            canReasonablyAskForMoney &&
            worksWellWithPageTemplate &&
            inCompatibleLocation &&
            locationCheck &&
            !isImmersive &&
            tagsMatch
    }

    function ContributionsABTest(options) {
        this.id = options.id;
        this.epic = options.epic || true;
        this.start = options.start;
        this.expiry = options.expiry;
        this.author = options.author;
        this.idealOutcome = options.idealOutcome;
        this.campaignId = options.campaignId;
        this.description = options.description;
        this.showForSensitive = options.showForSensitive || false;
        this.audience = options.audience;
        this.audienceOffset = options.audienceOffset;
        this.successMeasure = options.successMeasure;
        this.audienceCriteria = options.audienceCriteria;
        this.dataLinkNames = options.dataLinkNames || '';
        this.campaignPrefix = options.campaignPrefix || 'gdnwb_copts_memco';
        this.campaignSuffix = options.campaignSuffix || '';
        this.insertEvent = this.makeEvent('insert');
        this.viewEvent = this.makeEvent('view');
        this.isEngagementBannerTest = options.isEngagementBannerTest || false;

        /**
         * Provides a default `canRun` function with typical rules (see function below) for Contributions messages.
         * If your test provides its own `canRun` option, it will be included in the check.
         *
         * You can alternatively use the `overrideCanRun` option, which, if true, will only use the `canRun`
         * option provided and ignore the rules here (except for the targeting tool tags check, which will still be
         * honoured if `useTargetingTool` is provided alongside `overrideCanRun`.
         *
         * @type {Function}
         */
        this.canRun = (function () {
            if (options.overrideCanRun) {
                return doTagsMatch(options) && options.canRun();
            }

            var testCanRun = (typeof options.canRun === 'function') ? options.canRun() : true;
            return testCanRun && defaultCanEpicBeDisplayed(options);
        }).bind(this);

        this.variants = options.variants.map(function (variant) {
            return new ContributionsABTestVariant(variant, this);
        }.bind(this));
    }

    ContributionsABTest.prototype.makeEvent = function (event) {
        return this.id + ':' + event;
    };

    function ContributionsABTestVariant(options, test) {
        var trackingCampaignId = test.epic ? 'epic_' + test.campaignId : test.campaignId;

        this.campaignId = test.campaignId;
        this.id = options.id;
        this.maxViews = options.maxViews || maxViews;
        this.isUnlimited = options.isUnlimited || false;

        this.pageviewId = (config.ophan && config.ophan.pageViewId) || 'not_found';
        this.campaignCode = getCampaignCode(test.campaignPrefix, this.campaignId, this.id, test.campaignSuffix);
        this.campaignCodes = [this.campaignCode];

        this.contributeURL = options.contributeURL || this.getURL(contributionsBaseURL, this.campaignCode);
        this.membershipURL = options.membershipURL || this.getURL(membershipBaseURL, this.campaignCode);

        this.componentName = 'mem_acquisition_' + trackingCampaignId + '_' + this.id;

        this.template = options.template || controlTemplate;

        this.blockEngagementBanner = options.blockEngagementBanner || false;
        this.engagementBannerParams = options.engagementBannerParams || {};

        this.isOutbrainCompliant = options.isOutbrainCompliant || false;

        this.test = function () {

            var displayEpic = (typeof options.canEpicBeDisplayed === 'function') ?
                options.canEpicBeDisplayed(test) : true;

            if (!displayEpic) {
                return;
            }

            var onInsert = options.onInsert || noop;
            var onView = options.onView || noop;

            function render(templateFn) {
                var template = templateFn || this.template;
                var component = $.create(template(this));

                mediator.emit('register:begin', trackingCampaignId);
                return fastdom.write(function () {
                    var targets = [];

                    if (!options.insertAtSelector) {
                        targets = getTargets('.submeta', false);
                    } else {
                        targets = getTargets(options.insertAtSelector, options.insertMultiple);
                    }

                    if (targets.length > 0) {
                        if (options.insertAfter) {
                            component.insertAfter(targets);
                        } else {
                            component.insertBefore(targets);
                        }

                        mediator.emit(test.insertEvent, component);
                        onInsert(component);

                        component.each(function (element) {
                            // top offset of 18 ensures view only counts when half of element is on screen
                            var elementInView = ElementInView(element, window, { top: 18 });

                            elementInView.on('firstview', function () {
                                viewLog.logView(test.id);
                                mediator.emit(test.viewEvent);
                                mediator.emit('register:end', trackingCampaignId);
                                onView(this);
                            });
                        });
                    }
                }.bind(this));
            }

            return (typeof options.test === 'function') ? options.test(render.bind(this)) : render.apply(this);
        };

        this.registerListener('impression', 'impressionOnInsert', test.insertEvent, options);
        this.registerListener('success', 'successOnView', test.viewEvent, options);
    }

    function getCampaignCode(campaignCodePrefix, campaignID, id, campaignCodeSuffix) {
        var suffix = campaignCodeSuffix ? ('_' + campaignCodeSuffix) : '';
        return campaignCodePrefix + '_' + campaignID + '_' + id + suffix;
    }

    ContributionsABTestVariant.prototype.getURL = function(base, campaignCode) {
        var params = {
            REFPVID: this.pageviewId,
            INTCMP: campaignCode
        };
        return base + '?' + url.constructQuery(params);
    };


    ContributionsABTestVariant.prototype.contributionsURLBuilder = function(codeModifier) {
        return this.getURL(contributionsBaseURL, codeModifier(this.campaignCode));
    };

    ContributionsABTestVariant.prototype.membershipURLBuilder = function(codeModifier) {
        return this.getURL(membershipBaseURL, codeModifier(this.campaignCode));
    };

    ContributionsABTestVariant.prototype.registerListener = function (type, defaultFlag, event, options) {
        if (options[type]) this[type] = options[type];
        else if (options[defaultFlag]) {
            this[type] = (function (track) {
                return mediator.on(event, track);
            }).bind(this);
        }
    };

    function noop() {}

    // Utility function to build variants with common properties.
    function variantBuilderFactory(commonVariantProps) {
        return function(id, variantProps) {
            return assign({}, commonVariantProps, {id: id}, variantProps)
        }
    }

    return {
        defaultCanEpicBeDisplayed: defaultCanEpicBeDisplayed,
        makeABTest: function (test) {
            // this is so it can be instantiated with `new` later
            return function () {
                return new ContributionsABTest(test);
            };
        },

        variantBuilderFactory: variantBuilderFactory
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(93), __webpack_require__(95), __webpack_require__(12), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseBind, baseCreateWrapper, isFunction, slice) {

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Native method shortcuts */
  var push = arrayRef.push,
      unshift = arrayRef.unshift;

  /**
   * Creates a function that, when called, either curries or invokes `func`
   * with an optional `this` binding and partially applied arguments.
   *
   * @private
   * @param {Function|string} func The function or method name to reference.
   * @param {number} bitmask The bitmask of method flags to compose.
   *  The bitmask may be composed of the following flags:
   *  1 - `_.bind`
   *  2 - `_.bindKey`
   *  4 - `_.curry`
   *  8 - `_.curry` (bound)
   *  16 - `_.partial`
   *  32 - `_.partialRight`
   * @param {Array} [partialArgs] An array of arguments to prepend to those
   *  provided to the new function.
   * @param {Array} [partialRightArgs] An array of arguments to append to those
   *  provided to the new function.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {number} [arity] The arity of `func`.
   * @returns {Function} Returns the new function.
   */
  function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        isPartial = bitmask & 16,
        isPartialRight = bitmask & 32;

    if (!isBindKey && !isFunction(func)) {
      throw new TypeError;
    }
    if (isPartial && !partialArgs.length) {
      bitmask &= ~16;
      isPartial = partialArgs = false;
    }
    if (isPartialRight && !partialRightArgs.length) {
      bitmask &= ~32;
      isPartialRight = partialRightArgs = false;
    }
    var bindData = func && func.__bindData__;
    if (bindData && bindData !== true) {
      // clone `bindData`
      bindData = slice(bindData);
      if (bindData[2]) {
        bindData[2] = slice(bindData[2]);
      }
      if (bindData[3]) {
        bindData[3] = slice(bindData[3]);
      }
      // set `thisBinding` is not previously bound
      if (isBind && !(bindData[1] & 1)) {
        bindData[4] = thisArg;
      }
      // set if previously bound but not currently (subsequent curried functions)
      if (!isBind && bindData[1] & 1) {
        bitmask |= 8;
      }
      // set curried arity if not yet set
      if (isCurry && !(bindData[1] & 4)) {
        bindData[5] = arity;
      }
      // append partial left arguments
      if (isPartial) {
        push.apply(bindData[2] || (bindData[2] = []), partialArgs);
      }
      // append partial right arguments
      if (isPartialRight) {
        unshift.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
      }
      // merge flags
      bindData[1] |= bitmask;
      return createWrapper.apply(null, bindData);
    }
    // fast path for `_.bind`
    var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
    return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
  }

  return createWrapper;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys) {

  /**
   * Creates an array composed of the own enumerable property values of `object`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property values.
   * @example
   *
   * _.values({ 'one': 1, 'two': 2, 'three': 3 });
   * // => [1, 2, 3] (property order is not guaranteed across environments)
   */
  function values(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = Array(length);

    while (++index < length) {
      result[index] = object[props[index]];
    }
    return result;
  }

  return values;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * Used to convert characters to HTML entities:
   *
   * Though the `>` character is escaped for symmetry, characters like `>` and `/`
   * don't require escaping in HTML and have no special meaning unless they're part
   * of a tag or an unquoted attribute value.
   * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
   */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  return htmlEscapes;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used to match "interpolate" template delimiters */
  var reInterpolate = /<%=([\s\S]+?)%>/g;

  return reInterpolate;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(143), __webpack_require__(9), __webpack_require__(145)], __WEBPACK_AMD_DEFINE_RESULT__ = function(escapeHtmlChar, keys, reUnescapedHtml) {

  /**
   * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
   * corresponding HTML entities.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} string The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('Fred, Wilma, & Pebbles');
   * // => 'Fred, Wilma, &amp; Pebbles'
   */
  function escape(string) {
    return string == null ? '' : String(string).replace(reUnescapedHtml, escapeHtmlChar);
  }

  return escape;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(85), __webpack_require__(6), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createWrapper, slice, support) {

  /**
   * Creates a function that, when called, invokes `func` with the `this`
   * binding of `thisArg` and prepends any additional `bind` arguments to those
   * provided to the bound function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to bind.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {...*} [arg] Arguments to be partially applied.
   * @returns {Function} Returns the new bound function.
   * @example
   *
   * var func = function(greeting) {
   *   return greeting + ' ' + this.name;
   * };
   *
   * func = _.bind(func, { 'name': 'fred' }, 'hi');
   * func();
   * // => 'hi fred'
   */
  function bind(func, thisArg) {
    return arguments.length > 2
      ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
      : createWrapper(func, 1, null, null, thisArg);
  }

  return bind;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(1), __webpack_require__(36), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreate, isObject, setBindData, slice) {

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Native method shortcuts */
  var push = arrayRef.push;

  /**
   * The base implementation of `_.bind` that creates the bound function and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new bound function.
   */
  function baseBind(bindData) {
    var func = bindData[0],
        partialArgs = bindData[2],
        thisArg = bindData[4];

    function bound() {
      // `Function#bind` spec
      // http://es5.github.io/#x15.3.4.5
      if (partialArgs) {
        // avoid `arguments` object deoptimizations by using `slice` instead
        // of `Array.prototype.slice.call` and not assigning `arguments` to a
        // variable as a ternary expression
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      // mimic the constructor's `return` behavior
      // http://es5.github.io/#x13.2.2
      if (this instanceof bound) {
        // ensure `new bound` is an instance of `func`
        var thisBinding = baseCreate(func.prototype),
            result = func.apply(thisBinding, args || arguments);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisArg, args || arguments);
    }
    setBindData(bound, bindData);
    return bound;
  }

  return baseBind;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(23), __webpack_require__(60), __webpack_require__(50), __webpack_require__(8), __webpack_require__(63), __webpack_require__(1), __webpack_require__(51), __webpack_require__(6), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(assign, baseEach, forOwn, getArray, isArray, isNode, isObject, releaseArray, slice, support) {

  /** Used to match regexp flags from their coerced string values */
  var reFlags = /\w*$/;

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
      arrayClass = '[object Array]',
      boolClass = '[object Boolean]',
      dateClass = '[object Date]',
      funcClass = '[object Function]',
      numberClass = '[object Number]',
      objectClass = '[object Object]',
      regexpClass = '[object RegExp]',
      stringClass = '[object String]';

  /** Used to identify object classifications that `_.clone` supports */
  var cloneableClasses = {};
  cloneableClasses[funcClass] = false;
  cloneableClasses[argsClass] = cloneableClasses[arrayClass] =
  cloneableClasses[boolClass] = cloneableClasses[dateClass] =
  cloneableClasses[numberClass] = cloneableClasses[objectClass] =
  cloneableClasses[regexpClass] = cloneableClasses[stringClass] = true;

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to lookup a built-in constructor by [[Class]] */
  var ctorByClass = {};
  ctorByClass[arrayClass] = Array;
  ctorByClass[boolClass] = Boolean;
  ctorByClass[dateClass] = Date;
  ctorByClass[funcClass] = Function;
  ctorByClass[objectClass] = Object;
  ctorByClass[numberClass] = Number;
  ctorByClass[regexpClass] = RegExp;
  ctorByClass[stringClass] = String;

  /**
   * The base implementation of `_.clone` without argument juggling or support
   * for `thisArg` binding.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep=false] Specify a deep clone.
   * @param {Function} [callback] The function to customize cloning values.
   * @param {Array} [stackA=[]] Tracks traversed source objects.
   * @param {Array} [stackB=[]] Associates clones with source counterparts.
   * @returns {*} Returns the cloned value.
   */
  function baseClone(value, isDeep, callback, stackA, stackB) {
    if (callback) {
      var result = callback(value);
      if (typeof result != 'undefined') {
        return result;
      }
    }
    // inspect [[Class]]
    var isObj = isObject(value);
    if (isObj) {
      var className = toString.call(value);
      if (!cloneableClasses[className] || (!support.nodeClass && isNode(value))) {
        return value;
      }
      var ctor = ctorByClass[className];
      switch (className) {
        case boolClass:
        case dateClass:
          return new ctor(+value);

        case numberClass:
        case stringClass:
          return new ctor(value);

        case regexpClass:
          result = ctor(value.source, reFlags.exec(value));
          result.lastIndex = value.lastIndex;
          return result;
      }
    } else {
      return value;
    }
    var isArr = isArray(value);
    if (isDeep) {
      // check for circular references and return corresponding clone
      var initedStack = !stackA;
      stackA || (stackA = getArray());
      stackB || (stackB = getArray());

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      result = isArr ? ctor(value.length) : {};
    }
    else {
      result = isArr ? slice(value) : assign({}, value);
    }
    // add array properties assigned by `RegExp#exec`
    if (isArr) {
      if (hasOwnProperty.call(value, 'index')) {
        result.index = value.index;
      }
      if (hasOwnProperty.call(value, 'input')) {
        result.input = value.input;
      }
    }
    // exit for shallow clone
    if (!isDeep) {
      return result;
    }
    // add the source value to the stack of traversed objects
    // and associate it with its clone
    stackA.push(value);
    stackB.push(result);

    // recursively populate clone (susceptible to call stack limits)
    (isArr ? baseEach : forOwn)(value, function(objValue, key) {
      result[key] = baseClone(objValue, isDeep, callback, stackA, stackB);
    });

    if (initedStack) {
      releaseArray(stackA);
      releaseArray(stackB);
    }
    return result;
  }

  return baseClone;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(1), __webpack_require__(36), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreate, isObject, setBindData, slice) {

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Native method shortcuts */
  var push = arrayRef.push;

  /**
   * The base implementation of `createWrapper` that creates the wrapper and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new function.
   */
  function baseCreateWrapper(bindData) {
    var func = bindData[0],
        bitmask = bindData[1],
        partialArgs = bindData[2],
        partialRightArgs = bindData[3],
        thisArg = bindData[4],
        arity = bindData[5];

    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        key = func;

    function bound() {
      var thisBinding = isBind ? thisArg : this;
      if (partialArgs) {
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      if (partialRightArgs || isCurry) {
        args || (args = slice(arguments));
        if (partialRightArgs) {
          push.apply(args, partialRightArgs);
        }
        if (isCurry && args.length < arity) {
          bitmask |= 16 & ~32;
          return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
        }
      }
      args || (args = arguments);
      if (isBindKey) {
        func = thisBinding[key];
      }
      if (this instanceof bound) {
        thisBinding = baseCreate(func.prototype);
        var result = func.apply(thisBinding, args);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisBinding, args);
    }
    setBindData(bound, bindData);
    return bound;
  }

  return baseCreateWrapper;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used internally to indicate various things */
  var indicatorObject = {};

  return indicatorObject;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(support) {

  /**
   * The template used to create iterator functions.
   *
   * @private
   * @param {Object} data The data object used to populate the text.
   * @returns {string} Returns the interpolated text.
   */
  var iteratorTemplate = function(obj) {

    var __p = 'var index, iterable = ' +
    (obj.firstArg) +
    ', result = ' +
    (obj.init) +
    ';\nif (!iterable) return result;\n' +
    (obj.top) +
    ';';
     if (obj.array) {
    __p += '\nvar length = iterable.length; index = -1;\nif (' +
    (obj.array) +
    ') {  ';
     if (support.unindexedChars) {
    __p += '\n  if (isString(iterable)) {\n    iterable = iterable.split(\'\')\n  }  ';
     }
    __p += '\n  while (++index < length) {\n    ' +
    (obj.loop) +
    ';\n  }\n}\nelse {  ';
     } else if (support.nonEnumArgs) {
    __p += '\n  var length = iterable.length; index = -1;\n  if (length && isArguments(iterable)) {\n    while (++index < length) {\n      index += \'\';\n      ' +
    (obj.loop) +
    ';\n    }\n  } else {  ';
     }

     if (support.enumPrototypes) {
    __p += '\n  var skipProto = typeof iterable == \'function\';\n  ';
     }

     if (support.enumErrorProps) {
    __p += '\n  var skipErrorProps = iterable === errorProto || iterable instanceof Error;\n  ';
     }

        var conditions = [];    if (support.enumPrototypes) { conditions.push('!(skipProto && index == "prototype")'); }    if (support.enumErrorProps)  { conditions.push('!(skipErrorProps && (index == "message" || index == "name"))'); }

     if (obj.useHas && obj.keys) {
    __p += '\n  var ownIndex = -1,\n      ownProps = objectTypes[typeof iterable] && keys(iterable),\n      length = ownProps ? ownProps.length : 0;\n\n  while (++ownIndex < length) {\n    index = ownProps[ownIndex];\n';
        if (conditions.length) {
    __p += '    if (' +
    (conditions.join(' && ')) +
    ') {\n  ';
     }
    __p +=
    (obj.loop) +
    ';    ';
     if (conditions.length) {
    __p += '\n    }';
     }
    __p += '\n  }  ';
     } else {
    __p += '\n  for (index in iterable) {\n';
        if (obj.useHas) { conditions.push("hasOwnProperty.call(iterable, index)"); }    if (conditions.length) {
    __p += '    if (' +
    (conditions.join(' && ')) +
    ') {\n  ';
     }
    __p +=
    (obj.loop) +
    ';    ';
     if (conditions.length) {
    __p += '\n    }';
     }
    __p += '\n  }    ';
     if (support.nonEnumShadows) {
    __p += '\n\n  if (iterable !== objectProto) {\n    var ctor = iterable.constructor,\n        isProto = iterable === (ctor && ctor.prototype),\n        className = iterable === stringProto ? stringClass : iterable === errorProto ? errorClass : toString.call(iterable),\n        nonEnum = nonEnumProps[className];\n      ';
     for (k = 0; k < 7; k++) {
    __p += '\n    index = \'' +
    (obj.shadowedProps[k]) +
    '\';\n    if ((!(isProto && nonEnum[index]) && hasOwnProperty.call(iterable, index))';
            if (!obj.useHas) {
    __p += ' || (!nonEnum[index] && iterable[index] !== objectProto[index])';
     }
    __p += ') {\n      ' +
    (obj.loop) +
    ';\n    }      ';
     }
    __p += '\n  }    ';
     }

     }

     if (obj.array || support.nonEnumArgs) {
    __p += '\n}';
     }
    __p +=
    (obj.bottom) +
    ';\nreturn result';

    return __p
  };

  return iteratorTemplate;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator) {

  /**
   * A fallback implementation of `Object.keys` which produces an array of the
   * given object's own enumerable property names.
   *
   * @private
   * @type Function
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   */
  var shimKeys = createIterator({
    'args': 'object',
    'init': '[]',
    'top': 'if (!(objectTypes[typeof object])) return result',
    'loop': 'result.push(index)'
  });

  return shimKeys;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(30),
    __webpack_require__(0),
    __webpack_require__(28),
    __webpack_require__(7),
    __webpack_require__(81)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    cookies,
    config,
    fetchJson,
    storage,
    identity
) {
    // Persistence keys
    var USER_FEATURES_EXPIRY_COOKIE = 'gu_user_features_expiry';
    var PAYING_MEMBER_COOKIE = 'gu_paying_member';
    var AD_FREE_USER_COOKIE = 'GU_AFU';

    function UserFeatures() {
        // Exposed for testing
        this._requestNewData = requestNewData;
        this._deleteOldData = deleteOldData;
        this._persistResponse = persistResponse;
    }

    /**
     * Updates the user's data in a lazy fashion
     */
    UserFeatures.prototype.refresh = function () {
        if (identity.isUserLoggedIn() && userNeedsNewFeatureData()) {
            this._requestNewData();
        } else if (userHasDataAfterSignout()) {
            this._deleteOldData();
        }
    };

    /**
     * Does our _existing_ data say the user is a paying member?
     * This data may be stale; we do not wait for userFeatures.refresh()
     * @returns {boolean}
     */
    UserFeatures.prototype.isPayingMember = function () {
        // If the user is logged in, but has no cookie yet, play it safe and assume they're a paying user
        return identity.isUserLoggedIn()
            && (cookies.getCookie(PAYING_MEMBER_COOKIE) !== 'false');
    };

    UserFeatures.prototype.isAdFreeUser = function () {
        if (cookies.getCookie(AD_FREE_USER_COOKIE) === null) {
            this.refresh();
        }
        return cookies.getCookie(AD_FREE_USER_COOKIE) === 'true';
    };

    function userNeedsNewFeatureData() {
        return featuresDataIsMissing() || featuresDataIsOld();
    }

    function featuresDataIsMissing() {
        return !cookies.getCookie(USER_FEATURES_EXPIRY_COOKIE)
            || !cookies.getCookie(PAYING_MEMBER_COOKIE)
            || !cookies.getCookie(AD_FREE_USER_COOKIE);
    }

    function featuresDataIsOld() {
        var featuresExpiryCookie = cookies.getCookie(USER_FEATURES_EXPIRY_COOKIE);
        var featuresExpiryTime = parseInt(featuresExpiryCookie, 10);
        var timeNow = new Date().getTime();
        return timeNow >= featuresExpiryTime;
    }

    function userHasDataAfterSignout() {
        return !identity.isUserLoggedIn() && userHasData();
    }

    function userHasData() {
        return cookies.getCookie(USER_FEATURES_EXPIRY_COOKIE)
            || cookies.getCookie(PAYING_MEMBER_COOKIE)
            || cookies.getCookie(AD_FREE_USER_COOKIE);
    }

    function requestNewData() {
        fetchJson(config.page.userAttributesApiUrl + '/me/features', {
            mode: 'cors',
            credentials: 'include'
        })
        .then(persistResponse)
        .catch(function () {});
    }

    function persistResponse(JsonResponse) {
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 1);
        cookies.addCookie(USER_FEATURES_EXPIRY_COOKIE, expiryDate.getTime().toString());
        cookies.addCookie(PAYING_MEMBER_COOKIE, !JsonResponse.adblockMessage);
        cookies.addCookie(AD_FREE_USER_COOKIE, JsonResponse.adFree);
    }

    function deleteOldData() {
        // We expect adfree cookies to be cleaned up by the logout process, but what if the user's login simply times out?
        cookies.removeCookie(USER_FEATURES_EXPIRY_COOKIE);
        cookies.removeCookie(PAYING_MEMBER_COOKIE);
        cookies.removeCookie(AD_FREE_USER_COOKIE);
    }

    return new UserFeatures();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(24), __webpack_require__(65)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator, eachIteratorOptions, forOwnIteratorOptions) {

  /**
   * Iterates over own and inherited enumerable properties of an object,
   * executing the callback for each property. The callback is bound to `thisArg`
   * and invoked with three arguments; (value, key, object). Callbacks may exit
   * iteration early by explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * Shape.prototype.move = function(x, y) {
   *   this.x += x;
   *   this.y += y;
   * };
   *
   * _.forIn(new Shape, function(value, key) {
   *   console.log(key);
   * });
   * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
   */
  var forIn = createIterator(eachIteratorOptions, forOwnIteratorOptions, {
    'useHas': false
  });

  return forIn;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(18),
    __webpack_require__(131),
    __webpack_require__(122),
    __webpack_require__(81),
    __webpack_require__(128)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config,
    detect,
    robust,
    userFeatures,
    identityApi,
    userPrefs
) {
    // Having a constructor means we can easily re-instantiate the object in a test
    function CommercialFeatures() {
        var self = this;

        // this is used for SpeedCurve tests
        var noadsUrl = window.location.hash.match(/[#&]noads(&.*)?$/);

        var externalAdvertising =
            !noadsUrl &&
            !userPrefs.isOff('adverts');

        var sensitiveContent =
            config.page.shouldHideAdverts ||
            config.page.section === 'childrens-books-site';

        var isMinuteArticle = config.page.isMinuteArticle;

        var isArticle = config.page.contentType === 'Article';

        var isInteractive = config.page.contentType === 'Interactive';

        var isLiveBlog = config.page.isLiveBlog;

        var isHosted = config.page.isHosted;

        var isMatchReport = config.hasTone('Match reports');

        var isIdentityPage =
            config.page.contentType === 'Identity' ||
            config.page.section === 'identity'; // needed for pages under profile.* subdomain

        var switches = config.switches;

        var isWidePage = detect.getBreakpoint() === 'wide';

        var supportsSticky = document.documentElement.classList.contains('has-sticky');

        var newRecipeDesign = config.page.showNewRecipeDesign && config.tests.abNewRecipeDesign;

        // Feature switches

        this.dfpAdvertising =
            switches.commercial &&
            externalAdvertising &&
            !sensitiveContent;

        this.stickyTopBannerAd =
            !config.page.disableStickyTopBanner &&
            !supportsSticky;

        this.articleBodyAdverts =
            this.dfpAdvertising &&
            !isMinuteArticle &&
            isArticle &&
            !isLiveBlog &&
            !isHosted &&
            !newRecipeDesign;

        this.articleAsideAdverts =
            this.dfpAdvertising &&
            !isMinuteArticle &&
            !isMatchReport &&
            !!(isArticle || isLiveBlog) &&
            !newRecipeDesign;

        this.videoPreRolls =
            this.dfpAdvertising;

        this.highMerch =
            this.dfpAdvertising &&
            !isMinuteArticle &&
            !isHosted &&
            !isInteractive &&
            !config.page.isFront &&
            !newRecipeDesign;

        this.thirdPartyTags =
            externalAdvertising &&
            !isIdentityPage;

        this.outbrain =
            this.dfpAdvertising &&
            switches.outbrain &&
            isArticle &&
            !config.page.isPreview &&
            config.page.showRelatedContent &&
            !(identityApi.isUserLoggedIn() && config.page.commentable);

        this.commentAdverts =
            this.dfpAdvertising &&
            !isMinuteArticle &&
            config.switches.discussion &&
            config.page.commentable &&
            identityApi.isUserLoggedIn() &&
            (!isLiveBlog || isWidePage);

        this.liveblogAdverts =
            isLiveBlog &&
            this.dfpAdvertising;

        this.paidforBand =
            config.page.isPaidContent &&
            !config.page.hasSuperStickyBanner &&
            !supportsSticky;

        this.canReasonablyAskForMoney = // eg become a supporter, give a contribution
            !(userFeatures.isPayingMember() || config.page.shouldHideAdverts || config.page.isPaidContent);

        this.async = {
            canDisplayMembershipEngagementBanner : detect.adblockInUse.then(function (adblockUsed) {
                return !adblockUsed && self.canReasonablyAskForMoney;
            })
        };
    }

    try {
        config.commercial = config.commercial || {};
        return config.commercial.featuresDebug = new CommercialFeatures();
    } catch (error) {
        robust.logError('cm-commercialFeatures', error);
    }

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(23), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreateCallback, baseEach, isArray) {

  /**
   * Iterates over elements of a collection, executing the callback for each
   * element. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * Note: As with other "Collections" methods, objects with a `length` property
   * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
   * may be used for object iteration.
   *
   * @static
   * @memberOf _
   * @alias each
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   * @example
   *
   * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
   * // => logs each number and returns '1,2,3'
   *
   * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
   * // => logs each number and returns the object (property order is not guaranteed across environments)
   */
  function forEach(collection, callback, thisArg) {
    if (callback && typeof thisArg == 'undefined' && isArray(collection)) {
      var index = -1,
          length = collection.length;

      while (++index < length) {
        if (callback(collection[index], index, collection) === false) {
          break;
        }
      }
    } else {
      baseEach(collection, callback, thisArg);
    }
    return collection;
  }

  return forEach;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(28), __webpack_require__(0), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fetchJson, _config, _storage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.setGeolocation = exports.init = exports.isInEurope = exports.getSync = exports.getSupporterPaymentRegion = exports.get = undefined;

    var _fetchJson2 = _interopRequireDefault(_fetchJson);

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var storageKey = 'gu.geolocation';

    var editionToGeolocationMap = {
        UK: 'GB',
        US: 'US',
        AU: 'AU'
    };
    var daysBeforeGeolocationRefresh = 10;

    var getFromStorage = function getFromStorage() {
        return _storage.local.get(storageKey);
    };

    var get = function get() {
        return new Promise(function (resolve, reject) {
            var geolocationFromStorage = getFromStorage();

            if (geolocationFromStorage) {
                return resolve(geolocationFromStorage);
            }

            (0, _fetchJson2.default)('/geolocation', {
                headers: {
                    'Content-Type': 'application/json'
                },
                mode: 'cors'
            }).then(function (response) {
                if (response.country) {
                    resolve(response.country);
                } else {
                    reject('No country in geolocation response', response);
                }
            }).catch(reject);
        });
    };

    var setGeolocation = function setGeolocation(geolocation) {
        var currentDate = new Date();
        _storage.local.set(storageKey, geolocation, {
            expires: currentDate.setDate(currentDate.getDate() + daysBeforeGeolocationRefresh)
        });
    };

    var init = function init() {
        get().then(setGeolocation);
    };

    var editionToGeolocation = function editionToGeolocation() {
        var editionKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UK';
        return editionToGeolocationMap[editionKey];
    };

    var getSync = function getSync() {
        var geolocationFromStorage = getFromStorage();
        return geolocationFromStorage || editionToGeolocation(_config2.default.page.edition);
    };

    var regionCountryCodes = ['AU', 'CA', 'GB', 'US'];

    var europeCountryCodes = ['AD', 'AL', 'AT', 'BA', 'BE', 'BG', 'BL', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GF', 'GL', 'GP', 'GR', 'HR', 'HU', 'IE', 'IT', 'LI', 'LT', 'LU', 'LV', 'MC', 'ME', 'MF', 'IS', 'MQ', 'MT', 'NL', 'NO', 'PF', 'PL', 'PM', 'PT', 'RE', 'RO', 'RS', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TF', 'TR', 'WF', 'YT', 'VA', 'AX'];

    // Returns one of { GB, US, AU, CA, EU, INT }
    // These are the different 'regions' we accept when taking payment.
    // See https://membership.theguardian.com/uk/supporter# for more context.
    var getSupporterPaymentRegion = function getSupporterPaymentRegion(location) {
        if (regionCountryCodes.includes(location)) {
            return getSync();
        }
        if (europeCountryCodes.includes(location)) {
            return 'EU';
        }
        return 'INT';
    };

    var isInEurope = function isInEurope() {
        var countryCode = getSync();
        return europeCountryCodes.includes(countryCode) || countryCode === 'GB';
    };

    // Exposed for unit testing
    exports.get = get;
    exports.getSupporterPaymentRegion = getSupporterPaymentRegion;
    exports.getSync = getSync;
    exports.isInEurope = isInEurope;
    exports.init = init;
    exports.setGeolocation = setGeolocation;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArguments, isArray) {

  /**
   * The base implementation of `_.flatten` without support for callback
   * shorthands or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
   * @param {number} [fromIndex=0] The index to start from.
   * @returns {Array} Returns a new flattened array.
   */
  function baseFlatten(array, isShallow, isStrict, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (value && typeof value == 'object' && typeof value.length == 'number'
          && (isArray(value) || isArguments(value))) {
        // recursively flatten arrays (susceptible to call stack limits)
        if (!isShallow) {
          value = baseFlatten(value, isShallow, isStrict);
        }
        var valIndex = -1,
            valLength = value.length,
            resIndex = result.length;

        result.length += valLength;
        while (++valIndex < valLength) {
          result[resIndex++] = value[valIndex];
        }
      } else if (!isStrict) {
        result.push(value);
      }
    }
    return result;
  }

  return baseFlatten;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.testCanBeRun = exports.isExpired = undefined;

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var isTestSwitchedOn = function isTestSwitchedOn(test) {
        return _config2.default.switches['ab' + test.id];
    };

    var isExpired = exports.isExpired = function isExpired(testExpiry) {
        // new Date(test.expiry) sets the expiry time to 00:00:00
        // Using SetHours allows a test to run until the END of the expiry day
        var startOfToday = new Date().setHours(0, 0, 0, 0);
        return startOfToday > new Date(testExpiry);
    };

    var testCanBeRun = exports.testCanBeRun = function testCanBeRun(test) {
        var expired = isExpired(test.expiry);
        var isSensitive = _config2.default.page.isSensitive;
        return (isSensitive ? !!test.showForSensitive : true) && isTestSwitchedOn(test) && !expired && (!test.canRun || test.canRun());
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124), __webpack_require__(50), __webpack_require__(31), __webpack_require__(12), __webpack_require__(63), __webpack_require__(33), __webpack_require__(51), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(forIn, getArray, isArguments, isFunction, isNode, objectTypes, releaseArray, support) {

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
      arrayClass = '[object Array]',
      boolClass = '[object Boolean]',
      dateClass = '[object Date]',
      numberClass = '[object Number]',
      objectClass = '[object Object]',
      regexpClass = '[object RegExp]',
      stringClass = '[object String]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.isEqual`, without support for `thisArg` binding,
   * that allows partial "_.where" style comparisons.
   *
   * @private
   * @param {*} a The value to compare.
   * @param {*} b The other value to compare.
   * @param {Function} [callback] The function to customize comparing values.
   * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
   * @param {Array} [stackA=[]] Tracks traversed `a` objects.
   * @param {Array} [stackB=[]] Tracks traversed `b` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(a, b, callback, isWhere, stackA, stackB) {
    // used to indicate that when comparing objects, `a` has at least the properties of `b`
    if (callback) {
      var result = callback(a, b);
      if (typeof result != 'undefined') {
        return !!result;
      }
    }
    // exit early for identical values
    if (a === b) {
      // treat `+0` vs. `-0` as not equal
      return a !== 0 || (1 / a == 1 / b);
    }
    var type = typeof a,
        otherType = typeof b;

    // exit early for unlike primitive values
    if (a === a &&
        !(a && objectTypes[type]) &&
        !(b && objectTypes[otherType])) {
      return false;
    }
    // exit early for `null` and `undefined` avoiding ES3's Function#call behavior
    // http://es5.github.io/#x15.3.4.4
    if (a == null || b == null) {
      return a === b;
    }
    // compare [[Class]] names
    var className = toString.call(a),
        otherClass = toString.call(b);

    if (className == argsClass) {
      className = objectClass;
    }
    if (otherClass == argsClass) {
      otherClass = objectClass;
    }
    if (className != otherClass) {
      return false;
    }
    switch (className) {
      case boolClass:
      case dateClass:
        // coerce dates and booleans to numbers, dates to milliseconds and booleans
        // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
        return +a == +b;

      case numberClass:
        // treat `NaN` vs. `NaN` as equal
        return (a != +a)
          ? b != +b
          // but treat `+0` vs. `-0` as not equal
          : (a == 0 ? (1 / a == 1 / b) : a == +b);

      case regexpClass:
      case stringClass:
        // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
        // treat string primitives and their corresponding object instances as equal
        return a == String(b);
    }
    var isArr = className == arrayClass;
    if (!isArr) {
      // unwrap any `lodash` wrapped values
      var aWrapped = hasOwnProperty.call(a, '__wrapped__'),
          bWrapped = hasOwnProperty.call(b, '__wrapped__');

      if (aWrapped || bWrapped) {
        return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, callback, isWhere, stackA, stackB);
      }
      // exit for functions and DOM nodes
      if (className != objectClass || (!support.nodeClass && (isNode(a) || isNode(b)))) {
        return false;
      }
      // in older versions of Opera, `arguments` objects have `Array` constructors
      var ctorA = !support.argsObject && isArguments(a) ? Object : a.constructor,
          ctorB = !support.argsObject && isArguments(b) ? Object : b.constructor;

      // non `Object` object instances with different constructors are not equal
      if (ctorA != ctorB &&
            !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
            ('constructor' in a && 'constructor' in b)
          ) {
        return false;
      }
    }
    // assume cyclic structures are equal
    // the algorithm for detecting cyclic structures is adapted from ES 5.1
    // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
    var initedStack = !stackA;
    stackA || (stackA = getArray());
    stackB || (stackB = getArray());

    var length = stackA.length;
    while (length--) {
      if (stackA[length] == a) {
        return stackB[length] == b;
      }
    }
    var size = 0;
    result = true;

    // add `a` and `b` to the stack of traversed objects
    stackA.push(a);
    stackB.push(b);

    // recursively compare objects and arrays (susceptible to call stack limits)
    if (isArr) {
      // compare lengths to determine if a deep comparison is necessary
      length = a.length;
      size = b.length;
      result = size == length;

      if (result || isWhere) {
        // deep compare the contents, ignoring non-numeric properties
        while (size--) {
          var index = length,
              value = b[size];

          if (isWhere) {
            while (index--) {
              if ((result = baseIsEqual(a[index], value, callback, isWhere, stackA, stackB))) {
                break;
              }
            }
          } else if (!(result = baseIsEqual(a[size], value, callback, isWhere, stackA, stackB))) {
            break;
          }
        }
      }
    }
    else {
      // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
      // which, in this case, is more costly
      forIn(b, function(value, key, b) {
        if (hasOwnProperty.call(b, key)) {
          // count the number of properties.
          size++;
          // deep compare each property value.
          return (result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, callback, isWhere, stackA, stackB));
        }
      });

      if (result && !isWhere) {
        // ensure both objects have the same number of properties
        forIn(a, function(value, key, a) {
          if (hasOwnProperty.call(a, key)) {
            // `size` will be `-1` if `a` has more properties than `b`
            return (result = --size > -1);
          }
        });
      }
    }
    stackA.pop();
    stackB.pop();

    if (initedStack) {
      releaseArray(stackA);
      releaseArray(stackB);
    }
    return result;
  }

  return baseIsEqual;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (
) {
    function buildGoogleAnalyticsEvent(mediaEvent, metrics, canonicalUrl, player, eventAction, videoId) {

        var category = 'media';
        var playerName = player;
        var action = eventAction(mediaEvent);
        var fieldsObject = {
            eventCategory: category,
            eventAction: action,
            eventLabel: canonicalUrl,
            dimension19: videoId,
            dimension20: playerName
        };
        // Increment the appropriate metric based on the event type
        var metricId = metrics[mediaEvent.eventType];
        if (metricId) {
            fieldsObject[metricId] = 1;
        }
        return fieldsObject;
    }

    function getGoogleAnalyticsEventAction(mediaEvent) {
        var action = mediaEvent.mediaType + ' ';
        if (mediaEvent.isPreroll) {
            action += 'preroll';
        } else {
            action += 'content';
        }
        return action;
    }

    return {
        buildGoogleAnalyticsEvent: buildGoogleAnalyticsEvent,
        getGoogleAnalyticsEventAction: getGoogleAnalyticsEventAction
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(87)], __WEBPACK_AMD_DEFINE_RESULT__ = function(htmlEscapes) {

  /**
   * Used by `escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(match) {
    return htmlEscapes[match];
  }

  return escapeHtmlChar;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used to escape characters for inclusion in compiled string literals */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\t': 't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /**
   * Used by `template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(match) {
    return '\\' + stringEscapes[match];
  }

  return escapeStringChar;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(87), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(htmlEscapes, keys) {

  /** Used to match HTML entities and HTML characters */
  var reUnescapedHtml = RegExp('[' + keys(htmlEscapes).join('') + ']', 'g');

  return reUnescapedHtml;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createIterator, defaultsIteratorOptions) {

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object for all destination properties that resolve to `undefined`. Once a
   * property is set, additional defaults of the same property will be ignored.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param- {Object} [guard] Allows working with `_.reduce` without using its
   *  `key` and `object` arguments as sources.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * var object = { 'name': 'barney' };
   * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  var defaults = createIterator(defaultsIteratorOptions);

  return defaults;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * Creates a "_.pluck" style function, which returns the `key` value of a
   * given object.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} key The name of the property to retrieve.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var characters = [
   *   { 'name': 'fred',   'age': 40 },
   *   { 'name': 'barney', 'age': 36 }
   * ];
   *
   * var getName = _.property('name');
   *
   * _.map(characters, getName);
   * // => ['barney', 'fred']
   *
   * _.sortBy(characters, getName);
   * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
   */
  function property(key) {
    return function(object) {
      return object[key];
    };
  }

  return property;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(89), __webpack_require__(88)], __WEBPACK_AMD_DEFINE_RESULT__ = function(escape, reInterpolate) {

  /**
   * By default, the template delimiters used by Lo-Dash are similar to those in
   * embedded Ruby (ERB). Change the following template settings to use alternative
   * delimiters.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  var templateSettings = {

    /**
     * Used to detect `data` property values to be HTML-escaped.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'escape': /<%-([\s\S]+?)%>/g,

    /**
     * Used to detect code to be evaluated.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'evaluate': /<%([\s\S]+?)%>/g,

    /**
     * Used to detect `data` property values to inject.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'interpolate': reInterpolate,

    /**
     * Used to reference the data object in the template text.
     *
     * @memberOf _.templateSettings
     * @type string
     */
    'variable': '',

    /**
     * Used to import variables into the compiled template.
     *
     * @memberOf _.templateSettings
     * @type Object
     */
    'imports': {

      /**
       * A reference to the `lodash` function.
       *
       * @memberOf _.templateSettings.imports
       * @type Function
       */
      '_': { 'escape': escape }
    }
  };

  return templateSettings;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(29), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, createCallback, isArray) {

  /**
   * Creates an array of values by running each element in the collection
   * through the callback. The callback is bound to `thisArg` and invoked with
   * three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias collect
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of the results of each `callback` execution.
   * @example
   *
   * _.map([1, 2, 3], function(num) { return num * 3; });
   * // => [3, 6, 9]
   *
   * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
   * // => [3, 6, 9] (property order is not guaranteed across environments)
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.map(characters, 'name');
   * // => ['barney', 'fred']
   */
  function map(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    callback = createCallback(callback, thisArg, 3);
    if (isArray(collection)) {
      while (++index < length) {
        result[index] = callback(collection[index], index, collection);
      }
    } else {
      baseEach(collection, function(value, key, collection) {
        result[++index] = callback(value, key, collection);
      });
    }
    return result;
  }

  return map;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(78), __webpack_require__(189)], __WEBPACK_AMD_DEFINE_RESULT__ = function(maxPoolSize, objectPool) {

  /**
   * Releases the given object back to the object pool.
   *
   * @private
   * @param {Object} [object] The object to release.
   */
  function releaseObject(object) {
    var cache = object.cache;
    if (cache) {
      releaseObject(cache);
    }
    object.array = object.cache = object.criteria = object.object = object.number = object.string = object.value = null;
    if (objectPool.length < maxPoolSize) {
      objectPool.push(object);
    }
  }

  return releaseObject;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(41), __webpack_require__(301)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _memoize, _mvtCookie) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.variantFor = exports.isInTest = exports.variantIdFor = undefined;

    var _memoize2 = _interopRequireDefault(_memoize);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var NOT_IN_TEST = 'notintest';


    var getId = function getId(test) {
        return test.id;
    }; // use test ids as memo cache keys

    /**
     * Determine whether the user is in the test or not and return the associated
     * variant ID.
     *
     * The test population is just a subset of mvt ids. A test population must
     * begin from a specific value. Overlapping test ranges are permitted.
     *
     * @return {String} variant ID
     */
    var computeVariantIdFor = function computeVariantIdFor(test) {
        var smallestTestId = (0, _mvtCookie.getMvtNumValues)() * test.audienceOffset;
        var largestTestId = smallestTestId + (0, _mvtCookie.getMvtNumValues)() * test.audience;
        var mvtCookieId = Number((0, _mvtCookie.getMvtValue)());

        if (mvtCookieId && mvtCookieId > smallestTestId && mvtCookieId <= largestTestId) {
            // This mvt test id is in the test range, so allocate it to a test variant.
            var variantIds = test.variants.map(getId);

            return variantIds[mvtCookieId % variantIds.length];
        }

        return NOT_IN_TEST;
    };

    var variantIdFor = exports.variantIdFor = (0, _memoize2.default)(computeVariantIdFor, getId);

    var isInTest = exports.isInTest = function isInTest(test) {
        return variantIdFor(test) !== NOT_IN_TEST;
    };

    var variantFor = exports.variantFor = function variantFor(test) {
        var variantId = variantIdFor(test);
        return test.variants.filter(function (variant) {
            return variant.id === variantId;
        })[0];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _storage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.viewsInPreviousDays = exports.logView = undefined;
    var viewKey = 'gu.contributions.views';
    var viewLog = _storage.local.get(viewKey) || [];

    var maxLogEntries = 50;

    /**
     * Log that the user has seen an Epic test so we can limit how many times they see it.
     * The number of entries is limited to the number in maxLogEntries.
     *
     * @param testId
     */
    var logView = exports.logView = function logView(testId) {
        viewLog.push({
            date: new Date().getTime(),
            testId: testId
        });

        _storage.local.set(viewKey, viewLog.slice(-maxLogEntries));
    };

    var viewsInPreviousDays = exports.viewsInPreviousDays = function viewsInPreviousDays(days, test) {
        var ms = days * 1000 * 60 * 60 * 24;
        var now = new Date().getTime();

        return viewLog.filter(function (view) {
            return (test ? view.testId === test.id : true) && view.date > now - ms;
        }).length;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(338)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fetchData) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getSuggestedSurvey = exports.isRegular = undefined;

    var _fetchData2 = _interopRequireDefault(_fetchData);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /**
     * Given a response from tailor, we see if the response has a survey suggestion, and if so return the first
     * survey suggestion (there should only ever be one, but just in case).
     */
    var getSuggestedSurvey = function getSuggestedSurvey(queryParams) {
        return (0, _fetchData2.default)('suggestions', false, queryParams).then(function (response) {
            if (response.suggestions) {
                var surveySuggestions = response.suggestions.filter(function (suggestion) {
                    return suggestion.class === 'SurveySuggestion';
                });

                if (surveySuggestions.length > 0) {
                    return surveySuggestions[0];
                }
            }
        });
    };

    /**
     * Query the user's regular status
     */

    var isRegular = function isRegular() {
        return (0, _fetchData2.default)('suggestions', false).then(function (suggestions) {
            try {
                return suggestions.userDataForClient.regular;
            } catch (e) {
                return false;
            }
        }).catch(function () {
            return false;
        });
    };

    exports.isRegular = isRegular;
    exports.getSuggestedSurvey = getSuggestedSurvey;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used to pool arrays and objects used internally */
  var objectPool = [];

  return objectPool;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Since you’re here …\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            … we’ve got a small favour to ask. More people are reading the Guardian than ever, but far fewer are paying for it. Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\">unlike many news organisations, we haven’t put up a paywall &ndash; we want to keep our journalism as open as we can</span>. So you can see why we need to ask for your help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters &ndash; because it might well be your perspective, too.\n        </p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\"\n               href=\"<%=membershipUrl%>\"\n               target=\"_blank\">\n                Become a supporter\n            </a>\n        </div>\n\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\"\n               href=\"<%=contributionUrl%>\"\n               target=\"_blank\">\n                Make a contribution\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _mediator) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _mediator2 = _interopRequireDefault(_mediator);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var analyticsReady = false;


    _mediator2.default.on('analytics:ready', function () {
        analyticsReady = true;
    });

    var deferToAnalytics = function deferToAnalytics(afterAnalytics) {
        if (analyticsReady) {
            afterAnalytics();
        } else {
            _mediator2.default.on('analytics:ready', function () {
                afterAnalytics();
            });
        }
    };

    exports.default = deferToAnalytics;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var defaults = {
        controls: true,
        textTrackDisplay: false,
        textTrackSettings: false,
        controlBar: {
            children: ['playToggle', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'fullscreenToggle', 'volumeMenuButton']
        },
        // `autoplay` is always set to false.
        // If you are going to set autoplay to any other value, note it breaks
        // `preload="auto"` on < Chrome 35 and `preload="metadata"` on old Safari
        autoplay: false,
        preload: 'metadata',
        techOrder: ['html5'],
        notSupportedMessage: 'This video is no longer available.'
    };

    exports.default = function () {
        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, defaults, overrides);
    };

    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 193 */,
/* 194 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pamplemousse\">\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n</div>\n"

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(13)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    bonzo
) {
    function fullscreener() {
        var player = this,
            clickbox = bonzo.create('<div class="vjs-fullscreen-clickbox"></div>')[0],
            events = {
                click: function (e) {
                    if (this.paused()) {
                        this.play();
                    } else {
                        this.pause();
                    }
                    e.stop();
                },
                dblclick: function (e) {
                    e.stop();
                    if (this.isFullscreen()) {
                        this.exitFullscreen();
                    } else {
                        this.requestFullscreen();
                    }
                }
            };

        bonzo(clickbox)
            .appendTo(player.contentEl());

        bean.on(clickbox, 'click', events.click.bind(player));
        bean.on(clickbox, 'dblclick', events.dblclick.bind(player));

        player.on('fullscreenchange', function () {
            if (this.isFullscreen()) {
                player.trigger('player:fullscreen');
            }
        });
    }

    return fullscreener;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(5),
    __webpack_require__(4),
    __webpack_require__(57),
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(18),
    __webpack_require__(241),
    __webpack_require__(306),
    __webpack_require__(236),
    __webpack_require__(60),
    __webpack_require__(140),
    __webpack_require__(40)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    qwery,
    mediator,
    reportError,
    $,
    config,
    detect,
    history,
    indexOf,
    throttle,
    forOwn,
    gaHelper,
    ophan
) {
    var isDesktop = detect.isBreakpoint({ min: 'desktop' }),
        isEmbed = !!window.guardian.isEmbed,
        QUARTILES = [25, 50, 75],
        // Advert and content events used by analytics. The expected order of bean events is:
        EVENTS = [
            'preroll:request',
            'preroll:ready',
            'preroll:play',
            'preroll:end',
            'content:ready',
            'content:play',
            'content:end'
        ],
        gaTracker = config.googleAnalytics.trackers.editorial;

    /**
     *
     * @param mediaId {string}
     * @param mediaType {string} audio|video
     * @param eventType {string} e.g. firstplay, firstend
     * @param isPreroll {boolean}
     * @returns {{mediaId: string, mediaType: string, eventType: string, isPreroll: boolean}}
     */
    function MediaEvent(mediaId, mediaType, eventType, isPreroll) {
        return {
            mediaId: mediaId,
            mediaType: mediaType,
            eventType: eventType,
            isPreroll: isPreroll
        };
    }

    function bindCustomMediaEvents(eventsMap, player, mediaId, mediaType, isPreroll) {
        forOwn(eventsMap, function(value, key) {
            var fullEventName = 'media:' + value;
            var mediaEvent = MediaEvent(mediaId, mediaType, value, isPreroll);

            player.one(key, function() {
                player.trigger(fullEventName, mediaEvent);
                mediator.emit(fullEventName, mediaEvent);
            });
        });
    }

    function addContentEvents(player, mediaId, mediaType) {
        var eventsMap = {
            ready: 'ready',
            play: 'play',
            passed25: 'watched25',
            passed50: 'watched50',
            passed75: 'watched75',
            ended: 'end'
        };

        player.on('timeupdate', throttle(function() {
            var percent = Math.round((player.currentTime() / player.duration()) * 100);

            if (percent >= 25) {
                player.trigger('passed25');
            }
            if (percent >= 50) {
                player.trigger('passed50');
            }
            if (percent >= 75) {
                player.trigger('passed75');
            }
        }, 1000));

        bindCustomMediaEvents(eventsMap, player, mediaId, mediaType, false);
    }

    function addPrerollEvents(player, mediaId, mediaType) {
        var eventsMap = {
            'adstart': 'play',
            'adend': 'end',
            'adsready': 'ready',
            // This comes from the skipAd plugin
            'adskip': 'skip'
        };

        bindCustomMediaEvents(eventsMap, player, mediaId, mediaType, true);
    }

    function bindGoogleAnalyticsEvents(player, canonicalUrl) {
        var events = {
            'play': 'metric1',
            'skip': 'metric2',
            'watched25': 'metric3',
            'watched50': 'metric4',
            'watched75': 'metric5',
            'end': 'metric6'
        };

        Object.keys(events).map(function(eventName) {
            return 'media:' + eventName;
        }).forEach(function(playerEvent) {
            player.on(playerEvent, function(_, mediaEvent) {
                window.ga(gaTracker + '.send', 'event', gaHelper.buildGoogleAnalyticsEvent(mediaEvent, events, canonicalUrl,
                    'guardian-videojs', gaHelper.getGoogleAnalyticsEventAction, mediaEvent.mediaId));
            });
        });
    }

    function getMediaType(player) {
        return isEmbed ? 'video' : player.guMediaType;
    }

    function shouldAutoPlay(player) {
        return isDesktop && !history.isRevisit(config.page.pageId) && player.guAutoplay;
    }

    function constructEventName(eventName, player) {
        return getMediaType(player) + ':' + eventName;
    }

    function ophanRecord(id, event, player) {
        if (!id) return;

        function record(ophan) {
            var eventObject = {};
            eventObject[getMediaType(player)] = {
                id: id,
                eventType: event.type
            };
            ophan.record(eventObject);
        }

        if (isEmbed) {
            __webpack_require__.e/* require.ensure */(1).then((function (require) {
                record(__webpack_require__(375));
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
            record(ophan);
        }
    }

    function initOphanTracking(player, mediaId) {
        EVENTS.concat(QUARTILES.map(function (q) {
            return 'content:' + q;
        })).forEach(function (event) {
            player.one(constructEventName(event, player), function (event) {
                ophanRecord(mediaId, event, player);
            });
        });
    }

    function bindPrerollEvents(player) {
        var events = {
            end: function () {
                player.trigger(constructEventName('preroll:end', player));
                bindContentEvents(player, true);
            },
            start: function () {
                var duration = player.duration();
                if (duration) {
                    player.trigger(constructEventName('preroll:play', player));
                } else {
                    player.one('durationchange', events.start);
                }
            },
            ready: function () {
                player.trigger(constructEventName('preroll:ready', player));

                player.one('adstart', events.start);
                player.one('adend', events.end);

                if (shouldAutoPlay(player)) {
                    player.play();
                }
            }
        },
        adFailed = function () {
            bindContentEvents(player);
            if (shouldAutoPlay(player)) {
                player.play();
            }
            // Remove both handlers, because this adFailed handler should only happen once.
            player.off('adtimeout', adFailed);
            player.off('adserror', adFailed);
        };

        player.one('adsready', events.ready);

        //If no preroll avaliable or preroll fails, cancel ad framework and init content tracking.
        player.one('adtimeout', adFailed);
        player.one('adserror', adFailed);
    }

    function kruxTracking(player, event) {
        var desiredVideos = ['gu-video-457263940', 'gu-video-55e4835ae4b00856194f85c2'];
        //test videos /artanddesign/video/2015/jun/25/damien-hirst-paintings-john-hoyland-newport-street-gallery-london-video
        ///music/video/2015/aug/31/vmas-2015-highlights-video


        if (config.switches.kruxVideoTracking && config.switches.krux && $(player.el()).attr('data-media-id') && indexOf(desiredVideos, $(player.el()).attr('data-media-id')) !== -1) {
            if (event === 'videoPlaying') {
                //Krux is a global object loaded by krux.js file

                /*eslint-disable */
                Krux('admEvent', 'KAIQvckS', {});
                /*eslint-enable */

            } else if (event === 'videoEnded') {

                /*eslint-disable */
                Krux('admEvent', 'KBaTegd5', {});
                /*eslint-enable */
            }
        }

    }

    function bindContentEvents(player) {
        var events = {
            end: function () {
                player.trigger(constructEventName('content:end', player));
            },
            play: function () {
                var duration = player.duration();
                if (duration) {
                    player.trigger(constructEventName('content:play', player));
                } else {
                    player.one('durationchange', events.play);
                }
            },
            timeupdate: function () {
                var progress = Math.round(parseInt(player.currentTime() / player.duration() * 100, 10));
                QUARTILES.reverse().some(function (quart) {
                    if (progress >= quart) {
                        player.trigger(constructEventName('content:' + quart, player));
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            ready: function () {
                player.trigger(constructEventName('content:ready', player));

                player.one('play', events.play);
                player.on('timeupdate', throttle(events.timeupdate, 1000));
                player.one('ended', events.end);

                if (shouldAutoPlay(player)) {
                    player.play();
                }
            }
        };
        events.ready();
    }

    // These events are so that other libraries (e.g. Ophan) can hook into events without
    // needing to know about videojs
    function bindGlobalEvents(player) {
        player.on('playing', function () {
            kruxTracking(player, 'videoPlaying');
            bean.fire(document.body, 'videoPlaying');
        });
        player.on('pause', function () {
            bean.fire(document.body, 'videoPause');
        });
        player.on('ended', function () {
            bean.fire(document.body, 'videoEnded');
            kruxTracking(player, 'videoEnded');
        });
    }

    function beaconError(err) {
        if (err && 'message' in err && 'code' in err) {
            reportError(new Error(err.message), {
                feature: 'player',
                vjsCode: err.code
            }, false);
        }
    }

    function handleInitialMediaError(player) {
        var err = player.error();
        if (err !== null) {
            beaconError(err);
            return err.code === 4;
        }
        return false;
    }

    function bindErrorHandler(player) {
        player.on('error', function () {
            beaconError(player.error());
            $('.vjs-big-play-button').hide();
        });
    }

    return {
        constructEventName: constructEventName,
        bindContentEvents: bindContentEvents,
        bindPrerollEvents: bindPrerollEvents,
        bindGlobalEvents: bindGlobalEvents,
        initOphanTracking: initOphanTracking,
        handleInitialMediaError: handleInitialMediaError,
        bindErrorHandler: bindErrorHandler,
        addContentEvents: addContentEvents,
        addPrerollEvents: addPrerollEvents,
        bindGoogleAnalyticsEvents: bindGoogleAnalyticsEvents
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(57),
    __webpack_require__(0),
    __webpack_require__(30),
    __webpack_require__(4),
    __webpack_require__(7),
    __webpack_require__(254),
    __webpack_require__(43),
    __webpack_require__(243),
    __webpack_require__(186),
    __webpack_require__(137),
    __webpack_require__(242),
    __webpack_require__(332),
    __webpack_require__(259),
    __webpack_require__(334),
    __webpack_require__(303),
    __webpack_require__(337),
    __webpack_require__(330),
    __webpack_require__(326),
    __webpack_require__(331),
    __webpack_require__(336),
    __webpack_require__(335),
    __webpack_require__(258),
    __webpack_require__(302),
    __webpack_require__(40),
    __webpack_require__(333),
    __webpack_require__(327)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (reportError,
             config,
             cookies,
             mediator,
             store,
             compact,
             noop,
             abUtils,
             segmentUtil,
             testCanRunChecks,
             acquisitionTestSelector,
             OpinionEmailVariants,
             MembershipEngagementBannerTests,
             PaidContentVsOutbrain2,
             tailorSurvey,
             TheLongReadEmailVariants,
             FashionStatementEmailVariants,
             BookmarksEmailVariants2,
             FilmTodayEmailVariants,
             SleevenotesNewEmailVariant,
             SleevenotesLegacyEmailVariant,
             increaseInlineAdsRedux,
             measureUnderstanding,
             ophan,
             PaidCommenting,
             BundleDigitalSubPriceTest1
    ) {
    var TESTS = compact([
        new OpinionEmailVariants(),
        new PaidContentVsOutbrain2,
        acquisitionTestSelector.getTest(),
        new tailorSurvey.TailorSurvey(),
        TheLongReadEmailVariants,
        FashionStatementEmailVariants,
        BookmarksEmailVariants2,
        FilmTodayEmailVariants,
        SleevenotesNewEmailVariant,
        SleevenotesLegacyEmailVariant,
        new increaseInlineAdsRedux(),
        measureUnderstanding.MeasureUnderstanding(),
        new PaidCommenting(),
        new BundleDigitalSubPriceTest1()
    ].concat(MembershipEngagementBannerTests));

    function cleanParticipations() {
        // Removes any tests from localstorage that have been
        // renamed/deleted from the backend
        Object.keys(abUtils.getParticipations()).forEach(function (k) {
            if (typeof config.switches['ab' + k] === 'undefined') {
                abUtils.removeParticipation({id: k});
            } else {
                var testExists = TESTS.some(function (element) {
                    return element.id === k;
                });

                if (!testExists) {
                    abUtils.removeParticipation({id: k});
                }
            }
        });
    }

    function getActiveTests() {
        return TESTS.filter(function (test) {
            if (testCanRunChecks.isExpired(test.expiry)) {
                abUtils.removeParticipation(test);
                return false;
            }
            return true;
        });
    }

    function getExpiredTests() {
        return TESTS.filter(function (test) {
            return testCanRunChecks.isExpired(test.expiry);
        });
    }

    function getTest(id) {
        var testIds = TESTS.map(function (test) {
            return test.id;
        });
        var index = testIds.indexOf(id);
        return index > -1 ? TESTS[index] : null;
    }

    function abData(variantName, complete, campaignCodes) {
        var data = {
            'variantName': variantName,
            'complete': complete
        };

        if (campaignCodes) {
            data.campaignCodes = campaignCodes;
        }

        return data;
    }

    function getAbLoggableObject() {
        try {
            var log = {};

            getActiveTests()
                .filter(not(defersImpression))
                .filter(abUtils.isParticipating)
                .filter(testCanRunChecks.testCanBeRun)
                .forEach(function (test) {
                    var variantId = abUtils.getTestVariantId(test.id);
                    var variant = abUtils.getVariant(test, variantId);
                    var campaingCodes = (variant && variant.campaignCodes) ? variant.campaignCodes : undefined;

                    if (variantId && segmentUtil.isInTest(test)) {
                        log[test.id] = abData(variantId, 'false', campaingCodes);
                    }
                });

            getServerSideTests().forEach(function (test) {
                log['ab' + test] = abData('inTest', 'false');
            });

            return log;
        } catch (error) {
            // Encountering an error should invalidate the logging process.
            reportError(error, false);
            return {};
        }
    }

    function trackEvent() {
        recordOphanAbEvent(getAbLoggableObject());
    }

    function recordOphanAbEvent(data) {
        ophan.record({
            abTestRegister: data
        });
    }

    /**
     * Register a test and variant's complete state with Ophan
     *
     * @param test
     * @param {string} variantId
     * @param {boolean} complete
     * @returns {Function} to fire the event
     */
    function recordTestComplete(test, variantId, complete) {
        var data = {};
        var variant = abUtils.getVariant(test, variantId);

        data[test.id] = abData(variantId, String(complete), variant.campaignCodes);

        return function () {
            recordOphanAbEvent(data);
        };
    }

    // Finds variant in specific tests and runs it
    function run(test) {
        if (abUtils.isParticipating(test) && testCanRunChecks.testCanBeRun(test)) {
            var participations = abUtils.getParticipations(),
                variantId = participations[test.id].variant;
            var variant = abUtils.getVariant(test, variantId);
            if (variant) {
                variant.test();
            } else if (!segmentUtil.isInTest(test) && test.notInTest) {
                test.notInTest();
            }
        }
    }

    function allocateUserToTest(test) {
        // Only allocate the user if the test is valid and they're not already participating.
        if (testCanRunChecks.testCanBeRun(test) && !abUtils.isParticipating(test)) {
            abUtils.addParticipation(test, segmentUtil.variantIdFor(test));
        }
    }

    /**
     * Create a function that sets up listener to fire an Ophan `complete` event. This is used in the `success` and
     * `impression` properties of test variants to allow test authors to control when these events are sent out.
     *
     * @see {@link defersImpression}
     * @param {Boolean} complete
     * @returns {Function}
     */
    function registerCompleteEvent(complete) {
        return function initListener(test) {

            var variantId = abUtils.getTestVariantId(test.id);

            if (variantId && variantId !== 'notintest') {
                var variant = abUtils.getVariant(test, variantId);
                var listener = (complete ? variant.success : variant.impression) || noop;

                try {
                    listener(recordTestComplete(test, variantId, complete));
                } catch (err) {
                    reportError(err, false, false);
                }
            }
        };
    }

    /**
     * Checks if this test will defer its impression by providing its own impression function.
     *
     * If it does, the test won't be included in the Ophan call that happens at pageload, and must fire the impression
     * itself via the callback passed to the `impression` property in the variant.
     *
     * @param test
     * @returns {boolean}
     */
    function defersImpression(test) {
        return test.variants.every(function (variant) {
            return typeof variant.impression === 'function';
        });
    }

    function shouldRunTest(id, variant) {
        var test = getTest(id);
        return test &&
            abUtils.isParticipating(test) &&
            abUtils.getTestVariantId(id) === variant &&
            testCanRunChecks.testCanBeRun(test);
    }

    // These kinds of tests are both server and client side.
    function getServerSideTests() {
        return Object.keys(config.tests).filter(function (test) {
            return !!config.tests[test];
        });
    }

    function not(f) {
        return function () {
            return !f.apply(this, arguments);
        };
    }

    function getForcedIntoTests() {
        var devtoolsAbTests = JSON.parse(store.local.get('gu.devtools.ab')) || [];
        var tokens;

        if (/^#ab/.test(window.location.hash)) {
            tokens = window.location.hash.replace('#ab-', '').split(',');

            return tokens.map(function (token) {
                var abParam = token.split('=');

                return {
                    id: abParam[0],
                    variant: abParam[1]
                };
            });
        }

        return devtoolsAbTests;
    }
    var ab = {

        addTest: function (test) {
            TESTS.push(test);
        },

        clearTests: function () {
            TESTS = [];
        },

        segment: function () {
            getActiveTests().forEach(function (test) {
                allocateUserToTest(test);
            });
        },

        forceSegment: function (testId, variant) {
            getActiveTests().filter(function (test) {
                return test.id === testId;
            }).forEach(function (test) {
                abUtils.addParticipation(test, variant);
            });
        },

        forceVariantCompleteFunctions: function (testId, variantId) {
            var test = getTest(testId);

            var variant = test && test.variants.filter(function (v) {
                return v.id.toLowerCase() === variantId.toLowerCase();
            })[0];

            var impression = variant && variant.impression || noop;
            var complete = variant && variant.success || noop;

            impression(recordTestComplete(test, variantId, false));
            complete(recordTestComplete(test, variantId, true));
        },

        segmentUser: function () {
            var forcedIntoTests = getForcedIntoTests();

            if (forcedIntoTests.length) {
                forcedIntoTests.forEach(function (test) {
                    ab.forceSegment(test.id, test.variant);
                    ab.forceVariantCompleteFunctions(test.id, test.variant);
                });
            } else {
                ab.segment();
            }

            cleanParticipations();
        },

        run: function () {
            getActiveTests().forEach(run);
        },

        registerCompleteEvents: function () {
            getActiveTests().forEach(registerCompleteEvent(true));
        },

        registerImpressionEvents: function () {
            getActiveTests().filter(defersImpression).forEach(registerCompleteEvent(false));
        },

        getAbLoggableObject: getAbLoggableObject,
        getParticipations: abUtils.getParticipations,
        isParticipating: abUtils.isParticipating,
        getTest: getTest,
        trackEvent: trackEvent,
        getExpiredTests: getExpiredTests,
        getActiveTests: getActiveTests,
        getTestVariantId: abUtils.getTestVariantId,
        setTestVariant: abUtils.setTestVariant,
        getVariant: abUtils.getVariant,
        TESTS: TESTS,

        /**
         * check if a test can be run (i.e. is not expired and switched on)
         *
         * @param  {string|Object} test   id or test object
         * @return {Boolean}
         */
        testCanBeRun: function (test) {
            if (typeof test === 'string') {
                test = getTest(test);
                return test && testCanRunChecks.testCanBeRun(test);
            }

            return test.id && test.expiry && testCanRunChecks.testCanBeRun(test);
        },

        isInVariant: abUtils.isInVariant,

        shouldRunTest: shouldRunTest,

        // testing
        reset: function () {
            TESTS = [];
            segmentUtil.variantIdFor.cache = {};
        }
    };

    return ab;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(76), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _url, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var dfpEnv = {
        /* renderStartTime: integer. Point in time when DFP kicks in */
        renderStartTime: -1,

        /* adSlotSelector: string. A CSS selector to query ad slots in the DOM */
        adSlotSelector: '.js-ad-slot',

        /* sonobiEnabled: boolean. Set to true if sonobi real-time-bidding is enabled*/
        sonobiEnabled: (_config2.default.switches.sonobiHeaderBidding || (0, _url.getUrlVars)().sonobi) && !(_config2.default.switches.preflightAdCall && !!window.esi),

        /* preFlightAdCallEnabled: boolean. Set to true if real-time bidding should be performed through pre-flight ad call */
        preFlightAdCallEnabled: _config2.default.switches.preflightAdCall && !!window.esi,

        /* lazyLoadEnabled: boolean. Set to true when adverts are lazy-loaded */
        lazyLoadEnabled: false,

        /* lazyLoadObserve: boolean. Use IntersectionObserver in supporting browsers */
        lazyLoadObserve: 'IntersectionObserver' in window,

        /* creativeIDs: array<string>. List of loaded creative IDs */
        creativeIDs: [],

        /* advertIds: map<string -> int>. Keeps track of slot IDs and their position in the array of adverts */
        advertIds: {},

        /* advertsToLoad: array<Advert>. Lists adverts waiting to be loaded */
        advertsToLoad: [],

        /* advertsToRefresh: array<Advert>. Lists adverts refreshed when a breakpoint has been crossed */
        advertsToRefresh: [],

        /* adverts: array<Advert>. Keeps track of adverts and their state */
        adverts: [],

        shouldLazyLoad: function shouldLazyLoad() {
            // We do not want lazy loading on pageskins because it messes up the roadblock
            // Also, if the special dll parameter is passed with a value of 1, we don't lazy load
            return !_config2.default.page.hasPageSkin && (0, _url.getUrlVars)().dll !== '1';
        }
    };

    exports.default = dfpEnv;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var loadScript = function loadScript(src, props) {
        // #? type checks like this should be redundant post es6/flow conversion
        if (typeof src !== 'string') {
            return Promise.reject('no src supplied');
        }

        if (document.querySelector('script[src="' + src + '"]')) {
            return Promise.resolve();
        }

        return new Promise(function (resolve, reject) {
            var ref = document.scripts[0];
            var script = document.createElement('script');
            script.src = src;
            if (props) {
                Object.assign(script, props);
            }
            script.onload = resolve;
            script.onerror = reject;
            if (ref.parentNode) {
                ref.parentNode.insertBefore(script, ref);
            }
        });
    };

    exports.loadScript = loadScript;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(83), __webpack_require__(8), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, baseIndexOf, isArray, isString) {

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeMax = Math.max;

  /**
   * Checks if a given value is present in a collection using strict equality
   * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
   * offset from the end of the collection.
   *
   * @static
   * @memberOf _
   * @alias include
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {*} target The value to check for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
   * @example
   *
   * _.contains([1, 2, 3], 1);
   * // => true
   *
   * _.contains([1, 2, 3], 1, 2);
   * // => false
   *
   * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
   * // => true
   *
   * _.contains('pebbles', 'eb');
   * // => true
   */
  function contains(collection, target, fromIndex) {
    var index = -1,
        indexOf = baseIndexOf,
        length = collection ? collection.length : 0,
        result = false;

    fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
    if (isArray(collection)) {
      result = indexOf(collection, target, fromIndex) > -1;
    } else if (typeof length == 'number') {
      result = (isString(collection) ? collection.indexOf(target, fromIndex) : indexOf(collection, target, fromIndex)) > -1;
    } else {
      baseEach(collection, function(value) {
        if (++index >= fromIndex) {
          return !(result = value === target);
        }
      });
    }
    return result;
  }

  return contains;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(29), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, createCallback, isArray) {

  /**
   * Iterates over elements of a collection, returning the first element that
   * the callback returns truey for. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias detect, findWhere
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the found element, else `undefined`.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36, 'blocked': false },
   *   { 'name': 'fred',    'age': 40, 'blocked': true },
   *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
   * ];
   *
   * _.find(characters, function(chr) {
   *   return chr.age < 40;
   * });
   * // => { 'name': 'barney', 'age': 36, 'blocked': false }
   *
   * // using "_.where" callback shorthand
   * _.find(characters, { 'age': 1 });
   * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
   *
   * // using "_.pluck" callback shorthand
   * _.find(characters, 'blocked');
   * // => { 'name': 'fred', 'age': 40, 'blocked': true }
   */
  function find(collection, callback, thisArg) {
    callback = createCallback(callback, thisArg, 3);

    if (isArray(collection)) {
      var index = -1,
          length = collection.length;

      while (++index < length) {
        var value = collection[index];
        if (callback(value, index, collection)) {
          return value;
        }
      }
    } else {
      var result;
      baseEach(collection, function(value, index, collection) {
        if (callback(value, index, collection)) {
          result = value;
          return false;
        }
      });
      return result;
    }
  }

  return find;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(29), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, createCallback, isArray) {

  /**
   * Checks if the callback returns a truey value for **any** element of a
   * collection. The function returns as soon as it finds a passing value and
   * does not iterate over the entire collection. The callback is bound to
   * `thisArg` and invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias any
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if any element passed the callback check,
   *  else `false`.
   * @example
   *
   * _.some([null, 0, 'yes', false], Boolean);
   * // => true
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.some(characters, 'blocked');
   * // => true
   *
   * // using "_.where" callback shorthand
   * _.some(characters, { 'age': 1 });
   * // => false
   */
  function some(collection, callback, thisArg) {
    var result;
    callback = createCallback(callback, thisArg, 3);

    if (isArray(collection)) {
      var index = -1,
          length = collection.length;

      while (++index < length) {
        if ((result = callback(collection[index], index, collection))) {
          break;
        }
      }
    } else {
      baseEach(collection, function(value, index, collection) {
        return !(result = callback(value, index, collection));
      });
    }
    return !!result;
  }

  return some;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(244), __webpack_require__(29)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseUniq, createCallback) {

  /**
   * Creates a duplicate-value-free version of an array using strict equality
   * for comparisons, i.e. `===`. If the array is sorted, providing
   * `true` for `isSorted` will use a faster algorithm. If a callback is provided
   * each element of `array` is passed through the callback before uniqueness
   * is computed. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias unique
   * @category Arrays
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a duplicate-value-free array.
   * @example
   *
   * _.uniq([1, 2, 1, 3, 1]);
   * // => [1, 2, 3]
   *
   * _.uniq([1, 1, 2, 2, 3], true);
   * // => [1, 2, 3]
   *
   * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
   * // => ['A', 'b', 'C']
   *
   * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
   * // => [1, 2.5, 3]
   *
   * // using "_.pluck" callback shorthand
   * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
   * // => [{ 'x': 1 }, { 'x': 2 }]
   */
  function uniq(array, isSorted, callback, thisArg) {
    // juggle arguments
    if (typeof isSorted != 'boolean' && isSorted != null) {
      thisArg = callback;
      callback = (typeof isSorted != 'function' && thisArg && thisArg[isSorted] === array) ? null : isSorted;
      isSorted = false;
    }
    if (callback != null) {
      callback = createCallback(callback, thisArg, 3);
    }
    return baseUniq(array, isSorted, callback);
  }

  return uniq;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(300)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _waitForAdvert) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _waitForAdvert2 = _interopRequireDefault(_waitForAdvert);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var trackAdRender = function trackAdRender(id) {
        return (0, _waitForAdvert2.default)(id).then(function (_) {
            return _.whenRendered;
        });
    };
    exports.default = trackAdRender;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(223)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _dfpEnv) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getAdvertById = undefined;

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var getAdvertById = function getAdvertById(id) {
        return id in _dfpEnv2.default.advertIds ? _dfpEnv2.default.adverts[_dfpEnv2.default.advertIds[id]] : null;
    };
    exports.getAdvertById = getAdvertById;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(29), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, createCallback, isArray) {

  /**
   * Reduces a collection to a value which is the accumulated result of running
   * each element in the collection through the callback, where each successive
   * callback execution consumes the return value of the previous execution. If
   * `accumulator` is not provided the first element of the collection will be
   * used as the initial `accumulator` value. The callback is bound to `thisArg`
   * and invoked with four arguments; (accumulator, value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @alias foldl, inject
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [accumulator] Initial value of the accumulator.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the accumulated value.
   * @example
   *
   * var sum = _.reduce([1, 2, 3], function(sum, num) {
   *   return sum + num;
   * });
   * // => 6
   *
   * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
   *   result[key] = num * 3;
   *   return result;
   * }, {});
   * // => { 'a': 3, 'b': 6, 'c': 9 }
   */
  function reduce(collection, callback, accumulator, thisArg) {
    var noaccum = arguments.length < 3;
    callback = createCallback(callback, thisArg, 4);

    if (isArray(collection)) {
      var index = -1,
          length = collection.length;

      if (noaccum) {
        accumulator = collection[++index];
      }
      while (++index < length) {
        accumulator = callback(accumulator, collection[index], index, collection);
      }
    } else {
      baseEach(collection, function(value, index, collection) {
        accumulator = noaccum
          ? (noaccum = false, value)
          : callback(accumulator, value, index, collection)
      });
    }
    return accumulator;
  }

  return reduce;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(61), __webpack_require__(6), __webpack_require__(2), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isString, slice, support, values) {

  /**
   * Converts the `collection` to an array.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to convert.
   * @returns {Array} Returns the new converted array.
   * @example
   *
   * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
   * // => [2, 3, 4]
   */
  function toArray(collection) {
    if (collection && typeof collection.length == 'number') {
      return (support.unindexedChars && isString(collection))
        ? collection.split('')
        : slice(collection);
    }
    return values(collection);
  }

  return toArray;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(42), __webpack_require__(12), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(debounce, isFunction, isObject) {

  /** Used as an internal `_.debounce` options object */
  var debounceOptions = {
    'leading': false,
    'maxWait': 0,
    'trailing': false
  };

  /**
   * Creates a function that, when executed, will only call the `func` function
   * at most once per every `wait` milliseconds. Provide an options object to
   * indicate that `func` should be invoked on the leading and/or trailing edge
   * of the `wait` timeout. Subsequent calls to the throttled function will
   * return the result of the last `func` call.
   *
   * Note: If `leading` and `trailing` options are `true` `func` will be called
   * on the trailing edge of the timeout only if the the throttled function is
   * invoked more than once during the `wait` timeout.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to throttle.
   * @param {number} wait The number of milliseconds to throttle executions to.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
   * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
   * @returns {Function} Returns the new throttled function.
   * @example
   *
   * // avoid excessively updating the position while scrolling
   * var throttled = _.throttle(updatePosition, 100);
   * jQuery(window).on('scroll', throttled);
   *
   * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
   * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
   *   'trailing': false
   * }));
   */
  function throttle(func, wait, options) {
    var leading = true,
        trailing = true;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    if (options === false) {
      leading = false;
    } else if (isObject(options)) {
      leading = 'leading' in options ? options.leading : leading;
      trailing = 'trailing' in options ? options.trailing : trailing;
    }
    debounceOptions.leading = leading;
    debounceOptions.maxWait = wait;
    debounceOptions.trailing = trailing;

    return debounce(func, wait, debounceOptions);
  }

  return throttle;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(35),
    __webpack_require__(75),
    __webpack_require__(321)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    raven,
    fastdom,
    spacefinder
) {
    function SpaceFiller() {
        this.queue = Promise.resolve();
    }

    /**
     * A safer way of using spacefinder.
     * Given a set of spacefinder rules, applies a writer to the first matching paragraph.
     * Uses fastdom to avoid layout-thrashing, but queues up asynchronous writes to avoid race conditions. We don't
     * seek a slot for a new component until all the other component writes have finished.
     *
     * @param rules - a spacefinder ruleset
     * @param writer - function, takes a para element and injects a container for the new content synchronously. It should NOT use Fastdom.
     * @param options - Options
     * @param options.domWriter - Override fastdom.write as the mechanism for queueing writes
     *
     * @returns {Promise} - when insertion attempt completed, resolves 'true' if inserted, or 'false' if no space found
     */
    SpaceFiller.prototype.fillSpace = function (rules, writer, options) {
        var write = (options && options.domWriter) || fastdom.write;
        return this.queue = this.queue.then(insertNextContent).catch(onError);

        function insertNextContent() {
            return spacefinder.findSpace(rules, options).then(onSpacesFound, onNoSpacesFound);
        }

        function onSpacesFound(paragraphs) {
            return write(function () {
                return writer(paragraphs);
            });
        }

        function onNoSpacesFound(ex) {
            if (ex instanceof spacefinder.SpaceError) {
                return false;
            } else {
                throw ex;
            }
        }
    };

    function onError(e) {
        // e.g. if writer fails
        raven.captureException(e);
        return false;
    }

    return new SpaceFiller();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(19), __webpack_require__(224)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fastdom, _loadScript) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.init = undefined;

    var _fastdom2 = _interopRequireDefault(_fastdom);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var scriptSrc = 'https://www.youtube.com/iframe_api';
    var promise = new Promise(function (resolve) {
        if (window.YT && window.YT.Player) {
            resolve();
        } else {
            window.onYouTubeIframeAPIReady = resolve;
        }
    });

    var loadYoutubeJs = function loadYoutubeJs() {
        (0, _loadScript.loadScript)(scriptSrc, {});
    };

    var addVideoStartedClass = function addVideoStartedClass(el) {
        el.classList.add('youtube__video-started');
    };

    var onPlayerStateChangeEvent = function onPlayerStateChangeEvent(event, handlers, el) {
        // change class according to the current state
        // TODO: Fix this so we can add poster image.
        _fastdom2.default.write(function () {
            ['ENDED', 'PLAYING', 'PAUSED', 'BUFFERING', 'CUED'].forEach(function (status) {
                el.classList.toggle('youtube__video-' + status.toLocaleLowerCase(), event.data === window.YT.PlayerState[status]);
            });
            addVideoStartedClass(el);
        });

        if (handlers && typeof handlers.onPlayerStateChange === 'function') {
            handlers.onPlayerStateChange(event);
        }
    };

    var onPlayerReadyEvent = function onPlayerReadyEvent(event, handlers, el) {
        _fastdom2.default.write(function () {
            el.classList.add('youtube__video-ready');
        });

        // we should be able to remove this check once everything is using flow/ES^
        if (handlers && typeof handlers.onPlayerReady === 'function') {
            handlers.onPlayerReady(event);
        }
    };

    var setupPlayer = function setupPlayer(videoId, onReady, onStateChange) {
        return new window.YT.Player(videoId, {
            events: {
                onReady: onReady,
                onStateChange: onStateChange
            }
        });
    };

    var hasPlayerStarted = function hasPlayerStarted(event) {
        return event.target.getCurrentTime() > 0;
    };

    var init = function init(el, handlers, videoId) {
        loadYoutubeJs();

        return promise.then(function () {
            var onPlayerStateChange = function onPlayerStateChange(event) {
                onPlayerStateChangeEvent(event, handlers, el);
            };

            var onPlayerReady = function onPlayerReady(event) {
                if (hasPlayerStarted(event)) {
                    addVideoStartedClass(el);
                }

                onPlayerReadyEvent(event, handlers, el);
            };

            return setupPlayer(videoId, onPlayerReady, onPlayerStateChange);
        });
    };

    exports.init = init;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(134), __webpack_require__(183)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseFlatten, map) {

  /**
   * Flattens a nested array (the nesting can be to any depth). If `isShallow`
   * is truey, the array will only be flattened a single level. If a callback
   * is provided each element of the array is passed through the callback before
   * flattening. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new flattened array.
   * @example
   *
   * _.flatten([1, [2], [3, [[4]]]]);
   * // => [1, 2, 3, 4];
   *
   * _.flatten([1, [2], [3, [[4]]]], true);
   * // => [1, 2, 3, [[4]]];
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
   *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.flatten(characters, 'pets');
   * // => ['hoppy', 'baby puss', 'dino']
   */
  function flatten(array, isShallow, callback, thisArg) {
    // juggle arguments
    if (typeof isShallow != 'boolean' && isShallow != null) {
      thisArg = callback;
      callback = (typeof isShallow != 'function' && thisArg && thisArg[isShallow] === array) ? null : isShallow;
      isShallow = false;
    }
    if (callback != null) {
      array = map(array, callback, thisArg);
    }
    return baseFlatten(array, isShallow);
  }

  return flatten;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(130),
    __webpack_require__(0),
    __webpack_require__(140),
    __webpack_require__(40)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    mediator,
    forEach,
    config,
    gaHelper,
    ophan
) {

    function eventAction() {
        return 'video content';
    }

    function buildEventId(event, videoId) {
        return event + ':' + videoId;
    }

    function initYoutubeEvents(videoId) {

        var gaTracker = config.googleAnalytics.trackers.editorial;

        var events = {
            metricMap: {
                'play': 'metric1',
                'skip': 'metric2',
                '25': 'metric3',
                '50': 'metric4',
                '75': 'metric5',
                'end': 'metric6'
            },
            baseEventObject: {
                eventCategory: 'media',
                eventAction: eventAction(),
                eventLabel: videoId,
                dimension19: videoId,
                dimension20: 'gu-video-youtube'
            }
        };

        var eventsList = ['play', '25', '50', '75', 'end'];

        forEach(eventsList, function(event) {
            mediator.once(buildEventId(event, videoId), function(id) {
                var mediaEvent = MediaEvent(videoId, 'video', event);
                ophanRecord(mediaEvent);
                window.ga(gaTracker + '.send', 'event',
                    gaHelper.buildGoogleAnalyticsEvent(mediaEvent, events.metricMap, id,
                        'gu-video-youtube', eventAction, event.mediaId));
            });
        });

        function ophanRecord(event) {
            var eventObject = {
                video: {
                    id: 'gu-video-youtube-' + event.mediaId,
                    eventType: 'video:content:' + event.eventType
                }
            };
            ophan.record(eventObject);
        }
    }

    /**
     *
     * @param mediaId {string}
     * @param mediaType {string} audio|video
     * @param eventType {string} e.g. firstplay, firstend
     * @param isPreroll {boolean}
     * @returns {{mediaId: string, mediaType: string, eventType: string, isPreroll: boolean}}
     */
    function MediaEvent(mediaId, mediaType, eventType) {
        return {
            mediaId: mediaId,
            mediaType: mediaType,
            eventType: eventType
        };
    }

    function init(videoId) {
        initYoutubeEvents(videoId);
    }

    function track(event, id) {
        mediator.emit(buildEventId(event, id), id);
    }

    return {
        track: track,
        init: init
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Module: history.js
 Description: Gets and sets users reading history
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(19),
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(21),
    __webpack_require__(7),
    __webpack_require__(76),
    __webpack_require__(320),
    __webpack_require__(319),
    __webpack_require__(1),
    __webpack_require__(248),
    __webpack_require__(226),
    __webpack_require__(130),
    __webpack_require__(228),
    __webpack_require__(9),
    __webpack_require__(14),
    __webpack_require__(234),
    __webpack_require__(225),
    __webpack_require__(8),
    __webpack_require__(249),
    __webpack_require__(256)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    $,
    config,
    template,
    storage,
    url,
    viewTag,
    viewMegaNav,
    isObject,
    isNumber,
    find,
    forEach,
    some,
    keys,
    assign,
    reduce,
    contains,
    isArray,
    pick,
    mapValues
) {
    var editions = [
            'uk',
            'us',
            'au'
        ],
        editionalised = [
            'business',
            'commentisfree',
            'culture',
            'environment',
            'media',
            'money',
            'sport',
            'technology'
        ],
        pageMeta = [
            {tid: 'section',    tname: 'sectionName'},
            {tid: 'keywordIds', tname: 'keywords'},
            {tid: 'seriesId',   tname: 'series'},
            {tid: 'authorIds',  tname: 'author'}
        ],
        buckets = [
            {
                type: 'content',
                indexInRecord: 1
            },
            {
                type: 'front',
                indexInRecord: 2
            }
        ],
        summaryPeriodDays = 90,
        forgetUniquesAfter = 10,
        historySize = 50,

        storageKeyHistory = 'gu.history',
        storageKeySummary = 'gu.history.summary',

        today =  Math.floor(Date.now() / 86400000), // 1 day in ms
        historyCache,
        summaryCache,
        popularFilteredCache,
        topNavItemsCache,

        inMegaNav = false,

        isEditionalisedRx = new RegExp('^(' + editions.join('|') + ')\/(' + editionalised.join('|') + ')$'),
        stripEditionRx = new RegExp('^(' + editions.join('|') + ')\/');

    function saveHistory(history) {
        historyCache = history;
        return storage.local.set(storageKeyHistory, history);
    }

    function saveSummary(summary) {
        summaryCache = summary;
        return storage.local.set(storageKeySummary, summary);
    }

    function getHistory() {
        historyCache = historyCache || storage.local.get(storageKeyHistory) || [];
        return historyCache;
    }

    function getSummary() {
        if (!summaryCache) {
            summaryCache = storage.local.get(storageKeySummary);

            if (!isObject(summaryCache) || !isObject(summaryCache.tags) || !isNumber(summaryCache.periodEnd)) {
                summaryCache = {
                    periodEnd: today,
                    tags: {},
                    showInMegaNav: true
                };
            }
        }
        return summaryCache;
    }

    function seriesSummary() {
        function views(item) {
            return reduce(item, function (acc, record) {
                return acc + record[1];
            }, 0);
        }

        var seriesTags = pick(getSummary().tags, function(v, k) { 
            return contains(k, 'series'); 
        });

        var seriesTagsSummary = mapValues(seriesTags, function(tag) { 
            return views(tag[1]) + views(tag[2]); 
        });

        return seriesTagsSummary;
    }

    function mostViewedSeries() {
        return reduce(seriesSummary(), function (best, views, tag, summary) {
            return views > (summary[best] || 0) ? tag : best;
        }, '');
    }

    function deleteFromSummary(tag) {
        var summary = getSummary();

        delete summary.tags[tag];
        saveSummary(summary);
    }

    function isRevisit(pageId) {
        return (find(getHistory(), function (page) {
            return (page[0] === pageId);
        }) || [])[1] > 1;
    }

    function pruneSummary(summary, mockToday) {
        var newToday = mockToday || today,
            updateBy = newToday - summary.periodEnd;

        if (updateBy !== 0) {
            summary.periodEnd = newToday;

            forEach(summary.tags, function (record, tid) {
                var result = buckets.map(function (bucket) {
                    if (record[bucket.indexInRecord]) {
                        var visits = record[bucket.indexInRecord].map(function (day) {
                            var newAge = day[0] + updateBy;
                            return newAge < summaryPeriodDays && newAge >= 0 ? [newAge, day[1]] : false;
                        }).filter(Boolean);

                        return (visits.length > 1 || (visits.length === 1 && visits[0][0] < forgetUniquesAfter)) ? visits : [];
                    }

                    return [];
                });

                if (result.some(function (r) { return r.length; })) {
                    summary.tags[tid] = [record[0]].concat(result);
                } else {
                    delete summary.tags[tid];
                }
            });
        }

        return summary;
    }

    function getPopular(opts) {
        var tags = getSummary().tags,
            tids = keys(tags),
            op = assign({
                number: 100,
                weights: {},
                thresholds: {}
            }, opts);

        tids = op.whitelist ? tids.filter(function (tid) { return op.whitelist.indexOf(tid) > -1; }) : tids;
        tids = op.blacklist ? tids.filter(function (tid) { return op.blacklist.indexOf(tid) === -1; }) : tids;

        return tids.map(function (tid) {
            var record = tags[tid],
                rank = reduce(buckets, function (rank, bucket) {
                    return rank + tally(record[bucket.indexInRecord], op.weights[bucket.type], op.thresholds[bucket.type]);
                }, 0);

            return {
                idAndName: [tid, record[0]],
                rank: rank
            };
        })
        .filter(Boolean)
        .sort(function (a, b) {
          return a.rank - b.rank;
        })
        .slice(-op.number)
        .map(function (tid) {
            return tid.idAndName;
        })
        .reverse();
    }

    function getContributors() {
        var contibutors = [],
            tagId,
            tags = getSummary().tags;
        for (tagId in tags) {
            if (tagId.indexOf('profile/') === 0) {
                contibutors.push(tags[tagId]);
            }
        }
        return contibutors;
    }

    function getPopularFiltered(opts) {
        var flush = opts && opts.flush;

        popularFilteredCache = (!flush && popularFilteredCache) || getPopular({
            blacklist: getTopNavItems(),
            number: 10,
            weights: {
                'content': 1,
                'front': 5
            },
            thresholds: {
                'content': 5,
                'front': 1
            }
        });

        return popularFilteredCache;
    }

    function tally(visits, weight, minimum) {
        var totalVisits = 0,
            result;

        weight = weight || 1;
        minimum = minimum || 1;

        result = reduce(visits, function (tally, day) {
            var dayOffset = day[0],
                dayVisits = day[1];

            totalVisits += dayVisits;
            return tally + weight * (9 + dayVisits) * (summaryPeriodDays - dayOffset);
        }, 0);

        return totalVisits < minimum ? 0 : result;
    }

    function firstCsv(str) {
        return (str || '').split(',')[0];
    }

    function collapsePath(t) {
        if (t) {
            t = t.replace(/^\/|\/$/g, '');
            if (t.match(isEditionalisedRx)) {
                t = t.replace(stripEditionRx, '');
            }
            t = t.split('/');
            t = t.length === 2 && t[0] === t[1] ? [t[0]] : t;
            return t.join('/');
        } else {
            return '';
        }
    }

    function reset() {
        historyCache = undefined;
        summaryCache = undefined;
        storage.local.remove(storageKeyHistory);
        storage.local.remove(storageKeySummary);
    }

    function logHistory(pageConfig) {
        var pageId = pageConfig.pageId,
            history,
            foundCount = 0;

        if (!pageConfig.isFront) {
            history = getHistory()
                .filter(function (item) {
                    var isArr = isArray(item),
                        found = isArr && (item[0] === pageId);

                    foundCount = found ? item[1] : foundCount;
                    return isArr && !found;
                });

            history.unshift([pageId, foundCount + 1]);
            saveHistory(history.slice(0, historySize));
        }
    }

    function logSummary(pageConfig, mockToday) {
        var summary = pruneSummary(getSummary(), mockToday),
            page = collapsePath(pageConfig.pageId),
            isFront = false;

        var meta = pageMeta.reduceRight(function (tagMeta, tag) {
            var tid = collapsePath(firstCsv(pageConfig[tag.tid])),
                tname = tid && firstCsv(pageConfig[tag.tname]);

            if (tid && tname) {
                tagMeta[tid] = tname;
            }
            isFront = isFront || tid === page;
            return tagMeta;
        }, {});

        Object.keys(meta).forEach(function (tid) {
            var tname = meta[tid],
                record = summary.tags[tid] || [],
                visits,
                today;

            buckets.forEach(function (bucket) {
                record[bucket.indexInRecord] = record[bucket.indexInRecord] || [];
            });

            record[0] = tname;

            visits = record[isFront ? 2 : 1];
            today = find(visits, function (day) { return day[0] === 0; });

            if (today) {
                today[1] = today[1] + 1;
            } else {
                visits.unshift([0, 1]);
            }

            summary.tags[tid] = record;
        });

        saveSummary(summary);
    }

    function getTopNavItems() {
        topNavItemsCache = topNavItemsCache || $('.js-navigation-header .js-top-navigation a').map(function (item) {
            return collapsePath(url.getPath($(item).attr('href')));
        });

        return topNavItemsCache;
    }

    function getMegaNav() {
        return $('.js-global-navigation');
    }

    function showInMegaNav() {
        var tags, tagsHTML;

        if (getSummary().showInMegaNav === false) { return; }

        if (inMegaNav) { removeFromMegaNav(); }

        tags = getPopularFiltered();

        if (tags.length) {
            tagsHTML = template(viewMegaNav, {tags: tags.map(tagHtml).join('')});
            fastdom.write(function () {
                getMegaNav().prepend(tagsHTML);
            });
            inMegaNav = true;
        }
    }

    function removeFromMegaNav() {
        getMegaNav().each(function (megaNav) {
            fastdom.write(function () {
                $('.js-global-navigation__section--history', megaNav).remove();
            });
        });
        inMegaNav = false;
    }

    function showInMegaNavEnabled() {
        return getSummary().showInMegaNav !== false;
    }

    function showInMegaNavEnable(bool) {
        var summary = getSummary();

        summary.showInMegaNav = !!bool;

        if (summary.showInMegaNav) {
            showInMegaNav();
        } else {
            removeFromMegaNav();
        }

        saveSummary(summary);
    }

    function tagHtml(tag, index) {
        return template(viewTag, {id: tag[0], name: tag[1], index: index + 1});
    }

    return {
        logHistory: logHistory,
        logSummary: logSummary,
        showInMegaNav: showInMegaNav,
        showInMegaNavEnable: showInMegaNavEnable,
        showInMegaNavEnabled: showInMegaNavEnabled,
        getPopular: getPopular,
        getPopularFiltered: getPopularFiltered,
        getContributors: getContributors,
        deleteFromSummary: deleteFromSummary,
        isRevisit: isRevisit,
        reset: reset,
        seriesSummary: seriesSummary,
        mostViewedSeries: mostViewedSeries,

        test: {
            getSummary: getSummary,
            getHistory: getHistory,
            pruneSummary: pruneSummary,
            seriesSummary: seriesSummary
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(186), __webpack_require__(137), __webpack_require__(187), __webpack_require__(328), __webpack_require__(329), __webpack_require__(323), __webpack_require__(325), __webpack_require__(324)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _segmentUtil, _testCanRunChecks, _acquisitionsViewLog, _contributionsEpicAlwaysAskStrategy, _contributionsEpicAskFourEarning, _acquisitionsEpicLiveblog, _acquisitionsEpicTestimonialsRoundTwo, _acquisitionsEpicSingleCta) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getTest = exports.abTestClashData = exports.epicEngagementBannerTests = undefined;

    var viewLog = _interopRequireWildcard(_acquisitionsViewLog);

    var _contributionsEpicAlwaysAskStrategy2 = _interopRequireDefault(_contributionsEpicAlwaysAskStrategy);

    var _contributionsEpicAskFourEarning2 = _interopRequireDefault(_contributionsEpicAskFourEarning);

    var _acquisitionsEpicLiveblog2 = _interopRequireDefault(_acquisitionsEpicLiveblog);

    var _acquisitionsEpicTestimonialsRoundTwo2 = _interopRequireDefault(_acquisitionsEpicTestimonialsRoundTwo);

    var _acquisitionsEpicSingleCta2 = _interopRequireDefault(_acquisitionsEpicSingleCta);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    /**
     * acquisition tests in priority order (highest to lowest)
     */
    var tests = [_contributionsEpicAlwaysAskStrategy2.default, _acquisitionsEpicSingleCta2.default, _acquisitionsEpicTestimonialsRoundTwo2.default, _contributionsEpicAskFourEarning2.default, _acquisitionsEpicLiveblog2.default];

    var epicEngagementBannerTests = exports.epicEngagementBannerTests = tests.reduce(function (out, Test) {
        var testInstance = new Test();

        if (testInstance.isEngagementBannerTest) {
            out.push(testInstance);
        }
        return out;
    }, []);

    var abTestClashData = exports.abTestClashData = tests.map(function (Test) {
        return new Test();
    });

    // This can be annotated with a return type of ABTest when all of the imported tests are converted
    var getTest = exports.getTest = function getTest() {
        var eligibleTests = tests.filter(function (Test) {
            var t = new Test();
            var forced = window.location.hash.indexOf('ab-' + t.id) > -1;
            var variant = (0, _segmentUtil.variantFor)(t);

            if (!variant || !variant.maxViews) return false;

            var maxViewCount = variant.maxViews.count;
            var withinViewLimit = viewLog.viewsInPreviousDays(variant.maxViews.days) < maxViewCount;
            var enoughDaysBetweenViews = variant.maxViews && viewLog.viewsInPreviousDays(variant.maxViews.minDaysBetweenViews) === 0;

            var hasNotReachedRateLimit = withinViewLimit && enoughDaysBetweenViews || variant.isUnlimited;

            return forced || (0, _testCanRunChecks.testCanBeRun)(t) && (0, _segmentUtil.isInTest)(t) && hasNotReachedRateLimit;
        });

        return eligibleTests[0] && new eligibleTests[0]();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(253), __webpack_require__(7), __webpack_require__(137)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _defineProperty2, _storage, _testCanRunChecks) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isInVariant = exports.setTestVariant = exports.getAssignedVariant = exports.getVariant = exports.getTestVariantId = exports.removeParticipation = exports.addParticipation = exports.isParticipating = exports.setParticipations = exports.getParticipations = undefined;

    var _defineProperty3 = _interopRequireDefault(_defineProperty2);

    var testCanRunChecks = _interopRequireWildcard(_testCanRunChecks);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var participationsKey = 'gu.ab.participations';
    var getParticipations = exports.getParticipations = function getParticipations() {
        return _storage.local.get(participationsKey) || {};
    };

    var setParticipations = exports.setParticipations = function setParticipations(participations) {
        _storage.local.set(participationsKey, participations);
    };

    var isParticipating = exports.isParticipating = function isParticipating(test) {
        return test.id in getParticipations();
    };

    var addParticipation = exports.addParticipation = function addParticipation(test, variantId) {
        var participations = getParticipations();

        participations[test.id] = {
            variant: variantId
        };

        setParticipations(participations);
    };

    var removeParticipation = exports.removeParticipation = function removeParticipation(toRemove) {
        var participations = getParticipations();
        var filteredParticipations = Object.keys(participations).filter(function (participation) {
            return participation !== toRemove.id;
        }).reduce(function (result, input) {
            Object.assign(result, (0, _defineProperty3.default)({}, input, participations[input]));
            return result;
        }, {});
        setParticipations(filteredParticipations);
    };

    var getTestVariantId = exports.getTestVariantId = function getTestVariantId(testId) {
        var participation = getParticipations()[testId];
        return participation && participation.variant;
    };

    var getVariant = exports.getVariant = function getVariant(test, variantId) {
        var variantIds = test.variants.map(function (variant) {
            return variant.id;
        });
        var index = variantIds.indexOf(variantId);
        return index > -1 ? test.variants[index] : null;
    };

    var getAssignedVariant = exports.getAssignedVariant = function getAssignedVariant(test) {
        var variantId = getTestVariantId(test.id);
        return variantId ? getVariant(test, variantId) : null;
    };

    var setTestVariant = exports.setTestVariant = function setTestVariant(testId, variant) {
        var participations = getParticipations();

        if (testId in participations) {
            participations[testId].variant = variant;
            setParticipations(participations);
        }
    };

    /**
     * returns whether the caller should treat the user as being in that variant.
     */
    var isInVariant = exports.isInVariant = function isInVariant(test, variant) {
        return getParticipations()[test.id] && getParticipations()[test.id].variant === variant.id && testCanRunChecks.testCanBeRun(test);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(245), __webpack_require__(246), __webpack_require__(50), __webpack_require__(247), __webpack_require__(51), __webpack_require__(185)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIndexOf, cacheIndexOf, createCache, getArray, largeArraySize, releaseArray, releaseObject) {

  /**
   * The base implementation of `_.uniq` without support for callback shorthands
   * or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function} [callback] The function called per iteration.
   * @returns {Array} Returns a duplicate-value-free array.
   */
  function baseUniq(array, isSorted, callback) {
    var index = -1,
        indexOf = baseIndexOf,
        length = array ? array.length : 0,
        result = [];

    var isLarge = !isSorted && length >= largeArraySize,
        seen = (callback || isLarge) ? getArray() : result;

    if (isLarge) {
      var cache = createCache(seen);
      indexOf = cacheIndexOf;
      seen = cache;
    }
    while (++index < length) {
      var value = array[index],
          computed = callback ? callback(value, index, array) : value;

      if (isSorted
            ? !index || seen[seen.length - 1] !== computed
            : indexOf(seen, computed) < 0
          ) {
        if (callback || isLarge) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    if (isLarge) {
      releaseArray(seen.array);
      releaseObject(seen);
    } else if (callback) {
      releaseArray(seen);
    }
    return result;
  }

  return baseUniq;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIndexOf, keyPrefix) {

  /**
   * An implementation of `_.contains` for cache objects that mimics the return
   * signature of `_.indexOf` by returning `0` if the value is found, else `-1`.
   *
   * @private
   * @param {Object} cache The cache object to inspect.
   * @param {*} value The value to search for.
   * @returns {number} Returns `0` if `value` is found, else `-1`.
   */
  function cacheIndexOf(cache, value) {
    var type = typeof value;
    cache = cache.cache;

    if (type == 'boolean' || value == null) {
      return cache[value] ? 0 : -1;
    }
    if (type != 'number' && type != 'string') {
      type = 'object';
    }
    var key = type == 'number' ? value : keyPrefix + value;
    cache = (cache = cache[type]) && cache[key];

    return type == 'object'
      ? (cache && baseIndexOf(cache, value) > -1 ? 0 : -1)
      : (cache ? 0 : -1);
  }

  return cacheIndexOf;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(309), __webpack_require__(310), __webpack_require__(185)], __WEBPACK_AMD_DEFINE_RESULT__ = function(cachePush, getObject, releaseObject) {

  /**
   * Creates a cache object to optimize linear searches of large arrays.
   *
   * @private
   * @param {Array} [array=[]] The array to search.
   * @returns {null|Object} Returns the cache object or `null` if caching should not be used.
   */
  function createCache(array) {
    var index = -1,
        length = array.length,
        first = array[0],
        mid = array[(length / 2) | 0],
        last = array[length - 1];

    if (first && typeof first == 'object' &&
        mid && typeof mid == 'object' && last && typeof last == 'object') {
      return false;
    }
    var cache = getObject();
    cache['false'] = cache['null'] = cache['true'] = cache['undefined'] = false;

    var result = getObject();
    result.array = array;
    result.cache = cache;
    result.push = cachePush;

    while (++index < length) {
      result.push(array[index]);
    }
    return result;
  }

  return createCache;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** Used as the size when optimizations are enabled for large arrays */
  var largeArraySize = 75;

  return largeArraySize;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /** `Object#toString` result shortcuts */
  var numberClass = '[object Number]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /**
   * Checks if `value` is a number.
   *
   * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(8.4 * 5);
   * // => true
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      value && typeof value == 'object' && toString.call(value) == numberClass || false;
  }

  return isNumber;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(134), __webpack_require__(29), __webpack_require__(124), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseFlatten, createCallback, forIn, isObject) {

  /**
   * Creates a shallow clone of `object` composed of the specified properties.
   * Property names may be specified as individual arguments or as arrays of
   * property names. If a callback is provided it will be executed for each
   * property of `object` picking the properties the callback returns truey
   * for. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The source object.
   * @param {Function|...string|string[]} [callback] The function called per
   *  iteration or property names to pick, specified as individual property
   *  names or arrays of property names.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns an object composed of the picked properties.
   * @example
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
   * // => { 'name': 'fred' }
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
   *   return key.charAt(0) != '_';
   * });
   * // => { 'name': 'fred' }
   */
  function pick(object, callback, thisArg) {
    var result = {};
    if (typeof callback != 'function') {
      var index = -1,
          props = baseFlatten(arguments, true, false, 1),
          length = isObject(object) ? props.length : 0;

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
    } else {
      callback = createCallback(callback, thisArg, 3);
      forIn(object, function(value, key, object) {
        if (callback(value, key, object)) {
          result[key] = value;
        }
      });
    }
    return result;
  }

  return pick;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-tick inline-icon\"><svg width=\"10.79\" height=\"8.608\" viewBox=\"0 0 10.79 8.608\"><path d=\"M2.987 6.575L10.244 0l.546.532-7.803 8.076h-.26L0 4.788l.545-.546 2.442 2.333z\"/></svg></span>"}

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var addClassesAndTitle = exports.addClassesAndTitle = function addClassesAndTitle(markup, classes, title) {
        // Only mess with classes if we actually need to.
        var markupWithClasses = markup;
        if (classes) {
            // #? Typchecking not needed anymore
            if (Array.isArray(classes)) {
                markupWithClasses = markupWithClasses.replace(/class="/, 'class="' + classes.join(' ') + ' ');
            } else if (window.console && window.console.error) {
                // Some environments don't support or don't always expose the console object
                window.console.error('Classes for inlineSvg must be an array: ' + classes);
            }
        }

        // Only mess with title if we actually need to.
        var markupWithTitle = title ? markupWithClasses.replace(/<span /, '<span title="' + title + '" ') : markupWithClasses;

        return markupWithTitle;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(80);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

  /**
   * Creates an array with all falsey values removed. The values `false`, `null`,
   * `0`, `""`, `undefined`, and `NaN` are all falsey.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to compact.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.compact([0, 1, false, 2, '', 3]);
   * // => [1, 2, 3]
   */
  function compact(array) {
    var index = -1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result.push(value);
      }
    }
    return result;
  }

  return compact;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createCallback, forOwn) {

  /**
   * Creates an object with the same keys as `object` and values generated by
   * running each own enumerable property of `object` through the callback.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new object with values of the results of each `callback` execution.
   * @example
   *
   * _.mapValues({ 'a': 1, 'b': 2, 'c': 3} , function(num) { return num * 3; });
   * // => { 'a': 3, 'b': 6, 'c': 9 }
   *
   * var characters = {
   *   'fred': { 'name': 'fred', 'age': 40 },
   *   'pebbles': { 'name': 'pebbles', 'age': 1 }
   * };
   *
   * // using "_.pluck" callback shorthand
   * _.mapValues(characters, 'age');
   * // => { 'fred': 40, 'pebbles': 1 }
   */
  function mapValues(object, callback, thisArg) {
    var result = {};
    callback = createCallback(callback, thisArg, 3);

    forOwn(object, function(value, key, object) {
      result[key] = callback(value, key, object);
    });
    return result;
  }

  return mapValues;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(42),
    __webpack_require__(14)
], __WEBPACK_AMD_DEFINE_RESULT__ = function(
    bean,
    debounce,
    assign
) {

    // Be sure to wrap your event functions with fastdom as this doesn't assume DOM manipulation
    function noop() {}

    function elementIsInView(el, offsets_) {
        var offsets = assign({}, {left: 0, right: 0, top: 0, bottom: 0}, offsets_);

        var rect = el.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var viewportWidth = window.innerWidth;

        var fromTop = rect.top + offsets.top;
        var fromBottom = rect.bottom - offsets.bottom;
        var fromLeft = rect.left - offsets.left;
        var fromRight = rect.right + offsets.right;

        var visibleVertically = fromTop < viewportHeight && fromBottom > 0;
        var visibleHorizontally = fromLeft < viewportWidth && fromRight > 0;

        return visibleVertically && visibleHorizontally;
    }



    function ElementInview(element, container, offsets) {
        var hasBeenSeen = false;

        var events = {
            firstview: noop
        };

        bean.on(container, 'scroll', debounce(function() {
            var inView = elementIsInView(element, offsets);

            if (inView) {
                if (!hasBeenSeen) {
                    hasBeenSeen = true;
                    events.firstview(element);
                }
            }
        }, 200));

        return {
            on: function (event, func) {
                events[event] = func;
            }
        };
    }

    return ElementInview;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (config, detect) {
    return function () {
        this.id = 'IncreaseInlineAdsReduxRedux';
        this.start = '2017-05-05';
        this.expiry = '2017-05-29';
        this.author = 'Gideon Goldberg';
        this.description = 'Displays more inline ads in articles on desktop';
        this.audience = .05;
        this.audienceOffset = 0;
        this.successMeasure = 'Our inventory has increased';
        this.audienceCriteria = '';
        this.dataLinkNames = '';
        this.idealOutcome = 'Viewability and user engagement has not been impacted';
        this.showForSensitive = true;

        this.canRun = function () {
          return !config.page.isImmersive && detect.isBreakpoint({ min: 'desktop' });
        };

        this.variants = [
            {
                id: 'yes',
                test: function () {}
            },
            {
                id: 'no',
                test: function () {}
            }
        ];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(5),
    __webpack_require__(0),
    __webpack_require__(7),
    __webpack_require__(21),
    __webpack_require__(129),
    __webpack_require__(122),
    __webpack_require__(4)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    qwery,
    config,
    storage,
    template,
    commercialFeatures,
    userFeatures,
    mediator) {
    var EditionTest = function (edition, id, start, expiry, campaignPrefix) {

        this.edition = edition;
        this.campaignPrefix = campaignPrefix;
        this.id = id;
        this.start = start;
        this.expiry = expiry;
        this.author = 'Roberto Tyley';
        this.description = 'Show contributions/membership messages for the ' + edition + ' edition.';
        this.showForSensitive = false;
        this.audience = 0;
        this.audienceOffset = 0;
        this.successMeasure = 'Conversion';
        this.audienceCriteria = 'All users in the ' + edition + ' edition.';
        this.dataLinkNames = '';
        this.idealOutcome = '';

        // Required by the A/B testing framework - can not be async, unfortunately
        this.canRun = function () {
            var matchesEdition = config.page.edition == edition;
            return matchesEdition && commercialFeatures.canReasonablyAskForMoney;
        };

        this.completer = function (complete) {
            mediator.on('membership-message:display', function () {
                /* When the button link is clicked, call the function that indicates the A/B test is 'complete'
                 * ...note that for Membership & Contributions this completion is only the start of a longer
                 * journey that will hopefully end pages later with the user giving us money.
                 */
                bean.on(qwery('#membership__engagement-message-link')[0], 'click', complete);
            });
        };

        this.variants = [];

    };

    EditionTest.prototype.addMessageVariant = function (variantId, variantParams) {
        this.variants.push({
            id: variantId,
            engagementBannerParams: variantParams,
            /*  We don't want to run any 'code' in this test, we just want a variant to be selected. All message display
             * is performed in membership-engagement-banner.js, modifying the banner using the data in variantParams.
             */
            test: function () {},
            success: this.completer
        });
        return this;
    };

    EditionTest.prototype.addMembershipVariant = function (variantId, variantParams) {
        variantParams.campaignCode = this.campaignPrefix + variantId;
        return this.addMessageVariant(variantId, variantParams);
    };

    EditionTest.prototype.addContributionsVariant = function (variantId, variantParams) {
        variantParams.campaignCode = this.campaignPrefix + variantId;

        return this.addMessageVariant(variantId, {contributions: variantParams});
    };

    return []
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-quote inline-icon\"><svg width=\\\"17\\\" height=\\\"10\\\" viewBox=\\\"0 0 33 20\\\"><path d=\\\"M9.002 20c3.85.068 6.932-3.104 7-6.994.068-3.892-3.15-6.937-7-7.006-2.016-.036-3.59.694-4.888 2.053-.07-.48-.122-1.04-.113-1.553C4.064 2.97 7.414.937 11.003 1l-1-1C3.98 0 .098 4.447.002 10.006c-.097 5.557 3.35 9.892 9 9.994zM26.002 20c3.85.068 6.932-3.104 7-6.994.068-3.892-3.15-6.937-7-7.006-2.016-.036-3.59.694-4.888 2.053-.07-.48-.122-1.04-.113-1.553.063-3.53 3.413-5.563 7.002-5.5l-1-1c-6.022 0-9.904 4.447-10 10.006-.097 5.557 3.35 9.892 9 9.994z\\\"/></svg></span>"}

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-thumb inline-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"> <path fill=\"#FFF\" d=\"M33.78 22.437l-4.228 13.98L27.93 37.5 5.062 34.14V15.503l7.8-1.517L24.354 2.5h1.624L28.9 5.426l-4.548 8.67h.107l10.477 1.31\"></path> </svg></span>"}

/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(41), __webpack_require__(233)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _memoize, _getAdvertById) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _memoize2 = _interopRequireDefault(_memoize);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var waitForAdvert = (0, _memoize2.default)(function (id) {
        return new Promise(function (resolve) {
            var checkAdvert = function checkAdvert() {
                var advert = (0, _getAdvertById.getAdvertById)(id);
                if (!advert) {
                    window.setTimeout(checkAdvert, 200);
                } else {
                    resolve(advert);
                }
            };
            checkAdvert();
        });
    });

    exports.default = waitForAdvert;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(30)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _cookies) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getMvtFullId = exports.getMvtNumValues = exports.getMvtValue = exports.overwriteMvtCookie = undefined;


    var MULTIVARIATE_ID_COOKIE = 'GU_mvt_id';

    var VISITOR_ID_COOKIE = 's_vi';
    var BROWSER_ID_COOKIE = 'bwid';
    // The full mvt ID interval is [1, 1000000]
    var MAX_CLIENT_MVT_ID = 1000000;

    // For test purposes only.
    var overwriteMvtCookie = exports.overwriteMvtCookie = function overwriteMvtCookie(testId) {
        return (0, _cookies.addCookie)(MULTIVARIATE_ID_COOKIE, testId, 365);
    };

    var getMvtValue = exports.getMvtValue = function getMvtValue() {
        return Number((0, _cookies.getCookie)(MULTIVARIATE_ID_COOKIE));
    };

    var getMvtNumValues = exports.getMvtNumValues = function getMvtNumValues() {
        return Number(MAX_CLIENT_MVT_ID);
    };

    var getMvtFullId = exports.getMvtFullId = function getMvtFullId() {
        var bwidCookie = (0, _cookies.getCookie)(BROWSER_ID_COOKIE) || 'unknown-browser-id';
        var mvtidCookie = getMvtValue() || 'unknown-mvt-id';
        var visitoridCookie = (0, _cookies.getCookie)(VISITOR_ID_COOKIE) || 'unknown-visitor-id';

        return visitoridCookie + ' ' + bwidCookie + ' ' + mvtidCookie;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(125), __webpack_require__(136), __webpack_require__(75), __webpack_require__(4), __webpack_require__(7), __webpack_require__(21), __webpack_require__(40), __webpack_require__(318), __webpack_require__(296)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _toConsumableArray2, _events, _fastdomPromise, _mediator, _storage, _template, _ng, _measureUnderstanding, _thumb) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.MeasureUnderstanding = undefined;

    var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _template2 = _interopRequireDefault(_template);

    var _ng2 = _interopRequireDefault(_ng);

    var _measureUnderstanding2 = _interopRequireDefault(_measureUnderstanding);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var MeasureUnderstanding = function MeasureUnderstanding() {
        // Test id
        var id = 'MeasureUnderstanding';

        // Ophan survey id
        var component = 'measure_understanding';

        // List of pages the test will run in
        var paths = ['/us-news/2017/may/11/justice-department-fbi-documents-trump-russia-hack-clinton-email', '/us-news/2017/may/09/james-comey-fbi-fired-donald-trump', '/us-news/2017/may/10/theres-nothing-there-white-house-staff-deny-comey-sacking-is-linked-to-russia', '/us-news/2017/may/10/terrifying-astonishing-nixonian-james-comeys-termination-by-trump', '/us-news/2017/may/11/james-comey-farewell-letter-fbi-independence--sacking-fallout', '/us-news/2017/may/09/james-comey-fbi-fired-donald-trump-hillary-clinton-emails'];

        // A heuristic to detect explainers in the article via their dataset.canonicalUrl
        var prefix = 'https://interactive.guim.co.uk/2016/08/explainer-interactive';

        // Test duration
        var start = '2017-05-11';
        var expiry = '2017-05-18';

        // will run in articles only if no story questions atom is already there
        // *and* the user hasn't already answered the question
        var canRun = function canRun() {
            return paths.includes(location.pathname) && !_storage.local.get(id);
        };

        // at the click of a button, we send a notification to ophan and clean up
        // registered listeners to prevent duplicate calls
        var onClick = function onClick(evt) {
            // #? Flow will complain if we don't type check
            if (!(evt.target instanceof Element)) {
                throw new Error('This will never happen');
            }
            var button = evt.target.closest('.js-button');
            var value = button && button.getAttribute('data-value');
            if (value) {
                (function () {
                    // #? Flow will complain if we don't type check
                    if (!(evt.currentTarget instanceof Element)) {
                        throw new Error('This will never happen');
                    }
                    var question = evt.currentTarget;
                    var feedback = question.lastElementChild;
                    question.removeEventListener('click', onClick);
                    _fastdomPromise2.default.write(function () {
                        question.classList.add('is-answered');
                        [].concat((0, _toConsumableArray3.default)(question.querySelectorAll('.js-button'))).forEach(function (b) {
                            return b.setAttribute('hidden', 'hidden');
                        });
                        if (feedback) {
                            feedback.removeAttribute('hidden');
                        }
                    }).then(function () {
                        _storage.local.set(id, true, { expires: Date.parse(expiry) });
                        _ng2.default.record({ component: component, value: value });
                        _mediator2.default.emit('ab:understanding:complete');
                    });
                })();
            }
        };

        // test bootstrap: runs when the user is in the corresponding variant
        var test = function test() {
            var html = (0, _template2.default)(_measureUnderstanding2.default, {
                thumbsUp: _thumb.markup,
                thumbsDown: _thumb.markup
            });
            var articleBody = document.getElementsByClassName('js-article__body')[0];
            _fastdomPromise2.default.write(function () {
                articleBody.insertAdjacentHTML('beforeend', html);
                return articleBody.lastElementChild;
            }).then(function (clicktrap) {
                (0, _events.addEventListener)(clicktrap, 'click', onClick);
                _mediator2.default.emit('ab:understanding:displayed');
            });
        };

        var testWithout = function testWithout() {
            _fastdomPromise2.default.write(function () {
                [].concat((0, _toConsumableArray3.default)(document.getElementsByClassName('element-interactive'))).forEach(function (i) {
                    var url = i.getAttribute('data-canonical-url');
                    if (url && url.includes(prefix)) {
                        i.hidden = true;
                        i.style.display = 'none';
                    }
                });
            });
            test();
        };

        // registers an impression (in our case, when the form is added to the dom)
        var impression = function impression(track) {
            _mediator2.default.on('ab:understanding:displayed', track);
        };

        // registers a successful test (in our case, when the user answers the question)
        var success = function success(track) {
            _mediator2.default.on('ab:understanding:complete', track);
        };

        return Object.freeze({
            id: id,
            start: start,
            expiry: expiry,
            audience: 1,
            audienceOffset: 0,
            author: 'Nathan',
            description: 'Measure Understanding survey',
            successMeasure: '',
            audienceCriteria: '',
            idealOutcome: "We improve users' understanding of a topic by showing them Explainers",
            canRun: canRun,
            showForSensitive: true,
            variants: [{ id: 'with-explainer', test: test, impression: impression, success: success }, { id: 'without-explainer', test: testWithout, impression: impression, success: success }]
        });
    };

    exports.MeasureUnderstanding = MeasureUnderstanding;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(59), __webpack_require__(125), __webpack_require__(20), __webpack_require__(13), __webpack_require__(19), __webpack_require__(0), __webpack_require__(30), __webpack_require__(7), __webpack_require__(4), __webpack_require__(311), __webpack_require__(40), __webpack_require__(21), __webpack_require__(237), __webpack_require__(188)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _classCallCheck2, _toConsumableArray2, _bean, _bonzo, _fastdom, _config, _cookies, _storage, _mediator, _tailorSurvey, _ng, _template, _spaceFiller, _tailor) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.TailorSurvey = undefined;

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

    var _bean2 = _interopRequireDefault(_bean);

    var _bonzo2 = _interopRequireDefault(_bonzo);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _config2 = _interopRequireDefault(_config);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _tailorSurvey2 = _interopRequireDefault(_tailorSurvey);

    var _ng2 = _interopRequireDefault(_ng);

    var _template2 = _interopRequireDefault(_template);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    // Every time we show a survey to a user, we cannot show it again to that suer for a specified number of days.
    // We store 'surveyId=dayShowAgain' in the cookie, and pass any surveys that cannot currently be shown in the
    // call to tailor.
    var storeSurveyShowedInCookie = function storeSurveyShowedInCookie(data) {
        var id = data.survey.surveyId;
        var dayCanShowAgain = data.dayCanShowAgain;
        var newCookieValue = id + '=' + dayCanShowAgain;
        var currentCookieValues = (0, _cookies.getCookie)('GU_TAILOR_SURVEY');

        if (currentCookieValues) {
            // we've shown surveys already
            currentCookieValues = currentCookieValues + ',' + newCookieValue;
            (0, _cookies.removeCookie)('GU_TAILOR_SURVEY');
            (0, _cookies.addCookie)('GU_TAILOR_SURVEY', currentCookieValues, 365);
        } else {
            // first time we show any survey
            (0, _cookies.addCookie)('GU_TAILOR_SURVEY', newCookieValue, 365);
        }
    };

    // We go through the list of surveys that have already been shown to the user, and return a list of survey ids
    // that aren't currently allowed to be shown.
    var getSurveyIdsNotToShow = function getSurveyIdsNotToShow() {
        var currentCookieValues = (0, _cookies.getCookie)('GU_TAILOR_SURVEY');
        var values = currentCookieValues ? currentCookieValues.split(',') : [];
        var isAfterToday = function isAfterToday(cookieValue) {
            var date = cookieValue.split('=')[1];

            return new Date(date).valueOf() > new Date().valueOf();
        };
        var surveysWeCannotShow = values.filter(isAfterToday);

        return surveysWeCannotShow.map(function (idAndDate) {
            return idAndDate.split('=')[0];
        }).toString();
    };

    // Getting simple json from tailor's reponse to be passed to the html template
    var getJsonFromSurvey = function getJsonFromSurvey(survey) {
        return {
            question: survey.question,
            id: survey.surveyId
        };
    };

    // Rules to use when finding a space for the survey
    var spacefinderRules = {
        bodySelector: '.js-article__body',
        slotSelector: ' > p',
        minAbove: 0,
        minBelow: 0,
        clearContentMeta: 50,
        selectors: {
            ' .element-rich-link': {
                minAbove: 100,
                minBelow: 100
            },
            ' .element-image': {
                minAbove: 50,
                minBelow: 50
            },
            ' .player': {
                minAbove: 0,
                minBelow: 0
            },
            ' > h1': {
                minAbove: 0,
                minBelow: 0
            },
            ' > h2': {
                minAbove: 0,
                minBelow: 0
            },
            ' > *:not(p):not(h2):not(blockquote)': {
                minAbove: 0,
                minBelow: 0
            },
            ' .ad-slot': {
                minAbove: 100,
                minBelow: 100
            }
        }
    };

    // we can write a survey into a spare space using spaceFiller
    var inArticleWriter = function inArticleWriter(survey, surveyId) {
        return (0, _spaceFiller.fillSpace)(spacefinderRules, function (paras) {
            var componentName = 'data_tailor_survey_' + surveyId;

            _mediator2.default.emit('register:begin', componentName);
            (0, _bonzo2.default)(survey).insertBefore(paras[0]);
            _mediator2.default.emit('register:end', componentName);

            return surveyId;
        });
    };

    // the main function to render the survey
    var renderQuickSurvey = function renderQuickSurvey() {
        var queryParams = {};

        queryParams.edition = _config2.default.page.edition;

        // If we want to force tailor to show a particular survey we can set an attribute in local storage to have
        // key = 'surveyToShow', and value = the survey id. Tailor will then override other logic for display, and
        // look for a survey with this ID to return. This is useful as we can easily see how a particular survey
        // would be rendered, without actually putting it live. If this parameter is empty or not specified, tailor
        // behaves as usual.
        var surveyToShow = _storage.local.get('surveyToShow');

        if (surveyToShow) {
            queryParams.surveyToShow = surveyToShow;
        }

        // get the list of surveys that can't be shown as they have been shown recently
        var surveysNotToShow = getSurveyIdsNotToShow();

        if (surveysNotToShow) {
            queryParams.surveysNotToShow = surveysNotToShow;
        }

        return (0, _tailor.getSuggestedSurvey)(queryParams).then(function (suggestion) {
            if (suggestion) {
                storeSurveyShowedInCookie(suggestion.data);

                var json = getJsonFromSurvey(suggestion.data.survey);
                var survey = _bonzo2.default.create((0, _template2.default)(_tailorSurvey2.default, json));

                return inArticleWriter(survey, suggestion.data.survey.surveyId);
            }
            Promise.resolve();
        });
    };

    var disableRadioButtons = function disableRadioButtons(buttonClassName) {
        var radioButtons = document.getElementsByClassName(buttonClassName);

        [].concat((0, _toConsumableArray3.default)(radioButtons)).forEach(function (button) {
            var radio = button;

            radio.disabled = true;
        });
    };

    var surveyFadeOut = function surveyFadeOut() {
        var surveyContent = document.getElementsByClassName('impressions-survey__content');

        [].concat((0, _toConsumableArray3.default)(surveyContent)).forEach(function (content) {
            content.classList.add('js-impressions-survey__fadeout');
        });
    };

    var thankyouFadeIn = function thankyouFadeIn() {
        var surveyThanks = document.getElementsByClassName('impressions-survey__thanks');

        [].concat((0, _toConsumableArray3.default)(surveyThanks)).forEach(function (thanks) {
            thanks.classList.add('js-impressions-survey__fadein');
        });
    };

    var recordOphanAbEvent = function recordOphanAbEvent(answer, surveyId) {
        var componentId = 'data_tailor_survey_' + surveyId;

        _ng2.default.record({
            component: componentId,
            value: answer
        });
    };

    var handleSurveyResponse = function handleSurveyResponse(surveyId) {
        var surveyQuestions = [].concat((0, _toConsumableArray3.default)(document.getElementsByClassName('fi-survey__button')));

        surveyQuestions.forEach(function (question) {
            // #? use addEventListener
            _bean2.default.on(question, 'click', function (event) {
                if (event.target.attributes.getNamedItem('data-link-name')) {
                    var answer = event.target.attributes.getNamedItem('data-link-name').value;

                    recordOphanAbEvent(answer, surveyId);

                    _mediator2.default.emit('tailor:survey:clicked');
                    _fastdom2.default.write(function () {
                        disableRadioButtons('fi-survey__button');
                        surveyFadeOut();
                        thankyouFadeIn();
                    });
                }
            });
        });
    };

    var TailorSurvey = function TailorSurvey() {
        (0, _classCallCheck3.default)(this, TailorSurvey);

        this.id = 'TailorSurvey';
        this.start = '2017-03-07';
        this.expiry = '2017-05-31';
        this.author = 'Manlio & Mahana';
        this.description = 'Testing Tailor surveys';
        this.audience = 1;
        this.audienceOffset = 0;
        this.successMeasure = 'We can show a survey on Frontend as decided by Tailor';
        this.audienceCriteria = 'All users';
        this.dataLinkNames = 'Tailor survey';
        this.idealOutcome = '';
        this.canRun = function () {
            return !_config2.default.page.isAdvertisementFeature && _config2.default.page.contentType === 'Article';
        };
        this.variants = [{
            id: 'control',
            test: function test() {}
        }, {
            id: 'variant',
            test: function test() {
                renderQuickSurvey().then(function (surveyId) {
                    if (surveyId) {
                        _mediator2.default.emit('survey-added');
                        handleSurveyResponse(surveyId);
                    }
                });
            },
            impression: function impression(track) {
                _mediator2.default.on('survey-added', track);
            },
            success: function success(complete) {
                _mediator2.default.on('tailor:survey:clicked', complete);
            }
        }];
    };

    exports.TailorSurvey = TailorSurvey;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(307)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIndexOf, sortedIndex) {

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeMax = Math.max;

  /**
   * Gets the index at which the first occurrence of `value` is found using
   * strict equality for comparisons, i.e. `===`. If the array is already sorted
   * providing `true` for `fromIndex` will run a faster binary search.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {boolean|number} [fromIndex=0] The index to search from or `true`
   *  to perform a binary search on a sorted array.
   * @returns {number} Returns the index of the matched value or `-1`.
   * @example
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2);
   * // => 1
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
   * // => 4
   *
   * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
   * // => 2
   */
  function indexOf(array, value, fromIndex) {
    if (typeof fromIndex == 'number') {
      var length = array ? array.length : 0;
      fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0);
    } else if (fromIndex) {
      var index = sortedIndex(array, value);
      return array[index] === value ? index : -1;
    }
    return baseIndexOf(array, value, fromIndex);
  }

  return indexOf;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29), __webpack_require__(79)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createCallback, identity) {

  /**
   * Uses a binary search to determine the smallest index at which a value
   * should be inserted into a given sorted array in order to maintain the sort
   * order of the array. If a callback is provided it will be executed for
   * `value` and each element of `array` to compute their sort ranking. The
   * callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to inspect.
   * @param {*} value The value to evaluate.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {number} Returns the index at which `value` should be inserted
   *  into `array`.
   * @example
   *
   * _.sortedIndex([20, 30, 50], 40);
   * // => 2
   *
   * // using "_.pluck" callback shorthand
   * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
   * // => 2
   *
   * var dict = {
   *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
   * };
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return dict.wordToNumber[word];
   * });
   * // => 2
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return this.wordToNumber[word];
   * }, dict);
   * // => 2
   */
  function sortedIndex(array, value, callback, thisArg) {
    var low = 0,
        high = array ? array.length : low;

    // explicitly reference `identity` for better inlining in Firefox
    callback = callback ? createCallback(callback, thisArg, 1) : identity;
    value = callback(value);

    while (low < high) {
      var mid = (low + high) >>> 1;
      (callback(array[mid]) < value)
        ? low = mid + 1
        : high = mid;
    }
    return low;
  }

  return sortedIndex;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keyPrefix) {

  /**
   * Adds a given value to the corresponding cache object.
   *
   * @private
   * @param {*} value The value to add to the cache.
   */
  function cachePush(value) {
    var cache = this.cache,
        type = typeof value;

    if (type == 'boolean' || value == null) {
      cache[value] = true;
    } else {
      if (type != 'number' && type != 'string') {
        type = 'object';
      }
      var key = type == 'number' ? value : keyPrefix + value,
          typeCache = cache[type] || (cache[type] = {});

      if (type == 'object') {
        (typeCache[key] || (typeCache[key] = [])).push(value);
      } else {
        typeCache[key] = true;
      }
    }
  }

  return cachePush;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(189)], __WEBPACK_AMD_DEFINE_RESULT__ = function(objectPool) {

  /**
   * Gets an object from the object pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Object} The object from the pool.
   */
  function getObject() {
    return objectPool.pop() || {
      'array': null,
      'cache': null,
      'criteria': null,
      'false': false,
      'index': 0,
      'null': false,
      'number': null,
      'object': null,
      'push': null,
      'string': null,
      'true': false,
      'undefined': false,
      'value': null
    };
  }

  return getObject;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"impressions-survey__heading\">\n    <div class=\"impressions-survey__title\">Survey</div>\n    <div class=\"impressions-survey__title\">\n        <a href=\"https://www.theguardian.com/help/terms-of-service\" target=\"_blank\" class=\"impressions-survey__about\">About</a>\n    </div>\n</div>\n\n<div class=\"impressions-survey__body\" data-link-name=\"data_tailor_survey_<%=id%>\" data-component=\"data_tailor_survey_<%=id%>\">\n\n    <div class=\"impressions-survey__content\">\n        <h3 class=\"impressions-survey__question\">\n            <%=question%></h3>\n        <div class=\"impressions-survey__select\">\n            <label class=\"fi-survey__label\">\n                <input type=\"radio\" class=\"fi-survey__button\" data-link-name=\"answer5\" value=\"answer5\">\n                Strongly agree</label>\n            <label class=\"fi-survey__label\">\n                <input type=\"radio\" class=\"fi-survey__button\" data-link-name=\"answer4\" value=\"answer4\">\n                Slightly agree</label>\n            <label class=\"fi-survey__label\">\n                <input type=\"radio\" class=\"fi-survey__button\" data-link-name=\"answer3\" value=\"answer3\">\n                Neither agree nor disagree</label>\n            <label class=\"fi-survey__label\">\n                <input type=\"radio\" class=\"fi-survey__button\" data-link-name=\"answer2\" value=\"answer2\">\n                Slightly disagree</label>\n            <label class=\"fi-survey__label\">\n                <input type=\"radio\" class=\"fi-survey__button\" data-link-name=\"answer1\" value=\"answer1\">\n                Strongly disagree</label>\n        </div>\n    </div>\n\n    <div class=\"impressions-survey__thanks\">\n        Thank you for helping us<br>improve the Guardian\n    </div>\n</div>\n"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Hello again …\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            … today we have a small favour to ask. More people than ever are regularly reading the Guardian, but far fewer are paying for it.  Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\"> unlike many news organisations, we haven’t put up a paywall &ndash; we want to keep our journalism as open as we can</span>. So we think it’s fair to ask people who visit us often for their help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters &ndash; because it might well be your perspective, too.\n        </p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\"\n               href=\"<%=membershipUrl%>\"\n               target=\"_blank\">\n                Become a supporter\n            </a>\n        </div>\n\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\"\n               href=\"<%=contributionUrl%>\"\n               target=\"_blank\">\n                Make a contribution\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "<div class=\"block block--content contributions__epic contributions__epic--liveblog\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Since you’re here …\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            … we’ve got a small favour to ask. More people are reading the Guardian than ever, but far fewer are paying for it. Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\">unlike many news organisations, we haven’t put up a paywall &ndash; we want to keep our journalism as open as we can</span>. So you can see why we need to ask for your help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters &ndash; because it might well be your perspective, too.\n        </p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\"\n               href=\"<%=membershipUrl%>\"\n               target=\"_blank\">\n                Become a supporter\n            </a>\n        </div>\n\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\"\n               href=\"<%=contributionUrl%>\"\n               target=\"_blank\">\n                Make a contribution\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Since you’re here …\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            … we’ve got a small favour to ask. More people are reading the Guardian than ever, but far fewer are paying for it. Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\">unlike many news organisations, we haven’t put up a paywall – we want to keep our journalism as open as we can</span>. So you can see why we need to ask for your help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters – because it might well be your perspective, too.\n        </p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\"\n               href=\"<%=contributionUrl%>\"\n               target=\"_blank\">\n                Make a contribution\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Since you’re here …\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            … we’ve got a small favour to ask. More people are reading the Guardian than ever, but far fewer are paying for it. Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\">unlike many news organisations, we haven’t put up a paywall – we want to keep our journalism as open as we can</span>. So you can see why we need to ask for your help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters – because it might well be your perspective, too.\n        </p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\"\n               href=\"<%=membershipUrl%>\"\n               target=\"_blank\">\n                Become a supporter\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            Since you’re here &hellip;\n        </h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            &hellip; we’ve got a small favour to ask. More people are reading the Guardian than ever, but far fewer are paying for it. Advertising revenues across the media are falling fast. And <span class=\"contributions__highlight\">unlike many news organisations, we haven’t put up a paywall – we want to keep our journalism as open as we can</span>. So you can see why we need to ask for your help. The Guardian’s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters – because it might well be your perspective, too.\n        </p>\n\n        <div class=\"epic__testimonial-container epic__testimonial-container--subtle\">\n            <div class=\"epic__testimonial-quote epic__testimonial-quote--subtle\">\n                <%=quoteSvg%>\n            </div>\n            <blockquote class=\"epic__testimonial-text\">\n                <%=testimonialMessage%>\n                <br>\n                <cite class=\"epic__testimonial-name\">\n                    <%=testimonialName%>\n                </cite>\n            </blockquote>\n        </div>\n\n        <p class=\"contributions__paragraph contributions__paragraph--epic\">\n            If everyone who reads our reporting, who likes it, helps to support it, our future would be much more secure.\n        </p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\"\n               href=\"<%=membershipUrl%>\"\n               target=\"_blank\">\n                Become a supporter\n            </a>\n        </div>\n\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\"\n               href=\"<%=contributionUrl%>\"\n               target=\"_blank\">\n                Make a contribution\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contributions__epic\" data-component=\"<%=componentName%>\">\n    <div>\n        <h2 class=\"contributions__title contributions__title--epic\">\n            <%=title%></h2>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\"><%=p1%></p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\"><%=p2%></p>\n        <p class=\"contributions__paragraph contributions__paragraph--epic\"><%=p3%></p>\n    </div>\n\n    <div class=\"contributions__amount-field\">\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member contributions__contribute--epic-member-top\" href=\"<%=linkUrl1%>\" target=\"_blank\">\n                <%=cta1%>\n            </a>\n        </div>\n\n        <div>\n            <a class=\"contributions__option-button contributions__contribute contributions__contribute--epic contributions__contribute--epic-member\" href=\"<%=linkUrl2%>\" target=\"_blank\">\n                <%=cta2%>\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<div class=\"understanding\">\n    <p class=\"understanding__text\" tabindex=\"0\">Do you feel better informed as a result of reading this piece?</p>\n    <button class=\"understanding__choice js-button\" data-value=\"yes\">\n        <%= thumbsUp %>\n        <span>Yes</span>\n    </button>\n    <button class=\"understanding__choice js-button\" data-value=\"no\">\n        <%= thumbsDown %>\n        <span>No</span>\n    </button>\n    <div class=\"understanding__feedback\" hidden aria-role=\"alert\" aria-live=\"polite\">Thank you!</div>\n</div>\n"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "<li class=\"global-navigation__section js-global-navigation__section--history\" data-link-name=\"shortcuts\">\n    <span class=\"global-navigation__title global-navigation__title--history\">recently visited</span>\n    <ul class=\"global-navigation__children global-navigation__children--history\">\n        <%=tags%>\n        <a class=\"button button--small button--tag button--tertiary\" href=\"/preferences\" data-link-name=\"edit\">edit these</a>\n    </ul>\n</li>\n"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<li class=\"inline-list__item\">\n    <a href=\"/<%=id%>\" class=\"button button--small button--tag button--secondary\" data-link-name=\"<%=index%> | <%=name%>\"><%=name%></a>\n</li>\n"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(20),
    __webpack_require__(75),
    __webpack_require__(0),
    __webpack_require__(4),
    __webpack_require__(231),
    __webpack_require__(41)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    qwery,
    bean,
    fastdom,
    config,
    mediator,
    trackAdRender,
    memoize
) {
    // total_hours_spent_maintaining_this = 64
    //
    // maximum time (in ms) to wait for images to be loaded and rich links
    // to be upgraded
    var LOADING_TIMEOUT = 5000;

    // find spaces in articles for inserting ads and other inline content
    // minAbove and minBelow are measured in px from the top of the paragraph element being tested
    var defaultRules = { // these are written for adverts
        bodySelector: '.js-article__body',
        slotSelector: ' > p',
        absoluteMinAbove: 0, // minimum from slot to top of page
        minAbove: 250, // minimum from para to top of article
        minBelow: 300, // minimum from (top of) para to bottom of article
        clearContentMeta: 50, // vertical px to clear the content meta element (byline etc) by. 0 to ignore
        selectors: { // custom rules using selectors. format:
            //'.selector': {
            //   minAbove: <min px above para to bottom of els matching selector>,
            //   minBelow: <min px below (top of) para to top of els matching selector> }
            ' > h2': {minAbove: 0, minBelow: 250}, // hug h2s
            ' > *:not(p):not(h2)': {minAbove: 25, minBelow: 250} // require spacing for all other elements
        },

        // filter:(slot:Element, index:Integer, slots:Collection<Element>) -> Boolean
        // will run each slot through this fn to check if it must be counted in
        filter: null,

        // startAt:Element
        // will remove slots before this one
        startAt: null,

        // stopAt:Element
        // will remove slots from this one on
        stopAt: null,

        // fromBotton:Boolean
        // will reverse the order of slots (this is useful for lazy loaded content)
        fromBottom: false
    };

    var defaultOptions = {
        waitForImages: true,
        waitForLinks: true,
        waitForInteractives: false,
        waitForAds: false
    };

    function expire(resolve) {
        window.setTimeout(resolve, LOADING_TIMEOUT);
    }

    function getFuncId(rules) {
        return rules.bodySelector || 'document';
    }

    var onImagesLoaded = memoize(function (rules) {
        var notLoaded = qwery('img', rules.body).filter(function (img) {
            return !img.complete;
        });

        return notLoaded.length === 0 ?
            true :
            new Promise(function (resolve) {
                var loadedCount = 0;
                bean.on(rules.body, 'load', notLoaded, function onImgLoaded() {
                    loadedCount += 1;
                    if (loadedCount === notLoaded.length) {
                        bean.off(rules.body, 'load', onImgLoaded);
                        notLoaded = null;
                        resolve();
                    }
                });
            });
    }, getFuncId);

    var onRichLinksUpgraded = memoize(function (rules) {
        return qwery('.element-rich-link--not-upgraded', rules.body).length === 0 ?
            true :
            new Promise(function (resolve) {
                mediator.once('rich-link:loaded', resolve);
            });
    }, getFuncId);

    var onInteractivesLoaded = memoize(function (rules) {
        var notLoaded = qwery('.element-interactive', rules.body).filter(function (interactive) {
            var iframe = qwery(interactive.children).filter(isIframe);
            return !(iframe.length && isIframeLoaded(iframe[0]));
        });

        return notLoaded.length === 0 || !('MutationObserver' in window) ?
            true :
            Promise.all(notLoaded.map(function (interactive) {
                return new Promise(function (resolve) {
                    new MutationObserver(function (records, instance) {
                        if (!(records.length > 0 &&
                            records[0].addedNodes.length > 0 &&
                            isIframe(records[0].addedNodes[0]))
                        ) {
                            return;
                        }

                        var iframe = records[0].addedNodes[0];
                        if (isIframeLoaded(iframe)) {
                            instance.disconnect();
                            resolve();
                        } else {
                            iframe.addEventListener('load', function () {
                                instance.disconnect();
                                resolve();
                            });
                        }
                    }).observe(interactive, { childList: true });
                });
            }));

        function isIframe(node) {
            return node.nodeName === 'IFRAME';
        }

        function isIframeLoaded(iframe) {
           try {
               return iframe.contentWindow &&
                   iframe.contentWindow.document &&
                   iframe.contentWindow.document.readyState === 'complete';
           } catch(err) {
               return true;
           }
        }
    }, getFuncId);

    var onAdsLoaded = memoize(function (rules) {
        return Promise.all(qwery('.js-ad-slot', rules.body)
            .map(function (ad) { return ad.id; })
            .map(trackAdRender)
        );
    }, getFuncId);

    // test one element vs another for the given rules
    function _testCandidate(rules, challenger, opponent) {
        var isMinAbove = challenger.top - opponent.bottom >= rules.minAbove;
        var isMinBelow = opponent.top - challenger.top >= rules.minBelow;

        return isMinAbove || isMinBelow;
    }

    // test one element vs an array of other elements for the given rules
    function _testCandidates(rules, challenger, opponents) {
        return opponents.every(_testCandidate.bind(undefined, rules, challenger));
    }

    function _mapElementToComputedDimensions(el) {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            bottom: rect.bottom,
            element: el
        };
    }

    function _mapElementToDimensions(el) {
        return {
            top: el.offsetTop,
            bottom: el.offsetTop + el.offsetHeight,
            element: el
        };
    }

    function _enforceRules(data, rules) {
        var candidates = data.candidates;

        // enforce absoluteMinAbove rule
        if (rules.absoluteMinAbove) {
            candidates = candidates.filter(function (candidate) {
                return candidate.top >= rules.absoluteMinAbove;
            });
        }

        // enforce minAbove and minBelow rules
        candidates = candidates.filter(function (candidate) {
            var farEnoughFromTopOfBody = candidate.top >= rules.minAbove;
            var farEnoughFromBottomOfBody = candidate.top + rules.minBelow <= data.bodyHeight;
            return farEnoughFromTopOfBody && farEnoughFromBottomOfBody;
        });

        // enforce content meta rule
        if (rules.clearContentMeta) {
            candidates = candidates.filter(function (candidate) {
                return candidate.top > (data.contentMeta.bottom + rules.clearContentMeta);
            });
        }

        // enforce selector rules
        if (rules.selectors) {
            Object.keys(rules.selectors).forEach(function (selector) {
                candidates = candidates.filter(function (candidate) {
                    return _testCandidates(rules.selectors[selector], candidate, data.opponents[selector]);
                });
            });
        }

        if (rules.filter) {
            candidates = candidates.filter(rules.filter, rules);
        }

        return candidates;
    }

    function SpaceError(rules) {
        this.name = 'SpaceError';
        this.message = 'There is no space left matching rules from ' + rules.bodySelector;
        this.stack = (new Error()).stack;
    }

    // Rather than calling this directly, use spaceFiller to inject content into the page.
    // SpaceFiller will safely queue up all the various asynchronous DOM actions to avoid any race conditions.
    function findSpace(rules, options) {
        var getDimensions;

        rules || (rules = defaultRules);
        options || (options = defaultOptions);
        rules.body = rules.bodySelector ? document.querySelector(rules.bodySelector) : document;
        getDimensions = rules.absoluteMinAbove ? _mapElementToComputedDimensions : _mapElementToDimensions;

        return getReady()
        .then(getCandidates)
        .then(getMeasurements)
        .then(enforceRules)
        .then(returnCandidates);

        function getReady() {
            return Promise.race([
                new Promise(expire),
                Promise.all([
                    options.waitForImages ? onImagesLoaded(rules) : true,
                    options.waitForLinks ? onRichLinksUpgraded(rules) : true,
                    options.waitForInteractives ? onInteractivesLoaded(rules) : true,
                    options.waitForAds ? onAdsLoaded(rules) : true
                ])
            ]);
        }

        function getCandidates() {
            var candidates = qwery(rules.bodySelector + rules.slotSelector);
            if (rules.fromBottom) {
                candidates.reverse();
            }
            if (rules.startAt) {
                var drop = true;
                candidates = candidates.filter(function (candidate) {
                    if (candidate === rules.startAt) {
                        drop = false;
                    }
                    return !drop;
                });
            }
            if (rules.stopAt) {
                var keep = true;
                candidates = candidates.filter(function (candidate) {
                    if (candidate === rules.stopAt) {
                        keep = false;
                    }
                    return keep;
                });
            }
            return candidates;
        }

        function getMeasurements(candidates) {
            var contentMeta = rules.clearContentMeta ?
                document.querySelector('.js-content-meta') :
                null;
            var opponents = rules.selectors ?
                Object.keys(rules.selectors).map(function (selector) {
                    return [selector, qwery(rules.bodySelector + selector)];
                }) :
                null;

            return fastdom.read(function () {
                var bodyDims = rules.body.getBoundingClientRect();
                var candidatesWithDims = candidates.map(getDimensions);
                var contentMetaWithDims = rules.clearContentMeta ?
                    getDimensions(contentMeta) :
                    null;
                var opponentsWithDims = opponents ?
                    opponents.reduce(function (result, selectorAndElements) {
                        result[selectorAndElements[0]] = selectorAndElements[1].map(getDimensions);
                        return result;
                    }, {}) :
                    null;

                if (rules.absoluteMinAbove) {
                    rules.absoluteMinAbove -= bodyDims.top;
                }

                return {
                    bodyHeight: bodyDims.height,
                    candidates: candidatesWithDims,
                    contentMeta: contentMetaWithDims,
                    opponents: opponentsWithDims
                };
            });
        }

        function enforceRules(data) {
            return _enforceRules(data, rules);
        }

        function returnCandidates(candidates) {
            if (candidates.length) {
                return candidates.map(function (candidate) { return candidate.element; });
            } else {
                throw new SpaceError(rules);
            }
        }
    }

    return {
        findSpace: findSpace,
        SpaceError: SpaceError,

        _testCandidate: _testCandidate, // exposed for unit testing
        _testCandidates: _testCandidates // exposed for unit testing
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
], __WEBPACK_AMD_DEFINE_RESULT__ = function(
    config
) {
    function clean(string) {
        return string.trim().toLowerCase();
    }

    /**
     * Get the campaigns for a test.
     *
     * @param test      an A/B test object (with an 'id' property)
     * @return {Array}  campaigns associated with this test
     */
    function campaignsFor(id) {
        try {
            return config.page.campaigns.filter(function (campaign) {
                return campaign.fields && clean(campaign.fields.campaignId) === clean(id);
            });
        } catch (e) {
            return [];
        }
    }

    /**
     * Check if any of the active campaigns (from the targeting tool) apply to a given A/B test.
     *
     * @param test        an A/B test object (with an 'id' property)
     * @return {Boolean}
     */
    function isAbTestTargeted(test) {
        return campaignsFor(test.campaignId).length > 0;
    }

    return {
        isAbTestTargeted: isAbTestTargeted
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(84),
    __webpack_require__(132),
    __webpack_require__(21),
    __webpack_require__(0),
    __webpack_require__(313)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    contributionsUtilities,
    geolocation,
    template,
    config,
    liveblogEpicTemplate
) {
    var pageId = config.page.pageId || '';

    return contributionsUtilities.makeABTest({
        id: 'AcquisitionsEpicLiveblog',
        campaignId: 'epic_liveblog',
        campaignSuffix: pageId.replace(/-/g, '_').replace(/\//g, '__'),

        start: '2017-04-01',
        expiry: '2018-04-01',

        author: 'Joseph Smith',
        description: 'This places the epic underneath liveblog blocks which the author has specified in Composer should have an epic against them',
        successMeasure: 'Member acquisition and contributions',
        idealOutcome: 'Our wonderful readers will support The Guardian in this time of need!',

        audienceCriteria: 'All',
        audience: 1,
        audienceOffset: 0,

        showForSensitive: true,

        pageCheck: function(page) {
            return page.contentType === 'LiveBlog';
        },

        variants: [
            {
                id: 'control',
                isUnlimited: true,

                insertAtSelector: '.js-insert-epic-after',
                insertAfter: true,
                insertMultiple: true,
                successOnView: true,

                template: function (variant) {
                    return template(liveblogEpicTemplate, {
                        membershipUrl: variant.membershipURL,
                        contributionUrl: variant.contributeURL,
                        componentName: variant.componentName
                    });
                },
            }
        ]
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(84),
    __webpack_require__(132),
    __webpack_require__(21),
    __webpack_require__(0),
    __webpack_require__(314),
    __webpack_require__(315)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    contributionsUtilities,
    geolocation,
    template,
    config,
    acquisitionsEpicContributeTemplate,
    acquisitionsEpicSupportTemplate
) {
    return contributionsUtilities.makeABTest({
        id: 'AcquisitionsEpicSingleCta',
        campaignId: 'epic_single_cta',

        start: '2017-05-12',
        expiry: '2017-05-25',

        author: 'Joseph Smith',
        description: 'Test an epic with a single CTA: contribute in the US and support everywhere else',
        successMeasure: 'Member acquisition and contributions',
        idealOutcome: 'Overall number of conversions combining supporter and contributions will be greater for the variant that shows just a single CTA',

        audienceCriteria: 'All',
        audience: 0.5,
        audienceOffset: 0.5,

        variants: [
            {
                id: 'control',
                successOnView: true, // check
            },
            {
                id: 'single_cta',
                template: function(variant) {
                    var epicTemplate;

                    if (geolocation.getSync() === 'US') {
                        epicTemplate = acquisitionsEpicContributeTemplate;
                    } else {
                        epicTemplate = acquisitionsEpicSupportTemplate;
                    }

                    return template(epicTemplate, {
                        membershipUrl: variant.membershipURL,
                        contributionUrl: variant.contributeURL,
                        componentName: variant.componentName
                    });
                }
            }
        ]
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(21),
    __webpack_require__(84),
    __webpack_require__(316),
    __webpack_require__(260)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    template,
    contributionsUtilities,
    acquisitionsEpicTestimonials,
    quoteSvg
) {

    function createTestimonialTemplate(epicTemplate, testimonialInfo) {
        return function(variant) {
            return template(epicTemplate, {
                membershipUrl: variant.membershipURL,
                contributionUrl: variant.contributeURL,
                componentName: variant.componentName,
                quoteSvg: quoteSvg.markup,
                testimonialMessage: testimonialInfo.message,
                testimonialName: testimonialInfo.name
            })
        }
    }

    var testimonialsInfo = {
        control: {
            message: 'I read it fairly often and enjoy the variety of news and entertainment content. It never occurred to me that you wanted contributions, but I’d like you to stick around. Sometimes you actually have to pay for stuff you like. Go figure.',
            name: 'Mike L'
        },
        paywall: {
            message: 'Because I appreciate there not being a paywall: it is more democratic for the media to be available for all and not a commodity to be purchased by a few. I’m happy to make a contribution so others with less means still have access to information.',
            name: 'Thomasine F-R'
        },
        vanilla: {
            message: 'I respect and appreciate the quality of your reportage: the in-depth research it represents, its absence of ideology, and its broad view. It is excellent journalism. We need truth in our news today.',
            name: 'Winifred L'
        }
    };

    return contributionsUtilities.makeABTest({
        id: 'AcquisitionsEpicTestimonialsRoundTwo',
        campaignId: 'kr1_epic_testimonials_round_two',

        start: '2017-05-12',
        expiry: '2017-06-13',

        author: 'Jonathan Rankin',
        description: 'Test placing reader testimonials in the Epic (round 2)',
        successMeasure: 'Conversion rate',
        idealOutcome: 'We are able to determine which testimonial design is the best',

        audienceCriteria: 'All',
        audience: 0.5,
        audienceOffset: 0,

        variants: [
            {
                id: 'control',
                template: createTestimonialTemplate(acquisitionsEpicTestimonials, testimonialsInfo.control)
            },
            {
                id: 'paywall',
                template: createTestimonialTemplate(acquisitionsEpicTestimonials, testimonialsInfo.paywall)
            },
            {
                id: 'vanilla',
                template: createTestimonialTemplate(acquisitionsEpicTestimonials, testimonialsInfo.vanilla)
            }
        ]
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'BookmarksEmailVariants2',
            start: '2017-03-31',
            end: '2017-05-30',
            author: 'David Furey',
            audience: 1,
            audienceOffset: 0,
            signupPage: 'info/ng-interactive/2017/mar/30/sign-up-for-the-bookmarks-email',
            canonicalListId: 3039,
            testIds: [
                { variantId: 'Control', listId: 3867 },
                { variantId: 'Variant', listId: 3866 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(5),
    __webpack_require__(0),
    __webpack_require__(18),
    __webpack_require__(30),
    __webpack_require__(122)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    qwery,
    config,
    detect,
    cookies,
    userFeatures
) {
    return function () {
        var self = this;
        this.id = 'BundleDigitalSubPriceTest1M';
        this.start = '2017-05-10';
        this.expiry = '2017-05-25'; // Thursday 25th May
        this.author = 'Justin Pinner';
        this.description = 'Test digital subs price points via thrasher';
        this.showForSensitive = true;
        this.audience = 0.25;
        this.audienceOffset = 0.75;
        this.successMeasure = '';
        this.audienceCriteria = 'Non-paying UK network front users - mobile resolution and above';
        this.dataLinkNames = '';
        this.idealOutcome = 'Find the price that works for most people.';
        this.hypothesis = 'One of our price points will be more desirable than the others';

        this.canRun = function () {
            return document.querySelector('#membership-ab-thrasher') &&
                    !cookies.getCookie('GU_DBPT1M') &&
                    !userFeatures.isPayingMember() &&
                    config.page.isFront &&
                    config.page.pageId.toLowerCase() === "uk" &&
                    config.page.edition.toUpperCase() === 'UK';
        };

        this.thrasherContainer = function() {
            return document.querySelector('#membership-ab-thrasher');
        };

        this.thrasher = function() {
            return document.querySelector('.membership-ab-thrasher--wrapper');
        };

        this.setTitle = function() {
            if (this.thrasher()) {
                var titleEl = document.querySelector('.membership-ab-thrasher_header .main_title');
                if (titleEl) {
                    titleEl.innerHTML = '<p>Support' + (detect.isBreakpoint({min: 'mobileMedium', max: 'tablet'}) ? ' ' : '<br>')  + 'the Guardian</p>';
                }
            }
        };

        this.setCopy = function() {
            if (this.thrasher()) {
                var subTitleEl = document.querySelector('.membership-ab-thrasher_header .sub_title');
                if (subTitleEl) {
                    subTitleEl.innerHTML = '<p>We\'re introducing <strong>new ways</strong> to support' + (detect.isBreakpoint({min: 'desktop'}) ? '<br>' : ' ') + 'the Guardian\'s quality journalism and independent voice. Choose to subscribe or contribute today.</p>';
                }
            }
        };

        this.setLink = function(variant) {
            if (this.thrasher()) {
                var linkEl = document.querySelector('.membership-ab-thrasher--wrapper .link-button');
                if (linkEl && linkEl.getAttribute('href')) {
                    linkEl.setAttribute('href', config.page.membershipUrl + '/bundles?INTCMP=BUNDLE_PRICE_TEST_1M_' + config.page.edition.toUpperCase() + '_' + variant.toUpperCase());
                }
            }
        };

        this.setCaption = function() {
            if (this.thrasher()) {
                var captionEl = document.querySelector('.membership-ab-thrasher--wrapper .link-button div p');
                if (captionEl) {
                    captionEl.textContent = 'Subscribe now';
                }
            }
        };

        this.showThrasher = function() {
            var thrasherContainer = this.thrasherContainer();
            if (thrasherContainer) {
                if (!thrasherContainer.classList.contains('visible')) {
                    thrasherContainer.classList.add('visible');
                }
            }
        };

        this.setup = function(variant) {
            this.setTitle();
            this.setCopy();
            this.setLink(variant);
            this.setCaption();
            this.showThrasher();
        };

        this.completeFunc = function(complete) {
            // fire on thrasher's [find out more -->] button click
            bean.on(qwery('.membership-ab-thrasher--wrapper .link-button')[0], 'click', complete);
        };

        this.variants = [
            {
                id: 'A',
                test: function () {
                    self.setup('A');   // Band 'A' (control group) - current default price
                },
                success: this.completeFunc
            },
            {
                id: 'B',
                test: function () {
                    self.setup('B');  // B = Band 'B' - current default +20%
                },
                success: this.completeFunc
            },
            {
                id: 'C',
                test: function () {
                    self.setup('C');  // C = Band 'C' - current default -20%
                },
                success: this.completeFunc
            }
        ];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(129),
    __webpack_require__(84),
    __webpack_require__(0),
    __webpack_require__(30),
    __webpack_require__(7),
    __webpack_require__(21),
    __webpack_require__(317),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
            commercialFeatures,
            contributionsUtilities,
            config,
            cookies,
            store,
            template,
            contributionsEpicEqualButtons) {

    function canBeDisplayed() {
        var userHasNeverContributed = !cookies.getCookie('gu.contributions.contrib-timestamp');
        var worksWellWithPageTemplate = (config.page.contentType === 'Article') && !config.page.isMinuteArticle; // may render badly on other types
        var isSensitive = config.page.isSensitive === true;

        return userHasNeverContributed &&
            commercialFeatures.canReasonablyAskForMoney &&
            worksWellWithPageTemplate && !isSensitive;
    }

    return contributionsUtilities.makeABTest({
        id: 'ContributionsEpicAlwaysAskStrategy',
        campaignId: 'epic_always_ask_strategy',

        start: '2016-12-06',
        expiry: '2017-06-01',

        author: 'Guy Dawson',
        description: 'Test to assess the effects of always asking readers to contribute via the Epic over a prolonged period.',
        successMeasure: 'We are able to measure the positive and negative effects of this strategy.',
        idealOutcome: 'There are no negative effects and this is the optimum strategy!',

        audienceCriteria: 'All',
        audience: 0.02,
        audienceOffset: 0.88,
        showForSensitive: true,
        useTargetingTool: true,

        overrideCanRun: true,
        canRun: function () {
            return true;
        },

        variants: [
            {
                id: 'control',
                test: function() {},
                isUnlimited : true

            },

            {
                id: 'alwaysAsk',
                template: function (variant) {
                    return template(contributionsEpicEqualButtons, {
                        linkUrl1: variant.membershipURL,
                        linkUrl2: variant.contributeURL,
                        componentName: variant.componentName,
                        title: 'Since you’re here…',
                        p1: '… we have a small favour to ask. More people are reading the Guardian than ever but far fewer are paying for it. And advertising revenues across the media are falling fast. So you can see why we need to ask for your help. The Guardian\'s independent, investigative journalism takes a lot of time, money and hard work to produce. But we do it because we believe our perspective matters &ndash; because it might well be your perspective, too.',
                        p2: 'If everyone who reads our reporting, who likes it, helps to pay for it, our future would be much more secure.',
                        p3: '',
                        cta1: 'Become a Supporter',
                        cta2: 'Make a contribution'
                    });
                },

                insertAtSelector: '.submeta',

                test: function (render) {
                    if (canBeDisplayed()) render();
                },
                isUnlimited : true,
                successOnView: true
            }
        ]
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(84),
    __webpack_require__(190),
    __webpack_require__(312),
    __webpack_require__(188),
    __webpack_require__(21)

], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    contributionsUtilities,
    acquisitionsEpicControlTemplate,
    acquisitionsEpicControlTemplateRegulars,
    tailor,
    template
) {

   return contributionsUtilities.makeABTest({
        id: 'ContributionsEpicAskFourEarning',
        campaignId: 'kr1_epic_ask_four_earning',

        start: '2017-01-24',
        expiry: '2017-06-01',

        author: 'Jonathan Rankin',
        description: 'This places the epic on all articles for all users, with a limit of 4 impressions in any given 30 days',
        successMeasure: 'Conversion rate',
        idealOutcome: 'Acquires many Supporters',

        audienceCriteria: 'All',
        audience: 1,
        audienceOffset: 0,

        variants: [
            {
                id: 'control',
                maxViews: {
                    days: 30,
                    count: 4,
                    minDaysBetweenViews: 0
                },
                test: function(render) {
                    tailor.isRegular().then(function (regular) {
                        var t = regular ? acquisitionsEpicControlTemplateRegulars : acquisitionsEpicControlTemplate;

                        return render(function(variant) {
                            return template(t, {
                                membershipUrl: variant.membershipURL,
                                contributionUrl: variant.contributeURL,
                                componentName: variant.componentName
                            });
                        });
                    });
                },
                insertAtSelector: '.submeta',
                successOnView: true
            }
        ]
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'FashionStatementEmailVariants',
            start: '2017-03-14',
            end: '2017-03-31',
            author: 'David Furey',
            audience: 0,
            audienceOffset: 0,
            canonicalListId: 105,
            testIds: [
                { variantId: 'control', listId: 3863 },
                { variantId: 'variant', listId: 3862 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'FilmTodayEmailVariants',
            start: '2017-03-14',
            end: '2017-03-31',
            author: 'David Furey',
            audience: 0,
            audienceOffset: 0,
            canonicalListId: 1950,
            testIds: [
                { variantId: 'control', listId: 3865 },
                { variantId: 'variant', listId: 3864 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(19),
    __webpack_require__(5),
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(75)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    qwery,
    $,
    config,
    fastdomPromise
) {
    return function () {
        this.id = 'OpinionEmailVariants';
        this.start = '2017-01-12';
        this.expiry = '2017-05-30';
        this.author = 'David Furey';
        this.description = 'Using the wonderful frontend AB testing framework to AB test emails, since the AB ' +
            'function in ExactTarget re-randomises all recipients on each send, and we need users to receive their ' +
            'variant for several weeks. This test will ensure users are added to the corresponding email list ' +
            '(listId) in ExactTarget';
        this.audience = 0.2;
        this.audienceOffset = 0;
        this.successMeasure = 'We can trial two different email formats to fairly compare their CTO rates';
        this.audienceCriteria = 'All users who visit the email sign up page';
        this.dataLinkNames = '';
        this.idealOutcome = '90% of users in new format list, 10% in the other list';

        var OPINION_URL = 'info/ng-interactive/2017/jan/12/sign-up-for-the-guardian-opinion-email';

        this.canRun = function () {
            return (config.page.contentId === OPINION_URL ||
            config.page.pageId === '/email-newsletters');
        };

        function enhanceWebView(emailListID) {
            var emailForm = $('.js-email-sub__iframe')[0];
            emailForm.setAttribute('src', 'https://www.theguardian.com/email/form/plaintone/' + emailListID);
        }

        // Runs the test on https://www.theguardian.com/email-newsletters
        function updateNewslettersPage(emailListID) {
            return fastdomPromise.write(function () {
                var input = $('input[value="3811"]')[0];
                var button = $('button[value="3811"]')[0];
                input.setAttribute('value', emailListID);
                button.setAttribute('value', emailListID);
            });
        }

        function runTheTest(emailListID) {
            if (config.page.contentId === OPINION_URL) {
                enhanceWebView(emailListID);
            } else {
                updateNewslettersPage(emailListID);
            }
        }

        this.variants = [
            {
                id: 'Opinion-UK-Connected',
                test: function () {
                    runTheTest(3811);
                }
            },
            {
                id: 'Opinion-UK-Legacy',
                test: function () {
                    runTheTest(3814);
                }
            }
        ];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(5),
    __webpack_require__(0),
    __webpack_require__(18),
    __webpack_require__(122)

], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    qwery,
    config,
    detect,
    userFeatures
) {
    return function () {
        this.id = 'PaidCommentingInternal';
        this.start = '2017-03-02';
        this.expiry = '2017-04-27'; // Thursday 27th April
        this.author = 'Justin Pinner';
        this.description = 'Test effects of paid-only commenting (404 test)';
        this.showForSensitive = true;
        this.audience = 0;  // 0% test for internal assessment
        this.audienceOffset = 0;
        this.successMeasure = '';
        this.audienceCriteria = 'Internal (and specific opt-ins) only';
        this.dataLinkNames = '';
        this.idealOutcome = 'A paywall doesn\'t destroy commenting';
        this.hypothesis = 'Our most engaged commenters are prepared to pay for the facility. Trolls are not.';

        this.canRun = function () {
            return !userFeatures.isPayingMember();
        };

        this.completeFunc = function(complete) {
            // fire on paid comment's [buy now -->] button click
            bean.on(qwery('.d-comment-box__payment-cta-button__content')[0], 'click', complete);
        };

        this.variants = [
            {
                id: 'pre',
                test: function () {},
                success: this.completeFunc
            },
            {
                id: 'post',
                test: function () {},
                success: this.completeFunc
            }
        ];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (config) {
    return function () {
        this.id = 'PaidContentVsOutbrain2';
        this.start = '2017-04-24';
        this.expiry = '2018-01-08';
        this.author = 'Regis Kuckaertz / Lydia Shepherd';
        this.description = 'Measure the revenue generated (or lost) by replacing the Outbrain widget with a paid content widget';
        this.audience = .05;
        this.audienceOffset = 0;
        this.successMeasure = 'The paid content widget allows to release enough inventory to cover up for the lost revenue from Outbrain';
        this.audienceCriteria = '';
        this.dataLinkNames = '';
        this.idealOutcome = 'We generate more revenue *without* Outbrain and the brand image gets its shiny back';
        this.showForSensitive = true;

        this.canRun = function () {
            return config.page.edition === 'UK';
        };

        this.variants = [
            {
                id: 'paid-content',
                test: function () {
                }
            },
            {
                id: 'outbrain',
                test: function () {
                }
            }
        ];
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'SleeveNotesLegacyEmailVariant',
            start: '2017-03-02',
            end: '2017-05-30',
            author: 'Leigh-Anne Mathieson',
            audience: 0.3,
            audienceOffset: 0.7,
            signupPage: 'info/ng-interactive/2017/mar/06/sign-up-for-the-sleeve-notes-email',
            canonicalListId: 39,
            testIds: [
                { variantId: 'SleeveNotes-Legacy', listId: 3835 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'SleeveNotesNewEmailVariant',
            start: '2017-03-02',
            end: '2017-05-30',
            author: 'Leigh-Anne Mathieson',
            audience: 0.7,
            audienceOffset: 0,
            signupPage: 'info/ng-interactive/2017/mar/06/sign-up-for-the-sleeve-notes-email',
            canonicalListId: 39,
            testIds: [
                { variantId: 'SleeveNotes-New', listId: 3834 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(77)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'TheLongReadEmailVariants',
            start: '2017-03-14',
            end: '2017-03-31',
            author: 'David Furey',
            audience: 0,
            audienceOffset: 0,
            canonicalListId: 3322,
            testIds: [
                { variantId: 'control', listId: 3869 },
                { variantId: 'variant', listId: 3868 }
            ]
        }
    );
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(28),
    __webpack_require__(30),
    __webpack_require__(7),
    __webpack_require__(57),
    __webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function(
    fetchJson,
    cookies,
    storage,
    reportError,
    config
) {

    var URLS = {
        suggestions: 'https://tailor.guardianapis.com/suggestions?browserId='
    };

    var browserId = cookies.getCookie('bwid');

    function getURL(type, queryParams) {
        var baseURL = URLS[type];

        if (!browserId || !baseURL) return;

        baseURL += browserId;

        if (queryParams) {
            Object.keys(queryParams).forEach(function (key) {
                baseURL += '&' + key + '=' + queryParams[key];
            });
        }

        return baseURL;
    }

    /**
     * type (required) is a string which should match a key in the URLS object
     * bypassStorage a boolean, if true don't retrieve data from local storage
     * queryParams an object literal, each key/value will be query string parameter
     * eg. {foo:'bar', hello:'world'} translates to ?foo=bar&hello=world
     *
     **/
    function fetchData(type, bypassStorage, queryParams) {
        var url = getURL(type, queryParams);

        // exit if no valid url end point, or tailor switch is off
        if (!url || !config.switches.useTailorEndpoints) {
            return Promise.resolve({});
        }

        var tailorData = bypassStorage ? null : storage.local.get('gu.tailor');

        // if data in local storage, resolve with this
        if (tailorData && tailorData[url]) {
            return Promise.resolve(tailorData[url]);
        }

        return fetchJson(url)
            .then(handleResponse.bind(null, url))
            .catch(handleError.bind(null, url));
    }

    function handleResponse(url, data) {
        var tailorData = storage.local.get('gu.tailor') || {};
        var hour = 1000 * 60 * 60;

        tailorData[url] = data;

        storage.local.set('gu.tailor', tailorData, {expires: Date.now() + hour});

        return Promise.resolve(data);
    }

    function handleError(url, error) {
        reportError(error, {
            feature: 'tailor',
            url: url
        });
    }

    return fetchData;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(131), __webpack_require__(123), __webpack_require__(57), __webpack_require__(589), __webpack_require__(576), __webpack_require__(577), __webpack_require__(541), __webpack_require__(584), __webpack_require__(585), __webpack_require__(447), __webpack_require__(581), __webpack_require__(590), __webpack_require__(809), __webpack_require__(591), __webpack_require__(501), __webpack_require__(593), __webpack_require__(811), __webpack_require__(821), __webpack_require__(823), __webpack_require__(819), __webpack_require__(594), __webpack_require__(400), __webpack_require__(230), __webpack_require__(122)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _config, _robust, _userTiming, _reportError, _highMerch, _articleAsideAdverts, _articleBodyAdverts, _closeDisabledSlots, _prepareGoogletag, _prepareSonobiTag, _prepareSwitchTag, _fillAdvertSlots, _about, _video, _gallery, _onwardJourneyCarousel, _onward, _liveblogAdverts, _stickyTopBanner, _thirdPartyTags, _paidforBand, _paidContainers, _performanceLogging, _google, _userFeatures) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    var _reportError2 = _interopRequireDefault(_reportError);

    var _highMerch2 = _interopRequireDefault(_highMerch);

    var _closeDisabledSlots2 = _interopRequireDefault(_closeDisabledSlots);

    var _prepareGoogletag2 = _interopRequireDefault(_prepareGoogletag);

    var _prepareSonobiTag2 = _interopRequireDefault(_prepareSonobiTag);

    var _prepareSwitchTag2 = _interopRequireDefault(_prepareSwitchTag);

    var _about2 = _interopRequireDefault(_about);

    var _video2 = _interopRequireDefault(_video);

    var _gallery2 = _interopRequireDefault(_gallery);

    var _onwardJourneyCarousel2 = _interopRequireDefault(_onwardJourneyCarousel);

    var _onward2 = _interopRequireDefault(_onward);

    var _liveblogAdverts2 = _interopRequireDefault(_liveblogAdverts);

    var _stickyTopBanner2 = _interopRequireDefault(_stickyTopBanner);

    var _thirdPartyTags2 = _interopRequireDefault(_thirdPartyTags);

    var _paidforBand2 = _interopRequireDefault(_paidforBand);

    var performanceLogging = _interopRequireWildcard(_performanceLogging);

    var _userFeatures2 = _interopRequireDefault(_userFeatures);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var commercialModules = [['cm-highMerch', _highMerch2.default.init], ['cm-thirdPartyTags', _thirdPartyTags2.default.init], ['cm-prepare-sonobi-tag', _prepareSonobiTag2.default.init, true], ['cm-prepare-switch-tag', _prepareSwitchTag2.default.init, true], ['cm-articleAsideAdverts', _articleAsideAdverts.articleAsideAdvertsInit, true], ['cm-prepare-googletag', _prepareGoogletag2.default.init, true], ['cm-articleBodyAdverts', _articleBodyAdverts.articleBodyAdvertsInit], ['cm-liveblogAdverts', _liveblogAdverts2.default.init, true], ['cm-closeDisabledSlots', _closeDisabledSlots2.default.init], ['cm-stickyTopBanner', _stickyTopBanner2.default.init], ['cm-fill-advert-slots', _fillAdvertSlots.fillAdvertSlots, true], ['cm-paidContainers', _paidContainers.paidContainers], ['cm-paidforBand', _paidforBand2.default.init]];


    if (_config2.default.page.isHosted) {
        commercialModules.push(['cm-hostedAbout', _about2.default.init], ['cm-hostedVideo', _video2.default.init, true], ['cm-hostedGallery', _gallery2.default.init], ['cm-hostedOnward', _onward2.default.init, true], ['cm-hostedOJCarousel', _onwardJourneyCarousel2.default.init]);
    }

    var loadModules = function loadModules(modules, baseline) {
        performanceLogging.addStartTimeBaseline(baseline);

        var modulePromises = [];

        modules.forEach(function (module) {
            var moduleName = module[0];
            var moduleInit = module[1];
            var moduleDefer = module[2];

            (0, _robust.catchErrorsWithContext)([[moduleName, function pushAfterComplete() {
                // These modules all have async init procedures which don't block, and return a promise purely for
                // perf logging, to time when their async work is done. The command buffer guarantees execution order,
                // so we don't use the returned promise to order the bootstrap's module invocations.
                var wrapped = moduleDefer ? performanceLogging.defer(moduleName, moduleInit) : performanceLogging.wrap(moduleName, moduleInit);
                var result = wrapped();
                modulePromises.push(result);
            }]]);
        });

        return Promise.all(modulePromises).then(function () {
            performanceLogging.addEndTimeBaseline(baseline);
        });
    };

    exports.default = function () {
        if (_config2.default.switches.adFreeMembershipTrial && _userFeatures2.default.isAdFreeUser()) {
            _closeDisabledSlots2.default.init(true);
            return Promise.resolve();
        }

        (0, _userTiming.markTime)('commercial start');
        (0, _robust.catchErrorsWithContext)([['ga-user-timing-commercial-start', function runTrackPerformance() {
            (0, _google.trackPerformance)('Javascript Load', 'commercialStart', 'Commercial start parse time');
        }]]);

        // Stub the command queue
        window.googletag = {
            cmd: []
        };

        return loadModules(commercialModules, performanceLogging.primaryBaseline).then(function () {
            (0, _userTiming.markTime)('commercial end');
            (0, _robust.catchErrorsWithContext)([['ga-user-timing-commercial-end', function runTrackPerformance() {
                (0, _google.trackPerformance)('Javascript Load', 'commercialEnd', 'Commercial end parse time');
            }]]);
        }).catch(function (err) {
            // Just in case something goes wrong, we don't want it to
            // prevent enhanced from loading
            (0, _reportError2.default)(err, {
                feature: 'commercial'
            });
        });
    };

    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {

    return addTrackingPixel;

    function addTrackingPixel(url) {
        new Image().src = url;
    }

}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return addViewabilityTracker;

    function addViewabilityTracker(adSlot, creativeId, viewabilityTracker) {

      /*
        we need to ensure that any scripts in the viewabilityTracker are parsed
        and executed; this can be done with a Range and ContextualFragment
      */
      var range = document.createRange();
      range.setStart(adSlot, 0);
      range.setEnd(adSlot, 0);
      adSlot.appendChild(range.createContextualFragment(viewabilityTracker.replace('INSERT_UNIQUE_ID', creativeId)));
    }
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(57),
    __webpack_require__(543),
    __webpack_require__(544)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (reportError, dfpOrigin, postMessage) {
    var allowedHosts = [
        dfpOrigin,
        location.protocol + '//' + location.host
    ];
    var listeners = {};
    var registeredListeners = 0;

    var error405 = { code: 405, message: 'Service %% not implemented' };
    var error500 = { code: 500, message: 'Internal server error\n\n%%' };

    return {
        register: register,
        unregister: unregister
    };

    function register(type, callback, options) {
        options || (options = {});

        if( registeredListeners === 0 ) {
            on(options.window || window);
        }

        /* Persistent listeners are exclusive */
        if (options.persist) {
            listeners[type] = callback;
            registeredListeners += 1;
        } else {
            listeners[type] || (listeners[type] = []);
            if (listeners[type].indexOf(callback) === -1) {
                listeners[type].push(callback);
                registeredListeners += 1;
            }
        }
    }

    function unregister(type, callback, options) {
        options || (options = {});

        if (listeners[type] === undefined) {
            throw new Error(formatError(error405, type));
        }

        if (callback === undefined) {
            registeredListeners -= listeners[type].length;
            listeners[type].length = 0;
        } else {
            if (listeners[type] === callback) {
                listeners[type] = null;
                registeredListeners -= 1;
            } else {
                var idx = listeners[type].indexOf(callback);
                if (idx > -1) {
                    registeredListeners -= 1;
                    listeners[type].splice(idx, 1);
                }
            }
        }

        if (registeredListeners === 0) {
            off(options.window || window);
        }
    }

    function on(window) {
        window.addEventListener('message', onMessage);
    }

    function off(window) {
        window.removeEventListener('message', onMessage);
    }

    function onMessage(event) {
        // We only allow communication with ads created by DFP
        if (allowedHosts.indexOf(event.origin) < 0) {
            return;
        }

        try {
            // Even though the postMessage API allows passing objects as-is, the
            // serialisation/deserialisation is slower than using JSON
            // Source: https://bugs.chromium.org/p/chromium/issues/detail?id=536620#c11
            var data = JSON.parse(event.data);
        } catch( ex ) {
            return;
        }

        // These legacy messages are converted into bona fide resize messages
        if (isProgrammaticMessage(data)) {
            data = toStandardMessage(data);
        }

        if (!isValidPayload(data)) {
            return;
        }

        if (Array.isArray(listeners[data.type]) && listeners[data.type].length) {
            // Because any listener can have side-effects (by unregistering itself),
            // we run the promise chain on a copy of the `listeners` array.
            // Hat tip @piuccio
            var promise = listeners[data.type].slice()
            // We offer, but don't impose, the possibility that a listener returns
            // a value that must be sent back to the calling frame. To do this,
            // we pass the cumulated returned value as a second argument to each
            // listener. Notice we don't try some clever way to compose the result
            // value ourselves, this would only make the solution more complex.
            // That means a listener can ignore the cumulated return value and
            // return something else entirely—life is unfair.
            // We don't know what each callack will be made of, we don't want to.
            // And so we wrap each call in a promise chain, in case one drops the
            // occasional fastdom bomb in the middle.
            .reduce(function (promise, listener) {
                return promise.then(function promiseCallback(ret) {
                    var thisRet = listener(data.value, ret, getIframe(data));
                    return thisRet === undefined ? ret : thisRet;
                });
            }, Promise.resolve(true));

            return promise.then(function (response) {
                respond(null, response);
            }).catch(function (ex) {
                reportError(ex, { feature: 'native-ads' });
                respond(formatError(error500, ex), null);
            });
        } else if (typeof listeners[data.type] === 'function') {
            // We found a persistent listener, to which we just delegate
            // responsibility to write something. Anything. Really.
            listeners[data.type](respond, data.value, getIframe(data));
        } else {
            // If there is no routine attached to this event type, we just answer
            // with an error code
            respond(formatError(error405, data.type), null);
        }

        function respond(error, result) {
            postMessage({ id: data.id, error: error, result: result }, event.source, event.origin);
        }
    }

    // Until DFP provides a way for us to identify with 100% certainty our
    // in-house creatives, we are left with doing some basic tests
    // such as validating the anatomy of the payload and whitelisting
    // event type
    function isValidPayload(payload) {
        return 'type' in payload &&
            'value' in payload &&
            'id' in payload &&
            payload.type in listeners &&
            /^[a-f0-9]{8}-([a-f0-9]{4}-){3}[a-f0-9]{12}$/.test(payload.id);
    }

    // A legacy from programmatic ads running in friendly iframes. They can
    // on occasion be larger than the size returned by DFP. And so they
    // have been setup to send a message of the form:
    // {
    //   type: 'set-ad-height',
    //   value: {
    //     id:     <id of the enclosing iframe>
    //     height: <new height of the creative>
    //   }
    // }
    //
    function isProgrammaticMessage(payload) {
        return payload.type === 'set-ad-height' &&
            'id' in payload.value &&
            'height' in payload.value;
    }

    function toStandardMessage(payload) {
        return {
            id: 'aaaa0000-bb11-cc22-dd33-eeeeee444444',
            type: 'resize',
            iframeId: payload.value.id,
            value: { height: +payload.value.height, width: +payload.value.width }
        };
    }

    // Incoming messages contain the ID of the iframe into which the
    // source window is embedded.
    function getIframe(data) {
        return document.getElementById(data.iframeId);
    }

    // Cheap string formatting function. It accepts as its first argument
    // an object `{ code, message }`. `message` is a string where successive
    // occurences of %% will be replaced by the following arguments. e.g.
    //
    // formatError({ message: "%%, you are so %%" }, "Regis", "lovely")
    //
    // returns `{ message: "Regis, you are so lovely" }`. Oh, thank you!
    function formatError() {
        if (arguments.length < 2) {
            return arguments[0] || '';
        }

        var error = arguments[0];
        Array.prototype.slice.call(arguments, 1).forEach(function (arg) {
            // Keep in mind that when the first argument is a string,
            // String.replace only replaces the first occurence
            error.message = error.message.replace('%%', arg);
        });

        return error;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(35), __webpack_require__(0), __webpack_require__(123), __webpack_require__(546), __webpack_require__(40)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _raven, _config, _userTiming, _beacon, _ng) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.defer = exports.wrap = exports.addTag = exports.primaryBaseline = exports.addEndTimeBaseline = exports.addStartTimeBaseline = exports.updateAdvertMetric = exports.setListeners = undefined;

    var _raven2 = _interopRequireDefault(_raven);

    var _config2 = _interopRequireDefault(_config);

    var _beacon2 = _interopRequireDefault(_beacon);

    var _ng2 = _interopRequireDefault(_ng);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var performanceLog = {
        viewId: 'unknown',
        tags: [],
        modules: [],
        adverts: [],
        baselines: []
    };

    var primaryBaseline = 'primary';

    // moduleStart() and moduleEnd() can be used for measuring modules ad-hoc,
    // when they don't align to a baseline.
    var moduleStart = function moduleStart(moduleName) {
        var timerStart = (0, _userTiming.getCurrentTime)();
        performanceLog.modules.push({
            name: moduleName,
            start: timerStart
        });
    };

    var moduleEnd = function moduleEnd(moduleName) {
        var timerEnd = (0, _userTiming.getCurrentTime)();

        var moduleIndex = performanceLog.modules.findIndex(function (module) {
            return module.name === moduleName;
        });

        if (moduleIndex !== -1) {
            var module = performanceLog.modules[moduleIndex];
            module.duration = timerEnd - module.start;
        }
    };

    // updateAdvertMetric() is called whenever the advert timings need to be updated.
    // It may be called multiple times for the same advert, so that we effectively update
    // the object with additional timings.
    var updateAdvertMetric = function updateAdvertMetric(advert, metricName, metricValue) {
        performanceLog.adverts = performanceLog.adverts.filter(function (element) {
            return advert.id !== element.id;
        });
        advert.timings[metricName] = metricValue;
        performanceLog.adverts.push(Object.freeze(Object.assign({
            id: advert.id,
            isEmpty: advert.isEmpty
        }, advert.timings)));
    };

    var addStartTimeBaseline = function addStartTimeBaseline(baselineName) {
        performanceLog.baselines.push({
            name: baselineName,
            startTime: (0, _userTiming.getCurrentTime)()
        });
    };

    var addEndTimeBaseline = function addEndTimeBaseline(baselineName) {
        performanceLog.baselines.forEach(function (baseline) {
            if (baseline.name === baselineName) {
                baseline.endTime = (0, _userTiming.getCurrentTime)();
            }
        });
    };

    // This posts the performance log to the beacon endpoint. It is expected that this be called
    // multiple times in a page view, so that partial data is captured, and then topped up as adverts load in.
    var reportTrackingData = function reportTrackingData() {
        if (_config2.default.tests.commercialClientLogging) {
            var performanceReport = {
                viewId: _ng2.default.viewId,
                tags: performanceLog.tags,
                adverts: performanceLog.adverts,
                baselines: performanceLog.baselines,
                modules: (performanceLog.modules || []).filter(function (module) {
                    return !!module.duration;
                })
            };
            _beacon2.default.postJson('/commercial-report', JSON.stringify(performanceReport));
        }
    };

    var reportData = _raven2.default.wrap(reportTrackingData);

    var setListeners = function setListeners(googletag) {
        googletag.pubads().addEventListener('slotRenderEnded', reportData);
    };

    var addTag = function addTag(tag) {
        performanceLog.tags.push(tag);
    };

    var wrap = function wrap(name, fn) {
        var _ref = [moduleStart.bind(null, name), moduleEnd.bind(null, name)],
            start = _ref[0],
            stop = _ref[1];

        return function () {
            start();
            try {
                var ret = fn.apply(undefined, arguments);
                if (ret instanceof Promise) {
                    return ret.then(function (value) {
                        stop();
                        return value;
                    }, function (reason) {
                        stop();
                        throw reason;
                    });
                }
                stop();
                return ret;
            } catch (e) {
                stop();
                throw e;
            }
        };
    };

    var defer = function defer(name, fn) {
        var _ref2 = [moduleStart.bind(null, name), moduleEnd.bind(null, name)],
            start = _ref2[0],
            stop = _ref2[1];

        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            try {
                var ret = fn.apply(undefined, [start, stop].concat(args));
                // Module-initialiser functions using defer are expected to call stop(),
                // but a failed promise could be uncaught, so catch them here and call stop().
                if (ret instanceof Promise) {
                    return ret.catch(function (reason) {
                        stop();
                        throw reason;
                    });
                }
                return ret;
            } catch (e) {
                stop();
                throw e;
            }
        };
    };

    exports.setListeners = setListeners;
    exports.updateAdvertMetric = updateAdvertMetric;
    exports.addStartTimeBaseline = addStartTimeBaseline;
    exports.addEndTimeBaseline = addEndTimeBaseline;
    exports.primaryBaseline = primaryBaseline;
    exports.addTag = addTag;
    exports.wrap = wrap;
    exports.defer = defer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(616);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(615);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 410 */,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isFunction) {

  /**
   * Creates a function that is restricted to execute `func` once. Repeat calls to
   * the function will return the value of the first call. The `func` is executed
   * with the `this` binding of the created function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // `initialize` executes `createApplication` once
   */
  function once(func) {
    var ran,
        result;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    return function() {
      if (ran) {
        return result;
      }
      ran = true;
      result = func.apply(this, arguments);

      // clear the `func` variable so the function may be garbage collected
      func = null;
      return result;
    };
  }

  return once;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });


    var getAdSize = function getAdSize(width, height, switchUnitId) {
        var toString = function toString() {
            return width === height && height === 0 ? 'fluid' : width + ',' + height;
        };

        return Object.freeze({
            width: width,
            height: height,
            switchUnitId: switchUnitId,
            toString: toString
        });
    };

    var switchUnitId = {
        mpu: 228,
        leaderboard: 229,
        billboard: 229
    };

    var adSizes = {
        // standard ad sizes
        billboard: getAdSize(970, 250, switchUnitId.billboard),
        leaderboard: getAdSize(728, 90, switchUnitId.leaderboard),
        mpu: getAdSize(300, 250, switchUnitId.mpu),
        halfPage: getAdSize(300, 600),
        portrait: getAdSize(300, 1050),

        // dfp proprietary ad sizes
        fluid: getAdSize(0, 0),
        outOfPage: getAdSize(1, 1),

        // guardian proprietary ad sizes
        video: getAdSize(620, 1),
        video2: getAdSize(620, 350),
        merchandisingHighAdFeature: getAdSize(88, 89),
        merchandisingHigh: getAdSize(88, 87),
        merchandising: getAdSize(88, 88),
        inlineMerchandising: getAdSize(88, 85),
        fabric: getAdSize(88, 71),
        empty: getAdSize(2, 2)
    };

    adSizes['970x250'] = adSizes.billboard;
    adSizes['728x90'] = adSizes.leaderboard;
    adSizes['300x250'] = adSizes.mpu;
    adSizes['300x600'] = adSizes.halfPage;
    adSizes['300x1050'] = adSizes.portrait;

    exports.default = adSizes;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(223), __webpack_require__(444), __webpack_require__(499), __webpack_require__(433), __webpack_require__(498), __webpack_require__(400)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _dfpEnv, _Advert, _queueAdvert, _loadAdvert, _enableLazyLoad, _performanceLogging) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.addSlot = undefined;

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _Advert2 = _interopRequireDefault(_Advert);

    var _queueAdvert2 = _interopRequireDefault(_queueAdvert);

    var _loadAdvert2 = _interopRequireDefault(_loadAdvert);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var displayAd = function displayAd(adSlot, forceDisplay) {
        var advert = (0, _Advert2.default)(adSlot);

        _dfpEnv2.default.advertIds[advert.id] = _dfpEnv2.default.adverts.push(advert) - 1;
        if (_dfpEnv2.default.shouldLazyLoad() && !forceDisplay) {
            (0, _queueAdvert2.default)(advert);
            (0, _performanceLogging.updateAdvertMetric)(advert, 'loadingMethod', 'add-slot-lazy');
            (0, _enableLazyLoad.enableLazyLoad)(advert);
        } else {
            (0, _performanceLogging.updateAdvertMetric)(advert, 'loadingMethod', 'add-slot-instant');
            (0, _performanceLogging.updateAdvertMetric)(advert, 'lazyWaitComplete', 0);
            (0, _loadAdvert2.default)(advert);
        }
    };

    var addSlot = function addSlot(adSlot, forceDisplay) {
        window.googletag.cmd.push(function () {
            if (!(adSlot.id in _dfpEnv2.default.advertIds)) {
                // dynamically add ad slot
                displayAd(adSlot, forceDisplay);
            }
        });
    };

    exports.addSlot = addSlot;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(253), __webpack_require__(430)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _defineProperty2, _adSizes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _defineProperty3 = _interopRequireDefault(_defineProperty2);

    var _adSizes2 = _interopRequireDefault(_adSizes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var inlineDefinition = {
        sizeMappings: {
            mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.mpu, _adSizes2.default.fluid],
            desktop: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.mpu, _adSizes2.default.video, _adSizes2.default.video2, _adSizes2.default.fluid]
        }
    };


    var adSlotDefinitions = {
        im: {
            label: false,
            refresh: false,
            sizeMappings: {
                mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.inlineMerchandising, _adSizes2.default.fluid]
            }
        },
        'high-merch': {
            label: false,
            refresh: false,
            name: 'merchandising-high',
            sizeMappings: {
                mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.merchandisingHigh, _adSizes2.default.fluid]
            }
        },
        'high-merch-lucky': {
            label: false,
            refresh: false,
            name: 'merchandising-high-lucky',
            sizeMappings: {
                mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.fluid]
            }
        },
        'high-merch-paid': {
            label: false,
            refresh: false,
            name: 'merchandising-high',
            sizeMappings: {
                mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.merchandisingHighAdFeature, _adSizes2.default.fluid]
            }
        },
        inline: inlineDefinition,
        mostpop: inlineDefinition,
        comments: inlineDefinition,
        'top-above-nav': {
            sizeMappings: {
                mobile: [_adSizes2.default.outOfPage, _adSizes2.default.empty, _adSizes2.default.mpu, _adSizes2.default.fabric, _adSizes2.default.fluid]
            }
        }
    };

    var createAdSlotElement = function createAdSlotElement(name, attrs, classes) {
        var adSlot = document.createElement('div');
        adSlot.id = 'dfp-ad--' + name;
        adSlot.className = 'js-ad-slot ad-slot ' + classes.join(' ');
        adSlot.setAttribute('data-link-name', 'ad slot ' + name);
        adSlot.setAttribute('data-name', name);
        Object.keys(attrs).forEach(function (attr) {
            adSlot.setAttribute(attr, attrs[attr]);
        });
        return adSlot;
    };

    var createSlot = function createSlot(type) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var attributes = {};
        var definition = adSlotDefinitions[type];
        var slotName = options.name || definition.name || type;
        var classes = options.classes ? options.classes.split(' ').map(function (cn) {
            return 'ad-slot--' + cn;
        }) : [];

        var sizes = Object.assign({}, definition.sizeMappings);

        if (options.sizes) {
            Object.keys(options.sizes).forEach(function (size) {
                if (sizes[size]) {
                    sizes[size] = sizes[size].concat(options.sizes[size]);
                } else {
                    sizes[size] = options.sizes[size];
                }
            });
        }

        Object.keys(sizes).forEach(function (size) {
            sizes[size] = sizes[size].join('|');
        });

        Object.assign(attributes, sizes);

        if (definition.label === false) {
            attributes.label = 'false';
        }

        if (definition.refresh === false) {
            attributes.refresh = 'false';
        }

        classes.push('ad-slot--' + slotName);

        return createAdSlotElement(slotName, Object.keys(attributes).reduce(function (result, key) {
            return Object.assign({}, result, (0, _defineProperty3.default)({}, 'data-' + key, attributes[key]));
        }, {}), classes);
    };

    exports.default = createSlot;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(444)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _Advert) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _Advert2 = _interopRequireDefault(_Advert);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var loadAdvert = function loadAdvert(advert) {
        advert.whenSlotReady.catch(function () {
            // The display needs to be called, even in the event of an error.
        }).then(function () {
            _Advert2.default.startLoading(advert);
            window.googletag.display(advert.id);
        });
    };
    exports.default = loadAdvert;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(59), __webpack_require__(82), __webpack_require__(4), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _classCallCheck2, _createClass2, _mediator, _fastdom) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.Sticky = undefined;

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _createClass3 = _interopRequireDefault(_createClass2);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var Sticky = function () {
        function Sticky(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            (0, _classCallCheck3.default)(this, Sticky);

            this.element = element;

            this.opts = Object.assign(options, {
                top: 0,
                containInParent: true,
                emitMessage: false
            });
        }

        (0, _createClass3.default)(Sticky, [{
            key: 'init',
            value: function init() {
                var _this = this;

                var parentElement = this.element.parentElement;

                if (!parentElement) {
                    return;
                }

                _fastdom2.default.read(function () {
                    _this.offsetFromParent = _this.element.getBoundingClientRect().top - parentElement.getBoundingClientRect().top;
                }, this);
                _mediator2.default.on('window:throttledScroll', this.updatePosition.bind(this));
                // kick off an initial position update
                _fastdom2.default.read(this.updatePosition, this);
            }
        }, {
            key: 'updatePosition',
            value: function updatePosition() {
                var _this2 = this;

                var parentElement = this.element.parentElement;

                if (!parentElement) {
                    return;
                }

                var elementRect = this.element.getBoundingClientRect();
                var parentRect = parentElement.getBoundingClientRect();
                var elementHeight = elementRect.height;
                var css = void 0;
                var message = void 0;
                var stick = void 0;

                // have we scrolled past the element
                if (parentRect.top + this.offsetFromParent > 0) {
                    stick = false;
                    css = {
                        top: ''
                    };
                    message = 'unfixed';
                } else {
                    stick = true;
                    var top = this.opts.containInParent && parentRect.bottom <= elementRect.height ? Math.floor(parentRect.bottom - elementHeight - this.opts.top) : this.opts.top;
                    css = {
                        top: top + 'px'
                    };
                    message = 'fixed';
                }

                if (this.opts.emitMessage && message && message !== this.lastMessage) {
                    this.emitMessage(message);
                    this.lastMessage = message;
                }

                if (css) {
                    _fastdom2.default.write(function () {
                        if (stick) {
                            _this2.element.classList.add('is-sticky');
                        } else {
                            _this2.element.classList.remove('is-sticky');
                        }
                        Object.assign(_this2.element.style, css);
                    }, this);
                }
            }
        }, {
            key: 'emitMessage',
            value: function emitMessage(message) {
                _mediator2.default.emit('modules:' + this.element.id + ':' + message);
            }
        }]);
        return Sticky;
    }();

    exports.Sticky = Sticky;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(645), __webpack_require__(50), __webpack_require__(1), __webpack_require__(51), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCreateCallback, baseMerge, getArray, isObject, releaseArray, slice) {

  /**
   * Recursively merges own enumerable properties of the source object(s), that
   * don't resolve to `undefined` into the destination object. Subsequent sources
   * will overwrite property assignments of previous sources. If a callback is
   * provided it will be executed to produce the merged values of the destination
   * and source properties. If the callback returns `undefined` merging will
   * be handled by the method instead. The callback is bound to `thisArg` and
   * invoked with two arguments; (objectValue, sourceValue).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param {Function} [callback] The function to customize merging properties.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * var names = {
   *   'characters': [
   *     { 'name': 'barney' },
   *     { 'name': 'fred' }
   *   ]
   * };
   *
   * var ages = {
   *   'characters': [
   *     { 'age': 36 },
   *     { 'age': 40 }
   *   ]
   * };
   *
   * _.merge(names, ages);
   * // => { 'characters': [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred', 'age': 40 }] }
   *
   * var food = {
   *   'fruits': ['apple'],
   *   'vegetables': ['beet']
   * };
   *
   * var otherFood = {
   *   'fruits': ['banana'],
   *   'vegetables': ['carrot']
   * };
   *
   * _.merge(food, otherFood, function(a, b) {
   *   return _.isArray(a) ? a.concat(b) : undefined;
   * });
   * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot] }
   */
  function merge(object) {
    var args = arguments,
        length = 2;

    if (!isObject(object)) {
      return object;
    }
    // allows working with `_.reduce` and `_.reduceRight` without using
    // their `index` and `collection` arguments
    if (typeof args[2] != 'number') {
      length = args.length;
    }
    if (length > 3 && typeof args[length - 2] == 'function') {
      var callback = baseCreateCallback(args[--length - 1], args[length--], 2);
    } else if (length > 2 && typeof args[length - 1] == 'function') {
      callback = args[--length];
    }
    var sources = slice(arguments, 1, length),
        index = -1,
        stackA = getArray(),
        stackB = getArray();

    while (++index < length) {
      baseMerge(object, sources[index], callback, stackA, stackB);
    }
    releaseArray(stackA);
    releaseArray(stackB);
    return object;
  }

  return merge;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(18),
    __webpack_require__(123),
    __webpack_require__(578),
    __webpack_require__(400),
    __webpack_require__(542)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (detect, userTiming, defineSlot, performanceLogging, breakpointNameToAttribute) {
    Advert.startLoading = startLoading;
    Advert.stopLoading = stopLoading;
    Advert.startRendering = startRendering;
    Advert.stopRendering = stopRendering;
    return Advert;

    function Advert(adSlotNode) {
        var sizes = getAdBreakpointSizes(adSlotNode);
        var slotDefinition = defineSlot.defineSlot(adSlotNode, sizes);
        var advert = {
            id: adSlotNode.id,
            node: adSlotNode,
            sizes: sizes,
            size: null,
            slot: slotDefinition.slot,
            isEmpty: null,
            isLoading: false,
            isRendering: false,
            isLoaded: false,
            isRendered: false,
            whenLoaded: null,
            whenLoadedResolver: null,
            whenRendered: null,
            whenRenderedResolver: null,
            whenSlotReady: slotDefinition.slotReady,
            timings: {
                createTime: null,
                startLoading: null,
                stopLoading: null,
                startRendering: null,
                stopRendering: null,
                loadingMethod: null,
                lazyWaitComplete: null
            }
        };
        advert.whenLoaded = new Promise(function (resolve) {
            advert.whenLoadedResolver = resolve;
        }).then(function (isLoaded) {
            return advert.isLoaded = isLoaded;
        });
        advert.whenRendered = new Promise(function (resolve) {
            advert.whenRenderedResolver = resolve;
        }).then(function (isRendered) {
            return advert.isRendered = isRendered;
        });

        performanceLogging.updateAdvertMetric(advert, 'createTime', userTiming.getCurrentTime());

        return Object.seal(advert);
    }

    function getAdBreakpointSizes(advertNode) {
        return detect.breakpoints.reduce(function (sizes, breakpoint) {
            var data = advertNode.getAttribute('data-' + breakpointNameToAttribute(breakpoint.name));
            if (data) {
                sizes[breakpoint.name] = createSizeMapping(data);
            }
            return sizes;
        }, {});
    }

    /** A breakpoint can have various sizes assigned to it. You can assign either on
     * set of sizes or multiple.
     *
     * One size       - `data-mobile="300,50"`
     * Multiple sizes - `data-mobile="300,50|320,50"`
     */
    function createSizeMapping(attr) {
        return attr.split('|').map(function (size) {
            return size === 'fluid' ? 'fluid' : size.split(',').map(Number);
        });
    }

    function startLoading(advert) {
        advert.isLoading = true;
        advert.timings.startLoading = userTiming.getCurrentTime();
    }

    function stopLoading(advert, isLoaded) {
        advert.isLoading = false;
        advert.whenLoadedResolver(isLoaded);
        advert.timings.stopLoading = userTiming.getCurrentTime();
    }

    function startRendering(advert) {
        advert.isRendering = true;
        advert.timings.startRendering = userTiming.getCurrentTime();
    }

    function stopRendering(advert, isRendered) {
        advert.isRendering = false;
        advert.whenRenderedResolver(isRendered);
        performanceLogging.updateAdvertMetric(advert, 'stopRendering', userTiming.getCurrentTime());
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var loadCssPromise = new Promise(function (resolve) {
        if (window.guardian.css.loaded) {
            // CSS has loaded, go
            resolve();
        } else {
            // Push a listener for when the JS loads
            window.guardian.css.onLoad = resolve;
        }
    });

    exports.loadCssPromise = loadCssPromise;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(30), __webpack_require__(18), __webpack_require__(7), __webpack_require__(76), __webpack_require__(545), __webpack_require__(81), __webpack_require__(503), __webpack_require__(243), __webpack_require__(239), __webpack_require__(411), __webpack_require__(249)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config, _cookies, _detect, _storage, _url, _krux, _api, _userAdTargeting, _utils, _flatten, _once, _pick) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.buildPageTargeting = undefined;

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    var _krux2 = _interopRequireDefault(_krux);

    var _api2 = _interopRequireDefault(_api);

    var _flatten2 = _interopRequireDefault(_flatten);

    var _once2 = _interopRequireDefault(_once);

    var _pick2 = _interopRequireDefault(_pick);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var format = function format(keyword) {
        return keyword.replace(/[+\s]+/g, '-').toLowerCase();
    };

    var formatTarget = function formatTarget(target) {
        return target ? format(target).replace(/&/g, 'and').replace(/'/g, '') : null;
    };

    var abParam = function abParam() {
        var cmRegex = /^(cm|commercial)/;
        var abParticipations = (0, _utils.getParticipations)();
        var abParams = [];

        Object.keys(abParticipations).forEach(function (testKey) {
            var testValue = abParticipations[testKey];
            if (testValue.variant && testValue.variant !== 'notintest') {
                var testData = testKey + '-' + testValue.variant;
                // DFP key-value pairs accept value strings up to 40 characters long
                abParams.push(testData.substring(0, 40));
            }
        });

        if (_config2.default.tests) {
            Object.keys(_config2.default.tests).forEach(function (testKey) {
                var testValue = _config2.default.tests[testKey];
                if (typeof testValue === 'string' && cmRegex.test(testValue)) {
                    abParams.push(testValue);
                }
            });
        }

        return abParams;
    };

    var adtestParams = function adtestParams() {
        var cookieAdtest = (0, _cookies.getCookie)('adtest');
        if (cookieAdtest) {
            if (cookieAdtest.substring(0, 4) === 'demo') {
                (0, _cookies.removeCookie)('adtest');
            }
            return cookieAdtest;
        }
    };

    var getVisitedValue = function getVisitedValue() {
        var visitCount = _storage.local.get('gu.alreadyVisited') || 0;

        if (visitCount <= 5) {
            return visitCount.toString();
        } else if (visitCount >= 6 && visitCount <= 9) {
            return '6-9';
        } else if (visitCount >= 10 && visitCount <= 15) {
            return '10-15';
        } else if (visitCount >= 16 && visitCount <= 19) {
            return '16-19';
        } else if (visitCount >= 20 && visitCount <= 29) {
            return '20-29';
        } else if (visitCount >= 30) {
            return '30plus';
        }

        return visitCount.toString();
    };

    var getReferrer = function getReferrer() {
        var referrerTypes = [{
            id: 'facebook',
            match: 'facebook.com'
        }, {
            id: 'twitter',
            match: 't.co/'
        }, // added (/) because without slash it is picking up reddit.com too
        {
            id: 'googleplus',
            match: 'plus.url.google'
        }, {
            id: 'reddit',
            match: 'reddit.com'
        }, {
            id: 'google',
            match: 'www.google'
        }];

        var matchedRef = referrerTypes.filter(function (referrerType) {
            return _detect2.default.getReferrer().indexOf(referrerType.match) > -1;
        })[0] || {};

        return matchedRef.id;
    };

    var getWhitelistedQueryParams = function getWhitelistedQueryParams() {
        var whiteList = ['0p19G'];
        return (0, _pick2.default)((0, _url.getUrlVars)(), whiteList);
    };

    var formatAppNexusTargeting = function formatAppNexusTargeting(obj) {
        return (0, _flatten2.default)(Object.keys(obj).filter(function (key) {
            return obj[key] !== '' && obj[key] !== null;
        }).map(function (key) {
            var value = obj[key];
            return Array.isArray(value) ? value.map(function (nestedValue) {
                return key + '=' + nestedValue;
            }) : key + '=' + value;
        })).join(',');
    };

    var buildPageTargeting = (0, _once2.default)(function () {
        var page = _config2.default.page;
        var pageTargets = Object.assign({
            x: _krux2.default.getSegments(),
            pv: _config2.default.ophan.pageViewId,
            bp: _detect2.default.getBreakpoint(),
            at: adtestParams(),
            si: _api2.default.isUserLoggedIn() ? 't' : 'f',
            gdncrm: (0, _userAdTargeting.getUserSegments)(),
            ab: abParam(),
            ref: getReferrer(),
            ms: formatTarget(page.source),
            fr: getVisitedValue(),
            // round video duration up to nearest 30 multiple
            vl: page.videoDuration ? (Math.ceil(page.videoDuration / 30.0) * 30).toString() : undefined
        }, page.sharedAdTargeting, getWhitelistedQueryParams());

        // filter out empty values
        var pageTargeting = (0, _pick2.default)(pageTargets, function (target) {
            if (Array.isArray(target)) {
                return target.length > 0;
            }
            return target;
        });

        // third-parties wish to access our page targeting, before the googletag script is loaded.
        page.appNexusPageTargeting = formatAppNexusTargeting({
            pt1: pageTargeting.url,
            pt2: pageTargeting.edition,
            pt3: pageTargeting.ct,
            pt4: pageTargeting.p,
            pt5: pageTargeting.k,
            pt6: pageTargeting.su,
            pt7: pageTargeting.bp,
            pt8: pageTargeting.x,
            pt9: [pageTargeting.gdncrm, pageTargeting.pv, pageTargeting.co, pageTargeting.tn, pageTargeting.slot].join('|')
        });

        // This can be removed once we get sign-off from third parties who prefer to use appNexusPageTargeting.
        page.pageAdTargeting = pageTargeting;

        return pageTargeting;
    });

    exports.buildPageTargeting = buildPageTargeting;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(224), __webpack_require__(57), __webpack_require__(497), __webpack_require__(430), __webpack_require__(129), __webpack_require__(223), __webpack_require__(229)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _config, _loadScript, _reportError, _timeout, _adSizes, _commercialFeatures, _dfpEnv, _uniq) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    var _reportError2 = _interopRequireDefault(_reportError);

    var _timeout2 = _interopRequireDefault(_timeout);

    var _adSizes2 = _interopRequireDefault(_adSizes);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _uniq2 = _interopRequireDefault(_uniq);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    // The view id is used as the unique load id, for easier Switch log querying.


    /* eslint camelcase: 0 */
    /* eslint no-underscore-dangle: 0 */

    var loadId = window.esi && window.esi.viewId;
    var REQUEST_TIMEOUT = 5000;

    // Set Switch's load id to the value of the ophan page view id. This id links the js
    // ad retrieval call to the pre-flight ad call made by the edge node (Fastly).
    var setupLoadId = function setupLoadId() {
        var __switch_zero = window.__switch_zero || {};
        __switch_zero.units = __switch_zero.units || [];
        __switch_zero.commands = __switch_zero.commands || [];

        __switch_zero.commands.push(function () {
            __switch_zero.setLoadId(loadId);
            __switch_zero.setAdserverDomain('delivery.guardian.switchadhub.com');
        });
    };

    var setupSwitch = function setupSwitch(start, stop) {
        start();

        // Setting the async property to false will _still_ load the script in
        // a non-blocking fashion but will ensure it is executed before googletag
        (0, _loadScript.loadScript)(_config2.default.libs.switch, {
            async: false
        }).then(setupLoadId).then(stop);
    };

    // The switch api's callSwitch function will perform the retrieval of a pre-flight ad call,
    // using the load id that has been previously set with setupLoadId.
    var callSwitch = function callSwitch() {
        var __switch_zero = window.__switch_zero;

        if (__switch_zero) {
            try {
                __switch_zero.commands.push(function () {
                    __switch_zero.callSwitch();
                });
            } catch (error) {
                (0, _reportError2.default)(error, {
                    feature: 'commercial'
                }, false);
            }
        }
    };

    // Returns an array of valid Switch ad unit ids.
    var findAdUnitIds = function findAdUnitIds(sizes) {
        return (0, _uniq2.default)(sizes.map(function (size) {
            var sizeName = size[0] + 'x' + size[1];
            var adSizeDefinition = _adSizes2.default[sizeName] || {};

            return adSizeDefinition.switchUnitId;
        }).filter(function (id) {
            return !isNaN(id);
        }));
    };

    // Whenever fill-advert-slots calls define-slot, a server-rendered html ad slot is being registered.
    // Whenever a module calls create-slot, a slot is dynamically inserted onto the page.
    //
    // Dynamically constructed slots that are made using create-slot are not supported here,
    // until callSwitch can handle lazy loading.
    var pushAdUnit = function pushAdUnit(dfpDivId, sizeMapping) {
        var __switch_zero = window.__switch_zero;
        var promises = [];

        if (__switch_zero) {
            var adUnitIds = findAdUnitIds(sizeMapping.sizes);

            adUnitIds.forEach(function (adUnitId) {
                if (adUnitId) {
                    promises.push(new Promise(function (resolve) {
                        __switch_zero.units.push({
                            dfpDivId: dfpDivId,
                            switchAdUnitId: adUnitId,
                            deliveryCallback: resolve
                        });
                    }));
                }
            });

            return (0, _timeout2.default)(REQUEST_TIMEOUT, Promise.all(promises)).catch(function () {
                // The display needs to be called, even in the event of an error.
            });
        }
        return Promise.resolve();
    };

    var init = function init(start, stop) {
        if (_dfpEnv2.default.preFlightAdCallEnabled && _commercialFeatures2.default.dfpAdvertising) {
            setupSwitch(start, stop);
        }

        return Promise.resolve();
    };

    exports.default = {
        init: init,
        callSwitch: callSwitch,
        pushAdUnit: pushAdUnit
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 448 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(17)
  , core           = __webpack_require__(15)
  , LIBRARY        = __webpack_require__(141)
  , wksExt         = __webpack_require__(450)
  , defineProperty = __webpack_require__(22).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);

/***/ }),
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(134), __webpack_require__(85), __webpack_require__(648)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseFlatten, createWrapper, functions) {

  /**
   * Binds methods of an object to the object itself, overwriting the existing
   * method. Method names may be specified as individual arguments or as arrays
   * of method names. If no method names are provided all the function properties
   * of `object` will be bound.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Object} object The object to bind and assign the bound methods to.
   * @param {...string} [methodName] The object method names to
   *  bind, specified as individual method names or arrays of method names.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var view = {
   *   'label': 'docs',
   *   'onClick': function() { console.log('clicked ' + this.label); }
   * };
   *
   * _.bindAll(view);
   * jQuery('#docs').on('click', view.onClick);
   * // => logs 'clicked docs', when the button is clicked
   */
  function bindAll(object) {
    var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object),
        index = -1,
        length = funcs.length;

    while (++index < length) {
      var key = funcs[index];
      object[key] = createWrapper(object[key], 1, null, null, object);
    }
    return object;
  }

  return bindAll;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(75),
    __webpack_require__(38),
    __webpack_require__(14),
    __webpack_require__(21),
    __webpack_require__(655),
    __webpack_require__(654),
    __webpack_require__(494),
    __webpack_require__(495),
    __webpack_require__(392),
    __webpack_require__(393)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    fastdom,
    $,
    assign,
    template,
    fabricExpandableVideoHtml,
    fabricExpandableCtaHtml,
    arrowDown,
    closeCentral,
    addTrackingPixel,
    addViewabilityTracker
) {
    return FabricExpandableVideoV2;

    function FabricExpandableVideoV2(adSlot, params) {
        var isClosed     = true;
        var closedHeight = 250;
        var openedHeight = 500;

        var ctaTpl = template(fabricExpandableCtaHtml);

        return Object.freeze({ create: create });

        function create() {
            var videoHeight = openedHeight;
            var plusIconPosition = params.showCrossInContainer.substring(3);
            var additionalParams = {
                id: 'fabric-expandable-' + (Math.random() * 10000 | 0).toString(16),
                desktopCTA: params.ctaDesktopImage ? ctaTpl({ media: 'hide-until-tablet', link: params.link, image: params.ctaDesktopImage, position: params.ctaDesktopPosition }): '',
                mobileCTA: params.ctaMobileImage ? ctaTpl({ media: 'mobile-only', link: params.link, image: params.ctaMobileImage, position: params.ctaMobilePosition }): '',
                showArrow: (params.showMoreType === 'arrow-only' || params.showMoreType === 'plus-and-arrow') ?
                    '<button class="ad-exp__open-chevron ad-exp__open">' + arrowDown.markup + '</button>'
                    : '',
                showPlus: params.showMoreType === 'plus-only' || params.showMoreType === 'plus-and-arrow' ?
                    '<button class="ad-exp__close-button ad-exp__open ad-exp__open--' + plusIconPosition + '">' + closeCentral.markup + '</button>'
                    : '',
                videoEmbed: (params.YoutubeVideoURL !== '') ?
                    '<iframe id="YTPlayer" width="100%" height="' + videoHeight + '" src="' + params.YoutubeVideoURL + '?showinfo=0&amp;rel=0&amp;controls=0&amp;fs=0&amp;title=0&amp;byline=0&amp;portrait=0" frameborder="0" class="expandable-video"></iframe>'
                    : ''
            };
            var $fabricExpandableVideo = $.create(template(fabricExpandableVideoHtml, { data: assign(params, additionalParams) }));
            var $ad = $('.ad-exp--expand', $fabricExpandableVideo);

            bean.on(adSlot, 'click', '.ad-exp__open', function () {
                fastdom.write(function () { open(isClosed); });
            });

            bean.on(adSlot, 'click', '.video-container__cta, .creative__cta', function () {
                fastdom.write(function () { open(false); });
            });

            return fastdom.write(function () {
                $ad.css('height', closedHeight);
                $('.ad-exp-collapse__slide', $fabricExpandableVideo).css('height', closedHeight);
                if (params.trackingPixel) {
                    addTrackingPixel(params.trackingPixel + params.cacheBuster);
                }
                if (params.researchPixel) {
                    addTrackingPixel(params.researchPixel + params.cacheBuster);
                }
                $fabricExpandableVideo.appendTo(adSlot);
                if (params.viewabilityTracker) {
                    addViewabilityTracker(adSlot, params.id, params.viewabilityTracker);
                }
                adSlot.classList.add('ad-slot--fabric');
                if( adSlot.parentNode.classList.contains('top-banner-ad-container') ) {
                    adSlot.parentNode.classList.add('top-banner-ad-container--fabric');
                }
                return true;
            });

            function open(open) {
                var videoSrc = $('#YTPlayer').attr('src');
                var videoSrcAutoplay = videoSrc;

                if (videoSrc.indexOf('autoplay') === -1) {
                    videoSrcAutoplay = videoSrc + '&amp;autoplay=1';
                } else {
                    videoSrcAutoplay = videoSrcAutoplay.replace(
                        open ? 'autoplay=0' : 'autoplay=1',
                        open ? 'autoplay=1' : 'autoplay=0'
                    );
                }

                if (open) {
                    $('.ad-exp__close-button', adSlot).addClass('button-spin');
                    $('.ad-exp__open-chevron', adSlot).addClass('chevron-down');
                    $ad.css('height', openedHeight);
                    $fabricExpandableVideo.addClass('creative--open');
                    $('.slide-video, .slide-video .ad-exp__layer', adSlot)
                    .css('height', openedHeight)
                    .addClass('slide-video__expand');
                } else {
                    $('.ad-exp__close-button', adSlot).removeClass('button-spin');
                    $('.ad-exp__open-chevron', adSlot).removeClass('chevron-down');
                    $ad.css('height', closedHeight);
                    $fabricExpandableVideo.removeClass('creative--open');
                    $('.slide-video, .slide-video .ad-exp__layer', adSlot)
                    .css('height', closedHeight)
                    .removeClass('slide-video__expand');
                }

                isClosed = !open;

                setTimeout(function () {
                    $('#YTPlayer').attr('src', videoSrcAutoplay);
                }, 1000);
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(75),
    __webpack_require__(38),
    __webpack_require__(18),
    __webpack_require__(4),
    __webpack_require__(7),
    __webpack_require__(21),
    __webpack_require__(656),
    __webpack_require__(657),
    __webpack_require__(494),
    __webpack_require__(495),
    __webpack_require__(452),
    __webpack_require__(435),
    __webpack_require__(392),
    __webpack_require__(393)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    fastdom,
    $,
    detect,
    mediator,
    storage,
    template,
    fabricExpandingV1Html,
    fabricExpandingVideoHtml,
    arrowDown,
    closeCentral,
    bindAll,
    merge,
    addTrackingPixel,
    addViewabilityTracker
) {
    // Forked from expandable-v3.js

    var FabricExpandingV1 = function (adSlot, params) {
        this.adSlot       = adSlot;
        this.params       = params;
        this.isClosed     = true;
        this.initialExpandCounter = false;

        this.closedHeight = 250;
        this.openedHeight = 500;

        bindAll(this, 'updateBgPosition', 'listener');
    };

    FabricExpandingV1.hasScrollEnabled = !detect.isIOS() && !detect.isAndroid();

    FabricExpandingV1.prototype.updateBgPosition = function () {
        var that = this;

        var viewportHeight = detect.getViewport().height;
        var adSlotTop = this.adSlot.getBoundingClientRect().top;

        var adHeight = (this.isClosed) ? this.closedHeight : this.openedHeight;
        var inViewB = viewportHeight > adSlotTop;
        var inViewT = -adHeight * 2 < adSlotTop + 20;
        var topCusp = inViewT && (viewportHeight * 0.4 - adHeight > adSlotTop) ?
            'true' : 'false';
        var bottomCusp = inViewB && (viewportHeight * 0.5 < adSlotTop) ?
            'true' : 'false';
        var bottomScroll = (bottomCusp === 'true') ?
        50 - ((viewportHeight * 0.5 - adSlotTop) * -0.2) : 50;
        var topScroll = (topCusp === 'true') ?
            ((viewportHeight * 0.4 - adSlotTop - adHeight) * 0.2) : 0;

        var scrollAmount;

        switch (this.params.backgroundImagePType) {
            case 'split':
                scrollAmount = bottomScroll + topScroll;
                fastdom.write(function () {
                    $('.ad-exp--expand-scrolling-bg', that.adSlot).css({
                        'background-repeat': 'no-repeat',
                        'background-position': '50%' + scrollAmount + '%'
                    });
                });
                break;
            case 'fixed':
                scrollAmount = -adSlotTop;
                fastdom.write(function () {
                    $('.ad-exp--expand-scrolling-bg', that.adSlot).css('background-position', '50%' + (scrollAmount  + 'px'));
                });
                break;
            case 'fixed matching fluid250':
                fastdom.write(function () {
                    $('.ad-exp--expand-scrolling-bg', that.adSlot).addClass('ad-exp--expand-scrolling-bg-fixed');
                });
                break;
            case 'parallax':
                scrollAmount = Math.ceil(adSlotTop * 0.3) + 20;
                fastdom.write(function () {
                    $('.ad-exp--expand-scrolling-bg', that.adSlot).addClass('ad-exp--expand-scrolling-bg-parallax');
                    $('.ad-exp--expand-scrolling-bg', that.adSlot).css('background-position', '50%' + (scrollAmount + '%'));
                });
                break;
            case 'none' :
                break;
        }
    };

    FabricExpandingV1.prototype.listener = function () {
        var that = this;
        if (!this.initialExpandCounter && detect.getViewport().height > that.adSlot.getBoundingClientRect().top + this.openedHeight) {
            var itemId = $('.ad-slot__content', that.adSlot).attr('id'),
                itemIdArray = itemId.split('/');

            if (!storage.local.get('gu.commercial.expandable.' + itemIdArray[1])) {
                // expires in 1 week
                var week = 1000 * 60 * 60 * 24 * 7;
                fastdom.write(function () {
                    storage.local.set('gu.commercial.expandable.' + itemIdArray[1], true, { expires: Date.now() + week });
                    that.$button.addClass('button-spin');
                    $('.ad-exp__open-chevron').removeClass('chevron-up').addClass('chevron-down');
                    that.$ad.css('height', that.openedHeight);
                    that.isClosed = false;
                    that.initialExpandCounter = true;
                });
            } else if (this.isClosed) {
                fastdom.write(function () {
                    $('.ad-exp__open-chevron').addClass('chevron-up');
                });
            }
            return true;
        }
    };

    FabricExpandingV1.prototype.buildVideo = function (customClass) {
        var videoAspectRatio = 16 / 9;
        var videoHeight = detect.isBreakpoint({max: 'phablet'})
            ? 125
            : 250;
        var videoWidth = videoHeight * videoAspectRatio;
        var leftMargin = this.params.videoPositionH === 'center'
            ? 'margin-left: ' + videoWidth / -2 + 'px'
            : '';
        var leftPosition = this.params.videoPositionH === 'left'
            ? 'left: ' + this.params.videoHorizSpace + 'px'
            : '';
        var rightPosition = this.params.videoPositionH === 'right'
            ? 'right: ' + this.params.videoHorizSpace + 'px'
            : '';

        var viewModel = {
            width : videoWidth,
            height : videoHeight,
            src : this.params.videoURL + '?rel=0&amp;controls=0&amp;showinfo=0&amp;title=0&amp;byline=0&amp;portrait=0',
            className : [
                'expandable_video',
                'expandable_video--horiz-pos-' + this.params.videoPositionH,
                customClass
            ].join(' '),
            inlineStyle : [leftMargin, leftPosition, rightPosition].join('; ')
        };

        return template(fabricExpandingVideoHtml, viewModel);
    };

    FabricExpandingV1.prototype.stopVideo = function (delay) {
        delay = delay || 0;

        var videoSelector = detect.isBreakpoint({min: 'tablet'}) ? '.js-fabric-video--desktop' : '.js-fabric-video--mobile';
        var video = $(videoSelector, this.adSlot);
        var videoSrc = video.attr('src');

        window.setTimeout(function () {
            video.attr('src', videoSrc + '&amp;autoplay=0');
        }, delay);
    };

    FabricExpandingV1.prototype.create = function () {
        var hasVideo = this.params.videoURL !== '';
        var videoDesktop = {
            videoDesktop: hasVideo ? this.buildVideo('js-fabric-video--desktop') : ''
        };
        var videoMobile = {
            videoMobile: hasVideo ? this.buildVideo('js-fabric-video--mobile') : ''
        };
        var showmoreArrow = {
            showArrow: (this.params.showMoreType === 'arrow-only' || this.params.showMoreType === 'plus-and-arrow') ?
            '<button class="ad-exp__open-chevron ad-exp__open">' + arrowDown.markup + '</button>' : ''
        };
        var showmorePlus = {
            showPlus: (this.params.showMoreType === 'plus-only' || this.params.showMoreType === 'plus-and-arrow') ?
            '<button class="ad-exp__close-button ad-exp__open">' + closeCentral.markup + '</button>' : ''
        };
        var scrollbgDefaultY = '0%'; // used if no parallax / fixed background scroll support
        var scrollingbg = {
            scrollbg: this.params.backgroundImagePType !== 'none' ?
            '<div class="ad-exp--expand-scrolling-bg" style="background-image: url(' + this.params.backgroundImageP + '); background-position: ' + this.params.backgroundImagePPosition + ' ' + scrollbgDefaultY + '; background-repeat: ' + this.params.backgroundImagePRepeat + ';"></div>' : ''
        };
        this.params.id = 'fabric-expanding-' + (Math.random() * 10000 | 0).toString(16);
        var $fabricExpandingV1 = $.create(template(fabricExpandingV1Html, { data: merge(this.params, showmoreArrow, showmorePlus, videoDesktop, videoMobile, scrollingbg) }));

        mediator.on('window:throttledScroll', this.listener);

        bean.on(this.adSlot, 'click', '.ad-exp__open', function () {
            if (!this.isClosed && hasVideo) {
                // wait 1000ms for close animation to finish
                this.stopVideo(1000);
            }

            fastdom.write(function () {
                $('.ad-exp__close-button').toggleClass('button-spin');
                $('.ad-exp__open-chevron').removeClass('chevron-up').toggleClass('chevron-down');
                this.$ad.css('height', this.isClosed ? this.openedHeight : this.closedHeight);
                this.isClosed = !this.isClosed;
                this.initialExpandCounter = true;
            }.bind(this));
        }.bind(this));

        if (FabricExpandingV1.hasScrollEnabled) {
            // update bg position
            this.updateBgPosition();

            mediator.on('window:throttledScroll', this.updateBgPosition);
            // to be safe, also update on window resize
            mediator.on('window:throttledResize', this.updateBgPosition);
        }

        return fastdom.write(function () {

            this.$ad     = $('.ad-exp--expand', $fabricExpandingV1).css('height', this.closedHeight);
            this.$button = $('.ad-exp__open', $fabricExpandingV1);

            $('.ad-exp-collapse__slide', $fabricExpandingV1).css('height', this.closedHeight);

            if (this.params.trackingPixel) {
                addTrackingPixel(this.params.trackingPixel + this.params.cacheBuster);
            }

            if (this.params.researchPixel) {
                addTrackingPixel(this.params.researchPixel + this.params.cacheBuster);
            }

            $fabricExpandingV1.appendTo(this.adSlot);

            if (this.params.viewabilityTracker) {
                addViewabilityTracker(this.adSlot, this.params.id, this.params.viewabilityTracker);
            }

            this.adSlot.classList.add('ad-slot--fabric');

            if( this.adSlot.parentNode.classList.contains('top-banner-ad-container') ) {
                this.adSlot.parentNode.classList.add('top-banner-ad-container--fabric');
            }
            return true;
        }, this);
    };

    return FabricExpandingV1;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(18),
    __webpack_require__(21),
    __webpack_require__(4),
    __webpack_require__(392),
    __webpack_require__(393),
    __webpack_require__(658),
    __webpack_require__(662),
    __webpack_require__(665),
    __webpack_require__(435)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    detect,
    template,
    mediator,
    addTrackingPixel,
    addViewabilityTracker,
    fabricV1Html,
    iframeVideoStr,
    scrollBgStr,
    merge
) {
    var hasBackgroundFixedSupport = !detect.isAndroid();
    var isEnhanced = detect.isEnhanced();
    var isIE10OrLess = detect.getUserAgent.browser === 'MSIE' && (parseInt(detect.getUserAgent.version) <= 10);

    var fabricV1Tpl;
    var iframeVideoTpl;
    var scrollBgTpl;

    // This is a hasty clone of fluid250.js

    var FabricV1 = function (adSlot, params) {
        this.adSlot = adSlot;
        this.params = params;
    };

    FabricV1.prototype.create = function () {
        if (!fabricV1Tpl) {
            fabricV1Tpl = template(fabricV1Html);
            iframeVideoTpl = template(iframeVideoStr);
            scrollBgTpl = template(scrollBgStr);
        }

        var videoPosition = {
            position: this.params.videoPositionH === 'left' || this.params.videoPositionH === 'right' ?
            this.params.videoPositionH + ':' + this.params.videoHorizSpace + 'px;' : ''
        };

        var templateOptions = {
            id: 'fabric-' + (Math.random() * 10000 | 0).toString(16),
            showLabel: this.params.showAdLabel !== 'hide',
            video: this.params.videoURL ? iframeVideoTpl(merge(this.params, videoPosition)) : '',
            hasContainer: 'layerTwoAnimation' in this.params,
            layerTwoBGPosition: this.params.layerTwoBGPosition && (
                !this.params.layerTwoAnimation ||
                this.params.layerTwoAnimation === 'disabled' ||
                (!isEnhanced && this.params.layerTwoAnimation === 'enabled')
            ) ?
                this.params.layerTwoBGPosition :
                '0% 0%',
            scrollbg: this.params.backgroundImagePType && this.params.backgroundImagePType !== 'none' ?
                scrollBgTpl(this.params) :
                false
        };

        if (templateOptions.scrollbg) {
            // update bg position
            fastdom.read(this.updateBgPosition, this);
            mediator.on('window:throttledScroll', this.updateBgPosition.bind(this));
            // to be safe, also update on window resize
            mediator.on('window:throttledResize', this.updateBgPosition.bind(this));
        }

        if (this.params.trackingPixel) {
            addTrackingPixel(this.params.trackingPixel + this.params.cacheBuster);
        }

        if (this.params.researchPixel) {
            addTrackingPixel(this.params.researchPixel + this.params.cacheBuster);
        }

        return fastdom.write(function () {
            this.adSlot.insertAdjacentHTML('beforeend', fabricV1Tpl({data: merge(this.params, templateOptions)}));
            this.scrollingBg = this.adSlot.querySelector('.ad-scrolling-bg');
            this.layer2 = this.adSlot.querySelector('.hide-until-tablet .fabric-v1_layer2');
            this.scrollType = this.params.backgroundImagePType;

            // layer two animations must not have a background position, otherwise the background will
            // be visible before the animation has been initiated.
            if (this.params.layerTwoAnimation === 'enabled' && isEnhanced && !isIE10OrLess) {
                this.layer2.style.backgroundPosition = '';
            }

            if (this.scrollType === 'fixed' && hasBackgroundFixedSupport) {
                this.scrollingBg.style.backgroundAttachment = 'fixed';
            }

            // #? `classList.add` takes multiple arguments, but we are using it
            // here with arity 1 because polyfill.io has incorrect support with IE 10 and 11.
            // One may revert to this.adSlot.classList.add('ad-slot--fabric-v1', 'ad-slot--fabric', 'content__mobile-full-width');
            // When support is correct or when we stop supporting IE <= 11
            this.adSlot.classList.add('ad-slot--fabric-v1');
            this.adSlot.classList.add('ad-slot--fabric');
            this.adSlot.classList.add('content__mobile-full-width');

            if( this.adSlot.parentNode.classList.contains('top-banner-ad-container') ) {
                this.adSlot.parentNode.classList.add('top-banner-ad-container--fabric');
            }

            if (this.params.viewabilityTracker) {
                addViewabilityTracker(this.adSlot, this.params.id, this.params.viewabilityTracker);
            }

            return true;
        }, this);
    };

    FabricV1.prototype.updateBgPosition = function () {
        if (this.scrollType === 'parallax') {
            var scrollAmount = Math.ceil(this.adSlot.getBoundingClientRect().top * 0.3) + 20;
            fastdom.write(function () {
                this.scrollingBg.classList.add('ad-scrolling-bg-parallax');
                this.scrollingBg.style.backgroundPosition = '50% ' + scrollAmount + '%';
            }, this);
        } else if (this.scrollType === 'fixed' && !hasBackgroundFixedSupport) {
            var adRect = this.adSlot.getBoundingClientRect();
            var vPos = (window.innerHeight - adRect.bottom + adRect.height / 2) / window.innerHeight * 100;
            fastdom.write(function () {
                this.scrollingBg.style.backgroundPosition = '50% ' + vPos + '%';
            }, this);
        }
        this.layer2Animation();
    };

    FabricV1.prototype.layer2Animation = function () {
        var inViewB;
        if (this.params.layerTwoAnimation === 'enabled' && isEnhanced && !isIE10OrLess) {
            inViewB = detect.getViewport().height > this.adSlot.getBoundingClientRect().top;
            fastdom.write(function () {
                this.layer2.classList.add('ad-scrolling-text-hide' + (this.params.layerTwoAnimationPosition ? '-' + this.params.layerTwoAnimationPosition : ''));
                if (inViewB) {
                    this.layer2.classList.add('ad-scrolling-text-animate' + (this.params.layerTwoAnimationPosition ? '-' + this.params.layerTwoAnimationPosition : ''));
                }
            }, this);
        }
    };

    return FabricV1;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(136),
    __webpack_require__(75),
    __webpack_require__(18),
    __webpack_require__(21),
    __webpack_require__(392),
    __webpack_require__(393),
    __webpack_require__(659)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (qwery, events, fastdom, detect, template, addTrackingPixel, addViewabilityTracker, fabricVideoStr) {
    var fabricVideoTpl;

    return FabricVideo;

    function FabricVideo(adSlot, params) {
        var isUpdating = false;
        var isSmallScreen = detect.isBreakpoint({ max: 'phablet' });
        var hasVideo, video, layer2, inView;

        fabricVideoTpl || (fabricVideoTpl = template(fabricVideoStr));

        hasVideo = !(detect.isIOS() || detect.isAndroid() || isSmallScreen);

        params.id = 'fabric-video-' + (Math.random() * 10000 | 0).toString(16);

        if (isSmallScreen) {
            params.posterMobile = '<div class="creative__poster" style="background-image:url(' + params.Videobackupimage + ')"></div>';
        } else {
            if (hasVideo) {
                params.video = '<video muted class="creative__video creative__video--' + params.Videoalignment + '"><source src="' + params.VideoURL + '" type="video/mp4"></video>';
            }

            params.posterTablet = '<div class="creative__poster" style="background-image:url(' + params.BackgroundImagemobile + ')"></div>';
        }

        return Object.freeze({
            create: create
        });

        function create() {
            return fastdom.write(function () {
                if (params.Trackingpixel) {
                    addTrackingPixel(params.Trackingpixel + params.cacheBuster);
                }
                if (params.Researchpixel) {
                    addTrackingPixel(params.Researchpixel + params.cacheBuster)
                }
                adSlot.insertAdjacentHTML('beforeend', fabricVideoTpl({ data: params }));
                if (params.viewabilityTracker) {
                    addViewabilityTracker(adSlot, params.id, params.viewabilityTracker);
                }
                adSlot.classList.add('ad-slot--fabric');
                if( adSlot.parentNode.classList.contains('top-banner-ad-container') ) {
                    adSlot.parentNode.classList.add('top-banner-ad-container--fabric');
                }
            }).then(function () {
                layer2 = qwery('.creative__layer2', adSlot);

                events.addEventListener(window, 'scroll', onScroll, { passive: true });
                events.addEventListener(adSlot, 'animationend', function () {
                    window.removeEventListener('scroll', onScroll);
                });

                if (hasVideo) {
                    video = adSlot.getElementsByTagName('video')[0];
                    video.onended = onVideoEnded;
                }

                fastdom.read(onScroll);

                return true;
            });
        }

        function onVideoEnded() {
            video.onended = null;
            video = null;
        }

        function onScroll() {
            var viewportHeight = detect.getViewport().height;
            var rect = adSlot.getBoundingClientRect();
            inView = rect.top >= 0 && rect.bottom < viewportHeight;
            if (!isUpdating) {
                isUpdating = true;
                fastdom.write(updateView);
            }
        }

        function updateView() {
            isUpdating = false;
            if (video) {
                updateVideo();
            }
            updateAnimation();
        }

        function updateVideo() {
            if (inView) {
                video.play();
            } else {
                video.pause();
            }
        }

        function updateAnimation() {
            if (inView) {
                playAnimation();
            } else {
                pauseAnimation();
            }
        }

        function playAnimation() {
            layer2.forEach(function (l) { l.classList.add('is-animating'); });
        }

        function pauseAnimation() {
            layer2.forEach(function (l) { l.classList.remove('is-animating'); });
        }

    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(21),
    __webpack_require__(493),
    __webpack_require__(252),
    __webpack_require__(392),
    __webpack_require__(393),
    __webpack_require__(660),
    __webpack_require__(661),
    __webpack_require__(572),
    __webpack_require__(570)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    template,
    Toggles,
    svg,
    addTrackingPixel,
    addViewabilityTracker,
    frameStr,
    labelStr,
    externalLink,
    arrow
) {

    var Frame = function (adSlot, params) {
        this.adSlot = adSlot;
        this.params = params;
    };

    Frame.prototype.create = function () {
        this.params.externalLinkIcon = svg.addClassesAndTitle(externalLink.markup, ['frame__external-link-icon']);
        this.params.target = this.params.newWindow === 'yes' ? '_blank' : '_self';
        this.params.id = 'frame-' + (Math.random() * 10000 | 0).toString(16);

        var frameMarkup = template(frameStr, { data: this.params });
        var labelMarkup = template(labelStr, { data: {
            buttonTitle: 'Ad',
            infoTitle: 'Advertising on the Guardian',
            infoText: 'is created and paid for by third parties.',
            infoLinkText: 'Learn more about how advertising supports the Guardian.',
            infoLinkUrl: 'https://www.theguardian.com/advertising-on-the-guardian',
            icon: svg.addClassesAndTitle(arrow.markup, ['gu-comlabel__icon']),
            dataAttr: this.adSlot.id
        }});
        return fastdom.write(function () {
            this.adSlot.insertAdjacentHTML('beforeend', frameMarkup);
            this.adSlot.lastElementChild.insertAdjacentHTML('afterbegin', labelMarkup);
            this.adSlot.classList.add('ad-slot--frame');
            if (this.params.trackingPixel) {
                addTrackingPixel(this.params.trackingPixel + this.params.cacheBuster);
            }
            if (this.params.researchPixel) {
                addTrackingPixel(this.params.researchPixel + this.params.cacheBuster);
            }
            if (this.params.viewabilityTracker) {
                addViewabilityTracker(this.adSlot, this.params.id, this.params.viewabilityTracker);
            }
            new Toggles(this.adSlot).init();
            return true;
        }, this);
    };

    return Frame;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(21),
    __webpack_require__(18),
    __webpack_require__(392),
    __webpack_require__(393),
    __webpack_require__(663)
], __WEBPACK_AMD_DEFINE_RESULT__ = function(fastdom, template, detect, addTrackingPixel, addViewabilityTracker, revealerStr) {
    var revealerTpl;

    function Revealer(adSlot, params) {
        revealerTpl || (revealerTpl = template(revealerStr));

        params.id = 'revealer-' + (Math.random() * 10000 | 0).toString(16);

        return Object.freeze({
            create: create
        });

        function create() {
            var markup = revealerTpl(params);

            return fastdom.write(function () {
                adSlot.insertAdjacentHTML('beforeend', markup);
                // #? `classList.add` takes multiple arguments, but we are using it
                // here with arity 1 because polyfill.io has incorrect support with IE 10 and 11.
                // One may revert to adSlot.classList.add('ad-slot--revealer', 'ad-slot--fabric', 'content__mobile-full-width'); 
                // When support is correct or when we stop supporting IE <= 11
                adSlot.classList.add('ad-slot--revealer');
                adSlot.classList.add('ad-slot--fabric');
                adSlot.classList.add('content__mobile-full-width');
                if (params.trackingPixel) {
                    addTrackingPixel(params.trackingPixel + params.cacheBuster);
                }
                if (params.researchPixel) {
                    addTrackingPixel(params.researchPixel + params.cacheBuster);
                }
                if (params.viewabilityTracker) {
                    addViewabilityTracker(adSlot, params.id, params.viewabilityTracker);
                }
            }).then(function () {
                return fastdom.read(function () {
                    return detect.getViewport();
                });
            }).then(function (viewport) {
                return fastdom.write(function () {
                    var background = adSlot.getElementsByClassName('creative__background')[0];
                    // for the height, we need to account for the height of the location bar, which
                    // may or may not be there. 70px padding is not too much.
                    background.style.height = (viewport.height + 70) + 'px';
                    return true;
                });
            });
        }
    }

    return Revealer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(19),
    __webpack_require__(38),
    __webpack_require__(18),
    __webpack_require__(4),
    __webpack_require__(21),
    __webpack_require__(664),
    __webpack_require__(392),
    __webpack_require__(393)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    $,
    detect,
    mediator,
    template,
    scrollableMpuTpl,
    addTrackingPixel,
    addViewabilityTracker
) {

    /**
     * https://www.google.com/dfp/59666047#delivery/CreateCreativeTemplate/creativeTemplateId=10026567
     */
    var ScrollableMpu = function (adSlot, params) {
        this.adSlot = adSlot;
        this.params = params;
    };

    /**
     * TODO: rather blunt instrument this, due to the fact *most* mobile devices don't have a fixed
     * background-attachment - need to make this more granular
     */
    var hasScrollEnabled = !detect.isAndroid();

    function updateBgFluid250() {
        fastdom.write(function () {
            this.$scrollableImage.addClass('creative--scrollable-mpu-image-fixed');
        }, this);
    }

    function updateBgParallax() {
        var scrollAmount = Math.ceil(this.adSlot.getBoundingClientRect().top * 0.3) + 20;
        fastdom.write(function () {
            this.$scrollableImage
            .addClass('creative--scrollable-mpu-image-parallax')
            .css('background-position', '50% ' + scrollAmount + '%');
        }, this);
    }

    function updateBg() {
        var position = -this.$scrollableMpu[0].getBoundingClientRect().top;
        fastdom.write(function () {
            this.$scrollableImage.css('background-position', '100% ' + position + 'px');
        }, this);
    }

    ScrollableMpu.prototype.create = function () {
        var templateOptions = {
            id:               'scrollable-mpu-' + (Math.random() * 10000 | 0).toString(16),
            clickMacro:       this.params.clickMacro,
            destination:      this.params.destination,
            layer1Image:      hasScrollEnabled ? this.params.layer1Image : this.params.mobileImage,
            backgroundImage:  hasScrollEnabled && this.params.backgroundImage ?
                '<div class="creative--scrollable-mpu-image" style="background-image: url(' + this.params.backgroundImage + ');"></div>' : ''
        };
        this.$scrollableMpu = $.create(template(scrollableMpuTpl, templateOptions)).appendTo(this.adSlot);

        if (this.params.trackingPixel) {
            addTrackingPixel(this.params.trackingPixel + this.params.cacheBuster)
        }

        if (this.params.researchPixel) {
            addTrackingPixel(this.params.researchPixel + this.params.cacheBuster);
        }

        if (this.params.viewabilityTracker) {
            addViewabilityTracker(this.adSlot, this.params.id, this.params.viewabilityTracker);
        }

        if (hasScrollEnabled) {
            var updateFn =
                this.params.backgroundImagePType === 'fixed matching fluid250' ?
                    updateBgFluid250.bind(this) :
                this.params.backgroundImagePType === 'parallax' ?
                    updateBgParallax.bind(this) :
                    updateBg.bind(this);

            this.$scrollableImage = $('.creative--scrollable-mpu-image', this.adSlot);

            // update bg position
            fastdom.read(updateFn);

            mediator.on('window:throttledScroll', updateFn);
            // to be safe, also update on window resize
            mediator.on('window:throttledResize', updateFn);
        }

        return Promise.resolve(true);
    };

    return ScrollableMpu;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(20),
    __webpack_require__(4),
    __webpack_require__(225)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    bean,
    mediator,
    contains
) {

    var Toggles = function (parent) {

        var self = this,
            controls,
            doNotReset = ['popup--search'],
            readyClass = 'js-toggle-ready',
            isSignedIn = (function () {
                var nav = document.querySelector('.js-profile-nav');
                return nav && nav.classList.contains('is-signed-in');
            }()),
            component  = parent || document.body;

        this.init = function () {
            controls = Array.prototype.slice.call(component.querySelectorAll('[data-toggle]'));

            controls.forEach(function (control) {
                if (!control.classList.contains(readyClass)) {
                    var target = self.getTarget(component, control);

                    if (target && !(!isSignedIn && control.getAttribute('data-toggle-signed-in') === 'true')) {
                        control.toggleTarget = target;
                        control.classList.add(readyClass);
                        bean.add(control, 'click', function (e) {
                            e.preventDefault();
                            self.toggle(control, controls);
                        });
                    }
                }
            });
        };

        this.reset = function (omitEl) {
            controls.filter(function (control) {
                return !(omitEl === control || contains(doNotReset, control.getAttribute('data-toggle')));
            }).map(self.close);
        };

        mediator.on('module:clickstream:click', function (clickSpec) {
            self.reset(clickSpec ? clickSpec.target : null);
        });
    };

    Toggles.prototype.toggle = function (control, controls) {
        var self = this;

        controls.forEach(function (c) {
            if (c === control) {
                self[c.classList.contains('is-active') ? 'close' : 'open'](c);
            } else {
                self.close(c);
            }
        });
    };

    Toggles.prototype.getTarget = function (parent, control) {
        var targetClass = control.getAttribute('data-toggle');
        if (targetClass) {
            return parent.querySelector('.' + targetClass);
        }
    };

    Toggles.prototype.open = function (c) {
        c.classList.add('is-active');
        if (c.toggleTarget) {
            c.toggleTarget.classList.remove('is-off');
        }
    };

    Toggles.prototype.close = function (c) {
        c.classList.remove('is-active');
        if (c.toggleTarget) {
            c.toggleTarget.classList.add('is-off');
        }
    };

    return Toggles;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-arrow-down inline-icon\"><svg width=\\\"24\\\" height=\\\"18\\\" viewBox=\\\"-0.525 -4 24 18\\\" overflow=\\\"visible\\\" enable-background=\\\"new -0.525 -4 24 18\\\"><path d=\\\"M23.2.7L12.7 9.1l-1.1.9-1.1-.898L0 .7.5 0l11.1 6.3L22.7 0l.5.7z\\\"/></svg></span>"}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-close-central inline-icon\"><svg width=\\\"30\\\" height=\\\"30\\\"><path d=\\\"M21 9.8l-.8-.8-5.2 4.8-5.2-4.8-.8.8 4.8 5.2-4.8 5.2.8.8 5.2-4.8 5.2 4.8.8-.8-4.8-5.2 4.8-5.2\\\"/></svg></span>"}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(59), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _classCallCheck2, _createClass2) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _createClass3 = _interopRequireDefault(_createClass2);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var FiniteStateMachine = function () {
        function FiniteStateMachine(options) {
            (0, _classCallCheck3.default)(this, FiniteStateMachine);

            this.context = options.context;
            this.states = options.states || {};
            this.context.state = options.initial || '';
            this.debug = options.debug || false;
            this.onChangeState = options.onChangeState.bind(this.context) || function () {};
        }

        (0, _createClass3.default)(FiniteStateMachine, [{
            key: 'log',
            value: function log() {
                if (this.debug && window.console && window.console.log) {
                    var _window$console;

                    (_window$console = window.console).log.apply(_window$console, arguments);
                }
            }
        }, {
            key: 'trigger',
            value: function trigger(event, data) {
                this.log('fsm: (event)', event);

                var state = this.context.state;
                var noop = function noop() {};

                (this.states[state].events[event] || noop).call(this.context, data);

                // execute leave/enter callbacks if present and we have changed state
                if (state !== this.context.state || this.context.reloadState) {
                    this.context.reloadState = false;
                    this.onChangeState(state, this.context.state);
                    (this.states[state].leave || noop).apply(this.context);
                    (this.states[this.context.state].enter || noop).apply(this.context);

                    this.log('fsm: (state)', state + ' -> ' + this.context.state);
                }
            }
        }]);
        return FiniteStateMachine;
    }();

    exports.default = FiniteStateMachine;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var timeout = function timeout(interval, promise) {
        return Promise.race([promise, new Promise(function (resolve, reject) {
            setTimeout(function () {
                return reject(new Error('Timeout'));
            }, interval);
        })]);
    };

    exports.default = timeout;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(223), __webpack_require__(583)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _mediator, _dfpEnv, _lazyLoad) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.enableLazyLoad = undefined;

    var _mediator2 = _interopRequireDefault(_mediator);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /* observer: IntersectionObserver?. The observer used to detect when ad slots enter the viewport */
    var observer = null;

    var enableLazyLoad = function enableLazyLoad(advert) {
        if (!_dfpEnv2.default.lazyLoadEnabled) {
            _dfpEnv2.default.lazyLoadEnabled = true;
            if (_dfpEnv2.default.lazyLoadObserve) {
                observer = new window.IntersectionObserver(_lazyLoad.onIntersect, {
                    rootMargin: '200px 0%'
                });
                _dfpEnv2.default.advertsToLoad.forEach(function (ad) {
                    observer.observe(ad.node);
                });
            } else {
                _mediator2.default.on('window:throttledScroll', _lazyLoad.onScroll);
                (0, _lazyLoad.onScroll)();
            }
        } else if (_dfpEnv2.default.lazyLoadObserve && advert) {
            observer.observe(advert.node);
        }
    };

    exports.enableLazyLoad = enableLazyLoad;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(223)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _dfpEnv) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var queueAdvert = function queueAdvert(advert) {
        _dfpEnv2.default.advertsToLoad.push(advert);
        // Add to the array of ads to be refreshed (when the breakpoint changes)
        // only if its `data-refresh` attribute isn't set to false.
        if (advert.node.getAttribute('data-refresh') !== 'false') {
            _dfpEnv2.default.advertsToRefresh.push(advert);
        }
    };

    exports.default = queueAdvert;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(20), __webpack_require__(19), __webpack_require__(592), __webpack_require__(38), __webpack_require__(230)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _bean, _fastdom, _nextVideo, _$, _google) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _bean2 = _interopRequireDefault(_bean);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _nextVideo2 = _interopRequireDefault(_nextVideo);

    var _$2 = _interopRequireDefault(_$);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var nextVideoInterval = void 0;

    var $hostedNext = void 0;
    var $timer = void 0;
    var nextVideoPage = void 0;

    var cancelAutoplay = function cancelAutoplay() {
        _fastdom2.default.write(function () {
            $hostedNext.addClass('hosted-slide-out');
        });
        clearInterval(nextVideoInterval);
    };

    var cancelAutoplayMobile = function cancelAutoplayMobile() {
        _fastdom2.default.write(function () {
            $hostedNext.addClass('u-h');
        });
    };

    var triggerAutoplay = function triggerAutoplay(getCurrentTimeFn, duration) {
        nextVideoInterval = setInterval(function () {
            var timeLeft = duration - Math.ceil(getCurrentTimeFn());
            var countdownLength = 10; // seconds before the end when to show the timer

            if (timeLeft <= countdownLength) {
                _fastdom2.default.write(function () {
                    $hostedNext.addClass('js-autoplay-start');
                    $timer.text(timeLeft + 's');
                });
            }
            if (timeLeft <= 0) {
                (0, _google.trackNonClickInteraction)('Immediately play the next video');
                window.location = nextVideoPage;
            }
        }, 1000);
    };

    var triggerEndSlate = function triggerEndSlate() {
        _fastdom2.default.write(function () {
            $hostedNext.addClass('js-autoplay-start');
        });
        _bean2.default.on(document, 'click', (0, _$2.default)('.js-autoplay-cancel'), function () {
            cancelAutoplayMobile();
        });
    };

    var addCancelListener = function addCancelListener() {
        _bean2.default.on(document, 'click', (0, _$2.default)('.js-autoplay-cancel'), function () {
            cancelAutoplay();
        });
    };

    var canAutoplay = function canAutoplay() {
        return $hostedNext.length && nextVideoPage;
    };

    var init = function init() {
        return _nextVideo2.default.load().then(function () {
            $hostedNext = (0, _$2.default)('.js-hosted-next-autoplay');
            $timer = (0, _$2.default)('.js-autoplay-timer');
            nextVideoPage = $timer.length && $timer.data('next-page');
        });
    };

    exports.default = {
        init: init,
        canAutoplay: canAutoplay,
        triggerEndSlate: triggerEndSlate,
        triggerAutoplay: triggerAutoplay,
        addCancelListener: addCancelListener
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(59), __webpack_require__(82), __webpack_require__(5), __webpack_require__(19), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _classCallCheck2, _createClass2, _qwery, _fastdom, _$) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _createClass3 = _interopRequireDefault(_createClass2);

    var _qwery2 = _interopRequireDefault(_qwery);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _$2 = _interopRequireDefault(_$);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var HostedCarousel = function () {
        function HostedCarousel() {
            (0, _classCallCheck3.default)(this, HostedCarousel);
        }

        (0, _createClass3.default)(HostedCarousel, [{
            key: 'moveCarouselBy',
            value: function moveCarouselBy(direction) {
                this.moveCarouselTo(this.index + direction);
            }
        }, {
            key: 'moveCarouselTo',
            value: function moveCarouselTo(index) {
                var _this = this;

                var pageNo = Math.min(Math.max(index, 0), this.pageCount - 1);
                this.index = pageNo;

                _fastdom2.default.write(function () {
                    var translate = 'translate(-' + pageNo + '00%, 0)';
                    _this.$carousel.css({
                        '-webkit-transform': translate,
                        transform: translate
                    });
                    _this.$dots.each(function (el, i) {
                        (0, _$2.default)(el).toggleClass('highlighted', i % _this.pageCount === pageNo);
                    });
                    _this.$prevItem.css({
                        opacity: pageNo === 0 ? 0.5 : 1
                    });
                    _this.$nextItem.css({
                        opacity: pageNo === _this.pageCount - 1 ? 0.5 : 1
                    });
                });
            }
        }, {
            key: 'bindButtons',
            value: function bindButtons() {
                var _this2 = this;

                this.$carousel = (0, _$2.default)('.js-carousel-pages');
                this.$nextItem = (0, _$2.default)('.next-oj-item');
                this.$prevItem = (0, _$2.default)('.prev-oj-item');
                this.$dots = (0, _$2.default)('.js-carousel-dot');
                this.pageCount = (0, _$2.default)('.carousel-page', this.$carousel).length;
                this.index = 0;

                if (this.$carousel.length) {
                    this.$nextItem.each(function (el) {
                        el.addEventListener('click', _this2.moveCarouselBy.bind(_this2, 1));
                    });
                    this.$prevItem.each(function (el) {
                        el.addEventListener('click', _this2.moveCarouselBy.bind(_this2, -1));
                    });
                    this.$dots.each(function (el, i) {
                        el.addEventListener('click', _this2.moveCarouselTo.bind(_this2, i % _this2.pageCount));
                    });
                }
            }
        }]);
        return HostedCarousel;
    }();

    var init = function init() {
        if ((0, _qwery2.default)('.js-carousel-pages').length) {
            new HostedCarousel().bindButtons();
        }
        return Promise.resolve();
    };

    exports.default = {
        init: init,
        HostedCarousel: HostedCarousel
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(40)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _ng) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.tracking = undefined;

    var _ng2 = _interopRequireDefault(_ng);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var tracking = function tracking(trackingObj) {
        _ng2.default.record({
            outbrain: trackingObj
        });
    };

    exports.tracking = tracking;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _storage, _api) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.requestUserSegmentsFromId = exports.getUserSegments = undefined;

    var _api2 = _interopRequireDefault(_api);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var userSegmentsKey = 'gu.ads.userSegmentsData';

    var getUserSegments = function getUserSegments() {
        if (_storage.local.isAvailable()) {
            var userCookieData = void 0;
            var userSegmentsData = _storage.local.get(userSegmentsKey);

            if (userSegmentsData) {
                userCookieData = _api2.default.getUserFromCookie();

                if (userCookieData && userSegmentsData.userHash === userCookieData.id % 9999) {
                    return userSegmentsData.segments;
                }
                _storage.local.remove(userSegmentsKey);
            }
        }

        return [];
    };

    var requestUserSegmentsFromId = function requestUserSegmentsFromId() {
        if (_storage.local.isAvailable() && _storage.local.get(userSegmentsKey) === null && _api2.default.getUserFromCookie()) {
            _api2.default.getUserFromApi(function (user) {
                if (user && user.adData) {
                    (function () {
                        var userSegments = [];
                        Object.keys(user.adData).forEach(function (key) {
                            userSegments.push(key + user.adData[key]);
                        });
                        _storage.local.set(userSegmentsKey, {
                            segments: userSegments,
                            userHash: user.id % 9999
                        }, {
                            expires: new Date().getTime() + 24 * 60 * 60 * 1000
                        });
                    })();
                }
            });
        }
    };

    exports.getUserSegments = getUserSegments;
    exports.requestUserSegmentsFromId = requestUserSegmentsFromId;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(448)
  , createDesc     = __webpack_require__(46)
  , toIObject      = __webpack_require__(62)
  , toPrimitive    = __webpack_require__(90)
  , has            = __webpack_require__(45)
  , IE8_DOM_DEFINE = __webpack_require__(101)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(149)
  , hiddenKeys = __webpack_require__(100).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 506 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(75)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    qwery,
    fastdom
) {
    var adSlotSelector = '.js-ad-slot';

    function init(force) {
        // Get all ad slots
        var adSlots = qwery(adSlotSelector);

        if (!force) {
            // remove the ones which should not be there
            adSlots = adSlots.filter(shouldDisableAdSlot);
        }

        return fastdom.write(function () {
            adSlots.forEach(function (adSlot) {
                if (adSlot.parentNode) {
                    adSlot.parentNode.removeChild(adSlot);
                }
            });
        });
    }

    function shouldDisableAdSlot(adSlot) {
        return window.getComputedStyle(adSlot).display === 'none';
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return breakpointNameToAttribute;

    function breakpointNameToAttribute(breakpointName) {
        return breakpointName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return location.protocol + '//tpc.googlesyndication.com';
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(543)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (dfpOrigin) {
    return postMessage;

    function postMessage(message, targetWindow, targetOrigin) {
        targetWindow.postMessage(JSON.stringify(message), targetOrigin || dfpOrigin);
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(30),
    __webpack_require__(7)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config,
    cookies,
    storage
) {
    var kruxUrl = '//cdn.krxd.net/controltag?confid=JVZiE3vn';

    function retrieve(n) {
        var k = 'kx' + n;

        return storage.local.getRaw(k) || cookies.getCookie(k + '=([^;]*)') || '';
    }

    function getSegments() {
        return retrieve('segs') ? retrieve('segs').split(',') : [];
    }

    return {
        shouldRun: !(config.page.contentType == 'Network Front') && config.switches.krux,
        url: kruxUrl,
        getSegments: getSegments
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(58),
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config,
    fetch
) {
    return {
        fire: function (path) {
            var img = new Image();
            img.src = config.page.beaconUrl + path;

            return img;
        },
        postJson: function (path, jsonString) {
            var url = (config.page.beaconUrl || '').replace(/^\/\//, window.location.protocol + '//') + path;

            fetch(url, {
                method: 'post',
                header: {
                    'Content-Type': 'application/json',
                },
                body: jsonString,
                mode: 'cors',
            });
        },
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(7),
    __webpack_require__(230),
    __webpack_require__(131)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    mediator,
    storage,
    google,
    robust
) {
    var NG_STORAGE_KEY = 'gu.analytics.referrerVars';
    var loc = document.location;

    function addHandlers() {
        mediator.on('module:clickstream:interaction', trackNonClickInteraction);

        mediator.on('module:clickstream:click', function (spec) {
            // We don't want tracking errors to terminate the event emitter, as
            // this will mean other event listeners will not be called.
            robust.catchErrorsWithContext([
                ['c-analytics', function () { trackClick(spec); }],
            ]);
        });
    }

    function trackClick(spec) {
        if (!spec.validTarget) {
            return;
        }

        if (isSponsorLogoLinkClick(spec.target)) {
            return google.trackSponsorLogoLinkClick(spec.target);
        }

        if (spec.sameHost) {
            if (spec.samePage) {
                trackSamePageLinkClick(spec);
            } else {
                trackInternalLinkClick(spec);
            }
        } else {
            trackExternalLinkClick(spec);
        }
    }

    function isSponsorLogoLinkClick(target) {
        return target.hasAttribute('data-sponsor');
    }

    // used where we don't have an element to pass as a tag, eg. keyboard interaction
    function trackNonClickInteraction(actionName) {
        google.trackNonClickInteraction(actionName);
    }

    function trackSamePageLinkClick(spec) {
        // Do not perform a same-page track link when there isn't a tag.
        if (spec.tag) {
            google.trackSamePageLinkClick(spec.target, spec.tag);
        }
    }

    function trackInternalLinkClick(spec) {
        // Store in session storage.
        // GA and Omniture will both pick it up on next page load,
        // then Omniture will remove it from storage.
        var storeObj = {
            path: loc.pathname,
            tag: spec.tag || 'untracked',
            time: new Date().getTime()
        };
        storage.session.set(NG_STORAGE_KEY, storeObj);
    }

    function trackExternalLinkClick(spec) {
        // Execute the GA and Omniture tracking in parallel
        // and rely on Omniture to provide a 500 ms delay so they both get a chance to complete.
        // TODO when Omniture goes away, implement the delay ourselves.
        google.trackExternalLinkClick(spec.target, spec.tag);
    }

    function init(options) {
        options = options || {};
        if (options.location) {
            loc = options.location; // allow a fake location to be passed in for testing
        }
        addHandlers();
        mediator.emit('analytics:ready');
    }

    return {
        init: init,
        trackClick: trackClick,
        trackNonClickInteraction: trackNonClickInteraction
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Module: geo-most-popular.js
 Description: Shows popular trails for a given country.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(39),
    __webpack_require__(0),
    __webpack_require__(4),
    __webpack_require__(411)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    qwery,
    Component,
    config,
    mediator,
    once
) {

    var promise = new Promise(function (resolve, reject) {
        mediator.on('modules:onward:geo-most-popular:ready', resolve);
        mediator.on('modules:onward:geo-most-popular:cancel', resolve);
        mediator.on('modules:onward:geo-most-popular:error', reject);
    });

    function GeoMostPopular() {
        mediator.emit('register:begin', 'geo-most-popular');
    }

    Component.define(GeoMostPopular);

    GeoMostPopular.prototype.endpoint = '/most-read-geo.json';

    GeoMostPopular.prototype.ready = function () {
        mediator.emit('register:end', 'geo-most-popular');
        mediator.emit('modules:onward:geo-most-popular:ready', this);
    };

    GeoMostPopular.prototype.error = function (error) {
        mediator.emit('modules:onward:geo-most-popular:error', error);
    };

    return {

        render: once(function () {
            new GeoMostPopular().fetch(qwery('.js-components-container'), 'rightHtml');
            return promise;
        }),

        whenRendered: promise

    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-paid-content inline-commercial\"><svg viewBox=\\\"0 0 351 227\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\"><defs><path id=\\\"0\\\" d=\\\"m0 31.6h123v-15.7-15.7h-123v31.4\\\"/><mask id=\\\"1\\\" fill=\\\"#fff\\\"><use xlink:href=\\\"#0\\\"/></mask></defs><g fill=\\\"none\\\" fill-rule=\\\"evenodd\\\"><path fill=\\\"#005689\\\" d=\\\"m0 0h351v52h-351z\\\"/><g transform=\\\"translate(174 14)\\\"><path d=\\\"m4.2 26.8c.1-.8.6-1.8 1.9-1.9h4.5c1.3 0 1.9 1.1 1.9 1.9 0 1.7-1.1 2.3-4.4 2.3-2.9 0-4.1-1.2-4-2.3m6-14.2c0 3-.7 3.4-1.8 3.4-1.2 0-2.1-.4-2.1-3.4 0-3.1.9-3.9 2.1-3.9 1.2 0 1.8 1.1 1.8 3.9m-3.9 7.4c-.6 0-1.3-.4-1.3-1 0-.4.3-.9.7-1.2.8.3 1.6.3 2.6.3 4.1 0 6.9-1.9 6.9-5.5 0-1.6-.7-2.4-1.7-3.4l2.7.7v-3.2l-4.3.8c-1-.4-2.4-.8-3.7-.8-4.1 0-6.9 2.2-6.9 5.7 0 2.2 1.1 3.7 2.6 4.6l.1.1c-.9.6-2.8 2.1-2.8 3.8 0 1.3.8 2.5 2.5 2.9-1.8.4-3.8 1.3-3.8 3.4 0 2.2 3.1 4.2 8.1 4.2 6.2 0 8.7-3 8.7-6.8 0-3.2-1.5-4.7-5-4.7h-5.5m17 4.1c.2 0 .5 0 .7-.1 1.8-.2 3.5-1.1 4.4-2.2v2.2l6.3-.8v-1.1l-1.6-1.1v-14.2h-.5l-6.3 1.2v1.4l2.1.9v9.6c-.6.4-1.3.7-2.2.7-1.3 0-2.5-.4-2.5-2.3v-11.6h-.5l-6.3 1.3v1.4l2.1.8v8.6c0 2.8 1.2 5.1 4.4 5.1m72.8-2.9c-1 0-2.1-.6-2.1-2.4 0-1.3 1.3-2.5 2.5-2.6l1.2-.3v4.5c0 0-1 .8-1.6.8m-1.2-12c2 0 2.8 1.1 2.8 3.1v1.8l-3.2.6c-3.1.6-5.5 1.5-5.5 4.9 0 2.7 1.8 4.6 4.4 4.6 2 0 3.9-.9 4.6-2.3h.2c.3 1.7 1.7 2.3 3.4 2.3 1.3 0 2.5-.3 3-.8v-1.1l-1.5-.8v-9.5c0-3.7-2.7-4.9-7-4.9-2.8 0-4.5.7-6 1.4v4.1h2.5l1.1-3.2c.6-.2 1.2-.2 1.4-.2m-52.9 12c-1 0-2.1-.6-2.1-2.4 0-1.3 1.3-2.5 2.5-2.6l1.2-.3v4.5c0 0-1 .8-1.6.8m-1.2-12c2 0 2.8 1.1 2.8 3.1v1.8l-3.2.6c-3.1.6-5.5 1.5-5.5 4.9 0 2.7 1.8 4.6 4.4 4.6 2 0 3.9-.9 4.6-2.3h.2c.3 1.7 1.7 2.3 3.4 2.3 1.3 0 2.5-.3 3-.8v-1.1l-1.5-.8v-9.5c0-3.7-2.7-4.9-7-4.9-2.8 0-4.5.7-6 1.4v4.1h2.5l1.1-3.2c.6-.2 1.2-.2 1.4-.2m10 .4l1.6.8v11l-1.6.8v1.6h8.9v-1.6l-2.1-.8v-8.6c.9-.7 2.2-1 3.6-1 .5 0 .8.1 1.2.2v-4.7c-.2-.1-.4-.1-.6-.1-1.7 0-3.2 1.2-4.1 3.3v-3.4h-.5l-6.3 1.1v1.6m22-1.8c-.6-.5-1.7-.7-2.6-.7-3.9 0-7.6 2.3-7.6 8.8 0 6.3 3.7 8.3 6.2 8.3 2 0 3.4-.9 4-1.8h.2v1.7h.5l6.2-.7v-1.2l-1.6-.9v-20.8h-.5l-6.6 1.1v1.5l1.9.8v4.1m0 12.8c-.4.3-.9.6-1.7.6-2.1 0-3.1-1.7-3.1-5.7 0-4.6 1.3-6.1 2.9-6.1.9 0 1.5.3 1.8.7v10.5m7.4-12.6v1.5l1.6.8v11l-1.6.8v1.6h8.4v-1.6l-1.6-.8v-14.4h-.5l-6.3 1.1m4.4-7.7c-1.6 0-2.8 1.3-2.8 2.9 0 1.6 1.3 2.8 2.8 2.8 1.5 0 2.8-1.3 2.8-2.8-.1-1.6-1.3-2.9-2.8-2.9m20.3 23.5h8.4v-1.6l-1.6-.8v-10.5c.6-.5 1.5-.6 2.3-.6 1.5 0 1.9.5 1.9 2.2v8.9l-1.6.8v1.6h8.4v-1.6l-1.6-.8v-10c0-3-1.1-4.4-3.7-4.4-2.2 0-4.3.8-5.7 2.1v-2.2h-.5l-6.5 1.2v1.4l1.7.8v11l-1.6.8v1.6\\\" fill=\\\"#fff\\\" mask=\\\"url(#1)\\\" transform=\\\"translate(44)\\\"/><path d=\\\"m2.1 19c0 3 1.5 4.9 4.7 4.9 1.6 0 3.3-.4 4.3-1.2v-2c-.4.2-1 .3-1.5.3-1.5 0-2.2-.8-2.2-2.4v-8.7h3.7v-2.6h-3.7v-3.9l-5.3.8v3.2l-2.1.5v2.1h2.1v9.2m17.3 4.5v-1.6l-1.6-.8v-10.3c.6-.5 1.7-.9 2.5-.9 1.5 0 2.3.8 2.2 2.2v8.9l-1.6.8v1.6h8.4v-1.6l-1.6-.8v-10c0-3-1.7-4.4-4-4.4-2.2 0-4.5.7-5.9 2v-8.9h-.5l-6.3 1.1v1.6l2.1.8v17.9l-1.6.8v1.6h7.9m17.3-15c1.3 0 2 .9 2 5l-4.4.4c.1-4.2.9-5.4 2.4-5.4m6.9 7c0-6.8-2.7-8.9-6.8-8.9-4.7 0-7.9 3.3-7.9 8.6 0 5.5 2.9 8.5 8.3 8.5 2.9 0 5.1-1.4 5.9-2.5v-1.6c-1.1.4-2 .6-4 .6-2.9 0-4.9-1.7-4.9-4.8h9.5\\\" fill=\\\"#aadce6\\\"/></g><path fill=\\\"#fff\\\" d=\\\"m0 50h351v177h-351z\\\"/><g fill=\\\"#d8d8d8\\\"><path d=\\\"m54 58h187v72h-187z\\\"/><path d=\\\"m6 58h42v7h-42z\\\"/><path d=\\\"m248 58h42v72h-42z\\\"/><path d=\\\"m150 136h42v72h-42z\\\"/></g><path fill=\\\"#f6a623\\\" d=\\\"m248 136h91v72h-91z\\\"/><g fill=\\\"#d8d8d8\\\"><path d=\\\"m54 136h91v72h-91z\\\"/><path d=\\\"m297 58h42v72h-42z\\\"/><path d=\\\"m199 136h42v72h-42z\\\"/></g></g></svg></span>"}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-arrow-white-right inline-icon\"><svg xmlns=\\\"http://www.w3.org/2000/svg\\\" width=\\\"30\\\" height=\\\"30\\\"><path fill=\\\"#fff\\\" d=\\\"M22.8 14.6L15.2 7l-.7.7 5.5 6.6H6v1.5h14l-5.5 6.6.7.7 7.6-7.6v-.9\\\"/></svg></span>"}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-arrow inline-icon\"><svg width=\\\"24\\\" height=\\\"10\\\" viewBox=\\\"0 0 24 10\\\"><path d=\\\"M0 .7l10.5 8.4 1.1.9 1.1-.9 10.5-8.4-.5-.7-11.1 6.3-11-6.3-.6.7z\\\"/></svg></span>"}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-cross inline-icon\"><svg width=\\\"18\\\" height=\\\"18\\\" viewBox=\\\"0 0 18 18\\\"><path d=\\\"M7.5 9l-6.5-7 1-1 7 6.5 7-6.5 1 1-6.5 7 6.5 7-1 1-7-6.5-7 6.5-1-1 6.5-7z\\\"/></svg></span>"}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-external-link inline-icon\"><svg width=\\\"14\\\" height=\\\"10\\\" viewBox=\\\"0 0 14 10\\\"><path d=\\\"M12 1.1L8.27 4.83l.902.9L13 2.07 13.2 5h.8V.4l-.4-.4H9v.8zM11.7 6.625V8.7H1.2V2.2h5l.8-.6V1H.6l-.6.6v7.8l.6.6h11.8l.6-.6V6h-.7z\\\"/></svg></span>"}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"markup":"<span class=\"inline-marque-36 inline-icon\"><svg width=\\\"36\\\" height=\\\"36\\\" viewBox=\\\"0 0 36 36\\\">     <path d=\\\"M21.3 8.8c0-4.9-1.5-5.7-3.3-5.7-1.8 0-3.2.7-3.2 5.7s1.5 5.5 3.2 5.5c1.8-.1 3.3-.6 3.3-5.5m-6.5 18.8c-2.3 0-2.9 1.7-2.9 2.9 0 1.8 1.6 3.4 6.3 3.4 5.3 0 6.8-1.5 6.8-3.4 0-1.7-1.3-2.9-3.4-2.9h-6.8zm-4.3-25.2c-6.2 2.8-10.5 9-10.5 16.3 0 4.9 2 9.4 5.2 12.6v-.3c0-3.2 3.1-4.4 5.9-5-2.6-.6-3.9-2.5-3.9-4.4 0-2.6 2.9-4.8 4.3-5.8l-.2-.1c-2.5-1.4-4.1-3.8-4.1-7 0-2.7 1.2-4.9 3.3-6.3m25.5 16.4c0-7.4-4.5-13.8-10.9-16.5 2.1 1.4 3.4 3.5 3.5 6.3l.1.6c0 5.4-4.4 8.2-10.7 8.2-1.6 0-2.7-.1-4.1-.5-.6.4-1.1 1.1-1.1 1.8 0 .9.8 1.6 1.8 1.6h8.8c5.5 0 8.2 2.2 8.2 7.1 0 1.6-.3 3.1-1 4.3 3.3-3.4 5.4-7.9 5.4-12.9\\\"/> </svg></span>"}

/***/ }),
/* 574 */,
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });


    /* eslint no-bitwise: 0, no-plusplus: 0, default-case: 0 */

    /**
     * SHA-1 hash function reference implementation.
     *
     * @namespace
     */
    var Sha1 = {
        hash: function hash(content) {
            var msg = content;

            // convert string to UTF-8, as SHA only deals with byte-streams
            msg = decodeURIComponent(encodeURIComponent(msg));

            // constants [§4.2.1]
            var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];

            // PREPROCESSING

            msg += String.fromCharCode(0x80); // add trailing '1' bit (+ 0's padding) to string [§5.1.1]

            // convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
            var l = msg.length / 4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
            var N = Math.ceil(l / 16); // number of 16-integer-blocks required to hold 'l' ints
            var M = new Array(N);

            for (var i = 0; i < N; i++) {
                M[i] = new Array(16);
                for (var j = 0; j < 16; j++) {
                    // encode 4 chars per integer, big-endian encoding
                    M[i][j] = msg.charCodeAt(i * 64 + j * 4) << 24 | msg.charCodeAt(i * 64 + j * 4 + 1) << 16 | msg.charCodeAt(i * 64 + j * 4 + 2) << 8 | msg.charCodeAt(i * 64 + j * 4 + 3);
                } // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
            }
            // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
            // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
            // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
            M[N - 1][14] = (msg.length - 1) * 8 / Math.pow(2, 32);
            M[N - 1][14] = Math.floor(M[N - 1][14]);
            M[N - 1][15] = (msg.length - 1) * 8 & 0xffffffff;

            // set initial hash value [§5.3.1]
            var H0 = 0x67452301;
            var H1 = 0xefcdab89;
            var H2 = 0x98badcfe;
            var H3 = 0x10325476;
            var H4 = 0xc3d2e1f0;

            // HASH COMPUTATION [§6.1.2]

            var W = new Array(80);
            var a = void 0;
            var b = void 0;
            var c = void 0;
            var d = void 0;
            var e = void 0;

            for (var _i = 0; _i < N; _i++) {
                // 1 - prepare message schedule 'W'
                for (var t = 0; t < 16; t++) {
                    W[t] = M[_i][t];
                }
                for (var _t = 16; _t < 80; _t++) {
                    W[_t] = Sha1.ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
                }

                // 2 - initialise five working variables a, b, c, d, e with previous hash value
                a = H0;
                b = H1;
                c = H2;
                d = H3;
                e = H4;

                // 3 - main loop
                for (var _t2 = 0; _t2 < 80; _t2++) {
                    var s = Math.floor(_t2 / 20); // seq for blocks of 'f' functions and 'K' constants
                    var T = Sha1.ROTL(a, 5) + Sha1.f(s, b, c, d) + e + K[s] + W[_t2] & 0xffffffff;
                    e = d;
                    d = c;
                    c = Sha1.ROTL(b, 30);
                    b = a;
                    a = T;
                }

                // 4 - compute the new intermediate hash value (note 'addition modulo 2^32')
                H0 = H0 + a & 0xffffffff;
                H1 = H1 + b & 0xffffffff;
                H2 = H2 + c & 0xffffffff;
                H3 = H3 + d & 0xffffffff;
                H4 = H4 + e & 0xffffffff;
            }

            return Sha1.toHexStr(H0) + Sha1.toHexStr(H1) + Sha1.toHexStr(H2) + Sha1.toHexStr(H3) + Sha1.toHexStr(H4);
        },
        f: function f(s, x, y, z) {
            switch (s) {
                case 0:
                    return x & y ^ ~x & z; // Ch()
                case 1:
                    return x ^ y ^ z; // Parity()
                case 2:
                    return x & y ^ x & z ^ y & z; // Maj()
                case 3:
                    return x ^ y ^ z; // Parity()
            }
        },
        ROTL: function ROTL(x, n) {
            return x << n | x >>> 32 - n;
        },
        toHexStr: function toHexStr(n) {
            // note can't use toString(16) as it is implementation-dependant,
            // and in IE returns signed numbers when used on full words
            var s = '';
            var v = void 0;

            for (var i = 7; i >= 0; i--) {
                v = n >>> i * 4 & 0xf;
                s += v.toString(16);
            }

            return s;
        }
    };

    exports.default = Sha1;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(38), __webpack_require__(0), __webpack_require__(4), __webpack_require__(75), __webpack_require__(129)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _$, _config, _mediator, _fastdomPromise, _commercialFeatures) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.articleAsideAdvertsInit = undefined;

    var _$2 = _interopRequireDefault(_$);

    var _config2 = _interopRequireDefault(_config);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var minArticleHeight = 1300;

    var minImmersiveArticleHeight = 600;

    var minContentHeight = function minContentHeight() {
        return _config2.default.page.isImmersive ? minImmersiveArticleHeight : minArticleHeight;
    };

    var articleAsideAdvertsInit = function articleAsideAdvertsInit(start, stop) {
        start();

        var $col = (0, _$2.default)('.js-secondary-column');

        // are article aside ads disabled, or secondary column hidden?
        if (!(_commercialFeatures2.default.articleAsideAdverts && $col.length && $col.css('display') !== 'none')) {
            stop();
            return Promise.resolve(false);
        }

        var $mainCol = (0, _$2.default)('.js-content-main-column');
        var $adSlot = (0, _$2.default)('.js-ad-slot', $col);

        if (!$adSlot.length || !$mainCol.length) {
            stop();
            return Promise.resolve(false);
        }

        return _fastdomPromise2.default.read(function () {
            return $mainCol.dim().height;
        }).then(function (mainColHeight) {
            // Should switch to 'right-small' MPU for short articles
            if (mainColHeight < minContentHeight()) {
                return _fastdomPromise2.default.write(function () {
                    $adSlot.removeClass('right-sticky js-sticky-mpu is-sticky');
                    $adSlot[0].setAttribute('data-mobile', '1,1|2,2|300,250|fluid');
                    return $adSlot[0];
                });
            }
            return $adSlot[0];
        }).then(function (adSlot) {
            stop();
            _mediator2.default.emit('page:defaultcommercial:right', adSlot);
            return true;
        });
    };

    exports.articleAsideAdvertsInit = articleAsideAdvertsInit;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(18), __webpack_require__(75), __webpack_require__(243), __webpack_require__(137), __webpack_require__(237), __webpack_require__(430), __webpack_require__(431), __webpack_require__(231), __webpack_require__(432), __webpack_require__(129), __webpack_require__(258)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config, _detect, _fastdomPromise, _utils, _testCanRunChecks, _spaceFiller, _adSizes, _addSlot, _trackAdRender, _createSlot, _commercialFeatures, _increaseInlineAds) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports._ = exports.articleBodyAdvertsInit = undefined;

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _spaceFiller2 = _interopRequireDefault(_spaceFiller);

    var _adSizes2 = _interopRequireDefault(_adSizes);

    var _trackAdRender2 = _interopRequireDefault(_trackAdRender);

    var _createSlot2 = _interopRequireDefault(_createSlot);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _increaseInlineAds2 = _interopRequireDefault(_increaseInlineAds);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /* bodyAds is a counter that keeps track of the number of inline MPUs
     * inserted dynamically. */
    var bodyAds = void 0;
    var replaceTopSlot = void 0;
    var getSlotName = void 0;
    var getSlotType = void 0;

    var isOffsetingAds = (0, _testCanRunChecks.testCanBeRun)(new _increaseInlineAds2.default()) && (0, _utils.getTestVariantId)('IncreaseInlineAdsReduxRedux') === 'yes';

    var getSlotNameForMobile = function getSlotNameForMobile() {
        return bodyAds === 1 ? 'top-above-nav' : 'inline' + (bodyAds - 1);
    };

    var getSlotNameForDesktop = function getSlotNameForDesktop() {
        return 'inline' + bodyAds;
    };

    var getSlotTypeForMobile = function getSlotTypeForMobile() {
        return bodyAds === 1 ? 'top-above-nav' : 'inline';
    };

    var getSlotTypeForDesktop = function getSlotTypeForDesktop() {
        return 'inline';
    };

    var insertAdAtPara = function insertAdAtPara(para, name, type, classes, sizes) {
        var ad = (0, _createSlot2.default)(type, {
            name: name,
            classes: classes,
            sizes: sizes
        });

        return _fastdomPromise2.default.write(function () {
            if (para.parentNode) {
                para.parentNode.insertBefore(ad, para);
            }
        }).then(function () {
            (0, _addSlot.addSlot)(ad, name === 'im');
        });
    };

    // Add new ads while there is still space
    var addArticleAds = function addArticleAds(count, rules) {
        var insertInlineAds = function insertInlineAds(paras) {
            var slots = paras.slice(0, Math.min(paras.length, count)).map(function (para) {
                bodyAds += 1;
                return insertAdAtPara(para, getSlotName(), getSlotType(), 'inline' + (isOffsetingAds && bodyAds > 1 ? ' offset-right' : ''), isOffsetingAds && bodyAds > 1 ? {
                    desktop: [_adSizes2.default.halfPage]
                } : null);
            });

            return Promise.all(slots).then(function () {
                return slots.length;
            });
        };

        // This just returns whatever is passed in the second argument
        return _spaceFiller2.default.fillSpace(rules, insertInlineAds, {
            waitForImages: true,
            waitForLinks: true,
            waitForInteractives: true
        });
    };

    var getRules = function getRules() {
        var prevSlot = void 0;

        var adSlotClassSelectorSizes = {
            minAbove: 500,
            minBelow: 500
        };

        return {
            bodySelector: '.js-article__body',
            slotSelector: ' > p',
            minAbove: _detect2.default.isBreakpoint({
                max: 'tablet'
            }) ? 300 : 700,
            minBelow: 300,
            selectors: {
                ' > h2': {
                    minAbove: _detect2.default.getBreakpoint() === 'mobile' ? 100 : 0,
                    minBelow: 250
                },
                ' .ad-slot': adSlotClassSelectorSizes,
                ' > :not(p):not(h2):not(.ad-slot)': {
                    minAbove: 35,
                    minBelow: 400
                }
            },
            filter: function filter(slot) {
                if (!prevSlot || Math.abs(slot.top - prevSlot.top) - _adSizes2.default.mpu.height >= adSlotClassSelectorSizes.minBelow) {
                    prevSlot = slot;
                    return true;
                }
                return false;
            }
        };
    };

    var getAltRules = function getAltRules() {
        var altRules = getRules();
        altRules.selectors = {
            ' .ad-slot': {
                minAbove: 500,
                minBelow: 500
            }
        };
        return altRules;
    };

    var getLongArticleRules = function getLongArticleRules() {
        var longArticleRules = isOffsetingAds ? getAltRules() : getRules();
        var viewportHeight = _detect2.default.getViewport().height;
        longArticleRules.selectors[' .ad-slot'].minAbove = viewportHeight;
        longArticleRules.selectors[' .ad-slot'].minBelow = viewportHeight;
        return longArticleRules;
    };

    var addInlineAds = function addInlineAds() {
        return addArticleAds(2, isOffsetingAds ? getAltRules() : getRules()).then(function (countAdded) {
            if (countAdded === 2) {
                return addArticleAds(8, getLongArticleRules()).then(function (innerCountAdded) {
                    return 2 + innerCountAdded;
                });
            }
            return countAdded;
        });
    };

    var getInlineMerchRules = function getInlineMerchRules() {
        var inlineMerchRules = getRules();
        inlineMerchRules.minAbove = 300;
        inlineMerchRules.selectors[' > h2'].minAbove = 100;
        inlineMerchRules.selectors[' > :not(p):not(h2):not(.ad-slot)'].minAbove = 200;
        return inlineMerchRules;
    };

    var addInlineMerchAd = function addInlineMerchAd() {
        return _spaceFiller2.default.fillSpace(getInlineMerchRules(), function (paras) {
            return insertAdAtPara(paras[0], 'im', 'im').then(function () {
                return 1;
            });
        }, {
            waitForImages: true,
            waitForLinks: true,
            waitForInteractives: true
        });
    };

    var waitForMerch = function waitForMerch(countAdded) {
        return countAdded === 1 ? (0, _trackAdRender2.default)('dfp-ad--im') : Promise.resolve();
    };

    var articleBodyAdvertsInit = function articleBodyAdvertsInit() {
        if (!_commercialFeatures2.default.articleBodyAdverts) {
            return Promise.resolve(false);
        }

        bodyAds = 0;
        replaceTopSlot = _detect2.default.isBreakpoint({
            max: 'phablet'
        });
        getSlotName = replaceTopSlot ? getSlotNameForMobile : getSlotNameForDesktop;
        getSlotType = replaceTopSlot ? getSlotTypeForMobile : getSlotTypeForDesktop;

        if (_config2.default.page.hasInlineMerchandise) {
            var im = addInlineMerchAd();
            // Whether an inline merch has been inserted or not,
            // we still want to try to insert inline MPUs. But
            // we must wait for DFP to return, since if the merch
            // component is empty, it might completely change the
            // positions where we insert those MPUs.
            im.then(waitForMerch).then(addInlineAds);
            return im;
        }

        addInlineAds();
        return Promise.resolve(true);
    };

    exports.articleBodyAdvertsInit = articleBodyAdvertsInit;
    var _ = exports._ = {
        waitForMerch: waitForMerch,
        addInlineMerchAd: addInlineMerchAd,
        addInlineAds: addInlineAds
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(76), __webpack_require__(0), __webpack_require__(18), __webpack_require__(229), __webpack_require__(239), __webpack_require__(411), __webpack_require__(447)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _url, _config, _detect, _uniq, _flatten, _once, _prepareSwitchTag) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.defineSlot = undefined;

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    var _uniq2 = _interopRequireDefault(_uniq);

    var _flatten2 = _interopRequireDefault(_flatten);

    var _once2 = _interopRequireDefault(_once);

    var _prepareSwitchTag2 = _interopRequireDefault(_prepareSwitchTag);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var adUnit = (0, _once2.default)(function () {
        var urlVars = (0, _url.getUrlVars)();
        return urlVars['ad-unit'] ? '/' + _config2.default.page.dfpAccountId + '/' + urlVars['ad-unit'] : _config2.default.page.adUnit;
    });


    /**
     * Builds and assigns the correct size map for a slot based on the breakpoints
     * attached to the element via data attributes.
     *
     * A new size map is created for a given slot. We then loop through each breakpoint
     * defined in the config, checking if that breakpoint has been set on the slot.
     *
     * If it has been defined, then we add that size to the size mapping.
     *
     */
    var buildSizeMapping = function buildSizeMapping(sizes) {
        var mapping = window.googletag.sizeMapping();

        _detect2.default.breakpoints.filter(function (_) {
            return _.name in sizes;
        }).forEach(function (_) {
            mapping.addSize([_.width, 0], sizes[_.name]);
        });

        return mapping.build();
    };

    var getSizeOpts = function getSizeOpts(sizesByBreakpoint) {
        var sizeMapping = buildSizeMapping(sizesByBreakpoint);
        // as we're using sizeMapping, pull out all the ad sizes, as an array of arrays
        var sizes = (0, _uniq2.default)((0, _flatten2.default)(sizeMapping, true, function (map) {
            return map[1];
        }), function (size) {
            return size[0] + '-' + size[1];
        });

        return {
            sizeMapping: sizeMapping,
            sizes: sizes
        };
    };

    var defineSlot = function defineSlot(adSlotNode, sizes) {
        var slotTarget = adSlotNode.getAttribute('data-name');
        var sizeOpts = getSizeOpts(sizes);
        var id = adSlotNode.id;
        var slot = void 0;
        var slotReady = void 0;

        if (adSlotNode.getAttribute('data-out-of-page')) {
            slot = window.googletag.defineOutOfPageSlot(adUnit(), id).defineSizeMapping(sizeOpts.sizeMapping);
            slotReady = Promise.resolve();
        } else {
            slot = window.googletag.defineSlot(adUnit(), sizeOpts.sizes, id).defineSizeMapping(sizeOpts.sizeMapping);
            slotReady = _prepareSwitchTag2.default.pushAdUnit(id, sizeOpts);
        }

        if (slotTarget === 'im' && _config2.default.page.isbn) {
            slot.setTargeting('isbn', _config2.default.page.isbn);
        }

        slot.addService(window.googletag.pubads()).setTargeting('slot', slotTarget);

        return {
            slot: slot,
            slotReady: slotReady
        };
    };

    exports.defineSlot = defineSlot;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(223), __webpack_require__(433), __webpack_require__(498), __webpack_require__(400)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _dfpEnv, _loadAdvert, _enableLazyLoad, _performanceLogging) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.displayLazyAds = undefined;

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _loadAdvert2 = _interopRequireDefault(_loadAdvert);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var advertsToInstantlyLoad = ['dfp-ad--merchandising-high', 'dfp-ad--im'];

    var instantLoad = function instantLoad() {
        var instantLoadAdverts = _dfpEnv2.default.advertsToLoad.filter(function (advert) {
            if (advertsToInstantlyLoad.includes(advert.id)) {
                (0, _performanceLogging.updateAdvertMetric)(advert, 'loadingMethod', 'instant');
                (0, _performanceLogging.updateAdvertMetric)(advert, 'lazyWaitComplete', 0);
                return true;
            }
            (0, _performanceLogging.updateAdvertMetric)(advert, 'loadingMethod', 'lazy-load');
            return false;
        });

        _dfpEnv2.default.advertsToLoad = _dfpEnv2.default.advertsToLoad.filter(function (advert) {
            return !advertsToInstantlyLoad.includes(advert.id);
        });

        instantLoadAdverts.forEach(_loadAdvert2.default);
    };

    var displayLazyAds = function displayLazyAds() {
        window.googletag.pubads().collapseEmptyDivs();
        window.googletag.enableServices();
        instantLoad();
        (0, _enableLazyLoad.enableLazyLoad)();
    };

    exports.displayLazyAds = displayLazyAds;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fastdom) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.emptyAdvert = undefined;

    var _fastdom2 = _interopRequireDefault(_fastdom);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var emptyAdvert = function emptyAdvert(advert) {
        _fastdom2.default.write(function () {
            window.googletag.destroySlots([advert.slot]);
            advert.node.remove();
            advert.node = advert.slot = null;
        });
    };

    /* eslint no-multi-assign: "off"*/

    exports.emptyAdvert = emptyAdvert;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(5), __webpack_require__(575), __webpack_require__(81), __webpack_require__(129), __webpack_require__(223), __webpack_require__(444), __webpack_require__(499), __webpack_require__(579), __webpack_require__(806), __webpack_require__(586), __webpack_require__(447)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _qwery, _sha, _api, _commercialFeatures, _dfpEnv, _Advert, _queueAdvert, _displayLazyAds, _displayAds, _refreshOnResize, _prepareSwitchTag) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.fillAdvertSlots = undefined;

    var _qwery2 = _interopRequireDefault(_qwery);

    var _sha2 = _interopRequireDefault(_sha);

    var _api2 = _interopRequireDefault(_api);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _Advert2 = _interopRequireDefault(_Advert);

    var _queueAdvert2 = _interopRequireDefault(_queueAdvert);

    var _displayAds2 = _interopRequireDefault(_displayAds);

    var _refreshOnResize2 = _interopRequireDefault(_refreshOnResize);

    var _prepareSwitchTag2 = _interopRequireDefault(_prepareSwitchTag);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var createAdverts = function createAdverts() {
        // Get all ad slots
        var adverts = (0, _qwery2.default)(_dfpEnv2.default.adSlotSelector).filter(function (adSlot) {
            return !(adSlot.id in _dfpEnv2.default.advertIds);
        }).map(_Advert2.default);
        var currentLength = _dfpEnv2.default.adverts.length;
        _dfpEnv2.default.adverts = _dfpEnv2.default.adverts.concat(adverts);
        adverts.forEach(function (advert, index) {
            _dfpEnv2.default.advertIds[advert.id] = currentLength + index;
        });
    };

    /**
     * Loop through each slot detected on the page and define it based on the data
     * attributes on the element.
     */


    var queueAdverts = function queueAdverts() {
        // queue ads for load
        _dfpEnv2.default.adverts.forEach(_queueAdvert2.default);
    };

    var setPublisherProvidedId = function setPublisherProvidedId() {
        var user = _api2.default.getUserFromCookie();
        if (user) {
            var hashedId = _sha2.default.hash(user.id);
            window.googletag.pubads().setPublisherProvidedId(hashedId);
        }
    };

    var fillAdvertSlots = function fillAdvertSlots(start, stop) {
        if (_commercialFeatures2.default.dfpAdvertising) {
            window.googletag.cmd.push(start, createAdverts, queueAdverts, setPublisherProvidedId, _prepareSwitchTag2.default.callSwitch, _dfpEnv2.default.shouldLazyLoad() ? _displayLazyAds.displayLazyAds : _displayAds2.default, _refreshOnResize2.default, stop);
        }
        return Promise.resolve();
    };

    exports.fillAdvertSlots = fillAdvertSlots;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 582 */,
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(4), __webpack_require__(123), __webpack_require__(223), __webpack_require__(433), __webpack_require__(400), __webpack_require__(233)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _detect, _mediator, _userTiming, _dfpEnv, _loadAdvert, _performanceLogging, _getAdvertById) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.onScroll = exports.onIntersect = undefined;

    var _detect2 = _interopRequireDefault(_detect);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _loadAdvert2 = _interopRequireDefault(_loadAdvert);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var IntersectionObserver = window.IntersectionObserver;

    /* eslint no-use-before-define: "off" */

    var IntersectionObserverEntry = window.IntersectionObserverEntry;

    /* depthOfScreen: double. Top and bottom margin of the visual viewport to check for the presence of an advert */
    var depthOfScreen = 1.5;

    var stopListening = function stopListening() {
        _dfpEnv2.default.lazyLoadEnabled = false;
        _mediator2.default.off('window:throttledScroll', onScroll);
    };

    var stopObserving = function stopObserving(observer) {
        _dfpEnv2.default.lazyLoadEnabled = false;
        observer.disconnect();
    };

    var displayAd = function displayAd(advertId) {
        var advert = (0, _getAdvertById.getAdvertById)(advertId);
        if (advert) {
            (0, _performanceLogging.updateAdvertMetric)(advert, 'lazyWaitComplete', (0, _userTiming.getCurrentTime)());
            (0, _loadAdvert2.default)(advert);
        }
    };

    var onScroll = function onScroll() {
        var viewportHeight = _detect2.default.getViewport().height;

        var lazyLoadAds = _dfpEnv2.default.advertsToLoad.filter(function (advert) {
            var rect = advert.node.getBoundingClientRect();
            var isNotHidden = rect.top + rect.left + rect.right + rect.bottom !== 0;
            var isNotTooFarFromTop = (1 - depthOfScreen) * viewportHeight < rect.bottom;
            var isNotTooFarFromBottom = rect.top < viewportHeight * depthOfScreen;
            // load the ad only if it's setting within an acceptable range
            return isNotHidden && isNotTooFarFromTop && isNotTooFarFromBottom;
        }).map(function (advert) {
            return advert.id;
        });

        _dfpEnv2.default.advertsToLoad = _dfpEnv2.default.advertsToLoad.filter(function (advert) {
            return !lazyLoadAds.includes(advert.id);
        });

        if (_dfpEnv2.default.advertsToLoad.length === 0) {
            stopListening();
        }

        lazyLoadAds.forEach(displayAd);
    };

    var onIntersect = function onIntersect(entries, observer) {
        var advertIds = [];

        entries.filter(function (entry) {
            return !('isIntersecting' in entry) || entry.isIntersecting;
        }).forEach(function (entry) {
            observer.unobserve(entry.target);
            displayAd(entry.target.id);
            advertIds.push(entry.target.id);
        });

        _dfpEnv2.default.advertsToLoad = _dfpEnv2.default.advertsToLoad.filter(function (advert) {
            return advertIds.indexOf(advert.id) < 0;
        });

        if (_dfpEnv2.default.advertsToLoad.length === 0) {
            stopObserving(observer);
        }
    };

    exports.onIntersect = onIntersect;
    exports.onScroll = onScroll;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(35), __webpack_require__(0), __webpack_require__(224), __webpack_require__(129), __webpack_require__(446), __webpack_require__(541), __webpack_require__(223), __webpack_require__(808), __webpack_require__(807), __webpack_require__(400), __webpack_require__(817), __webpack_require__(814), __webpack_require__(815), __webpack_require__(816), __webpack_require__(818), __webpack_require__(813), __webpack_require__(812)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _raven, _config, _loadScript, _commercialFeatures, _buildPageTargeting, _closeDisabledSlots, _dfpEnv, _onSlotRender, _onSlotLoad, _performanceLogging) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _raven2 = _interopRequireDefault(_raven);

    var _config2 = _interopRequireDefault(_config);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _closeDisabledSlots2 = _interopRequireDefault(_closeDisabledSlots);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _onSlotRender2 = _interopRequireDefault(_onSlotRender);

    var _onSlotLoad2 = _interopRequireDefault(_onSlotLoad);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var setDfpListeners = function setDfpListeners() {
        (0, _performanceLogging.setListeners)(window.googletag);

        var pubads = window.googletag.pubads();
        pubads.addEventListener('slotRenderEnded', _raven2.default.wrap(_onSlotRender2.default));
        pubads.addEventListener('slotOnload', _raven2.default.wrap(_onSlotLoad2.default));
    };

    var setPageTargeting = function setPageTargeting() {
        var pubads = window.googletag.pubads();
        var targeting = (0, _buildPageTargeting.buildPageTargeting)();
        Object.keys(targeting).forEach(function (key) {
            pubads.setTargeting(key, targeting[key]);
        });
    };

    var removeAdSlots = function removeAdSlots() {
        return _closeDisabledSlots2.default.init(true);
    };

    var init = function init(start, stop) {
        var setupAdvertising = function setupAdvertising() {
            (0, _performanceLogging.addTag)(_dfpEnv2.default.sonobiEnabled ? 'sonobi' : 'waterfall');

            window.googletag.cmd.push(start, setDfpListeners, setPageTargeting, stop);

            // Just load googletag. Sonobi's wrapper will already be loaded, and googletag is already added to the window by sonobi.
            return (0, _loadScript.loadScript)(_config2.default.libs.googletag, { async: false });
        };

        if (_commercialFeatures2.default.dfpAdvertising) {
            setupAdvertising()
            // A promise error here, from a failed module load,
            // could be a network problem or an intercepted request.
            // Abandon the init sequence.
            .catch(removeAdSlots);
            return Promise.resolve();
        }

        return removeAdSlots();
    };

    exports.default = {
        init: init
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(224), __webpack_require__(129), __webpack_require__(446), __webpack_require__(223)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _config, _loadScript, _commercialFeatures, _buildPageTargeting, _dfpEnv) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    // Wrap the native implementation of getOwnPropertyNames in a try-catch. If any polyfill attempts
    // to re-implement this function, and doesn't consider the "access permissions" issue that exists in IE11,
    // then the resulting "Access Denied" error will be caught. Without this, the error is always delivered to Sentry,
    // but does not pass through window.onerror. More info here: https://github.com/paulmillr/es6-shim/issues/333
    var catchPolyfillErrors = function catchPolyfillErrors() {
        // Skip polyfill error-catch in dev environments.
        if (_config2.default.page.isDev) {
            return;
        }

        var nativeGetOwnPropertyNames = Object.getOwnPropertyNames;
        // Cast to any to workaround Flow warning:
        // covariant property incompatible with contravariant use in assignment of property.
        Object.getOwnPropertyNames = function (obj) {
            try {
                return nativeGetOwnPropertyNames(obj);
            } catch (e) {
                // continue regardless of error
                return [];
            }
        };
    };


    var setupSonobi = function setupSonobi(start, stop) {
        start();

        // Setting the async property to false will _still_ load the script in
        // a non-blocking fashion but will ensure it is executed before googletag
        (0, _loadScript.loadScript)(_config2.default.libs.sonobi, { async: false }).then(catchPolyfillErrors).then(stop);
    };

    var init = function init(start, stop) {
        if (_dfpEnv2.default.sonobiEnabled && _commercialFeatures2.default.dfpAdvertising) {
            (0, _buildPageTargeting.buildPageTargeting)();
            setupSonobi(start, stop);
        }

        return Promise.resolve();
    };

    exports.default = {
        init: init
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(125), __webpack_require__(18), __webpack_require__(4), __webpack_require__(223), __webpack_require__(542)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _toConsumableArray2, _detect, _mediator, _dfpEnv, _breakpointNameToAttribute) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

    var _detect2 = _interopRequireDefault(_detect);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _dfpEnv2 = _interopRequireDefault(_dfpEnv);

    var _breakpointNameToAttribute2 = _interopRequireDefault(_breakpointNameToAttribute);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /* hasBreakpointChanged: ((string, string) -> undefined) -> undefined. Invokes the callback if a breakpoint has been crossed since last invocation */
    var hasBreakpointChanged = _detect2.default.hasCrossedBreakpoint(true);

    /* breakpointNames: array<string>. List of breakpoint names */
    var breakpointNames = _detect2.default.breakpoints.map(function (_) {
        return _.name;
    });

    // TODO: reset advert flags
    var refresh = function refresh(currentBreakpoint, previousBreakpoint) {
        var getBreakpointIndex = function getBreakpointIndex(breakpoint, slotBreakpoints) {
            var validBreakpointNames = breakpointNames.slice(0, breakpointNames.indexOf(breakpoint) + 1).map(_breakpointNameToAttribute2.default);
            return Math.max.apply(Math, (0, _toConsumableArray3.default)(slotBreakpoints.map(function (_) {
                return validBreakpointNames.lastIndexOf(_);
            })));
        };

        var shouldRefresh = function shouldRefresh(advert) {
            // get the slot breakpoints
            var slotBreakpoints = Object.keys(advert.sizes);
            // find the currently matching breakpoint
            var currentSlotBreakpoint = getBreakpointIndex(currentBreakpoint, slotBreakpoints);
            // find the previously matching breakpoint
            var previousSlotBreakpoint = getBreakpointIndex(previousBreakpoint, slotBreakpoints);
            return currentSlotBreakpoint !== -1 && currentSlotBreakpoint !== previousSlotBreakpoint;
        };

        // only refresh if the slot needs to
        var advertsToRefresh = _dfpEnv2.default.advertsToRefresh.filter(shouldRefresh);
        if (advertsToRefresh.length) {
            window.googletag.pubads().refresh(advertsToRefresh.map(function (_) {
                return _.slot;
            }));
        }
    };

    var windowResize = function windowResize() {
        // refresh on resize
        hasBreakpointChanged(refresh);
    };

    var refreshOnResize = function refreshOnResize() {
        _mediator2.default.on('window:throttledResize', windowResize);
    };

    exports.default = refreshOnResize;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(409), __webpack_require__(75), __webpack_require__(21), __webpack_require__(653), __webpack_require__(250), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _typeof2, _fastdomPromise, _template, _adFeedbackPopup, _tick, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof3 = _interopRequireDefault(_typeof2);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _template2 = _interopRequireDefault(_template);

    var _adFeedbackPopup2 = _interopRequireDefault(_adFeedbackPopup);

    var _tick2 = _interopRequireDefault(_tick);

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var shouldRenderLabel = function shouldRenderLabel(adSlotNode) {
        return !(adSlotNode.classList.contains('ad-slot--fluid') || adSlotNode.classList.contains('ad-slot--frame') || adSlotNode.classList.contains('gu-style') || adSlotNode.getAttribute('data-label') === 'false' || adSlotNode.getElementsByClassName('ad-slot__label').length);
    };


    var renderAdvertLabel = function renderAdvertLabel(adSlotNode) {
        if (shouldRenderLabel(adSlotNode)) {
            var _ret = function () {
                var feedbackPopup = '';
                var feedbackThanksMessage = '';
                if (_config2.default.switches.adFeedback) {
                    feedbackPopup = (0, _template2.default)(_adFeedbackPopup2.default, {
                        feedbackOptions: {
                            inappropriate: "It's offensive or inappropriate",
                            repetitive: 'I keep seeing this',
                            irrelevant: "It's not relevant to me",
                            useful: 'This advert was useful'
                        },
                        icon: _tick2.default.markup,
                        slot: adSlotNode.id
                    });
                    feedbackThanksMessage = '<i class="ad-feedback__thanks-message"> Thanks for your feedback </i>';
                }
                var labelDiv = '<div class="ad-slot__label">Advertisement' + feedbackPopup + feedbackThanksMessage + '</div>';
                return {
                    v: _fastdomPromise2.default.write(function () {
                        adSlotNode.insertAdjacentHTML('afterbegin', labelDiv);
                    })
                };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        }
        return Promise.resolve(null);
    };

    exports.default = renderAdvertLabel;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(409), __webpack_require__(5), __webpack_require__(35), __webpack_require__(75), __webpack_require__(4), __webpack_require__(430), __webpack_require__(820), __webpack_require__(805), __webpack_require__(587), __webpack_require__(562), __webpack_require__(493), __webpack_require__(603), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _typeof2, _qwery, _raven, _fastdomPromise, _mediator, _adSizes, _stickyMpu, _applyCreativeTemplate, _renderAdvertLabel, _geoMostPopular, _toggles, _userAdFeedback, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof3 = _interopRequireDefault(_typeof2);

    var _qwery2 = _interopRequireDefault(_qwery);

    var _raven2 = _interopRequireDefault(_raven);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _adSizes2 = _interopRequireDefault(_adSizes);

    var _stickyMpu2 = _interopRequireDefault(_stickyMpu);

    var _applyCreativeTemplate2 = _interopRequireDefault(_applyCreativeTemplate);

    var _renderAdvertLabel2 = _interopRequireDefault(_renderAdvertLabel);

    var _geoMostPopular2 = _interopRequireDefault(_geoMostPopular);

    var _toggles2 = _interopRequireDefault(_toggles);

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /**
     * ADVERT RENDERING
     * ----------------
     *
     * Most adverts come back from DFP ready to display as-is. But sometimes we need more: embedded components that can share
     * Guardian styles, for example, or behaviours like sticky-scrolling. This module helps 'finish' rendering any advert, and
     * decorates them with these behaviours.
     *
     */

    var addClassIfHasClass = function addClassIfHasClass(newClassNames) {
        return function hasClass(classNames) {
            return function onAdvertRendered(_, advert) {
                if (classNames.some(function (className) {
                    return advert.node.classList.contains(className);
                })) {
                    return _fastdomPromise2.default.write(function () {
                        newClassNames.forEach(function (className) {
                            advert.node.classList.add(className);
                        });
                    });
                }
            };
        };
    };

    var addFluid250 = addClassIfHasClass(['ad-slot--fluid250']);
    var addFluid = addClassIfHasClass(['ad-slot--fluid']);

    var sizeCallbacks = {};

    /**
     * DFP fluid ads should use existing fluid-250 styles in the top banner position
     */
    sizeCallbacks[_adSizes2.default.fluid] = addFluid(['ad-slot']);

    /**
     * Trigger sticky scrolling for MPUs in the right-hand article column
     */
    sizeCallbacks[_adSizes2.default.mpu] = function (_, advert) {
        if (advert.node.classList.contains('js-sticky-mpu')) {
            (0, _stickyMpu2.default)(advert.node);
        } else {
            return addFluid(['ad-slot--revealer'])(_, advert);
        }
    };

    /**
     * Resolve the stickyMpu.whenRendered promise
     */
    sizeCallbacks[_adSizes2.default.halfPage] = function () {
        _mediator2.default.emit('page:commercial:sticky-mpu');
    };

    sizeCallbacks[_adSizes2.default.video] = function (_, advert) {
        _fastdomPromise2.default.write(function () {
            advert.node.classList.add('u-h');
        });
    };

    sizeCallbacks[_adSizes2.default.video2] = function (_, advert) {
        _fastdomPromise2.default.write(function () {
            advert.node.classList.add('ad-slot--outstream');
        });
    };

    /**
     * Out of page adverts - creatives that aren't directly shown on the page - need to be hidden,
     * and their containers closed up.
     */
    var outOfPageCallback = function outOfPageCallback(event, advert) {
        if (!event.slot.getOutOfPage()) {
            var _ret = function () {
                var parent = advert.node.parentNode;
                return {
                    v: _fastdomPromise2.default.write(function () {
                        advert.node.classList.add('u-h');
                        // if in a slice, add the 'no mpu' class
                        if (parent.classList.contains('fc-slice__item--mpu-candidate')) {
                            parent.classList.add('fc-slice__item--no-mpu');
                        }
                    })
                };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        }
    };
    sizeCallbacks[_adSizes2.default.outOfPage] = outOfPageCallback;
    sizeCallbacks[_adSizes2.default.empty] = outOfPageCallback;

    /**
     * Portrait adverts exclude the locally-most-popular widget
     */
    sizeCallbacks[_adSizes2.default.portrait] = function () {
        // remove geo most popular
        _geoMostPopular2.default.whenRendered.then(function (popular) {
            return _fastdomPromise2.default.write(function () {
                popular.elem.remove();
                popular.elem = null;
            });
        });
    };

    /**
     * Commercial components with merch sizing get fluid-250 styling
     */
    sizeCallbacks[_adSizes2.default.merchandising] = addFluid250(['ad-slot--commercial-component']);

    var addContentClass = function addContentClass(adSlotNode) {
        var adSlotContent = (0, _qwery2.default)('> div:not(.ad-slot__label)', adSlotNode);

        if (adSlotContent.length) {
            _fastdomPromise2.default.write(function () {
                adSlotContent[0].classList.add('ad-slot__content');
            });
        }
    };

    /**
     * @param advert - as defined in commercial/modules/dfp/Advert
     * @param slotRenderEvent - GPT slotRenderEndedEvent
     * @returns {Promise} - resolves once all necessary rendering is queued up
     */
    var renderAdvert = function renderAdvert(advert, slotRenderEvent) {
        addContentClass(advert.node);

        return (0, _applyCreativeTemplate2.default)(advert.node).then(function (isRendered) {
            var callSizeCallback = function callSizeCallback() {
                var size = advert.size.toString();
                if (size === '0,0') {
                    size = 'fluid';
                }
                return Promise.resolve(sizeCallbacks[size] ? sizeCallbacks[size](slotRenderEvent, advert) : null);
            };

            var addRenderedClass = function addRenderedClass() {
                return isRendered ? _fastdomPromise2.default.write(function () {
                    advert.node.classList.add('ad-slot--rendered');
                }) : Promise.resolve();
            };

            var addFeedbackDropdownToggle = function addFeedbackDropdownToggle() {
                return _config2.default.switches.adFeedback && isRendered ? _fastdomPromise2.default.write(function () {
                    if (!advert.node.classList.contains('js-toggle-ready')) {
                        new _toggles2.default(advert.node).init();
                    }
                }) : Promise.resolve();
            };

            var applyFeedbackOnClickListeners = function applyFeedbackOnClickListeners(slotRender) {
                var readyClass = 'js-onclick-ready';
                return _config2.default.switches.adFeedback && isRendered ? _fastdomPromise2.default.write(function () {
                    (0, _qwery2.default)('.js-ad-feedback-option:not(.js-onclick-ready)').forEach(function (el) {
                        var slotId = el.getAttribute('data-slot');
                        var problem = el.getAttribute('data-problem');
                        el.addEventListener('click', function () {
                            (0, _userAdFeedback.recordUserAdFeedback)(window.location.pathname, slotId, slotRender, problem);
                        });
                        el.classList.add(readyClass);
                    });
                }) : Promise.resolve();
            };

            return callSizeCallback().then(function () {
                return (0, _renderAdvertLabel2.default)(advert.node);
            }).then(addFeedbackDropdownToggle).then(function () {
                return applyFeedbackOnClickListeners(slotRenderEvent);
            }).then(addRenderedClass).then(function () {
                return isRendered;
            });
        }).catch(_raven2.default.captureException);
    };

    exports.default = renderAdvert;
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(409), __webpack_require__(0), __webpack_require__(75), __webpack_require__(222), __webpack_require__(431), __webpack_require__(432), __webpack_require__(231), __webpack_require__(129)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _typeof2, _config, _fastdomPromise, _ab, _addSlot, _createSlot, _trackAdRender, _commercialFeatures) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof3 = _interopRequireDefault(_typeof2);

    var _config2 = _interopRequireDefault(_config);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _ab2 = _interopRequireDefault(_ab);

    var _createSlot2 = _interopRequireDefault(_createSlot);

    var _trackAdRender2 = _interopRequireDefault(_trackAdRender);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var isLuckyBastard = function isLuckyBastard() {
        var testName = 'PaidContentVsOutbrain2';
        return _ab2.default.testCanBeRun(testName) && _ab2.default.getTestVariantId(testName) === 'paid-content';
    };


    var insertAlternativeSlot = function insertAlternativeSlot(isHiResLoaded) {
        if (isHiResLoaded) {
            return;
        }

        var container = document.querySelector(!(_config2.default.page.seriesId || _config2.default.page.blogIds) ? '.js-related, .js-outbrain-anchor' : '.js-outbrain-anchor');
        var slot = (0, _createSlot2.default)('high-merch-lucky');

        _fastdomPromise2.default.write(function () {
            if (container && container.parentNode) {
                container.parentNode.insertBefore(slot, container.nextSibling);
            }
        }).then(function () {
            (0, _addSlot.addSlot)(slot, true);
        });
    };

    var init = function init() {
        if (_commercialFeatures2.default.highMerch) {
            var _ret = function () {
                var anchorSelector = _config2.default.page.commentable ? '#comments + *' : '.content-footer > :first-child';
                var anchor = document.querySelector(anchorSelector);
                var container = document.createElement('div');

                container.className = 'fc-container fc-container--commercial';
                container.appendChild((0, _createSlot2.default)(_config2.default.page.isPaidContent ? 'high-merch-paid' : 'high-merch'));

                if (_commercialFeatures2.default.outbrain && isLuckyBastard()) {
                    (0, _trackAdRender2.default)('dfp-ad--merchandising-high').then(insertAlternativeSlot);
                }

                return {
                    v: _fastdomPromise2.default.write(function () {
                        if (anchor && anchor.parentNode) {
                            anchor.parentNode.insertBefore(container, anchor);
                        }
                    })
                };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        } else if (_commercialFeatures2.default.outbrain && isLuckyBastard()) {
            insertAlternativeSlot(false);
        }

        return Promise.resolve();
    };

    exports.default = {
        init: init
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(822)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _surveySimple) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _surveySimple2 = _interopRequireDefault(_surveySimple);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var init = function init() {
        var survey = new _surveySimple2.default({
            id: 'hosted-about',
            header: 'Advertiser content',
            paragraph1: 'Advertiser content is used to describe advertisement features that are paid for, produced and controlled by the advertiser rather than the publisher​.',
            paragraph2: 'They​ are subject to regulation by the Advertising Standards Authority in the UK, the Federal Trade Commission in the US and the Advertising Standards Bureau in Australia.',
            paragraph3: 'This content is produced by the advertiser and does not involve Guardian News and Media staff.',
            showCloseBtn: true
        });

        return survey.attach().then(function () {
            var aboutBtn = document.querySelector('.js-hosted-about');
            var overlay = document.querySelector('.js-survey-overlay');

            if (aboutBtn && overlay) {
                aboutBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    overlay.classList.remove('u-h');
                });
            }
        });
    };
    exports.default = {
        init: init
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(59), __webpack_require__(82), __webpack_require__(13), __webpack_require__(19), __webpack_require__(38), __webpack_require__(5), __webpack_require__(0), __webpack_require__(76), __webpack_require__(18), __webpack_require__(496), __webpack_require__(4), __webpack_require__(236), __webpack_require__(547), __webpack_require__(445)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _classCallCheck2, _createClass2, _bonzo, _fastdom, _$, _qwery, _config, _url, _detect, _fsm, _mediator, _throttle, _interactionTracking, _loadCssPromise) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _createClass3 = _interopRequireDefault(_createClass2);

    var _bonzo2 = _interopRequireDefault(_bonzo);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _$2 = _interopRequireDefault(_$);

    var _qwery2 = _interopRequireDefault(_qwery);

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    var _fsm2 = _interopRequireDefault(_fsm);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _throttle2 = _interopRequireDefault(_throttle);

    var _interactionTracking2 = _interopRequireDefault(_interactionTracking);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var HostedGallery = function () {
        function HostedGallery() {
            (0, _classCallCheck3.default)(this, HostedGallery);

            // CONFIG
            var breakpoint = _detect2.default.getBreakpoint();
            this.useSwipe = _detect2.default.hasTouchScreen() && (breakpoint === 'mobile' || breakpoint === 'tablet');
            this.swipeThreshold = 0.05;
            this.index = this.index || 1;
            this.imageRatios = [];

            // ELEMENT BINDINGS
            this.$galleryEl = (0, _$2.default)('.js-hosted-gallery-container');
            this.$galleryFrame = (0, _$2.default)('.js-hosted-gallery-frame');
            this.$header = (0, _$2.default)('.js-hosted-headerwrap');
            this.$imagesContainer = (0, _$2.default)('.js-hosted-gallery-images', this.$galleryEl);
            this.$captionContainer = (0, _$2.default)('.js-gallery-caption-bar');
            this.$captions = (0, _$2.default)('.js-hosted-gallery-caption', this.$captionContainer);
            this.$scrollEl = (0, _$2.default)('.js-hosted-gallery-scroll-container', this.$galleryEl);
            this.$images = (0, _$2.default)('.js-hosted-gallery-image', this.$imagesContainer);
            this.$progress = (0, _$2.default)('.js-hosted-gallery-progress', this.$galleryEl);
            this.$border = (0, _$2.default)('.js-hosted-gallery-rotating-border', this.$progress);
            this.prevBtn = (0, _qwery2.default)('.inline-arrow-up', this.$progress)[0];
            this.nextBtn = (0, _qwery2.default)('.inline-arrow-down', this.$progress)[0];
            this.infoBtn = (0, _qwery2.default)('.js-gallery-caption-button', this.$captionContainer)[0];
            this.$counter = (0, _$2.default)('.js-hosted-gallery-image-count', this.$progress);
            this.$ctaFloat = (0, _$2.default)('.js-hosted-gallery-cta', this.$galleryEl)[0];
            this.$ojFloat = (0, _$2.default)('.js-hosted-gallery-oj', this.$galleryEl)[0];
            this.$meta = (0, _$2.default)('.js-hosted-gallery-meta', this.$galleryEl)[0];
            this.ojClose = (0, _qwery2.default)('.js-hosted-gallery-oj-close', this.$ojFloat)[0];

            if (this.$galleryEl.length) {
                this.resize = this.trigger.bind(this, 'resize');
                _mediator2.default.on('window:throttledResize', this.resize);

                // FSM CONFIG
                this.fsm = new _fsm2.default({
                    initial: 'image',
                    onChangeState: function onChangeState() {},

                    context: this,
                    states: this.states
                });

                this.infoBtn.addEventListener('click', this.trigger.bind(this, 'toggle-info'));
                this.ojClose.addEventListener('click', this.toggleOj.bind(this));

                if (document.body) {
                    document.body.addEventListener('keydown', this.handleKeyEvents.bind(this));
                }
                this.loadSurroundingImages(1, this.$images.length);
                this.setPageWidth();

                if (this.useSwipe) {
                    this.$galleryEl.addClass('use-swipe');
                    this.initSwipe();
                } else {
                    this.$galleryEl.addClass('use-scroll');
                    this.initScroll();
                }
            }
        }

        (0, _createClass3.default)(HostedGallery, [{
            key: 'toggleOj',
            value: function toggleOj() {
                (0, _bonzo2.default)(this.$ojFloat).toggleClass('minimise-oj');
            }
        }, {
            key: 'initScroll',
            value: function initScroll() {
                var _this = this;

                this.nextBtn.addEventListener('click', function () {
                    _this.scrollTo(_this.index + 1);
                    if (_this.index < _this.$images.length) {
                        _this.trigger('next', {
                            nav: 'Click'
                        });
                    } else {
                        _this.trigger('reload');
                    }
                });
                this.prevBtn.addEventListener('click', function () {
                    _this.scrollTo(_this.index - 1);
                    if (_this.index > 1) {
                        _this.trigger('prev', {
                            nav: 'Click'
                        });
                    } else {
                        _this.trigger('reload');
                    }
                });

                this.$scrollEl[0].addEventListener('scroll', (0, _throttle2.default)(this.fadeContent.bind(this), 20));
            }
        }, {
            key: 'initSwipe',
            value: function initSwipe() {
                var _this2 = this;

                var threshold = void 0; // time in ms
                var ox = void 0;
                var dx = void 0;
                var updateTime = 20;
                this.$imagesContainer.css('width', this.$images.length + '00%');

                this.$galleryEl[0].addEventListener('touchstart', function (e) {
                    threshold = _this2.swipeContainerWidth * _this2.swipeThreshold;
                    ox = e.touches[0].pageX;
                    dx = 0;
                });

                var touchMove = function touchMove(e) {
                    e.preventDefault();
                    if (e.touches.length > 1 || e.scale && e.scale !== 1) {
                        return;
                    }
                    dx = e.touches[0].pageX - ox;
                    _this2.translateContent(_this2.index, dx, updateTime);
                };

                this.$galleryEl[0].addEventListener('touchmove', (0, _throttle2.default)(touchMove, updateTime, {
                    trailing: false
                }));

                this.$galleryEl[0].addEventListener('touchend', function () {
                    var direction = void 0;
                    if (Math.abs(dx) > threshold) {
                        direction = dx > threshold ? 1 : -1;
                    } else {
                        direction = 0;
                    }
                    dx = 0;

                    if (direction === 1) {
                        if (_this2.index > 1) {
                            _this2.trigger('prev', {
                                nav: 'Swipe'
                            });
                        } else {
                            _this2.trigger('reload');
                        }
                    } else if (direction === -1) {
                        if (_this2.index < _this2.$images.length) {
                            _this2.trigger('next', {
                                nav: 'Swipe'
                            });
                        } else {
                            _this2.trigger('reload');
                        }
                    } else {
                        _this2.trigger('reload');
                    }
                });
            }
        }, {
            key: 'trigger',
            value: function trigger(event, data) {
                this.fsm.trigger(event, data);
            }
        }, {
            key: 'loadSurroundingImages',
            value: function loadSurroundingImages(index, count) {
                var $img = void 0;
                var that = this;

                var setSize = function setSize($image, imageIndex) {
                    if (!that.imageRatios[imageIndex]) {
                        that.imageRatios[imageIndex] = $image[0].naturalWidth / $image[0].naturalHeight;
                    }
                    that.resizeImage.call(that, imageIndex);
                };

                [0, 1, 2].map(function (i) {
                    return index + i === 0 ? count - 1 : (index - 1 + i) % count;
                }).forEach(function (i) {
                    $img = (0, _$2.default)('img', this.$images[i]);
                    if (!$img[0].complete) {
                        $img[0].addEventListener('load', setSize.bind(this, $img, i));
                    } else {
                        setSize($img, i);
                    }
                }, this);
            }
        }, {
            key: 'resizeImage',
            value: function resizeImage(imgIndex) {
                var $galleryFrame = this.$galleryFrame[0];
                var width = $galleryFrame.clientWidth;
                var height = $galleryFrame.clientHeight;

                var getFrame = function getFrame(desiredRatio) {
                    var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
                    var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : height;

                    var frame = {
                        height: h,
                        width: w,
                        topBottom: 0,
                        leftRight: 0
                    };
                    if (!desiredRatio) return frame;
                    if (desiredRatio > w / h) {
                        // portrait screens
                        frame.height = w / desiredRatio;
                        frame.topBottom = (h - frame.height) / 2;
                    } else {
                        // landscape screens
                        frame.width = h * desiredRatio;
                        frame.leftRight = (w - frame.width) / 2;
                    }
                    return frame;
                };

                var $imageDiv = this.$images[imgIndex];
                var $ctaFloat = this.$ctaFloat;
                var $ojFloat = this.$ojFloat;
                var $meta = this.$meta;
                var $images = this.$images;
                var $sizer = (0, _$2.default)('.js-hosted-gallery-image-sizer', $imageDiv);
                var imgRatio = this.imageRatios[imgIndex];
                var ctaSize = getFrame(0);
                var ctaIndex = HostedGallery.ctaIndex();
                var tabletSize = 740;
                var imageSize = getFrame(imgRatio);

                _fastdom2.default.write(function () {
                    $sizer.css('width', imageSize.width);
                    $sizer.css('height', imageSize.height);
                    $sizer.css('top', imageSize.topBottom);
                    $sizer.css('left', imageSize.leftRight);
                    if (imgIndex === ctaIndex) {
                        (0, _bonzo2.default)($ctaFloat).css('bottom', ctaSize.topBottom);
                    }
                    if (imgIndex === $images.length - 1) {
                        (0, _bonzo2.default)($ojFloat).css('bottom', ctaSize.topBottom);
                    }
                    if (imgIndex === $images.length - 1) {
                        (0, _bonzo2.default)($ojFloat).css('padding-bottom', ctaSize.topBottom > 40 || width > tabletSize ? 0 : 40);
                    }
                    if (imgIndex === 0) {
                        (0, _bonzo2.default)($meta).css('padding-bottom', imageSize.topBottom > 40 || width > tabletSize ? 20 : 40);
                    }
                });
            }
        }, {
            key: 'translateContent',
            value: function translateContent(imgIndex, offset, duration) {
                var px = -1 * (imgIndex - 1) * this.swipeContainerWidth;
                var galleryEl = this.$imagesContainer[0];
                var $meta = this.$meta;

                galleryEl.style.webkitTransitionDuration = duration + 'ms';
                galleryEl.style.mozTransitionDuration = duration + 'ms';
                galleryEl.style.msTransitionDuration = duration + 'ms';
                galleryEl.style.transitionDuration = duration + 'ms';
                galleryEl.style.webkitTransform = 'translate(' + (px + offset) + 'px,0) translateZ(0)';
                galleryEl.style.mozTransform = 'translate(' + (px + offset) + 'px,0)';
                galleryEl.style.msTransform = 'translate(' + (px + offset) + 'px,0)';
                galleryEl.style.transform = 'translate(' + (px + offset) + 'px,0) translateZ(0)';
                _fastdom2.default.write(function () {
                    (0, _bonzo2.default)($meta).css('opacity', offset !== 0 ? 0 : 1);
                });
            }
        }, {
            key: 'fadeContent',
            value: function fadeContent(e) {
                var _this3 = this;

                var length = this.$images.length;
                var scrollTop = e.target instanceof HTMLElement ? e.target.scrollTop : 0;
                var scrollHeight = e.target instanceof HTMLElement ? e.target.scrollHeight : 0;
                var progress = Math.round(length * (scrollTop / scrollHeight) * 100) / 100;
                var fractionProgress = progress % 1;
                var deg = Math.ceil(fractionProgress * 360);
                var newIndex = Math.round(progress + 0.75);
                var ctaIndex = HostedGallery.ctaIndex() || -1;
                _fastdom2.default.write(function () {
                    _this3.$images.each(function (image, index) {
                        var opacity = (progress - index + 1) * 16 / 11 - 0.0625;
                        (0, _bonzo2.default)(image).css('opacity', Math.min(Math.max(opacity, 0), 1));
                    });

                    (0, _bonzo2.default)(_this3.$border).css('transform', 'rotate(' + deg + 'deg)');
                    (0, _bonzo2.default)(_this3.$border).css('-webkit-transform', 'rotate(' + deg + 'deg)');

                    (0, _bonzo2.default)(_this3.$galleryEl).toggleClass('show-cta', progress <= ctaIndex && progress >= ctaIndex - 0.25);
                    (0, _bonzo2.default)(_this3.$galleryEl).toggleClass('show-oj', progress >= length - 1.25);

                    (0, _bonzo2.default)(_this3.$progress).toggleClass('first-half', fractionProgress && fractionProgress < 0.5);

                    (0, _bonzo2.default)(_this3.$meta).css('opacity', progress !== 0 ? 0 : 1);
                });

                if (newIndex && newIndex !== this.index) {
                    this.index = newIndex;
                    this.trigger('reload', {
                        nav: 'Scroll'
                    });
                }
            }
        }, {
            key: 'scrollTo',
            value: function scrollTo(index) {
                var scrollEl = this.$scrollEl;
                var length = this.$images.length;
                var scrollHeight = scrollEl[0].scrollHeight;
                _fastdom2.default.write(function () {
                    scrollEl.scrollTop((index - 1) * scrollHeight / length);
                });
            }
        }, {
            key: 'trackNavBetweenImages',
            value: function trackNavBetweenImages(data) {
                if (data && data.nav) {
                    var trackingPrefix = _config2.default.page.trackingPrefix || '';
                    _interactionTracking2.default.trackNonClickInteraction(trackingPrefix + data.nav + ' - image ' + this.index);
                }
            }
        }, {
            key: 'onResize',
            value: function onResize() {
                var _this4 = this;

                this.resizer = this.resizer || function () {
                    _this4.loadSurroundingImages(_this4.index, _this4.$images.length);
                    if (_this4.useSwipe) {
                        _this4.swipeContainerWidth = _this4.$galleryFrame.dim().width;
                        _this4.translateContent(_this4.index, 0, 0);
                    }
                    _this4.setPageWidth();
                };
                (0, _throttle2.default)(this.resizer, 200)();
            }
        }, {
            key: 'setPageWidth',
            value: function setPageWidth() {
                var $imagesContainer = this.$imagesContainer[0];
                var $gallery = this.$galleryEl[0];
                var width = $gallery.clientWidth;
                var height = $imagesContainer.clientHeight;
                var $header = this.$header;
                var $footer = this.$captionContainer;
                var $galleryFrame = this.$galleryFrame;
                var imgRatio = 5 / 3;
                var imageWidth = width;
                var leftRight = 0;
                var that = this;
                if (imgRatio < width / height) {
                    imageWidth = height * imgRatio;
                    leftRight = (width - imageWidth) / 2 + 'px';
                }
                this.swipeContainerWidth = imageWidth;
                _fastdom2.default.write(function () {
                    $header.css('width', imageWidth);
                    $footer.css('margin', '0 ' + leftRight);
                    $footer.css('width', 'auto');
                    $galleryFrame.css('left', leftRight);
                    $galleryFrame.css('right', leftRight);
                    that.loadSurroundingImages(that.index, that.$images.length);
                });
            }
        }, {
            key: 'handleKeyEvents',
            value: function handleKeyEvents(e) {
                var keyNames = {
                    '37': 'left',
                    '38': 'up',
                    '39': 'right',
                    '40': 'down'
                };
                if (e.keyCode === 37 || e.keyCode === 38) {
                    // up/left
                    e.preventDefault();
                    this.scrollTo(this.index - 1);
                    this.trigger('prev', {
                        nav: 'KeyPress:' + keyNames[e.keyCode]
                    });
                    return false;
                } else if (e.keyCode === 39 || e.keyCode === 40) {
                    // down/right
                    e.preventDefault();
                    this.scrollTo(this.index + 1);
                    this.trigger('next', {
                        nav: 'KeyPress:' + keyNames[e.keyCode]
                    });
                    return false;
                } else if (e.keyCode === 73) {
                    // 'i'
                    this.trigger('toggle-info');
                }
            }
        }, {
            key: 'loadAtIndex',
            value: function loadAtIndex(i) {
                this.index = i;
                this.trigger('reload');
                if (this.useSwipe) {
                    this.translateContent(this.index, 0, 0);
                } else {
                    this.scrollTo(this.index);
                }
            }
        }], [{
            key: 'ctaIndex',
            value: function ctaIndex() {
                var ctaIndex = _config2.default.page.ctaIndex;
                var images = _config2.default.page.images;
                return ctaIndex > 0 && ctaIndex < images.length - 1 ? ctaIndex : undefined;
            }
        }]);
        return HostedGallery;
    }();

    HostedGallery.prototype.states = {
        image: {
            enter: function enter() {
                var that = this;

                // load prev/current/next
                this.loadSurroundingImages(this.index, this.$images.length);
                this.$captions.each(function (caption, index) {
                    (0, _bonzo2.default)(caption).toggleClass('current-caption', that.index === index + 1);
                });
                (0, _bonzo2.default)(this.$counter).html(this.index + '/' + this.$images.length);

                if (this.useSwipe) {
                    this.translateContent(this.index, 0, 100);
                    (0, _bonzo2.default)(this.$galleryEl).toggleClass('show-oj', this.index === this.$images.length);
                    (0, _bonzo2.default)(this.$galleryEl).toggleClass('show-cta', this.index === HostedGallery.ctaIndex() + 1);
                }

                var pageName = _config2.default.page.pageName || window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
                (0, _url.pushUrl)({}, document.title, pageName + '#img-' + this.index, true);
                // event bindings
                _mediator2.default.on('window:throttledResize', this.resize);
            },
            leave: function leave() {
                this.trigger('hide-info');
                _mediator2.default.off('window:throttledResize', this.resize);
            },

            events: {
                next: function next(e) {
                    if (this.index < this.$images.length) {
                        // last img
                        this.index += 1;
                        this.trackNavBetweenImages(e);
                    }
                    this.reloadState = true;
                },
                prev: function prev(e) {
                    if (this.index > 1) {
                        // first img
                        this.index -= 1;
                        this.trackNavBetweenImages(e);
                    }
                    this.reloadState = true;
                },
                reload: function reload(e) {
                    this.trackNavBetweenImages(e);
                    this.reloadState = true;
                },

                'toggle-info': function toggleInfo() {
                    this.$captionContainer.toggleClass('hosted-gallery--show-caption');
                },
                'hide-info': function hideInfo() {
                    this.$captionContainer.removeClass('hosted-gallery--show-caption');
                },
                'show-info': function showInfo() {
                    this.$captionContainer.addClass('hosted-gallery--show-caption');
                },
                resize: function resize() {
                    this.onResize();
                }
            }
        }
    };

    var init = function init() {
        if ((0, _qwery2.default)('.js-hosted-gallery-container').length) {
            return _loadCssPromise.loadCssPromise.then(function () {
                var res = void 0;
                var galleryHash = window.location.hash;
                var gallery = new HostedGallery();
                var match = /\?index=(\d+)/.exec(document.location.href);
                if (match) {
                    // index specified so launch gallery at that index
                    gallery.loadAtIndex(parseInt(match[1], 10));
                } else {
                    res = /^#(?:img-)?(\d+)$/.exec(galleryHash);
                    if (res) {
                        gallery.loadAtIndex(parseInt(res[1], 10));
                    }
                }

                return gallery;
            });
        }

        return Promise.resolve();
    };

    exports.default = {
        init: init,
        HostedGallery: HostedGallery
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(28), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _config, _fetchJson, _fastdomPromise) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    var _fetchJson2 = _interopRequireDefault(_fetchJson);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var loadNextVideo = function loadNextVideo() {
        var placeholders = document.querySelectorAll('.js-autoplay-placeholder');

        if (placeholders.length) {
            return (0, _fetchJson2.default)(_config2.default.page.ajaxUrl + '/' + _config2.default.page.pageId + '/autoplay.json', {
                mode: 'cors'
            }).then(function (json) {
                return _fastdomPromise2.default.write(function () {
                    var i = void 0;
                    for (i = 0; i < placeholders.length; i += 1) {
                        placeholders[i].innerHTML = json.html;
                    }
                });
            });
        }
        return Promise.resolve();
    };
    exports.default = {
        init: loadNextVideo,
        load: loadNextVideo
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(28), __webpack_require__(75), __webpack_require__(501)], __WEBPACK_AMD_DEFINE_RESULT__ = function (module, exports, _config, _mediator, _fetchJson, _fastdomPromise, _onwardJourneyCarousel) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _config2 = _interopRequireDefault(_config);

    var _mediator2 = _interopRequireDefault(_mediator);

    var _fetchJson2 = _interopRequireDefault(_fetchJson);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _onwardJourneyCarousel2 = _interopRequireDefault(_onwardJourneyCarousel);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var loadOnwardComponent = function loadOnwardComponent(start, stop) {
        start();

        var placeholders = document.getElementsByClassName('js-onward-placeholder');

        if (placeholders.length) {
            (0, _fetchJson2.default)(_config2.default.page.ajaxUrl + '/' + _config2.default.page.pageId + '/' + _config2.default.page.contentType.toLowerCase() + '/' + 'onward.json', {
                mode: 'cors'
            }).then(function (json) {
                return _fastdomPromise2.default.write(function () {
                    var i = void 0;
                    for (i = 0; i < placeholders.length; i += 1) {
                        placeholders[i].insertAdjacentHTML('beforeend', json.html);
                    }
                });
            }).then(function () {
                _onwardJourneyCarousel2.default.init();
                _mediator2.default.emit('hosted:onward:done');
            }).then(stop);
        } else {
            stop();
        }

        return Promise.resolve();
    };
    exports.default = {
        init: loadOnwardComponent,
        whenRendered: new Promise(function (resolve) {
            _mediator2.default.on('hosted:onward:done', resolve);
        })
    };
    module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(5), __webpack_require__(20), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _qwery, _bean, _fastdom) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.paidContainers = undefined;

    var _qwery2 = _interopRequireDefault(_qwery);

    var _bean2 = _interopRequireDefault(_bean);

    var _fastdom2 = _interopRequireDefault(_fastdom);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var onKeyPress = function onKeyPress(handler) {
        return function (event) {
            if (event.keyCode === 0x20 || event.keyCode === 0x0d) {
                handler(event);
            }
        };
    };

    var onOpenClick = function onOpenClick(event) {
        var summary = event.currentTarget;
        var details = summary.parentNode;
        var label = summary.querySelector('.js-button__label');
        if (details.hasAttribute('open')) {
            _fastdom2.default.write(function () {
                label.textContent = 'More ' + summary.getAttribute('data-text');
            });
        } else {
            _fastdom2.default.write(function () {
                label.textContent = 'Less';
            });
        }
    };

    var paidContainers = function paidContainers() {
        var showMores = (0, _qwery2.default)('.adverts__more > summary');
        _bean2.default.on(document, 'click', showMores, onOpenClick);
        _bean2.default.on(document, 'click', showMores, onKeyPress(onOpenClick));

        return Promise.resolve();
    };

    exports.paidContainers = paidContainers;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(597)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _outbrainSections) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getCode = undefined;

    /* These codes are given to us directly by Outbrain. They will eventually
       be sent back to them via a data- attribute, in order for them to return
       contextually-relevant links. The codes differ whether on a smartphone,
       tablet or desktop. Also, except on mobile, we will request two sets of
       links from Outbrain, hence the two codes in some contexts.
       Currently, there are two categories of codes:
       1. defaults: these are the codes used by default for the Outbrain widget
       2. merchandising: these are the codes when the widget replaces the low-
        priority merchandising component
    */
    var outbrainCodes = {
        defaults: {
            news: {
                mobile: {
                    code: 'MB_4'
                },
                desktop: {
                    image: 'AR_12',
                    text: 'AR_14'
                },
                tablet: {
                    image: 'MB_6',
                    text: 'MB_8'
                }
            },
            defaults: {
                mobile: {
                    code: 'MB_5'
                },
                desktop: {
                    image: 'AR_13',
                    text: 'AR_15'
                },
                tablet: {
                    image: 'MB_7',
                    text: 'MB_9'
                }
            }
        },

        merchandising: {
            mobile: {
                code: 'MB_10'
            },
            desktop: {
                code: 'AR_28'
            },
            tablet: {
                code: 'MB_11'
            }
        },

        nonCompliant: {
            mobile: {
                code: 'MB_10'
            },
            desktop: {
                code: 'AR_28'
            },
            tablet: {
                code: 'MB_11'
            }
        }
    };


    var getCode = function getCode(data) {
        if (!(data.slot in outbrainCodes) || data.slot === 'defaults') {
            return outbrainCodes.defaults[(0, _outbrainSections.getSection)(data.section)][data.breakpoint === 'wide' ? 'desktop' : data.breakpoint];
        } else if (data.slot === 'nonCompliant') {
            return outbrainCodes.nonCompliant[data.breakpoint === 'wide' ? 'desktop' : data.breakpoint];
        }
        return outbrainCodes.merchandising[data.breakpoint === 'wide' ? 'desktop' : data.breakpoint];
    };

    exports.getCode = getCode;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(38), __webpack_require__(0), __webpack_require__(75), __webpack_require__(18), __webpack_require__(224), __webpack_require__(595), __webpack_require__(502)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _$, _config, _fastdomPromise, _detect, _loadScript, _outbrainCodes, _outbrainTracking) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.load = undefined;

    var _$2 = _interopRequireDefault(_$);

    var _config2 = _interopRequireDefault(_config);

    var _fastdomPromise2 = _interopRequireDefault(_fastdomPromise);

    var _detect2 = _interopRequireDefault(_detect);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var outbrainUrl = '//widgets.outbrain.com/outbrain.js';

    var outbrainTpl = function outbrainTpl(_ref) {
        var widgetCode = _ref.widgetCode;
        return '\n    <div class="OUTBRAIN" data-widget-id="' + widgetCode + '" data-ob-template="guardian"></div>\n    ';
    };

    var selectors = {
        outbrain: {
            widget: '.js-outbrain',
            container: '.js-outbrain-container'
        },
        merchandising: {
            widget: '.js-container--commercial',
            container: '.js-outbrain-container'
        },
        nonCompliant: {
            widget: '.js-outbrain',
            container: '.js-outbrain-container'
        }
    };

    var build = function build(codes, breakpoint) {
        var html = outbrainTpl({
            widgetCode: codes.code || codes.image || ''
        });
        if (breakpoint !== 'mobile' && codes.text) {
            html += outbrainTpl({
                widgetCode: codes.text
            });
        }
        return html;
    };

    var load = function load(target) {
        var slot = target && target in selectors ? target : 'defaults';
        var $outbrain = (0, _$2.default)(selectors.outbrain.widget);
        var $container = (0, _$2.default)(selectors.outbrain.container, $outbrain[0]);
        var breakpoint = _detect2.default.getBreakpoint();

        var widgetCodes = (0, _outbrainCodes.getCode)({
            slot: slot,
            section: _config2.default.page.section,
            breakpoint: breakpoint
        });

        var widgetHtml = build(widgetCodes, breakpoint);

        if ($container.length) {
            return _fastdomPromise2.default.write(function () {
                if (slot === 'merchandising') {
                    (0, _$2.default)(selectors[slot].widget).replaceWith($outbrain[0]);
                }
                $container.append(widgetHtml);
                $outbrain.css('display', 'block');
            }).then(function () {
                (0, _outbrainTracking.tracking)({
                    widgetId: widgetCodes.code || widgetCodes.image
                });
                (0, _loadScript.loadScript)(outbrainUrl);
            });
        }
        return Promise.resolve();
    };

    exports.load = load;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var sections = ['politics', 'world', 'business', 'commentisfree'];

    var getSection = function getSection(section) {
        var sectionLower = section.toLowerCase();
        return (/news/.test(sectionLower) || sections.includes(sectionLower) ? 'news' : 'defaults'
        );
    };

    exports.getSection = getSection;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(251), __webpack_require__(596), __webpack_require__(502)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _detect, _checkMediator, _outbrainLoad, _outbrainTracking) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.init = undefined;

    var _detect2 = _interopRequireDefault(_detect);

    var _checkMediator2 = _interopRequireDefault(_checkMediator);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /*
     Loading Outbrain is dependent on successful return of high relevance component
     from DFP. AdBlock is blocking DFP calls so we are not getting any response and thus
     not loading Outbrain. As Outbrain is being partially loaded behind the adblock we can
     make the call instantly when we detect adBlock in use.
    */
    var canLoadInstantly = function canLoadInstantly() {
        return _detect2.default.adblockInUse.then(function (adblockInUse) {
            return !document.getElementById('dfp-ad--merchandising-high') || adblockInUse;
        });
    };

    var onIsOutbrainNonCompliant = function onIsOutbrainNonCompliant(outbrainNonCompliant) {
        if (outbrainNonCompliant) (0, _outbrainLoad.load)('nonCompliant');else (0, _outbrainLoad.load)();
        (0, _outbrainTracking.tracking)({
            state: outbrainNonCompliant ? 'nonCompliant' : 'compliant'
        });
        return Promise.resolve();
    };

    var onIsOutbrainMerchandiseCompliant = function onIsOutbrainMerchandiseCompliant(outbrainMerchandiseCompliant) {
        if (outbrainMerchandiseCompliant) {
            (0, _outbrainLoad.load)('merchandising');
            (0, _outbrainTracking.tracking)({
                state: 'outbrainMerchandiseCompliant'
            });
            return Promise.resolve();
        }
        return _checkMediator2.default.waitForCheck('isOutbrainNonCompliant').then(onIsOutbrainNonCompliant);
    };

    var onIsOutbrainBlockedByAds = function onIsOutbrainBlockedByAds(outbrainBlockedByAds) {
        if (outbrainBlockedByAds) {
            (0, _outbrainTracking.tracking)({
                state: 'outbrainBlockedByAds'
            });
            return Promise.resolve();
        }
        return _checkMediator2.default.waitForCheck('isOutbrainMerchandiseCompliant').then(onIsOutbrainMerchandiseCompliant);
    };

    var onCanLoadInstantly = function onCanLoadInstantly(loadInstantly) {
        if (loadInstantly) {
            return _checkMediator2.default.waitForCheck('isOutbrainNonCompliant').then(onIsOutbrainNonCompliant);
        }
        return _checkMediator2.default.waitForCheck('isOutbrainBlockedByAds').then(onIsOutbrainBlockedByAds);
    };

    var onIsOutbrainDisabled = function onIsOutbrainDisabled(outbrainDisabled) {
        if (outbrainDisabled) {
            (0, _outbrainTracking.tracking)({
                state: 'outbrainDisabled'
            });
            return Promise.resolve();
        }
        return canLoadInstantly().then(onCanLoadInstantly);
    };

    var init = function init() {
        return _checkMediator2.default.waitForCheck('isOutbrainDisabled').then(onIsOutbrainDisabled);
    };

    exports.init = init;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(19), __webpack_require__(38), __webpack_require__(0), __webpack_require__(18), __webpack_require__(21), __webpack_require__(231), __webpack_require__(129), __webpack_require__(666), __webpack_require__(224)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fastdom, _$, _config, _detect, _template, _trackAdRender, _commercialFeatures, _plista, _loadScript) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _$2 = _interopRequireDefault(_$);

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    var _template2 = _interopRequireDefault(_template);

    var _trackAdRender2 = _interopRequireDefault(_trackAdRender);

    var _commercialFeatures2 = _interopRequireDefault(_commercialFeatures);

    var _plista2 = _interopRequireDefault(_plista);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var plistaTpl = (0, _template2.default)(_plista2.default);

    var selectors = {
        container: '.js-plista-container'
    };

    var _module = {};

    var loadInstantly = function loadInstantly() {
        return _detect2.default.adblockInUse.then(function (adblockInUse) {
            return !document.getElementById('dfp-ad--merchandising-high') || adblockInUse;
        });
    };

    // a modification of the code provided by Plista; altered to be a lazy load rather than during DOM construction
    var embed = function embed(publickey, widgetName, geo, u, categories) {
        var name = 'PLISTA_' + publickey;
        var lib = window[name];
        var $container = (0, _$2.default)(selectors.container);

        $container.append(plistaTpl({
            widgetName: widgetName
        }));
        $container.css('display', 'block');

        if (!lib || !lib.publickey) {
            window[name] = {
                publickey: publickey,
                widgets: [{
                    name: widgetName,
                    pre: u
                }],
                geo: geo,
                categories: categories,
                dataMode: 'data-display'
            };
            (0, _loadScript.loadScript)('//static-au.plista.com/async/' + name + '.js');
        } else {
            lib.widgets.push({
                name: widgetName,
                pre: u
            });
        }
    };

    _module.load = function () {
        _fastdom2.default.write(function () {
            embed(_config2.default.page.plistaPublicApiKey, 'innerArticle', 'au');
        });
    };

    _module.init = function () {
        if (_commercialFeatures2.default.outbrain) {
            return loadInstantly().then(function (adBlockInUse) {
                if (adBlockInUse) {
                    _module.load();
                } else {
                    return (0, _trackAdRender2.default)('dfp-ad--merchandising-high').then(function (isLoaded) {
                        if (!isLoaded) {
                            _module.load();
                        }
                    });
                }
            });
        }
        return Promise.resolve(false);
    };

    exports.default = _module;
    _module.exports = exports['default'];
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.onLoad = exports.url = exports.shouldRun = undefined;

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var remarketingUrl = '//www.googleadservices.com/pagead/conversion_async.js';


    var onLoad = function onLoad() {
        window.google_trackConversion({
            google_conversion_id: 971225648,
            google_custom_params: window.google_tag_params,
            google_remarketing_only: true
        });
    };

    var shouldRun = _config2.default.switches.remarketing;

    var url = remarketingUrl;

    exports.shouldRun = shouldRun;
    exports.url = url;
    exports.onLoad = onLoad;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.url = exports.shouldRun = undefined;

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var shouldRun = !_config2.default.page.isFront && _config2.default.switches.simpleReach && _config2.default.page.isPaidContent;


    var simpleReachUrl = '';

    if (shouldRun) {
        var authors = _config2.default.page.author.split(',');
        var channels = _config2.default.page.sectionName.split(',');
        var keywords = _config2.default.page.keywords.split(',');

        // We can't ditch the dangling underscores as SimpleReach needs this parameter, see:
        // http://docs.simplereach.com/implementation-1/standard-implementation
        // eslint-disable-next-line no-underscore-dangle
        window.__reach_config = {
            pid: '58ff7f3a736b795c10004930',
            title: _config2.default.page.headline,
            date: new Date(_config2.default.page.webPublicationDate),
            authors: authors,
            channels: channels,
            tags: keywords,
            article_id: _config2.default.page.pageId,
            ignore_errors: false
        };

        simpleReachUrl = '//d8rk54i4mohrb.cloudfront.net/js/reach.js';
    }

    var url = simpleReachUrl;

    exports.shouldRun = shouldRun;
    exports.url = url;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _config) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.useImage = exports.url = exports.shouldRun = undefined;

    var _config2 = _interopRequireDefault(_config);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var getUrl = function getUrl(location) {
        var taPartner = 'partner:guardian-uk';
        var taAccount = _config2.default.page.isDev ? 'tuata-dev-internal' : 'tuatourism-australia-global';
        var taPageName = taPartner + ':' + location.pathname;
        var taServer = location.hostname;
        var taUrl = location.href;
        var taCachebreak = new Date().getTime();

        return '//tourismaustralia.sc.omtrdc.net/b/ss/' + taAccount + '/1/H.26.2/s' + taCachebreak + '?AQB=1&ndh=0&ns=tourismaustralia&pageName=' + encodeURIComponent(taPageName) + '&g= ' + encodeURIComponent(taUrl) + '&server=' + encodeURIComponent(taServer) + '&v11=' + encodeURIComponent(taPartner) + '&AQE=1';
    };


    var shouldRun = _config2.default.page.section === 'ashes-australia-travel' && _config2.default.switches.tourismAustralia;
    var url = getUrl(window.location);
    var useImage = true;

    exports.shouldRun = shouldRun;
    exports.url = url;
    exports.useImage = useImage;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(19), __webpack_require__(58), __webpack_require__(0), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports, _fastdom, _fetch, _config, _detect) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.recordUserAdFeedback = undefined;

    var _fastdom2 = _interopRequireDefault(_fastdom);

    var _fetch2 = _interopRequireDefault(_fetch);

    var _config2 = _interopRequireDefault(_config);

    var _detect2 = _interopRequireDefault(_detect);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var onComplete = function onComplete(adSlotId) {
        // we're complete - update the UI
        _fastdom2.default.write(function () {
            var label = document.querySelector('#' + adSlotId + '>.ad-slot__label');
            if (label) {
                label.classList.add('feedback-submitted');
            }
        });
    };

    var recordUserAdFeedback = function recordUserAdFeedback(pagePath, adSlotId, slotRenderEvent, feedbackType) {
        var feedbackUrl = 'https://j2cy9stt59.execute-api.eu-west-1.amazonaws.com/prod/adFeedback';
        var stage = _config2.default.page.isProd ? 'PROD' : 'CODE';
        var ua = _detect2.default.getUserAgent;
        var breakPoint = _detect2.default.getBreakpoint();

        var data = {
            stage: stage,
            page: pagePath,
            adSlotId: adSlotId,
            creativeId: slotRenderEvent.sourceAgnosticCreativeId.toString(),
            lineId: slotRenderEvent.sourceAgnosticLineItemId.toString(),
            feedback: feedbackType,
            browser: ua.browser.toString() + ua.version.toString(),
            breakPoint: breakPoint
        };

        return (0, _fetch2.default)(feedbackUrl, {
            method: 'post',
            body: JSON.stringify(data),
            mode: 'cors'
        }).then(function () {
            return onComplete(adSlotId);
        }, function () {
            return onComplete(adSlotId);
        });
    };

    exports.recordUserAdFeedback = recordUserAdFeedback;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(621), __esModule: true };

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(622), __esModule: true };

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(632);
__webpack_require__(631);
__webpack_require__(633);
__webpack_require__(634);
module.exports = __webpack_require__(15).Symbol;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67);
__webpack_require__(104);
module.exports = __webpack_require__(450).f('iterator');

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(138)
  , gOPS    = __webpack_require__(506)
  , pIE     = __webpack_require__(448);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(99);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(138)
  , toIObject = __webpack_require__(62);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(91)('meta')
  , isObject = __webpack_require__(37)
  , has      = __webpack_require__(45)
  , setDesc  = __webpack_require__(22).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(54)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(62)
  , gOPN      = __webpack_require__(505).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */
/***/ (function(module, exports) {



/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(17)
  , has            = __webpack_require__(45)
  , DESCRIPTORS    = __webpack_require__(16)
  , $export        = __webpack_require__(44)
  , redefine       = __webpack_require__(150)
  , META           = __webpack_require__(626).KEY
  , $fails         = __webpack_require__(54)
  , shared         = __webpack_require__(103)
  , setToStringTag = __webpack_require__(102)
  , uid            = __webpack_require__(91)
  , wks            = __webpack_require__(10)
  , wksExt         = __webpack_require__(450)
  , wksDefine      = __webpack_require__(449)
  , keyOf          = __webpack_require__(625)
  , enumKeys       = __webpack_require__(623)
  , isArray        = __webpack_require__(624)
  , anObject       = __webpack_require__(25)
  , toIObject      = __webpack_require__(62)
  , toPrimitive    = __webpack_require__(90)
  , createDesc     = __webpack_require__(46)
  , _create        = __webpack_require__(142)
  , gOPNExt        = __webpack_require__(627)
  , $GOPD          = __webpack_require__(504)
  , $DP            = __webpack_require__(22)
  , $keys          = __webpack_require__(138)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(505).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(448).f  = $propertyIsEnumerable;
  __webpack_require__(506).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(141)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(449)('asyncIterator');

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(449)('observable');

/***/ }),
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(130), __webpack_require__(60), __webpack_require__(8), __webpack_require__(651)], __WEBPACK_AMD_DEFINE_RESULT__ = function(forEach, forOwn, isArray, isPlainObject) {

  /**
   * The base implementation of `_.merge` without argument juggling or support
   * for `thisArg` binding.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {Function} [callback] The function to customize merging properties.
   * @param {Array} [stackA=[]] Tracks traversed source objects.
   * @param {Array} [stackB=[]] Associates values with source counterparts.
   */
  function baseMerge(object, source, callback, stackA, stackB) {
    (isArray(source) ? forEach : forOwn)(source, function(source, key) {
      var found,
          isArr,
          result = source,
          value = object[key];

      if (source && ((isArr = isArray(source)) || isPlainObject(source))) {
        // avoid merging previously merged cyclic sources
        var stackLength = stackA.length;
        while (stackLength--) {
          if ((found = stackA[stackLength] == source)) {
            value = stackB[stackLength];
            break;
          }
        }
        if (!found) {
          var isShallow;
          if (callback) {
            result = callback(value, source);
            if ((isShallow = typeof result != 'undefined')) {
              value = result;
            }
          }
          if (!isShallow) {
            value = isArr
              ? (isArray(value) ? value : [])
              : (isPlainObject(value) ? value : {});
          }
          // add `source` and associated `value` to the stack of traversed objects
          stackA.push(source);
          stackB.push(value);

          // recursively merge objects and arrays (susceptible to call stack limits)
          if (!isShallow) {
            baseMerge(value, source, callback, stackA, stackB);
          }
        }
      }
      else {
        if (callback) {
          result = callback(value, source);
          if (typeof result == 'undefined') {
            result = source;
          }
        }
        if (typeof result != 'undefined') {
          value = result;
        }
      }
      object[key] = value;
    });
  }

  return baseMerge;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 646 */,
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124), __webpack_require__(31), __webpack_require__(12), __webpack_require__(63), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(forIn, isArguments, isFunction, isNode, support) {

  /** `Object#toString` result shortcuts */
  var objectClass = '[object Object]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A fallback implementation of `isPlainObject` which checks if a given value
   * is an object created by the `Object` constructor, assuming objects created
   * by the `Object` constructor have no inherited enumerable properties and that
   * there are no `Object.prototype` extensions.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   */
  function shimIsPlainObject(value) {
    var ctor,
        result;

    // avoid non Object objects, `arguments` objects, and DOM elements
    if (!(value && toString.call(value) == objectClass) ||
        (ctor = value.constructor, isFunction(ctor) && !(ctor instanceof ctor)) ||
        (!support.argsClass && isArguments(value)) ||
        (!support.nodeClass && isNode(value))) {
      return false;
    }
    // IE < 9 iterates inherited properties before own properties. If the first
    // iterated property is an object's own property then there are no inherited
    // enumerable properties.
    if (support.ownLast) {
      forIn(value, function(value, key, object) {
        result = hasOwnProperty.call(object, key);
        return false;
      });
      return result !== false;
    }
    // In most environments an object's own properties are iterated before
    // its inherited properties. If the last iterated property is an object's
    // own property then there are no inherited enumerable properties.
    forIn(value, function(value, key) {
      result = key;
    });
    return typeof result == 'undefined' || hasOwnProperty.call(value, result);
  }

  return shimIsPlainObject;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function(forIn, isFunction) {

  /**
   * Creates a sorted array of property names of all enumerable properties,
   * own and inherited, of `object` that have function values.
   *
   * @static
   * @memberOf _
   * @alias methods
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names that have function values.
   * @example
   *
   * _.functions(_);
   * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
   */
  function functions(object) {
    var result = [];
    forIn(object, function(value, key) {
      if (isFunction(value)) {
        result.push(key);
      }
    });
    return result.sort();
  }

  return functions;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 649 */,
/* 650 */,
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(3), __webpack_require__(647), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArguments, isNative, shimIsPlainObject, support) {

  /** `Object#toString` result shortcuts */
  var objectClass = '[object Object]';

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Native method shortcuts */
  var getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf;

  /**
   * Checks if `value` is an object created by the `Object` constructor.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * _.isPlainObject(new Shape);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   */
  var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
    if (!(value && toString.call(value) == objectClass) || (!support.argsClass && isArguments(value))) {
      return false;
    }
    var valueOf = value.valueOf,
        objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);

    return objProto
      ? (value == objProto || getPrototypeOf(value) == objProto)
      : shimIsPlainObject(value);
  };

  return isPlainObject;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 652 */,
/* 653 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ad-feedback popup__toggle\" data-toggle=\"<%=slot%>__popup--feedback\"\n   aria-haspopup=\"true\" aria-controls=\"ad-feedback-menu__<%=slot%>\"></div>\n\n<div class=\"ad-feedback popup popup--default popup__group <%=slot%>__popup--feedback is-off\" id=\"ad-feedback-menu__<%=slot%>\">\n    <h3 class=\"ad-feedback popup__group-header\">\n        To help improve the ad experience on the Guardian, please select from the following:\n    </h3>\n    <ul>\n        <% for(option in feedbackOptions) { %>\n            <li class=\"popup__item popup__item--option js-ad-feedback-option\" data-slot=\"<%=slot%>\" data-problem=\"<%=option%>\">\n                <button id=\"<%=slot%>-feedback-<%=option%>\" type=\"button\" value=\"<%=option%>\">\n                    <%=feedbackOptions[option]%>\n                </button>\n            </li>\n        <% } %>\n    </ul>\n</div>\n"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "<a class=\"creative__cta creative__cta--position-<%=position%> <%=media%>\" href=\"<%=link%>\" target=\"_blank\"><img src=\"<%=image%>\" alt></a>\n"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<div id=\"<%= data.id %>\" class=\"creative--expandable-video creative--expandable-video-v2 <%=data.videoOptions%>\">\n\n    <div class=\"ad-slot__label adFullWidth__label facia-container--layout-front\">\n        <div class=\"facia-container__inner\">Advertisement</div>\n    </div>\n\n    <div class=\"ad-exp--expand l-side-margins mobile-only\" style=\"background: <%=data.backgroundColor%> url('<%=data.backgroundImageM%>') <%=data.backgroundRepeatM%> <%=data.backgroundPositionM%>\">\n        <div class=\"slide-container\">\n            <div class=\"ad-exp-collapse__slide slide-1\" style=\"background: <%=data.slide1BGColor%> url('<%=data.slide1BGImageM%>') <%=data.slide1BGImageRepeatM%> <%=data.slide1BGImagePositionM%>;\">\n                <div class=\"ad-exp__open\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide1Layer1BGImageM%>') <%=data.slide1Layer1BGImageRepeatM%> <%=data.slide1Layer1BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide1Layer2BGImageM%>') <%=data.slide1Layer2BGImageRepeatM%> <%=data.slide1Layer2BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide1Layer3BGImageM%>') <%=data.slide1Layer3BGImageRepeatM%> <%=data.slide1Layer3BGImagePositionM%>;\"></div>\n                </div>\n            </div>\n            <div class=\"ad-exp-collapse__slide slide-2\" style=\"background: <%=data.slide2BGColor%> url('<%=data.slide2BGImageM%>') <%=data.slide2BGImagePositionM%> <%=data.slide2BGImageRepeatM%>;\">\n                <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide2Layer1BGImageM%>') <%=data.slide2Layer1BGImageRepeatM%> <%=data.slide2Layer1BGImagePositionM%>;\"></div>\n                <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide2Layer2BGImageM%>') <%=data.slide2Layer2BGImageRepeatM%> <%=data.slide2Layer2BGImagePositionM%>;\"></div>\n                <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide2Layer3BGImageM%>') <%=data.slide2Layer3BGImageRepeatM%> <%=data.slide2Layer3BGImagePositionM%>;\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"ad-exp--expand l-side-margins hide-until-tablet\" style=\"background: <%=data.backgroundColor%> url('<%=data.backgroundImage%>') <%=data.backgroundRepeat%> <%=data.backgroundPosition%>\">\n        <div class=\"slide-container\" style=\"\">\n            <div class=\"ad-exp-collapse__slide slide-1\" style=\"background: <%=data.slide1BGColor%> url('<%=data.slide1BGImage%>') <%=data.slide1BGImageRepeat%> <%=data.slide1BGImagePosition%>;\">\n                <div class=\"ad-exp__open\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide1Layer1BGImage%>') <%=data.slide1Layer1BGImageRepeat%> <%=data.slide1Layer1BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide1Layer2BGImage%>') <%=data.slide1Layer2BGImageRepeat%> <%=data.slide1Layer2BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background : url('<%=data.slide1Layer3BGImage%>') <%=data.slide1Layer3BGImageRepeat%> <%=data.slide1Layer3BGImagePosition%>;\"></div>\n                </div>\n            </div>\n            <div class=\"ad-exp-collapse__slide slide-2\" style=\"background: <%=data.slide2BGColor%> url('<%=data.slide2BGImage%>') <%=data.slide2BGImagePosition%> <%=data.slide2BGImageRepeat%>;\">\n                <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide2Layer1BGImage%>') <%=data.slide2Layer1BGImageRepeat%> <%=data.slide2Layer1BGImagePosition%>;\"></div>\n                <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide2Layer2BGImage%>') <%=data.slide2Layer2BGImageRepeat%> <%=data.slide2Layer2BGImagePosition%>;\"></div>\n                <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide2Layer3BGImage%>') <%=data.slide2Layer3BGImageRepeat%> <%=data.slide2Layer3BGImagePosition%>;\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"slide-video\">\n        <div class=\"slide-container\">\n            <a href=\"<%=data.link%>\" target=\"_blank\" class=\"video-container__cta\"></a>\n            <div class=\"video-container__inner\">\n                <%=data.videoEmbed%>\n            </div>\n            <%=data.mobileCTA%>\n            <%=data.desktopCTA%>\n        </div>\n    </div>\n\n    <%=data.showPlus%>\n    <%=data.showArrow%>\n</div>\n"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "<div id=\"<%= data.id %>\" class=\"creative--expandable creative--fabric-expanding-v1\">\n    <div class=\"ad-slot__label adFullWidth__label facia-container--layout-front\">\n        <div class=\"facia-container__inner\">Advertisement</div>\n    </div>\n    <div class=\"ad-exp--expand l-side-margins mobile-only\" style=\"background-color: <%=data.backgroundColor%>\">\n        <div class=\"facia-container__inner facia-container__inner--full-span\" style=\"background: url('<%=data.backgroundImageM%>') <%=data.backgroundRepeatM%> <%=data.backgroundPositionM%>;\">\n            <%=data.showPlus%>\n            <%=data.showArrow%>\n            <div class=\"ad-exp-collapse__slide slide-1\" style=\"background: <%=data.slide1BGColor%> url('<%=data.slide1BGImageM%>') <%=data.slide1BGImageRepeatM%> <%=data.slide1BGImagePositionM%>;\">\n                <a href=\"<%=data.clickMacro%><%=data.link%>\" target=\"_new\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide1Layer1BGImageM%>') <%=data.slide1Layer1BGImageRepeatM%> <%=data.slide1Layer1BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide1Layer2BGImageM%>') <%=data.slide1Layer2BGImageRepeatM%> <%=data.slide1Layer2BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide1Layer3BGImageM%>') <%=data.slide1Layer3BGImageRepeatM%> <%=data.slide1Layer3BGImagePositionM%>;\"></div>\n                </a>\n            </div>\n            <div class=\"ad-exp-collapse__slide slide-2\" style=\"background: <%=data.slide2BGColor%> url('<%=data.slide2BGImageM%>') <%=data.slide2BGImagePositionM%> <%=data.slide2BGImageRepeatM%>;\">\n                <%=data.videoMobile%>\n                <a href=\"<%=data.clickMacro%><%=data.link%>\" target=\"_new\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide2Layer1BGImageM%>') <%=data.slide2Layer1BGImageRepeatM%> <%=data.slide2Layer1BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide2Layer2BGImageM%>') <%=data.slide2Layer2BGImageRepeatM%> <%=data.slide2Layer2BGImagePositionM%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide2Layer3BGImageM%>') <%=data.slide2Layer3BGImageRepeatM%> <%=data.slide2Layer3BGImagePositionM%>;\"></div>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div class=\"ad-exp--expand l-side-margins hide-until-tablet\" style=\"background-color: <%=data.backgroundColor%>\">\n        <%=data.scrollbg%>\n        <div class=\"facia-container__inner facia-container__inner--full-span\" style=\"background: url('<%=data.backgroundImage%>') <%=data.backgroundRepeat%> <%=data.backgroundPosition%>;\">\n            <%=data.showPlus%>\n            <%=data.showArrow%>\n            <div class=\"ad-exp-collapse__slide slide-1\" style=\"background: <%=data.slide1BGColor%> url('<%=data.slide1BGImage%>') <%=data.slide1BGImageRepeat%> <%=data.slide1BGImagePosition%>;\">\n                <a href=\"<%=data.clickMacro%><%=data.link%>\" target=\"_new\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide1Layer1BGImage%>') <%=data.slide1Layer1BGImageRepeat%> <%=data.slide1Layer1BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide1Layer2BGImage%>') <%=data.slide1Layer2BGImageRepeat%> <%=data.slide1Layer2BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background : url('<%=data.slide1Layer3BGImage%>') <%=data.slide1Layer3BGImageRepeat%> <%=data.slide1Layer3BGImagePosition%>;\"></div>\n                </a>\n            </div>\n            <div class=\"ad-exp-collapse__slide slide-2\" style=\"background: <%=data.slide2BGColor%> url('<%=data.slide2BGImage%>') <%=data.slide2BGImagePosition%> <%=data.slide2BGImageRepeat%>;\">\n                <%=data.videoDesktop%>\n                <a href=\"<%=data.clickMacro%><%=data.link%>\" target=\"_new\">\n                    <div class=\"ad-exp__layer ad-exp__layer1\" style=\"background: url('<%=data.slide2Layer1BGImage%>') <%=data.slide2Layer1BGImageRepeat%> <%=data.slide2Layer1BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer2\" style=\"background: url('<%=data.slide2Layer2BGImage%>') <%=data.slide2Layer2BGImageRepeat%> <%=data.slide2Layer2BGImagePosition%>;\"></div>\n                    <div class=\"ad-exp__layer ad-exp__layer3\" style=\"background: url('<%=data.slide2Layer3BGImage%>') <%=data.slide2Layer3BGImageRepeat%> <%=data.slide2Layer3BGImagePosition%>;\"></div>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<iframe\n    width=\"<%=width%>\"\n    height=\"<%=height%>\"\n    src=\"<%=src%>\"\n    frameborder=\"0\"\n    class=\"<%=className%>\"\n    style=\"<%=inlineStyle%>\">\n</iframe>\n"

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "<%if (data.hasContainer) {%><div class=\"creative--fabric-v1-bg-container\"><%}%>\n<%if (data.showLabel) {%>\n<div class=\"ad-slot__label creative--fabric-v1__label fc-container--layout-front\">\n    <div class=\"fc-container__inner\">Advertisement</div>\n</div>\n<%}%>\n<div id=\"<%= data.id %>\" class=\"creative--fabric-v1 l-side-margins hide-until-tablet\" style=\"\n    background-color: <%=data.backgroundColor%>;\n    background-image: url(<%=data.backgroundImage%>);\n    background-position: <%=data.backgroundPosition%>;\n    background-repeat: <%=data.backgroundRepeat%>;\n\">\n    <%if (data.scrollbg) {%><%=data.scrollbg%><%}%>\n    <a href=\"<%=data.clickMacro%><%=data.link%>\" target=\"_blank\">\n        <div class=\"gs-container\">\n            <%=data.video%>\n            <div class=\"fabric-v1_layer fabric-v1_layer1\" style=\"\n            background-image: url(<%=data.layerOneBGImage%>);\n            background-position: <%=data.layerOneBGPosition%>;\n        \"></div>\n            <div class=\"fabric-v1_layer fabric-v1_layer2\" style=\"\n            background-image: url(<%=data.layerTwoBGImage%>);\n            background-position: <%=data.layerTwoBGPosition%>;\n        \"></div>\n            <div class=\"fabric-v1_layer fabric-v1_layer3\" style=\"\n            background-image: url(<%=data.layerThreeBGImage%>);\n            background-position: <%=data.layerThreeBGPosition%>;\n        \"></div>\n        </div>\n    </a>\n</div>\n<div class=\"creative--fabric-v1 l-side-margins mobile-only\" style=\"\n    background-color: <%=data.backgroundColor%>;\n    background-image: url(<%=data.backgroundImageM%>);\n    background-position: <%=data.backgroundPositionM%>;\n    background-repeat: <%=data.backgroundRepeatM%>;\n\">\n    <%if (data.scrollbg) {%><%=data.scrollbg%><%}%>\n    <a href=\"<%=data.link%>\" target=\"_blank\">\n        <div class=\"gs-container\">\n            <div class=\"fabric-v1_layer fabric-v1_layer1\" style=\"\n            background-image: url(<%=data.layerOneBGImageM%>);\n            background-position: <%=data.layerOneBGPositionM%>;\n        \"></div>\n            <div class=\"fabric-v1_layer fabric-v1_layer1\" style=\"\n            background-image: url(<%=data.layerTwoBGImageM%>);\n            background-position: <%=data.layerTwoBGPositionM%>;\n        \"></div>\n            <div class=\"fabric-v1_layer fabric-v1_layer1\" style=\"\n            background-image: url(<%=data.layerThreeBGImageM%>);\n            background-position: <%=data.layerThreeBGPositionM%>;\n        \"></div>\n        </div>\n    </a>\n</div>\n<%if (data.hasContainer) {%></div><%}%>\n"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<div id=\"<%= data.id %>\" class=\"creative creative--fabric-video\">\n    <a class=\"creative__link\" href=\"<%=data.clickMacro%><%=data.Link%>\" target=\"_blank\">\n        <div class=\"creative__alt creative__alt--tablet hide-until-tablet\"  style=\"background-color:<%=data.Backgroundcolour%>;background-image:url(<%=data.Backgroundimage%>);background-position:<%=data.Backgroundposition%>;background-repeat:<%=data.Backgroundrepeat%>;\">\n            <%=data.posterTablet%>\n            <%=data.video%>\n            <div class=\"creative__layer creative__layer1\" style=\"background-image:url(<%=data.Layer1backgroundimage%>);background-position: <%=data.Layer1backgroundimageposition%>;\"></div>\n            <div class=\"creative__layer creative__layer2\">\n                <div style=\"background-image:url(<%=data.Layer2animatedimage1%>)\" class=\"creative__slide creative__slide1\"></div>\n                <div style=\"background-image:url(<%=data.Layer2animatedimage2%>)\" class=\"creative__slide creative__slide2\"></div>\n                <div style=\"background-image:url(<%=data.Layer2animatedimage3%>)\" class=\"creative__slide creative__slide3\"></div>\n                <div style=\"background-image:url(<%=data.Layer2animatedimage4%>)\" class=\"creative__slide creative__slide4\">\n                    <%if (data.Layer2clickbutton){%>\n                        <img src=\"<%=data.Layer2clickbutton%>\" class=\"click_button\"></div>\n                    <%}%>\n                </div>\n            </div>\n            <div class=\"creative__layer creative__layer3\" style=\"background-image:url(<%=data.Layer3backgroundimage%>);background-position: <%=data.Layer3backgroundimageposition%>;\"></div>\n        </div>\n\n        <div class=\"creative__alt creative__alt--mobile mobile-only\" style=\"background-color:<%=data.Backgroundcolour%>;background-image: url(<%=data.BackgroundImagemobile%>);background-position:<%=data.BackgroundImagemobileposition%>;background-repeat:<%=data.Backgroundimagemobilerepeat%>;\">\n            <%=data.posterMobile%>\n            <div class=\"creative__layer creative__layer1\" style=\"background-image:url(<%=data.Layer1backgroundimagemobile%>);background-position:<%=data.Layer1backgroundimagepositionmobile%>;\"></div>\n            <div class=\"creative__layer creative__layer2\" style=\"background-image:url(<%=data.Layer2backgroundimagemobile%>);background-position:<%=data.Layer2backgroundimagepositionmobile%>;\"></div>\n            <div class=\"creative__layer creative__layer3\" style=\"background-image:url(<%=data.Layer3backgroundimagemobile%>);background-position:<%=data.Layer3backgroundimagepositionmobile%>;\"></div>\n        </div>\n    </a>\n</div>\n"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "<aside id=\"<%= data.id %>\" class=\"frame\" data-link-name=\"creative | frame\">\n    <div class=\"frame__background\">\n        <img class=\"frame__background-image\" src=\"<%=data.backgroundImage%>\">\n    </div>\n    <div class=\"frame__foreground\">\n        <a href=\"<%=data.clickMacro%><%=data.destinationUrl%>\" class=\"frame__link-background\" data-link-name=\"image\" target=\"<%=data.target%>\"></a>\n        <a class=\"frame__logo frame__logo--<%=data.brandLogoPosition%>\" href=\"<%=data.brandUrl%>\" data-link-name=\"logo\" target=\"<%=data.target%>\">\n            <img class=\"frame__logo__image\" src=\"<%=data.brandLogo%>\">\n        </a>\n        <a style=\"color: <%=data.contentColour%>\" class=\"frame__content frame__content--<%=data.contentVerticalPosition%> frame__content--<%=data.contentHorizontalPosition%>\" href=\"<%=data.clickMacro%><%=data.destinationUrl%>\" target=\"<%=data.target%>\">\n            <h2 style=\"font-size: <%=data.headerFontSize%>px\" class=\"frame__content-title\"><%=data.header%></h2>\n            <p style=\"font-size: <%=data.textFontSize%>px\" class=\"frame__content-text\"><%=data.text%></p>\n        </a>\n        <a href=\"<%=data.clickMacro%><%=data.callToActionUrl%>\" class=\"frame__cta frame__link button button--tertiary button--medium\" data-link-name=\"call to action\" target=\"<%=data.target%>\">\n            <%=data.callToAction%><%=data.externalLinkIcon%>\n        </a>\n    </div>\n</aside>\n"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gu-comlabel has-popup\">\n\t<button class=\"u-button-reset gu-comlabel__btn popup__toggle\" data-toggle=\"gu-compopup--<%=data.dataAttr%>\"><%=data.buttonTitle%> <%=data.icon%></button>\n\t<div class=\"popup popup--default is-off gu-compopup gu-compopup--<%=data.dataAttr%> gu-stylebox\">\n\t\t<h3 class=\"gu-compopup__title\"><%=data.infoTitle%></h3>\n\t\t<p class=\"gu-compopup__text\"><%=data.infoText%></p>\n\t\t<a class=\"gu-compopup__link\" href=\"<%=data.infoLinkUrl%>\" target=\"_blank\"><%=data.infoLinkText%></a>\n\t</div>\n</div>\n"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "<iframe width=\"409px\" height=\"230px\" src=\"<%=videoURL%>?rel=0&amp;controls=0&amp;showinfo=0&amp;title=0&amp;byline=0&amp;portrait=0\" frameborder=\"0\" class=\"fluid250_video fluid250_video--desktop fluid250_video--vert-pos-<%=videoPositionV%> fluid250_video--horiz-pos-<%=videoPositionH%>\" style=\"<%=position%>\"></iframe>\n"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<aside id=\"<%= id %>\" class=\"creative creative--revealer\">\n    <a class=\"creative__cta\" href=\"<%=clickMacro%><%=link%>\" target=\"_blank\">\n        <div class=\"creative__background\" style=\"background-image: url('<%=backgroundImage%>')\"></div>\n        <img class=\"creative__button creative__button--<%=buttonVPos%> creative__button--<%=buttonHPos%>\" src=\"<%=button%>\" alt>\n    </a>\n</div>\n"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<a id=\"<%= id %>\" class=\"creative--scrollable-mpu\"\n    href=\"<%=clickMacro%><%=destination%>\"\n    target=\"_new\">\n    <div class=\"creative--scrollable-mpu-inner\">\n    \t<%=backgroundImage%>\n    \t<div class=\"creative--scrollable-mpu-static-image\" style=\"background-image: url('<%=layer1Image%>');\"></div>\n    </div>\n</a>\n"

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ad-scrolling-bg\" style=\"background-image: url('<%=backgroundImageP%>'); background-position: 50% 0; background-repeat: <%=backgroundImagePRepeat%>\"></div>\n"

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "<div class=\"PLISTA\" data-ob-template=\"guardian\">\n    <div data-display=\"plista_widget_<%=widgetName%>\"></div>\n</div>\n"

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "<div class=\"survey-overlay-simple js-survey-overlay u-h\" data-link-name=\"hosted page about overlay\" role=\"dialog\" aria-label=\"about hosted content\">\n    <div class=\"survey-container\">\n        <h3 class=\"survey-text__header\">\n            <%=header%>\n            <% if (showCloseBtn) { %>\n            <div class=\"survey-close js-survey-close\">\n                <button class=\"site-message__close-btn js-site-message-close\" data-link-name=\"hide about hosted message\">\n                    <span class=\"u-h\">Close</span>\n                    <%=crossIcon%>\n                </button>\n            </div>\n            <% } %>\n        </h3>\n        <div class=\"survey-icon\">\n            <%=paidContent%>\n        </div>\n        <div class=\"survey-text\">\n            <p class=\"survey-text__paragraph\">\n                <%=paragraph1%>\n            </p>\n            <p class=\"survey-text__paragraph\">\n                <%=paragraph2%>\n            </p>\n            <p class=\"survey-text__paragraph\">\n                <%=paragraph3%>\n            </p>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fc-container fc-container--<%=widgetType%> hide-on-childrens-books-site js-<%=widgetType%>\">\n    <div class=\"fc-container__inner js-<%=widgetType%>-container\"></div>\n</div>\n"

/***/ }),
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(57),

    // These need to be bundled, so that they can be fetched asynchronously in production
    __webpack_require__(480),
    __webpack_require__(481),
    __webpack_require__(478),
    __webpack_require__(477),
    __webpack_require__(476),
    __webpack_require__(479),
    __webpack_require__(482)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    reportError
) {
    /**
     * Not all adverts render themselves - some just provide data for templates that we implement in commercial.js.
     * This looks for any such data and, if we find it, renders the appropriate component.
     */
    return function applyCreativeTemplate(adSlot) {
        return getAdvertIframe(adSlot).then(function (iframe) {
            return renderCreativeTemplate(adSlot, iframe);
        });
    };

    function getAdvertIframe(adSlot) {
        return new Promise(function (resolve, reject) {
            // DFP will sometimes return empty iframes, denoted with a '__hidden__' parameter embedded in its ID.
            // We need to be sure only to select the ad content frame.
            var contentFrame = adSlot.querySelector('iframe:not([id*="__hidden__"])');

            if (!contentFrame) {
                reject();
            }
            // On IE, wait for the frame to load before interacting with it
            else if (contentFrame.readyState && contentFrame.readyState !== 'complete') {
                contentFrame.addEventListener('readystatechange', function onRSC(e) {
                    var updatedIFrame = e.srcElement;

                    if (
                        /*eslint-disable valid-typeof*/
                    updatedIFrame &&
                    typeof updatedIFrame.readyState !== 'unknown' &&
                    updatedIFrame.readyState === 'complete'
                    /*eslint-enable valid-typeof*/
                    ) {
                        updatedIFrame.removeEventListener('readystatechange', onRSC);
                        resolve(contentFrame);
                    }
                });
            } else {
                resolve(contentFrame);
            }
        });
    }

    function renderCreativeTemplate(adSlot, iFrame) {
        var creativeConfig = fetchCreativeConfig();

        if (creativeConfig) {
            return hideIframe()
                .then(JSON.parse)
                .then(mergeViewabilityTracker)
                .then(renderCreative)
                .catch(function (err) {
                  reportError('Failed to get creative JSON ' + err, {feature: 'commercial'}, false);
                });
        } else {
            return Promise.resolve(true);
        }

        function fetchCreativeConfig() {
            try {
                var breakoutScript = iFrame.contentDocument.body.querySelector('.breakout__script[type="application/json"]');
                return breakoutScript ? breakoutScript.innerHTML : null;
            } catch (err) {
                return null;
            }

        }

        function mergeViewabilityTracker(json) {
            var viewabilityTrackerDiv = iFrame.contentDocument.getElementById('viewabilityTracker');
            var viewabilityTracker = viewabilityTrackerDiv ?
                viewabilityTrackerDiv.childNodes[0].nodeValue.trim() :
                null;
            if (viewabilityTracker) {
                json.params.viewabilityTracker = viewabilityTracker;
            }
            return json;
        }

        function renderCreative(config) {
            return new Promise(function(resolve) {
                __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(804)("./" + config.name)]; (function (Creative) {
                    resolve(new Creative(adSlot, config.params, config.opts).create());
                }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
            });
        }

        function hideIframe() {
            return fastdom.write(function () {
                iFrame.style.display = 'none';
                return creativeConfig;
            });
        }
    }

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(223),
    __webpack_require__(433)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (dfpEnv, loadAdvert) {
    return displayAds;

    function displayAds() {
        window.googletag.pubads().enableSingleRequest();
        window.googletag.pubads().collapseEmptyDivs();
        window.googletag.enableServices();
        // as this is an single request call, only need to make a single display call (to the first ad
        // slot)
        loadAdvert(dfpEnv.advertsToLoad[0]);
        dfpEnv.advertsToLoad.length = 0;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(233),
    __webpack_require__(544)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (getAdvertById, postMessage) {
    var host = location.protocol + '//' + location.host;
    return onLoad;

    /* This is for native ads. We send two pieces of information:
       - the ID of the iframe into which this ad is embedded. This is currently
         the only way to link an incoming message to the iframe it is "coming from"
       - the HOST of the parent frame. Again, inside the embedded document there is
         no way to know if we are running the site in production, dev or local mode.
         But, this information is necessary in the window.postMessage call, and so
         we resort to sending it as a token of welcome :)
    */
    function onLoad(event) {
        var advert = getAdvertById.getAdvertById(event.slot.getSlotElementId());
        if ((typeof advert.size === 'string' && advert.size === 'fluid') ||
            (advert.size[0] === 0 && advert.size[1] === 0)
        ) {
            var iframe = advert.node.getElementsByTagName('iframe')[0];
            postMessage({ id: iframe.id, host: host }, iframe.contentWindow);
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(411),
    __webpack_require__(0),
    __webpack_require__(4),
    __webpack_require__(57),
    __webpack_require__(123),
    __webpack_require__(546),
    __webpack_require__(223),
    __webpack_require__(444),
    __webpack_require__(588),
    __webpack_require__(580),
    __webpack_require__(233)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (once, config, mediator, reportError, userTiming, beacon, dfpEnv, Advert, renderAdvert, emptyAdvert, getAdvertById) {
    var recordFirstAdRendered = once(function () {
        beacon.fire('/count/ad-render.gif');
    });

    return onSlotRender;

    function onSlotRender(event) {
        recordFirstAdRendered();

        var advert = getAdvertById.getAdvertById(event.slot.getSlotElementId());
        Advert.stopLoading(advert, true);
        Advert.startRendering(advert);
        advert.isEmpty = event.isEmpty;

        if (event.isEmpty) {
            emptyAdvert.emptyAdvert(advert);
            reportEmptyResponse(advert.id, event);
            emitRenderEvents(false);
        } else {
            advert.size = event.size;
            dfpEnv.creativeIDs.push(event.creativeId);
            renderAdvert(advert, event)
            .then(emitRenderEvents);
        }

        function emitRenderEvents(isRendered) {
            Advert.stopRendering(advert, isRendered);
            mediator.emit('modules:commercial:dfp:rendered', event);
        }
    }

    function reportEmptyResponse(adSlotId, event) {
        // This empty slot could be caused by a targeting problem,
        // let's report these and diagnose the problem in sentry.
        // Keep the sample rate low, otherwise we'll get rate-limited (report-error will also sample down)
        if (Math.random() < 0.0001) {
            var adUnitPath = event.slot.getAdUnitPath();
            var adTargetingMap = event.slot.getTargetingMap();
            var adTargetingKValues = adTargetingMap ? adTargetingMap['k'] : [];
            var adKeywords = adTargetingKValues ? adTargetingKValues.join(', ') : '';

            reportError(new Error('dfp returned an empty ad response'), {
                feature: 'commercial',
                adUnit: adUnitPath,
                adSlot: adSlotId,
                adKeywords: adKeywords
            }, false);
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 Hosted video
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(810),
    __webpack_require__(500),
    __webpack_require__(38),
    __webpack_require__(191),
    __webpack_require__(18),
    __webpack_require__(57),
    __webpack_require__(196),
    __webpack_require__(192),
    __webpack_require__(195),
    __webpack_require__(194)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    hostedYoutube,
    nextVideoAutoplay,
    $,
    deferToAnalytics,
    detect,
    reportError,
    events,
    videojsOptions,
    fullscreener,
    loadingTmpl
) {
    var player;

    function isDesktop() {
        return detect.isBreakpoint({ min: 'desktop' });
    }

    function initLoadingSpinner(player) {
        player.loadingSpinner.contentEl().innerHTML = loadingTmpl;
    }

    function upgradeVideoPlayerAccessibility(player) {
        // Set the video tech element to aria-hidden, and label the buttons in the videojs control bar.
        $('.vjs-tech', player.el()).attr('aria-hidden', true);

        // Hide superfluous controls, and label useful buttons.
        $('.vjs-big-play-button', player.el()).attr('aria-hidden', true);
        $('.vjs-current-time', player.el()).attr('aria-hidden', true);
        $('.vjs-time-divider', player.el()).attr('aria-hidden', true);
        $('.vjs-duration', player.el()).attr('aria-hidden', true);
        $('.vjs-embed-button', player.el()).attr('aria-hidden', true);

        $('.vjs-play-control', player.el()).attr('aria-label', 'video play');
        $('.vjs-mute-control', player.el()).attr('aria-label', 'video mute');
        $('.vjs-fullscreen-control', player.el()).attr('aria-label', 'video fullscreen');
    }

    function setupVideo(video, videojs) {
        var mediaId = video.getAttribute('data-media-id');
        player = videojs(video, videojsOptions());
        player.guMediaType = 'video';
        videojs.plugin('fullscreener', fullscreener);

        events.addContentEvents(player, mediaId, player.guMediaType);
        events.bindGoogleAnalyticsEvents(player, window.location.pathname);

        player.ready(function () {
            onPlayerReady(this, mediaId);
        });

        nextVideoAutoplay.init().then(function(){
            if (nextVideoAutoplay.canAutoplay()) {
                //on desktop show the next video link 10 second before the end of the currently watching video
                if (isDesktop()) {
                    nextVideoAutoplay.addCancelListener();
                    player && player.one('timeupdate', nextVideoAutoplay.triggerAutoplay.bind(this, player.currentTime.bind(player), parseInt(video.getAttribute('data-duration'), 10)));
                } else {
                    player && player.one('ended', nextVideoAutoplay.triggerEndSlate);
                }
            }
        });
    }

    function onPlayerReady(player, mediaId) {
        var vol;
        initLoadingSpinner(player);
        upgradeVideoPlayerAccessibility(player);

        // unglitching the volume on first load
        vol = player.volume();
        if (vol) {
            player.volume(0);
            player.volume(vol);
        }

        player.fullscreener();

        deferToAnalytics(function () {
            events.initOphanTracking(player, mediaId);
            events.bindGlobalEvents(player);
            events.bindContentEvents(player);
        });

        player.on('error', onPlayerError);
    }

    function onPlayerError() {
        var player = this;
        var err = player.error();
        if (err && 'message' in err && 'code' in err) {
            reportError(new Error(err.message), {
                feature: 'hosted-player',
                vjsCode: err.code
            }, false);
        }
    }

    function init(start, stop) {
        start();

        var $videoEl = $('.vjs-hosted__video, video');
        var $youtubeIframe = $('.js-hosted-youtube-video');

        if ($youtubeIframe.length === 0 && $videoEl.length === 0) {
            // halt execution
            stop();
            return Promise.resolve();
        }

        // Return a promise that resolves after the async work is done.
        new Promise(function(resolve){
            __webpack_require__.e/* require.ensure */(4).then((function (require) {
                resolve(__webpack_require__(540));
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        })
        .then(function () {
            return new Promise(function(resolve){
                __webpack_require__.e/* require.ensure */(4/* aggressive-merge */).then((function (require) {
                    resolve(__webpack_require__(475));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            });
        })
        .then(function (videojs) {
            $videoEl.each(function(el){
                setupVideo(el, videojs);
            });

            $youtubeIframe.each(hostedYoutube.init);
        })
        .then(stop, stop);

        return Promise.resolve();
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(500),
    __webpack_require__(238),
    __webpack_require__(240),
    __webpack_require__(38),
    __webpack_require__(18),
    __webpack_require__(4),
    __webpack_require__(225),
    __webpack_require__(130)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    nextVideoAutoplay,
    youtubePlayer,
    tracking,
    $,
    detect,
    mediator,
    contains,
    forEach
) {
    var eventsFired = [];

    function isDesktop() {
        return contains(['desktop', 'leftCol', 'wide'], detect.getBreakpoint());
    }

    function sendPercentageCompleteEvents(atomId, youtubePlayer, playerTotalTime) {
        var quartile = playerTotalTime / 4;
        var playbackEvents = {
            '25': quartile,
            '50': quartile * 2,
            '75': quartile * 3
        };

        forEach(playbackEvents, function (value, key) {
            if (!contains(eventsFired, key) && youtubePlayer.getCurrentTime() > value) {
                tracking.track(key, atomId);
                eventsFired.push(key);
                mediator.emit(key);
            }
        });
    }

    function init(el) {
        var atomId = $(el).data('media-id');
        var duration = $(el).data('duration');
        var $currentTime = $('.js-youtube-current-time');
        var playTimer;

        tracking.init(atomId);
        youtubePlayer.init(el, {
            onPlayerStateChange: function (event) {
                var player = event.target;

                //show end slate when movie finishes
                if (event.data === window.YT.PlayerState.ENDED) {
                    tracking.track('end', atomId);
                    $currentTime.text('0:00');
                    if (nextVideoAutoplay.canAutoplay()) {
                        //on mobile show the next video link in the end of the currently watching video
                        if (!isDesktop()) {
                            nextVideoAutoplay.triggerEndSlate();
                        }
                    }
                } else {
                    //update current time
                    var currentTime = Math.floor(player.getCurrentTime());
                    var seconds = currentTime % 60;
                    var minutes = (currentTime - seconds) / 60;
                    $currentTime.text(minutes + (seconds < 10 ? ':0' : ':') + seconds);
                }

                if (event.data === window.YT.PlayerState.PLAYING) {
                    tracking.track('play', atomId);
                    var playerTotalTime = player.getDuration();
                    playTimer = setInterval(function () {
                        sendPercentageCompleteEvents(atomId, player, playerTotalTime);
                    }, 1000);
                } else {
                    clearTimeout(playTimer);
                }
            },
            onPlayerReady: function (event) {
                nextVideoAutoplay.init().then(function(){
                    if (nextVideoAutoplay.canAutoplay() && isDesktop()) {
                        nextVideoAutoplay.addCancelListener();
                        nextVideoAutoplay.triggerAutoplay(event.target.getCurrentTime.bind(event.target), duration);
                    }
                });
            }
        }, el.id);
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(18),
    __webpack_require__(0),
    __webpack_require__(4),
    __webpack_require__(431),
    __webpack_require__(129),
    __webpack_require__(432),
    __webpack_require__(237)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    detect,
    config,
    mediator,
    addSlot,
    commercialFeatures,
    createSlot,
    spaceFiller
) {
    var INTERVAL = 5;      // number of posts between ads
    var OFFSET = 1.5;      // ratio of the screen height from which ads are loaded
    var MAX_ADS = 8;       // maximum number of ads to display

    var slotCounter = 0, isMobile, windowHeight, firstSlot;

    function startListening() {
        mediator.on('modules:autoupdate:updates', onUpdate);
    }

    function stopListening() {
        mediator.off('modules:autoupdate:updates', onUpdate);
    }

    function getSpaceFillerRules(windowHeight, update) {
        var prevSlot, prevIndex;
        update = !!update;
        return {
            bodySelector: '.js-liveblog-body',
            slotSelector: ' > .block',
            fromBottom: update,
            startAt: update ? firstSlot : null,
            absoluteMinAbove: update ? 0 : (windowHeight * OFFSET),
            minAbove: 0,
            minBelow: 0,
            filter: filterSlot
        };

        function filterSlot(slot, index) {
            if (index === 0) {
                prevSlot = slot;
                prevIndex = index;
                return !update;
            } else if (index - prevIndex >= INTERVAL && Math.abs(slot.top - prevSlot.top) >= windowHeight) {
                prevSlot = slot;
                prevIndex = index;
                return true;
            }

            return false;
        }
    }

    function insertAds(slots) {
        for (var i = 0; i < slots.length && slotCounter < MAX_ADS; i++) {
            var slotName = isMobile && slotCounter === 0 ?
                'top-above-nav' : isMobile ?
                'inline' + slotCounter :
                'inline' + (slotCounter + 1);
            var adSlot = createSlot('inline', { name: slotName, classes: 'liveblog-inline' });
            slots[i].parentNode.insertBefore(adSlot, slots[i].nextSibling);
            addSlot.addSlot(adSlot);
            slotCounter += 1;
        }
    }

    function fill(rules) {
        return spaceFiller.fillSpace(rules, insertAds)
            .then(function (result) {
                if (result && slotCounter < MAX_ADS) {
                    firstSlot = document.querySelector(rules.bodySelector + ' > .ad-slot').previousSibling;
                    startListening();
                } else {
                    firstSlot = null;
                }
            });
    }

    function onUpdate() {
        stopListening();
        Promise.resolve(getSpaceFillerRules(windowHeight, true)).then(fill);
    }

    function init(start, stop) {
        start();

        if (!commercialFeatures.liveblogAdverts) {
            stop();
            return Promise.resolve();
        }

        isMobile = detect.getBreakpoint() === 'mobile';

        fastdom.read(function () {
            return windowHeight = document.documentElement.clientHeight;
        })
        .then(getSpaceFillerRules)
        .then(fill)
        .then(stop);

        return Promise.resolve();
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(136),
    __webpack_require__(14),
    __webpack_require__(75),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (events, assign, fastdom, messenger) {
    messenger.register('background', function(specs, ret, iframe) {
        return setBackground(specs, iframe.closest('.js-ad-slot'));
    });

    return setBackground;

    function setBackground(specs, adSlot) {
        if (!specs ||
            !('backgroundImage' in specs) ||
            !('backgroundRepeat' in specs) ||
            !('backgroundPosition' in specs) ||
            !('scrollType' in specs)
        ) {
            return null;
        }

        // Create an element to hold the background image
        var background = document.createElement('div');
        background.className = 'creative__background creative__background--' + specs.scrollType;
        assign(background.style, specs);

        // Wrap the background image in a DIV for positioning. Also, we give
        // this DIV a background colour if it is provided. This is because
        // if we set the background colour in the creative itself, the background
        // image won't be visible (think z-indexed layers)
        var backgroundParent = document.createElement('div');
        backgroundParent.className = 'creative__background-parent';
        if ('backgroundColour' in specs) {
            backgroundParent.style.backgroundColor = specs.backgroundColour;
        }
        backgroundParent.appendChild(background);

        if( specs.scrollType === 'fixed' ) {
            return fastdom.write(function () {
                adSlot.insertBefore(backgroundParent, adSlot.firstChild);
            });
        } else {
            var updateQueued = false;

            return fastdom.write(function () {
                adSlot.insertBefore(backgroundParent, adSlot.firstChild);
            })
            .then(function () {
                events.addEventListener(window, 'scroll', onScroll, { passive: true });
                onScroll();

                function onScroll() {
                    if (!updateQueued) {
                        updateQueued = true;
                        fastdom.read(function () {
                            updateQueued = false;
                            var rect = backgroundParent.getBoundingClientRect();
                            var dy = (0.3 * rect.top | 0) + 20;

                            // We update the style in a read batch because the DIV
                            // has been promoted to its own layer and is also
                            // strictly self-contained. Also, without doing that
                            // the animation is extremely jittery.
                            background.style.backgroundPositionY = dy + '%';
                        });
                    }
                }
            });
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(230),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (google, messenger) {
    messenger.register('click', function (linkName, ret, iframe) {
        return sendClick(iframe.closest('.js-ad-slot') || { id: 'unknown' }, linkName);
    });

    return sendClick;

    function sendClick(adSlot, linkName) {
        google.trackNativeAdLinkClick(adSlot.id, linkName);
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (messenger) {
    var aProto = Array.prototype;

    messenger.register('get-styles', function(specs) {
        return getStyles(specs, document.styleSheets);
    });
    return getStyles;

    function getStyles(specs, styleSheets) {
        if (!specs || typeof specs.selector !== 'string') {
            return null;
        }

        var i = 0;
        var ii = styleSheets.length;
        var result = [];
        while (i < ii) {
            var sheet = styleSheets[i++];
            if (sheet.ownerNode && sheet.ownerNode.matches && sheet.ownerNode.matches(specs.selector)) {
                if (sheet.ownerNode.tagName === 'STYLE') {
                    result.push(sheet.ownerNode.textContent);
                } else {
                    result.push(aProto.reduce.call(sheet.cssRules || [], function (res, input) {
                        return res + input.cssText;
                    }, ''));
                }
            }
        }

        return result;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(14),
    __webpack_require__(75),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (assign, fastdom, messenger) {
    messenger.register('resize', function(specs, ret, iframe) {
        return resize(specs, iframe, iframe.closest('.js-ad-slot'));
    });

    return resize;

    function resize(specs, iframe, adSlot) {
        if (!specs || !('height' in specs || 'width' in specs)) {
            return null;
        }

        var styles = {};

        if (specs.width) {
            styles.width = normalise(specs.width);
        }

        if (specs.height) {
            styles.height = normalise(specs.height);
        }

        return fastdom.write(function () {
            assign(adSlot.style, styles);
            assign(iframe.style, styles);
        });
    }

    function normalise(length) {
        var lengthRegexp = /^(\d+)(%|px|em|ex|ch|rem|vh|vw|vmin|vmax)?/;
        var defaultUnit = 'px';
        var matches = String(length).match(lengthRegexp);
        if (!matches) {
            return null;
        }
        return matches[1] + (matches[2] === undefined ? defaultUnit : matches[2]);
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(136),
    __webpack_require__(18),
    __webpack_require__(75),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (events, detect, fastdom, messenger) {
    // An intersection observer will allow us to efficiently send slot
    // coordinates for only those that are in the viewport.
    var w = window;
    var useIO = 'IntersectionObserver' in w;
    var taskQueued = false;
    var iframes = {};
    var iframeCounter = 0;
    var observer, visibleIframeIds;

    messenger.register('scroll', onMessage, { persist: true });

    return {
        addScrollListener: addScrollListener,
        removeScrollListener: removeScrollListener,
        reset: reset
    };

    function reset(window_) {
        w = window_ || window;
        useIO = 'IntersectionObserver' in w;
        taskQueued = false;
        iframes = {};
        iframeCounter = 0;
    }

    function onMessage(respond, start, iframe) {
        if (start) {
            addScrollListener(iframe, respond);
        } else {
            removeScrollListener(iframe);
        }
    }

    function addScrollListener(iframe, respond) {
        if (iframeCounter === 0) {
            events.addEventListener(w, 'scroll', onScroll, { passive: true });
            if (useIO) {
                observer = new w.IntersectionObserver(onIntersect);
            }
        }

        iframes[iframe.id] = {
            node: iframe,
            // When using IOs, a slot is hidden by default. When the IO starts
            // observing it, the onIntercept callback will be triggered if it
            // is already in the viewport
            visible: !useIO,
            respond: respond
        };
        iframeCounter += 1;

        if (useIO) {
            observer.observe(iframe);
        }

        fastdom.read(function() {
            return iframe.getBoundingClientRect();
        })
        .then(function (domRect) {
            sendCoordinates(iframe.id, domRect);
        });
    }

    function removeScrollListener(iframe) {
        if (iframes[iframe.id]) {
            if (useIO && observer) {
                observer.unobserve(iframe);
            }
            iframes[iframe.id] = false;
            iframeCounter -= 1;
        }

        if (iframeCounter === 0) {
            w.removeEventListener('scroll', onScroll);
            if (useIO && observer) {
                observer.disconnect();
                observer = null;
            }
        }
    }

    function onScroll() {
        if (!taskQueued) {
            var viewport = detect.getViewport();
            taskQueued = true;

            return fastdom.read(function () {
                taskQueued = false;

                var iframeIds = Object.keys(iframes);

                if (useIO) {
                    visibleIframeIds
                    .map(getDimensions)
                    .forEach(function (data) {
                        sendCoordinates(data[0], data[1]);
                    });
                } else {
                    iframeIds
                    .map(getDimensions)
                    .filter(isIframeInViewport, viewport)
                    .forEach(function (data) {
                        sendCoordinates(data[0], data[1]);
                    });
                }
            });
        }
    }

    function isIframeInViewport(item) {
        return item[1].bottom > 0 && item[1].top < this.height;
    }

    function getDimensions(id) {
        return [id, iframes[id].node.getBoundingClientRect()];
    }

    function onIntersect(changes) {
        visibleIframeIds = changes
        .filter(function (_) { return _.intersectionRatio > 0; })
        .map(   function (_) { return _.target.id; });
    }

    // Instances of classes bound to the current view are not serialised correctly
    // by JSON.stringify. That's ok, we don't care if it's a DOMRect or some other
    // object, as long as the calling view receives the frame coordinates.
    function domRectToRect(rect) {
        return {
            width:  rect.width,
            height: rect.height,
            top:    rect.top,
            bottom: rect.bottom,
            left:   rect.left,
            right:  rect.right
        };
    }

    function sendCoordinates(iframeId, domRect) {
        iframes[iframeId].respond(null, domRectToRect(domRect));
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (fastdom, messenger) {
    messenger.register('type', function(specs, ret, iframe) {
        return setType(specs, iframe.closest('.js-ad-slot'));
    });

    return setType;

    function setType(type, adSlot) {
        return fastdom.write(function () {
            adSlot.classList.add('ad-slot--' + type);
        });
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(18),
    __webpack_require__(75),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (detect, fastdom, messenger) {
    var w = window;
    var iframes = {};
    var iframeCounter = 0;
    var taskQueued = false;
    var lastViewportRead, lastViewport;

    messenger.register('viewport', onMessage, { persist: true });
    lastViewportRead = fastdom.read(function() {
        lastViewport = detect.getViewport();
    });

    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener,
        reset: reset
    };

    function reset(window_) {
        w = window_ || window;
        taskQueued = false;
        iframes = {};
        iframeCounter = 0;
    }

    function onMessage(respond, start, iframe) {
        if (start) {
            addResizeListener(iframe, respond);
        } else {
            removeResizeListener(iframe);
        }
    }

    function addResizeListener(iframe, respond) {
        if (iframeCounter === 0) {
            w.addEventListener('resize', onResize);
        }

        iframes[iframe.id] = {
            node: iframe,
            respond: respond
        };
        iframeCounter += 1;
        return lastViewportRead.then(function () {
            sendViewportDimensions.bind(lastViewport)(iframe.id);
        });
    }

    function removeResizeListener(iframe) {
        if (iframes[iframe.id]) {
            iframes[iframe.id] = false;
            iframeCounter -= 1;
        }

        if (iframeCounter === 0) {
            w.removeEventListener('resize', onResize);
        }
    }

    function onResize() {
        if (!taskQueued) {
            taskQueued = true;

            return fastdom.read(function () {
                return lastViewport = detect.getViewport();
            }).then(function (viewport) {
                Object.keys(iframes).forEach(sendViewportDimensions, viewport);
                taskQueued = false;
            });
        }
    }

    function sendViewportDimensions(iframeId) {
        iframes[iframeId].respond(null, this);
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(434),
    __webpack_require__(129)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (config, sticky, commercialFeatures) {
    function init() {
        if (!commercialFeatures.paidforBand) {
            return Promise.resolve(false);
        }

        var elem = document.querySelector('.paidfor-band');
        if (elem) {
            new sticky.Sticky(elem).init();
        }

        return Promise.resolve();
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(4),
    __webpack_require__(75),
    __webpack_require__(434),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config,
    mediator,
    fastdom,
    sticky,
    messenger
) {
    var noSticky = document.documentElement.classList.contains('has-no-sticky');
    var stickyElement;
    var rightSlot;

    function stickyMpu(adSlot) {
        if (adSlot.getAttribute('data-name') !== 'right') {
            return;
        }

        rightSlot = adSlot;

        var referenceElement = document.querySelector(config.page.hasShowcaseMainElement ? '.media-primary' : '.content__article-body,.js-liveblog-body-content');
        if (!referenceElement) {
            return;
        }

        fastdom.read(function () {
            return (referenceElement[config.page.hasShowcaseMainElement ? 'offsetHeight' : 'offsetTop']) + adSlot.offsetHeight;
        }).then(function (newHeight) {
            return fastdom.write(function () {
                adSlot.parentNode.style.height = newHeight + 'px';
            });
        }).then(function () {
            if (noSticky) {
                //if there is a sticky 'paid by' band move the sticky mpu down so it will be always visible
                var options = config.page.isPaidContent ? {top: 43} : {};
                stickyElement = new sticky.Sticky(adSlot, options);
                stickyElement.init();
                messenger.register('resize', onResize);
            }
            mediator.emit('page:commercial:sticky-mpu');
        });
    }

    function onResize(specs, _, iframe) {
        if (rightSlot.contains(iframe)) {
            messenger.unregister('resize', onResize);
            stickyElement.updatePosition();
        }
    }

    stickyMpu.whenRendered = new Promise(function (resolve) {
        mediator.on('page:commercial:sticky-mpu', resolve);
    });

    return stickyMpu;

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(136),
    __webpack_require__(0),
    __webpack_require__(18),
    __webpack_require__(75),
    __webpack_require__(231),
    __webpack_require__(129),
    __webpack_require__(233),
    __webpack_require__(394)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    events,
    config,
    detect,
    fastdom,
    trackAdRender,
    commercialFeatures,
    getAdvertById,
    messenger
) {
    var topSlotId = 'dfp-ad--top-above-nav';
    var updateQueued = false;
    var win, header, headerHeight, topSlot, topSlotHeight, topSlotStyles, stickyBanner, scrollY;

    return {
        init: init,
        update: update,
        resize: resizeStickyBanner,
        onScroll: onScroll
    };

    function init(_window) {
        if (!commercialFeatures.stickyTopBannerAd) {
            return Promise.resolve();
        }

        win = _window || window;
        topSlot = document.getElementById(topSlotId);
        if (topSlot && detect.isBreakpoint({ min: 'desktop' })) {
            header = document.getElementById('header');
            stickyBanner = topSlot.parentNode;

            // First, let's assign some default values so that everything
            // is in good order before we start animating changes in height
            return initState()
            // Second, start listening for height and scroll changes
            .then(setupListeners)
            .then(onFirstRender);
        } else {
            topSlot = null;
            return Promise.resolve();
        }
    }

    function initState() {
        return fastdom.read(function () {
            headerHeight = header.offsetHeight;
            return topSlot.offsetHeight;
        })
        .then(function (currentHeight) {
            return Promise.all([
                resizeStickyBanner(currentHeight),
                onScroll()
            ]);
        });
    }

    // Register a message listener for when the creative wants to resize
    // its container
    // We also listen for scroll events if we need to, to snap the slot in
    // place when it reaches the end of the header.
    function setupListeners() {
        messenger.register('resize', onResize);
        if (!config.page.hasSuperStickyBanner) {
            events.addEventListener(win, 'scroll', onScroll, { passive: true });
        }
    }

    function onFirstRender() {
        trackAdRender(topSlotId)
        .then(function (isRendered) {
            if (isRendered) {
                var advert = getAdvertById.getAdvertById(topSlotId);
                if (advert &&
                    advert.size &&
                    // skip for Fabric creatives
                    advert.size[0] !== 88 &&
                    // skip for native ads
                    advert.size[1] > 0
                ) {
                    fastdom.read(function () {
                        var styles = window.getComputedStyle(topSlot);
                        return parseInt(styles.paddingTop) + parseInt(styles.paddingBottom) + advert.size[1];
                    })
                    .then(resizeStickyBanner);
                } else {
                    fastdom.read(function () {
                        return topSlot.offsetHeight;
                    })
                    .then(resizeStickyBanner);
                }
            }
        });
    }

    function onResize(specs, _, iframe) {
        if (topSlot.contains(iframe)) {
            update(specs.height);
            messenger.unregister('resize', onResize);
        }
    }

    function update(newHeight) {
        return fastdom.read(function () {
            topSlotStyles || (topSlotStyles = win.getComputedStyle(topSlot));
            return newHeight + parseInt(topSlotStyles.paddingTop) + parseInt(topSlotStyles.paddingBottom);
        })
        .then(resizeStickyBanner);
    }

    function onScroll() {
        scrollY = win.pageYOffset;
        if (!updateQueued) {
            updateQueued = true;
            return fastdom.write(function () {
                updateQueued = false;
                if (headerHeight < scrollY) {
                    stickyBanner.style.position = 'absolute';
                    stickyBanner.style.top = headerHeight + 'px';
                } else {
                    stickyBanner.style.position =
                    stickyBanner.style.top = null;
                }
            })
            .then(setupAnimation);
        }
    }

    // Sudden changes in the layout can be jarring to the user, so we animate
    // them for a better experience. We only do this if the slot is in view
    // though.
    function setupAnimation() {
        return fastdom.write(function () {
            if (scrollY <= headerHeight) {
                header.classList.add('l-header--animate');
                stickyBanner.classList.add('sticky-top-banner-ad--animate');
            } else {
                header.classList.remove('l-header--animate');
                stickyBanner.classList.remove('sticky-top-banner-ad--animate');
            }
        });
    }

    // Because the top banner is not in the document flow, resizing it requires
    // that we also make space for it. This is done by adjusting the top margin
    // of the header.
    // This is also the best place to adjust the scrolling position in case the
    // user has scrolled past the header.
    function resizeStickyBanner(newHeight) {
        if (topSlotHeight !== newHeight) {
            return fastdom.write(function () {
                stickyBanner.classList.add('sticky-top-banner-ad');
                stickyBanner.style.height =
                header.style.marginTop = newHeight + 'px';

                if (topSlotHeight !== undefined && headerHeight <= scrollY) {
                    win.scrollBy(0, newHeight - topSlotHeight);
                }

                topSlotHeight = newHeight;
                return newHeight;
            });
        } else {
            return Promise.resolve(-1);
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(75),
    __webpack_require__(38),
    __webpack_require__(21),
    __webpack_require__(128),
    __webpack_require__(667),
    __webpack_require__(569),
    __webpack_require__(573),
    __webpack_require__(571),
    __webpack_require__(568),
    __webpack_require__(229)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    fastdom,
    $,
    template,
    userPrefs,
    surveySimpleTemplate,
    arrowWhiteRight,
    marque36icon,
    crossIcon,
    paidContent,
    uniq
) {
    var surveySimple = function (config) {
        this.config = config || {};
        this.id = this.config.id;
        this.prefs = 'overlay-messages';
        this.shouldClosePermanently = this.config.shouldClosePermanently || false;
        this.bannerTmpl = template(surveySimpleTemplate,
            {
                header: this.config.header,
                paragraph1: this.config.paragraph1,
                paragraph2: this.config.paragraph2,
                paragraph3: this.config.paragraph3,
                showCloseBtn: this.config.showCloseBtn,
                arrowWhiteRight: arrowWhiteRight.markup,
                marque36icon: marque36icon.markup,
                crossIcon: crossIcon.markup,
                paidContent: paidContent.markup
            });
    };

    surveySimple.prototype.attach = function () {
        if (!this.hasSeen()) {
            return fastdom.write(function () {
                $(document.body).append(this.bannerTmpl);

                if (this.config.showCloseBtn) {
                    var closeBtn = document.querySelector('.js-survey-close');
                    closeBtn.addEventListener('click', this.handleClick.bind(this));
                }
            }.bind(this));
        } else {
            return Promise.resolve();
        }
    };

    surveySimple.prototype.handleClick = function () {
        $('.js-survey-overlay').addClass('u-h');
        if (this.shouldClosePermanently) {
            this.closePermanently();
        }
    };

    surveySimple.prototype.hasSeen = function () {
        var messageStates = userPrefs.get(this.prefs);
        return messageStates && messageStates.indexOf(this.id) > -1;
    };

    surveySimple.prototype.closePermanently = function () {
        var messageStates = userPrefs.get(this.prefs) || [];
        messageStates.push(this.id);
        userPrefs.set(this.prefs, uniq(messageStates));
    };

    surveySimple.prototype.show = function () {
        fastdom.write(function () {
            $('.js-survey-overlay').removeClass('u-h');
        });
    };

    return surveySimple;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * A regionalised container for all the commercial tags.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(38),
    __webpack_require__(0),
    __webpack_require__(75),
    __webpack_require__(21),
    __webpack_require__(222),
    __webpack_require__(129),
    __webpack_require__(824),
    __webpack_require__(825),
    __webpack_require__(827),
    __webpack_require__(826),
    __webpack_require__(600),
    __webpack_require__(601),
    __webpack_require__(602),
    __webpack_require__(545),
    __webpack_require__(598),
    __webpack_require__(599),
    __webpack_require__(673)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    $,
    config,
    fastdom,
    template,
    ab,
    commercialFeatures,
    audienceScienceGateway,
    audienceSciencePql,
    imrWorldwide,
    imrWorldwideLegacy,
    remarketing,
    simpleReach,
    tourismAustralia,
    krux,
    outbrain,
    plista,
    externalContentContainerStr
    ) {

    function loadExternalContentWidget() {

        var externalTpl = template(externalContentContainerStr);

        function findAnchor() {
            var selector = !(config.page.seriesId || config.page.blogIds) ?
                '.js-related, .js-outbrain-anchor' :
                '.js-outbrain-anchor';
            return Promise.resolve(document.querySelector(selector));
        }

        function renderWidget(widgetType, init) {
            findAnchor()
            .then(function (anchorNode) {
                return fastdom.write(function () {
                    $(anchorNode).after(externalTpl({widgetType: widgetType}));
                })
            })
            .then(init);
        }

        var shouldServePlista = config.switches.plistaForOutbrainAu && config.page.edition.toLowerCase() === 'au';

        if (shouldServePlista) {
            renderWidget('plista', plista.init);
        } else {
            renderWidget('outbrain', outbrain.init);
        }
    }

    function init() {

        if (!commercialFeatures.thirdPartyTags) {
            return Promise.resolve(false);
        }

        // Outbrain/Plista needs to be loaded before first ad as it is checking for presence of high relevance component on page
        if (!isLuckyBastard()) {
            loadExternalContentWidget();
        }

        loadOther();

        return Promise.resolve(true);
    }

    function isLuckyBastard() {
        var testName = 'PaidContentVsOutbrain2';
        return ab.testCanBeRun(testName) && ab.getTestVariantId(testName) === 'paid-content';
    }

    function loadOther() {
        var services = [
            audienceSciencePql,
            audienceScienceGateway,
            imrWorldwide,
            imrWorldwideLegacy,
            remarketing,
            simpleReach,
            tourismAustralia,
            krux
        ].filter(function (_) { return _.shouldRun; });

        if (services.length) {
            insertScripts(services);
        }
    }

    function insertScripts(services) {
        var ref = document.scripts[0];
        var frag = document.createDocumentFragment();
        while (services.length) {
            var service = services.shift();
            if (service.useImage) {
                new Image().src = service.url;
            } else {
                var script = document.createElement('script');
                script.src = service.url;
                script.onload = service.onLoad;
                frag.appendChild(script);
            }
        }
        ref.parentNode.insertBefore(frag, ref);
    }

    return {
        init: init
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (config) {
    var audienceScienceGatewayUrl = '//js.revsci.net/gateway/gw.js?csid=F09828&auto=t&bpid=theguardian';

    return {
        shouldRun: config.page.edition === 'UK' && config.switches.audienceScienceGateway,
        url: audienceScienceGatewayUrl
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0),
    __webpack_require__(76)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (config, urlUtils) {

    var gatewayUrl = '//pq-direct.revsci.net/pql';
    var sectionPlacements = {
        sport:        ['FKSWod', '2xivTZ', 'MTLELH'],
        football:     ['6FaXJO', 'ORE2W-', 'MTLELH'],
        lifeandstyle: ['TQV1_5', 'J0tykU', 'kLC9nW', 'MTLELH'],
        technology:   ['9a9VRE', 'TL3gqK', 'MTLELH'],
        fashion:      ['TQV1_5', 'J0tykU', 'kLC9nW', 'MTLELH'],
        news:         ['eMdl6Y', 'mMYVrM', 'MTLELH'],
        'default':    ['FLh9mM', 'c7Zrhu', 'Y1C40a', 'LtKGsC', 'MTLELH']
    };
    var section = sectionPlacements[config.page.section] ? config.page.section : 'default';
    var audienceSciencePqlUrl = getUrl();

    function getUrl() {
        var placements = sectionPlacements[section];
        var query = urlUtils.constructQuery({
            placementIdList: placements.join(','),
            cb: new Date().getTime()
        });
        return gatewayUrl + '?' + query;
    }

    function onLoad() {
        window.googletag.cmd.push(
            setAudienceScienceCallback,
            setAudienceScienceKeys
        );
    }

    function getSegments() {
        var placements = window.asiPlacements || {};
        return Object.keys(placements)
        .filter(function (placement) {
            return placements[placement].default;
        })
        .map(function (placement) {
            return 'pq_' + placement;
        });
    }

    function setAudienceScienceKeys() {
        getSegments().forEach(addKey);
    }

    // Remove all Audience Science related targeting keys as soon as we recieve
    // an AS creative (will get called by the creative itself)
    function setAudienceScienceCallback() {
        window.onAudienceScienceCreativeLoaded = function () {
            getSegments().forEach(removeKey);
        };
    }

    function addKey(key) {
        window.googletag.pubads().setTargeting(key, 'T');
    }

    function removeKey(key) {
        window.googletag.pubads().clearTargeting(key);
    }

    return {
        shouldRun: config.page.edition === 'UK' && config.switches.audienceScienceGateway,
        url: audienceSciencePqlUrl,
        reset: function () {
            section = sectionPlacements[config.page.section] ? config.page.section : 'default';
        },
        onLoad: onLoad,
        getSegments: getSegments
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config
) {
    // The Nielsen NetRatings tag. Also known as IMR worldwide.

    var imrWorldwideUrl = '//secure-au.imrworldwide.com/v60.js';

    function onLoad() {
        var pvar = { cid: 'au-guardian', content: '0', server: 'secure-gl' };
        // nol_t is a global function set by the imrworldwide library
        /*eslint-disable no-undef*/
        var trac = nol_t(pvar);
        trac.record().post();
    }

    return {
        shouldRun: config.switches.imrWorldwide,
        url: imrWorldwideUrl,
        onLoad: onLoad
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(0)
], __WEBPACK_AMD_DEFINE_RESULT__ = function (
    config
) {
    // The Nielsen NetRatings tag. Also known as IMR worldwide.
    var imrWorldwideUrl = '//secure-dcr.imrworldwide.com/novms/js/2/ggcmb510.js';

    var guMetadata = {
      "books": "P5033A084-E9BF-453A-91D3-C558751D9A85",
      "business": "P5B109609-6223-45BA-B052-55F34A79D7AD",
      "commentisfree": "PA878EFC7-93C8-4352-905E-9E03883FD6BD",
      "artanddesign": "PE5076E6F-B85D-4B45-9536-F150EF3FC853",
      "culture": "PE5076E6F-B85D-4B45-9536-F150EF3FC853",
      "stage": "PE5076E6F-B85D-4B45-9536-F150EF3FC853",
      "education": "P4A01DB74-5B97-435A-89F0-C07EA2C739EC",
      "environment": "P2F34A388-A280-4C3F-AF43-FAF16EFCB7B1",
      "cities": "P2F34A388-A280-4C3F-AF43-FAF16EFCB7B1",
      "global-development": "P2F34A388-A280-4C3F-AF43-FAF16EFCB7B1",
      "sustainable-business": "P2F34A388-A280-4C3F-AF43-FAF16EFCB7B1",
      "fashion": "PCF345621-F34D-40B2-852C-6223C9C8F1E2",
      "film": "P878ECFA5-14A7-4038-9924-3696C93706FC",
      "law": "P1FA129DD-9B9E-49BB-98A4-AA7ED8523DFD",
      "lifeandstyle": "PCFE04250-E5F6-48C7-91DB-5CED6854818C",
      "media": "P1434DC6D-6585-4932-AE17-2864CD0AAE99",
      "money": "PB71E7F1E-F231-4F73-9CC8-BE8822ADD0C2",
      "music": "P78382DEE-CC9B-4B36-BD27-809007BFF300",
      "international": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "au": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "australia-news": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "uk": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "uk-news": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "us": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "us-news": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "world": "P505182AA-1D71-49D8-8287-AA222CD05424",
      "politics": "P5B7468E3-CE04-40FD-9444-22FB872FE83E",
      "careers": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "culture-professionals-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "global-development-professionals-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "government-computing-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "guardian-professional": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "healthcare-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "higher-education-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "housing-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "local-government-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "local-leaders-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "public-leaders-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "small-business-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "social-care-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "teacher-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "voluntary-sector-network": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "women-in-leadership": "P3637DC6B-E43C-4E92-B22C-3F255CC573DA",
      "science": "PDAD6BC22-C97B-4151-956B-7F069B2C56E9",
      "society": "P7AF4A592-96FB-4255-B33F-352406F4C7D2",
      "sport": "PCC1AEBB6-7D1A-4F34-8256-EFC314E5D0C3",
      "football": "PCC1AEBB6-7D1A-4F34-8256-EFC314E5D0C3",
      "technology": "P29EF991A-3FEE-4215-9F03-58EACA8286B9",
      "travel": "PD1CEDC3E-2653-4CB6-A4FD-8A315DE07548",
      "tv-and-radio": "P66E48909-8FC9-49E8-A7E6-0D31C61805AD",
      "brand-only": "P0EE0F4F4-8D7C-4082-A2A4-82C84728DC59"
    }

    function onLoad() {
      var sectionFromMeta = config.page.section.toLowerCase();
      var subBrandApId = guMetadata[sectionFromMeta] || guMetadata["brand-only"];

      var sectionRef = (sectionFromMeta in guMetadata) ? sectionFromMeta : "The Guardian - brand only"

      var _nolggGlobalParams = {
        sfcode:"dcr",
        apid: subBrandApId,
        apn: "theguardian"
      };

      // Lets assume that the imrworldwide library is defining NOLCMB
      /*eslint-disable no-undef*/
      var nSdkInstance = NOLCMB.getInstance(_nolggGlobalParams.apid);
      nSdkInstance.ggInitialize(_nolggGlobalParams);

      var dcrStaticMetadata = {
        type: "static",
        assetid: config.page.pageId,
        section: sectionRef
      }

      nSdkInstance.ggPM("staticstart", dcrStaticMetadata);
    }

    return {
        shouldRun: config.switches.imrWorldwide,
        url: imrWorldwideUrl,
        onLoad: onLoad
    };

}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })
]);


// WEBPACK FOOTER //
// 6f778614ddb0d0b3e692/graun.commercial.js